(function() {
    'use strict';

    angular
        .module('doctorclubboApp', [
            'ngStorage',
            'tmh.dynamicLocale',
            'pascalprecht.translate',
            'ngResource',
            'ngCookies',
            'ngAria',
            'ngCacheBuster',
            'ngFileUpload',
            'ui.bootstrap',
            'ui.bootstrap.datetimepicker',
            'ui.router',
            'infinite-scroll',
            // jhipster-needle-angularjs-add-module JHipster will add new module here
            'angular-loading-bar'
        ])
        .run(run);

    run.$inject = ['stateHandler', 'translationHandler'];

    function run(stateHandler, translationHandler) {
        stateHandler.initialize();
        translationHandler.initialize();
    }
})();

(function () {
    'use strict';

    angular
        .module('doctorclubboApp')
        .factory('User', User);

    User.$inject = ['$resource'];

    function User ($resource) {
        var service = $resource('api/users/:login', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'save': { method:'POST' },
            'update': { method:'PUT' },
            'delete':{ method:'DELETE'}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .factory('ProfileService', ProfileService);

    ProfileService.$inject = ['$http'];

    function ProfileService($http) {

        var dataPromise;

        var service = {
            getProfileInfo : getProfileInfo
        };

        return service;

        function getProfileInfo() {
            if (angular.isUndefined(dataPromise)) {
                dataPromise = $http.get('api/profile-info').then(function(result) {
                    if (result.data.activeProfiles) {
                        var response = {};
                        response.activeProfiles = result.data.activeProfiles;
                        response.ribbonEnv = result.data.ribbonEnv;
                        response.inProduction = result.data.activeProfiles.indexOf("prod") !== -1;
                        response.swaggerEnabled = result.data.activeProfiles.indexOf("swagger") !== -1;
                        return response;
                    }
                });
            }
            return dataPromise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .directive('pageRibbon', pageRibbon);

    pageRibbon.$inject = ['ProfileService', '$rootScope', '$translate'];

    function pageRibbon(ProfileService, $rootScope, $translate) {
        var directive = {
            replace : true,
            restrict : 'AE',
            template : '<div class="ribbon hidden"><a href="" translate="global.ribbon.{{ribbonEnv}}">{{ribbonEnv}}</a></div>',
            link : linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            ProfileService.getProfileInfo().then(function(response) {
                if (response.ribbonEnv) {
                    scope.ribbonEnv = response.ribbonEnv;
                    element.addClass(response.ribbonEnv);
                    element.removeClass('hidden');
                }
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('doctorclubboApp')
        .factory('Register', Register);

    Register.$inject = ['$resource'];

    function Register ($resource) {
        return $resource('api/register', {}, {});
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .factory('Principal', Principal);

    Principal.$inject = ['$q', 'Account'];

    function Principal ($q, Account) {
        var _identity,
            _authenticated = false;

        var service = {
            authenticate: authenticate,
            hasAnyAuthority: hasAnyAuthority,
            hasAuthority: hasAuthority,
            identity: identity,
            isAuthenticated: isAuthenticated,
            isIdentityResolved: isIdentityResolved
        };

        return service;

        function authenticate (identity) {
            _identity = identity;
            _authenticated = identity !== null;
        }

        function hasAnyAuthority (authorities) {
            if (!_authenticated || !_identity || !_identity.authorities) {
                return false;
            }

            for (var i = 0; i < authorities.length; i++) {
                if (_identity.authorities.indexOf(authorities[i]) !== -1) {
                    return true;
                }
            }

            return false;
        }

        function hasAuthority (authority) {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(function(_id) {
                return _id.authorities && _id.authorities.indexOf(authority) !== -1;
            }, function(){
                return false;
            });
        }

        function identity (force) {
            var deferred = $q.defer();

            if (force === true) {
                _identity = undefined;
            }

            // check and see if we have retrieved the identity data from the server.
            // if we have, reuse it by immediately resolving
            if (angular.isDefined(_identity)) {
                deferred.resolve(_identity);

                return deferred.promise;
            }

            // retrieve the identity data from the server, update the identity object, and then resolve.
            Account.get().$promise
                .then(getAccountThen)
                .catch(getAccountCatch);

            return deferred.promise;

            function getAccountThen (account) {
                _identity = account.data;
                _authenticated = true;
                deferred.resolve(_identity);
            }

            function getAccountCatch () {
                _identity = null;
                _authenticated = false;
                deferred.resolve(_identity);
            }
        }

        function isAuthenticated () {
            return _authenticated;
        }

        function isIdentityResolved () {
            return angular.isDefined(_identity);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .factory('PasswordResetInit', PasswordResetInit);

    PasswordResetInit.$inject = ['$resource'];

    function PasswordResetInit($resource) {
        var service = $resource('api/account/reset_password/init', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .factory('PasswordResetFinish', PasswordResetFinish);

    PasswordResetFinish.$inject = ['$resource'];

    function PasswordResetFinish($resource) {
        var service = $resource('api/account/reset_password/finish', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .factory('Password', Password);

    Password.$inject = ['$resource'];

    function Password($resource) {
        var service = $resource('api/account/change_password', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .directive('hasAuthority', hasAuthority);

    hasAuthority.$inject = ['Principal'];

    function hasAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authority = attrs.hasAuthority.replace(/\s+/g, '');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    Principal.hasAuthority(authority)
                        .then(function (result) {
                            if (result) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        });
                };

            if (authority.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .directive('hasAnyAuthority', hasAnyAuthority);

    hasAnyAuthority.$inject = ['Principal'];

    function hasAnyAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authorities = attrs.hasAnyAuthority.replace(/\s+/g, '').split(',');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {
                    var result;
                    if (reset) {
                        setVisible();
                    }

                    result = Principal.hasAnyAuthority(authorities);
                    if (result) {
                        setVisible();
                    } else {
                        setHidden();
                    }
                };

            if (authorities.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .factory('Auth', Auth);

    Auth.$inject = ['$rootScope', '$state', '$sessionStorage', '$q', '$translate', 'Principal', 'AuthServerProvider', 'Account', 'LoginService', 'Register', 'Activate', 'Password', 'PasswordResetInit', 'PasswordResetFinish'];

    function Auth ($rootScope, $state, $sessionStorage, $q, $translate, Principal, AuthServerProvider, Account, LoginService, Register, Activate, Password, PasswordResetInit, PasswordResetFinish) {
        var service = {
            activateAccount: activateAccount,
            authorize: authorize,
            changePassword: changePassword,
            createAccount: createAccount,
            getPreviousState: getPreviousState,
            login: login,
            logout: logout,
            loginWithToken: loginWithToken,
            resetPasswordFinish: resetPasswordFinish,
            resetPasswordInit: resetPasswordInit,
            resetPreviousState: resetPreviousState,
            storePreviousState: storePreviousState,
            updateAccount: updateAccount
        };

        return service;

        function activateAccount (key, callback) {
            var cb = callback || angular.noop;

            return Activate.get(key,
                function (response) {
                    return cb(response);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function authorize (force) {
            var authReturn = Principal.identity(force).then(authThen);

            return authReturn;

            function authThen () {
                var isAuthenticated = Principal.isAuthenticated();

                // an authenticated user can't access to login and register pages
                if (isAuthenticated && $rootScope.toState.parent === 'account' && ($rootScope.toState.name === 'login' || $rootScope.toState.name === 'register' || $rootScope.toState.name === 'social-auth')) {
                    $state.go('home');
                }

                // recover and clear previousState after external login redirect (e.g. oauth2)
                if (isAuthenticated && !$rootScope.fromState.name && getPreviousState()) {
                    var previousState = getPreviousState();
                    resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }

                if ($rootScope.toState.data.authorities && $rootScope.toState.data.authorities.length > 0 && !Principal.hasAnyAuthority($rootScope.toState.data.authorities)) {
                    if (isAuthenticated) {
                        // user is signed in but not authorized for desired state
                        $state.go('accessdenied');
                    }
                    else {
                        // user is not authenticated. stow the state they wanted before you
                        // send them to the login service, so you can return them when you're done
                        storePreviousState($rootScope.toState.name, $rootScope.toStateParams);

                        // now, send them to the signin state so they can log in
                        $state.go('accessdenied').then(function() {
                            LoginService.open();
                        });
                    }
                }
            }
        }

        function changePassword (newPassword, callback) {
            var cb = callback || angular.noop;

            return Password.save(newPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function createAccount (account, callback) {
            var cb = callback || angular.noop;

            return Register.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    this.logout();
                    return cb(err);
                }.bind(this)).$promise;
        }

        function login (credentials, callback) {
            var cb = callback || angular.noop;
            var deferred = $q.defer();

            AuthServerProvider.login(credentials)
                .then(loginThen)
                .catch(function (err) {
                    this.logout();
                    deferred.reject(err);
                    return cb(err);
                }.bind(this));

            function loginThen (data) {
                Principal.identity(true).then(function(account) {
                    // After the login the language will be changed to
                    // the language selected by the user during his registration
                    if (account!== null) {
                        $translate.use(account.langKey).then(function () {
                            $translate.refresh();
                        });
                    }
                    deferred.resolve(data);
                });
                return cb();
            }

            return deferred.promise;
        }

        function loginWithToken(jwt, rememberMe) {
            return AuthServerProvider.loginWithToken(jwt, rememberMe);
        }

        function logout () {
            AuthServerProvider.logout();
            Principal.authenticate(null);
        }

        function resetPasswordFinish (keyAndPassword, callback) {
            var cb = callback || angular.noop;

            return PasswordResetFinish.save(keyAndPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function resetPasswordInit (mail, callback) {
            var cb = callback || angular.noop;

            return PasswordResetInit.save(mail, function() {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function updateAccount (account, callback) {
            var cb = callback || angular.noop;

            return Account.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function getPreviousState() {
            var previousState = $sessionStorage.previousState;
            return previousState;
        }

        function resetPreviousState() {
            delete $sessionStorage.previousState;
        }

        function storePreviousState(previousStateName, previousStateParams) {
            var previousState = { "name": previousStateName, "params": previousStateParams };
            $sessionStorage.previousState = previousState;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .factory('AuthServerProvider', AuthServerProvider);

    AuthServerProvider.$inject = ['$http', '$localStorage', '$sessionStorage', '$q'];

    function AuthServerProvider ($http, $localStorage, $sessionStorage, $q) {
        var service = {
            getToken: getToken,
            login: login,
            loginWithToken: loginWithToken,
            storeAuthenticationToken: storeAuthenticationToken,
            logout: logout
        };

        return service;

        function getToken () {
            return $localStorage.authenticationToken || $sessionStorage.authenticationToken;
        }

        function login (credentials) {

            var data = {
                username: credentials.username,
                password: credentials.password,
                rememberMe: credentials.rememberMe
            };
            return $http.post('api/authenticate', data).success(authenticateSuccess);

            function authenticateSuccess (data, status, headers) {
                var bearerToken = headers('Authorization');
                if (angular.isDefined(bearerToken) && bearerToken.slice(0, 7) === 'Bearer ') {
                    var jwt = bearerToken.slice(7, bearerToken.length);
                    service.storeAuthenticationToken(jwt, credentials.rememberMe);
                    return jwt;
                }
            }
        }

        function loginWithToken(jwt, rememberMe) {
            var deferred = $q.defer();

            if (angular.isDefined(jwt)) {
                this.storeAuthenticationToken(jwt, rememberMe);
                deferred.resolve(jwt);
            } else {
                deferred.reject();
            }

            return deferred.promise;
        }

        function storeAuthenticationToken(jwt, rememberMe) {
            if(rememberMe){
                $localStorage.authenticationToken = jwt;
            } else {
                $sessionStorage.authenticationToken = jwt;
            }
        }

        function logout () {
            delete $localStorage.authenticationToken;
            delete $sessionStorage.authenticationToken;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .factory('Activate', Activate);

    Activate.$inject = ['$resource'];

    function Activate ($resource) {
        var service = $resource('api/activate', {}, {
            'get': { method: 'GET', params: {}, isArray: false}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .factory('Account', Account);

    Account.$inject = ['$resource'];

    function Account ($resource) {
        var service = $resource('api/account', {}, {
            'get': { method: 'GET', params: {}, isArray: false,
                interceptor: {
                    response: function(response) {
                        // expose response
                        return response;
                    }
                }
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('NavbarController', NavbarController);

    NavbarController.$inject = ['$state', 'Auth', 'Principal', 'ProfileService', 'LoginService'];

    function NavbarController ($state, Auth, Principal, ProfileService, LoginService) {
        var vm = this;

        vm.isNavbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;

        ProfileService.getProfileInfo().then(function(response) {
            vm.inProduction = response.inProduction;
            vm.swaggerEnabled = response.swaggerEnabled;
        });

        vm.login = login;
        vm.logout = logout;
        vm.toggleNavbar = toggleNavbar;
        vm.collapseNavbar = collapseNavbar;
        vm.$state = $state;

        function login() {
            collapseNavbar();
            LoginService.open();
        }

        function logout() {
            collapseNavbar();
            Auth.logout();
            $state.go('home');
        }

        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .directive('activeMenu', activeMenu);

    activeMenu.$inject = ['$translate', '$locale', 'tmhDynamicLocale'];

    function activeMenu($translate, $locale, tmhDynamicLocale) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var language = attrs.activeMenu;

            scope.$watch(function() {
                return $translate.use();
            }, function(selectedLanguage) {
                if (language === selectedLanguage) {
                    tmhDynamicLocale.set(language);
                    element.addClass('active');
                } else {
                    element.removeClass('active');
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('error', {
                parent: 'app',
                url: '/error',
                data: {
                    authorities: [],
                    pageTitle: 'error.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/error.html'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            })
            .state('accessdenied', {
                parent: 'app',
                url: '/accessdenied',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/accessdenied.html'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('home', {
            parent: 'app',
            url: '/',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/home/home.html',
                    controller: 'HomeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('HomeController', HomeController);

    HomeController.$inject = ['$scope', 'Principal', 'LoginService', '$state'];

    function HomeController ($scope, Principal, LoginService, $state) {
        var vm = this;

        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.register = register;
        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });

        getAccount();

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }
        function register () {
            $state.go('register');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('UtenteDialogController', UtenteDialogController);

    UtenteDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Utente', 'Specializzazione', 'Attivita', 'Dispositivo', 'Dispositivo_os', 'Tablet',  'Tv', 'Provincia', 'Comune', 'Recall_status', 'Agenzia'];

    function UtenteDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Utente, Specializzazione, Attivita, Dispositivo, Dispositivo_os, Tablet,  Tv, Provincia, Comune, Recall_status, Agenzia) {
        var vm = this;

        vm.utente = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.specializzaziones = Specializzazione.query();
        vm.attivitas = Attivita.query();
        vm.dispositivos = Dispositivo.query();
        vm.dispositivo_os = Dispositivo_os.query();
        vm.tablets = Tablet.query();
        vm.tablet_os = Dispositivo_os.query();
        vm.tvs = Tv.query();
        vm.provincias = Provincia.query();
        vm.comunes = Comune.query();
        vm.recall_statuses = Recall_status.query();
        vm.agenzias = Agenzia.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.utente.id !== null) {
                Utente.update(vm.utente, onSaveSuccess, onSaveError);
            } else {
                Utente.save(vm.utente, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('doctorclubboApp:utenteUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.dtNascita = false;
        vm.datePickerOpenStatus.dtIns = false;
        vm.datePickerOpenStatus.dtUpdate = false;
        vm.datePickerOpenStatus.recallDt = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('UtenteDetailController', UtenteDetailController);

    UtenteDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Utente', 'Specializzazione', 'Attivita', 'Dispositivo', 'Dispositivo_os', 'Tablet',  'Tv', 'Provincia', 'Comune', 'Recall_status', 'Agenzia'];

    function UtenteDetailController($scope, $rootScope, $stateParams, previousState, entity, Utente, Specializzazione, Attivita, Dispositivo, Dispositivo_os, Tablet,  Tv, Provincia, Comune, Recall_status, Agenzia) {
        var vm = this;

        vm.utente = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('doctorclubboApp:utenteUpdate', function(event, result) {
            vm.utente = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('UtenteDeleteController',UtenteDeleteController);

    UtenteDeleteController.$inject = ['$uibModalInstance', 'entity', 'Utente'];

    function UtenteDeleteController($uibModalInstance, entity, Utente) {
        var vm = this;

        vm.utente = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Utente.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('utente', {
            parent: 'entity',
            url: '/utente?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.utente.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/utente/utentes.html',
                    controller: 'UtenteController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('utente');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('utente-detail', {
            parent: 'entity',
            url: '/utente/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.utente.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/utente/utente-detail.html',
                    controller: 'UtenteDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('utente');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Utente', function($stateParams, Utente) {
                    return Utente.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'utente',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('utente-detail.edit', {
            parent: 'utente-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/utente/utente-dialog.html',
                    controller: 'UtenteDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Utente', function(Utente) {
                            return Utente.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('utente.new', {
            parent: 'utente',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/utente/utente-dialog.html',
                    controller: 'UtenteDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nome: null,
                                cognome: null,
                                cf: null,
                                dtNascita: null,
                                numIscrizione: null,
                                telefono: null,
                                cellulare: null,
                                fax: null,
                                email: null,
                                email2: null,
                                specializzazione1: null,
                                specializzazione2: null,
                                specializzazione3: null,
                                attivita: null,
                                precontattogg: null,
                                precontattoOrario1: null,
                                precontattoOrario2: null,
                                ricerchegg: null,
                                ricercheOrario: null,
                                isfgg: null,
                                isfOrario: null,
                                note: null,
                                dispositivo: null,
                                dispositivoOs: null,
                                tablet: null,
                                tabletOs: null,
                                tv: null,
                                canaliTv: null,
                                provincia: null,
                                comune: null,
                                cap: null,
                                indirizzo: null,
                                dtIns: null,
                                dtUpdate: null,
                                recallStatus: null,
                                statusNote: null,
                                recallDt: null,
                                spedizioneProv: null,
                                spedizioneComune: null,
                                spedizioneCap: null,
                                spedizioneIndirizzo: null,
                                spedizioneTel: null,
                                source: null,
                                balance: null,
                                externalUserid: null,
                                agency_id: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('utente', null, { reload: 'utente' });
                }, function() {
                    $state.go('utente');
                });
            }]
        })
        .state('utente.edit', {
            parent: 'utente',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/utente/utente-dialog.html',
                    controller: 'UtenteDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Utente', function(Utente) {
                            return Utente.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('utente', null, { reload: 'utente' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('utente.delete', {
            parent: 'utente',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/utente/utente-delete-dialog.html',
                    controller: 'UtenteDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Utente', function(Utente) {
                            return Utente.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('utente', null, { reload: 'utente' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('doctorclubboApp')
        .factory('Utente', Utente);

    Utente.$inject = ['$resource', 'DateUtils'];

    function Utente ($resource, DateUtils) {
        var resourceUrl =  'api/utentes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dtNascita = DateUtils.convertDateTimeFromServer(data.dtNascita);
                        data.dtIns = DateUtils.convertDateTimeFromServer(data.dtIns);
                        data.dtUpdate = DateUtils.convertDateTimeFromServer(data.dtUpdate);
                        data.recallDt = DateUtils.convertDateTimeFromServer(data.recallDt);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('UtenteController', UtenteController);

    UtenteController.$inject = ['$scope', '$state', 'Utente', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function UtenteController ($scope, $state, Utente, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            Utente.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.utentes = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('UploadDialogController', UploadDialogController);

    UploadDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Upload', 'Agenzia', 'Campagna'];

    function UploadDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Upload, Agenzia, Campagna) {
        var vm = this;

        vm.upload = entity;
        vm.clear = clear;
        vm.save = save;
        vm.agenzias = Agenzia.query();
        vm.campagnas = Campagna.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.upload.id !== null) {
                Upload.update(vm.upload, onSaveSuccess, onSaveError);
            } else {
                Upload.save(vm.upload, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('doctorclubboApp:uploadUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('UploadDetailController', UploadDetailController);

    UploadDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Upload', 'Agenzia', 'Campagna'];

    function UploadDetailController($scope, $rootScope, $stateParams, previousState, entity, Upload, Agenzia, Campagna) {
        var vm = this;

        vm.upload = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('doctorclubboApp:uploadUpdate', function(event, result) {
            vm.upload = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('UploadDeleteController',UploadDeleteController);

    UploadDeleteController.$inject = ['$uibModalInstance', 'entity', 'Upload'];

    function UploadDeleteController($uibModalInstance, entity, Upload) {
        var vm = this;

        vm.upload = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Upload.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('upload', {
            parent: 'entity',
            url: '/upload?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.upload.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/upload/uploads.html',
                    controller: 'UploadController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('upload');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('upload-detail', {
            parent: 'upload',
            url: '/upload/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.upload.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/upload/upload-detail.html',
                    controller: 'UploadDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('upload');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Upload', function($stateParams, Upload) {
                    return Upload.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'upload',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('upload-detail.edit', {
            parent: 'upload-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/upload/upload-dialog.html',
                    controller: 'UploadDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Upload', function(Upload) {
                            return Upload.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('upload.new', {
            parent: 'upload',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/upload/upload-dialog.html',
                    controller: 'UploadDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nome: null,
                                file: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('upload', null, { reload: 'upload' });
                }, function() {
                    $state.go('upload');
                });
            }]
        })
        .state('upload.edit', {
            parent: 'upload',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/upload/upload-dialog.html',
                    controller: 'UploadDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Upload', function(Upload) {
                            return Upload.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('upload', null, { reload: 'upload' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('upload.delete', {
            parent: 'upload',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/upload/upload-delete-dialog.html',
                    controller: 'UploadDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Upload', function(Upload) {
                            return Upload.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('upload', null, { reload: 'upload' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('doctorclubboApp')
        .factory('Upload', Upload);

    Upload.$inject = ['$resource'];

    function Upload ($resource) {
        var resourceUrl =  'api/uploads/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('UploadController', UploadController);

    UploadController.$inject = ['$state', 'Upload', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function UploadController($state, Upload, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            Upload.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.uploads = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('TvDialogController', TvDialogController);

    TvDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Tv'];

    function TvDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Tv) {
        var vm = this;

        vm.tv = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.tv.id !== null) {
                Tv.update(vm.tv, onSaveSuccess, onSaveError);
            } else {
                Tv.save(vm.tv, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('doctorclubboApp:tvUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('TvDetailController', TvDetailController);

    TvDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Tv'];

    function TvDetailController($scope, $rootScope, $stateParams, previousState, entity, Tv) {
        var vm = this;

        vm.tv = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('doctorclubboApp:tvUpdate', function(event, result) {
            vm.tv = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('TvDeleteController',TvDeleteController);

    TvDeleteController.$inject = ['$uibModalInstance', 'entity', 'Tv'];

    function TvDeleteController($uibModalInstance, entity, Tv) {
        var vm = this;

        vm.tv = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Tv.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('tv', {
            parent: 'entity',
            url: '/tv',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.tv.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/tv/tvs.html',
                    controller: 'TvController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tv');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('tv-detail', {
            parent: 'entity',
            url: '/tv/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.tv.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/tv/tv-detail.html',
                    controller: 'TvDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tv');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Tv', function($stateParams, Tv) {
                    return Tv.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'tv',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('tv-detail.edit', {
            parent: 'tv-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tv/tv-dialog.html',
                    controller: 'TvDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Tv', function(Tv) {
                            return Tv.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('tv.new', {
            parent: 'tv',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tv/tv-dialog.html',
                    controller: 'TvDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                tv: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('tv', null, { reload: 'tv' });
                }, function() {
                    $state.go('tv');
                });
            }]
        })
        .state('tv.edit', {
            parent: 'tv',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tv/tv-dialog.html',
                    controller: 'TvDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Tv', function(Tv) {
                            return Tv.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('tv', null, { reload: 'tv' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('tv.delete', {
            parent: 'tv',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tv/tv-delete-dialog.html',
                    controller: 'TvDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Tv', function(Tv) {
                            return Tv.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('tv', null, { reload: 'tv' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('doctorclubboApp')
        .factory('Tv', Tv);

    Tv.$inject = ['$resource'];

    function Tv ($resource) {
        var resourceUrl =  'api/tvs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('TvController', TvController);

    TvController.$inject = ['$scope', '$state', 'Tv'];

    function TvController ($scope, $state, Tv) {
        var vm = this;

        vm.tvs = [];

        loadAll();

        function loadAll() {
            Tv.query(function(result) {
                vm.tvs = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('Ticket_statusDialogController', Ticket_statusDialogController);

    Ticket_statusDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Ticket_status'];

    function Ticket_statusDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Ticket_status) {
        var vm = this;

        vm.ticket_status = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.ticket_status.id !== null) {
                Ticket_status.update(vm.ticket_status, onSaveSuccess, onSaveError);
            } else {
                Ticket_status.save(vm.ticket_status, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('doctorclubboApp:ticket_statusUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('Ticket_statusDetailController', Ticket_statusDetailController);

    Ticket_statusDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Ticket_status'];

    function Ticket_statusDetailController($scope, $rootScope, $stateParams, previousState, entity, Ticket_status) {
        var vm = this;

        vm.ticket_status = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('doctorclubboApp:ticket_statusUpdate', function(event, result) {
            vm.ticket_status = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('Ticket_statusDeleteController',Ticket_statusDeleteController);

    Ticket_statusDeleteController.$inject = ['$uibModalInstance', 'entity', 'Ticket_status'];

    function Ticket_statusDeleteController($uibModalInstance, entity, Ticket_status) {
        var vm = this;

        vm.ticket_status = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Ticket_status.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('ticket-status', {
            parent: 'entity',
            url: '/ticket-status',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.ticket_status.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/ticket-status/ticket-statuses.html',
                    controller: 'Ticket_statusController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('ticket_status');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('ticket-status-detail', {
            parent: 'entity',
            url: '/ticket-status/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.ticket_status.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/ticket-status/ticket-status-detail.html',
                    controller: 'Ticket_statusDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('ticket_status');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Ticket_status', function($stateParams, Ticket_status) {
                    return Ticket_status.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'ticket-status',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('ticket-status-detail.edit', {
            parent: 'ticket-status-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ticket-status/ticket-status-dialog.html',
                    controller: 'Ticket_statusDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Ticket_status', function(Ticket_status) {
                            return Ticket_status.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ticket-status.new', {
            parent: 'ticket-status',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ticket-status/ticket-status-dialog.html',
                    controller: 'Ticket_statusDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                status: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('ticket-status', null, { reload: 'ticket-status' });
                }, function() {
                    $state.go('ticket-status');
                });
            }]
        })
        .state('ticket-status.edit', {
            parent: 'ticket-status',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ticket-status/ticket-status-dialog.html',
                    controller: 'Ticket_statusDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Ticket_status', function(Ticket_status) {
                            return Ticket_status.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ticket-status', null, { reload: 'ticket-status' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ticket-status.delete', {
            parent: 'ticket-status',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ticket-status/ticket-status-delete-dialog.html',
                    controller: 'Ticket_statusDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Ticket_status', function(Ticket_status) {
                            return Ticket_status.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ticket-status', null, { reload: 'ticket-status' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('doctorclubboApp')
        .factory('Ticket_status', Ticket_status);

    Ticket_status.$inject = ['$resource'];

    function Ticket_status ($resource) {
        var resourceUrl =  'api/ticket-statuses/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('Ticket_statusController', Ticket_statusController);

    Ticket_statusController.$inject = ['$scope', '$state', 'Ticket_status'];

    function Ticket_statusController ($scope, $state, Ticket_status) {
        var vm = this;

        vm.ticket_statuses = [];

        loadAll();

        function loadAll() {
            Ticket_status.query(function(result) {
                vm.ticket_statuses = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('TicketDialogController', TicketDialogController);

    TicketDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Ticket', 'Ticket_status', 'Campagna'];

    function TicketDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Ticket, Ticket_status, Campagna) {
        var vm = this;

        vm.ticket = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.ticket_statuses = Ticket_status.query();
        vm.campagnas = Campagna.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.ticket.id !== null) {
                Ticket.update(vm.ticket, onSaveSuccess, onSaveError);
            } else {
                Ticket.save(vm.ticket, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('doctorclubboApp:ticketUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.dtins = false;
        vm.datePickerOpenStatus.dtend = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('TicketDetailController', TicketDetailController);

    TicketDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Ticket', 'Ticket_status', 'Campagna'];

    function TicketDetailController($scope, $rootScope, $stateParams, previousState, entity, Ticket, Ticket_status, Campagna) {
        var vm = this;

        vm.ticket = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('doctorclubboApp:ticketUpdate', function(event, result) {
            vm.ticket = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('TicketDeleteController',TicketDeleteController);

    TicketDeleteController.$inject = ['$uibModalInstance', 'entity', 'Ticket'];

    function TicketDeleteController($uibModalInstance, entity, Ticket) {
        var vm = this;

        vm.ticket = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Ticket.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('ticket', {
            parent: 'entity',
            url: '/ticket?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.ticket.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/ticket/tickets.html',
                    controller: 'TicketController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('ticket');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('ticket-detail', {
            parent: 'entity',
            url: '/ticket/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.ticket.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/ticket/ticket-detail.html',
                    controller: 'TicketDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('ticket');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Ticket', function($stateParams, Ticket) {
                    return Ticket.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'ticket',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('ticket-detail.edit', {
            parent: 'ticket-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ticket/ticket-dialog.html',
                    controller: 'TicketDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Ticket', function(Ticket) {
                            return Ticket.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ticket.new', {
            parent: 'ticket',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ticket/ticket-dialog.html',
                    controller: 'TicketDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                codice: null,
                                dtins: null,
                                dtend: null,
                                importo: null,
                                importousato: null,
                                statusid: null,
                                idcampagna: null,
                                parentid: null,
                                idemissione: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('ticket', null, { reload: 'ticket' });
                }, function() {
                    $state.go('ticket');
                });
            }]
        })
        .state('ticket.edit', {
            parent: 'ticket',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ticket/ticket-dialog.html',
                    controller: 'TicketDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Ticket', function(Ticket) {
                            return Ticket.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ticket', null, { reload: 'ticket' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ticket.delete', {
            parent: 'ticket',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ticket/ticket-delete-dialog.html',
                    controller: 'TicketDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Ticket', function(Ticket) {
                            return Ticket.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ticket', null, { reload: 'ticket' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('doctorclubboApp')
        .factory('Ticket', Ticket);

    Ticket.$inject = ['$resource', 'DateUtils'];

    function Ticket ($resource, DateUtils) {
        var resourceUrl =  'api/tickets/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dtins = DateUtils.convertDateTimeFromServer(data.dtins);
                        data.dtend = DateUtils.convertDateTimeFromServer(data.dtend);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('TicketController', TicketController);

    TicketController.$inject = ['$scope', '$state', 'Ticket', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function TicketController ($scope, $state, Ticket, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            Ticket.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.tickets = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('TabletDialogController', TabletDialogController);

    TabletDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Tablet'];

    function TabletDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Tablet) {
        var vm = this;

        vm.tablet = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.tablet.id !== null) {
                Tablet.update(vm.tablet, onSaveSuccess, onSaveError);
            } else {
                Tablet.save(vm.tablet, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('doctorclubboApp:tabletUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('TabletDetailController', TabletDetailController);

    TabletDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Tablet'];

    function TabletDetailController($scope, $rootScope, $stateParams, previousState, entity, Tablet) {
        var vm = this;

        vm.tablet = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('doctorclubboApp:tabletUpdate', function(event, result) {
            vm.tablet = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('TabletDeleteController',TabletDeleteController);

    TabletDeleteController.$inject = ['$uibModalInstance', 'entity', 'Tablet'];

    function TabletDeleteController($uibModalInstance, entity, Tablet) {
        var vm = this;

        vm.tablet = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Tablet.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('tablet', {
            parent: 'entity',
            url: '/tablet',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.tablet.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/tablet/tablets.html',
                    controller: 'TabletController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tablet');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('tablet-detail', {
            parent: 'entity',
            url: '/tablet/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.tablet.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/tablet/tablet-detail.html',
                    controller: 'TabletDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tablet');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Tablet', function($stateParams, Tablet) {
                    return Tablet.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'tablet',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('tablet-detail.edit', {
            parent: 'tablet-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tablet/tablet-dialog.html',
                    controller: 'TabletDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Tablet', function(Tablet) {
                            return Tablet.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('tablet.new', {
            parent: 'tablet',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tablet/tablet-dialog.html',
                    controller: 'TabletDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                tablet: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('tablet', null, { reload: 'tablet' });
                }, function() {
                    $state.go('tablet');
                });
            }]
        })
        .state('tablet.edit', {
            parent: 'tablet',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tablet/tablet-dialog.html',
                    controller: 'TabletDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Tablet', function(Tablet) {
                            return Tablet.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('tablet', null, { reload: 'tablet' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('tablet.delete', {
            parent: 'tablet',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tablet/tablet-delete-dialog.html',
                    controller: 'TabletDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Tablet', function(Tablet) {
                            return Tablet.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('tablet', null, { reload: 'tablet' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('doctorclubboApp')
        .factory('Tablet', Tablet);

    Tablet.$inject = ['$resource'];

    function Tablet ($resource) {
        var resourceUrl =  'api/tablets/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('TabletController', TabletController);

    TabletController.$inject = ['$scope', '$state', 'Tablet'];

    function TabletController ($scope, $state, Tablet) {
        var vm = this;

        vm.tablets = [];

        loadAll();

        function loadAll() {
            Tablet.query(function(result) {
                vm.tablets = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('StatementTypeDialogController', StatementTypeDialogController);

    StatementTypeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'StatementType'];

    function StatementTypeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, StatementType) {
        var vm = this;

        vm.statementType = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.statementType.id !== null) {
                StatementType.update(vm.statementType, onSaveSuccess, onSaveError);
            } else {
                StatementType.save(vm.statementType, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('doctorclubboApp:statementTypeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('StatementTypeDetailController', StatementTypeDetailController);

    StatementTypeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'StatementType'];

    function StatementTypeDetailController($scope, $rootScope, $stateParams, previousState, entity, StatementType) {
        var vm = this;

        vm.statementType = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('doctorclubboApp:statementTypeUpdate', function(event, result) {
            vm.statementType = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('StatementTypeDeleteController',StatementTypeDeleteController);

    StatementTypeDeleteController.$inject = ['$uibModalInstance', 'entity', 'StatementType'];

    function StatementTypeDeleteController($uibModalInstance, entity, StatementType) {
        var vm = this;

        vm.statementType = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            StatementType.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('statement-type', {
            parent: 'entity',
            url: '/statement-type',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.statementType.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/statement-type/statement-types.html',
                    controller: 'StatementTypeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('statementType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('statement-type-detail', {
            parent: 'entity',
            url: '/statement-type/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.statementType.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/statement-type/statement-type-detail.html',
                    controller: 'StatementTypeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('statementType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'StatementType', function($stateParams, StatementType) {
                    return StatementType.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'statement-type',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('statement-type-detail.edit', {
            parent: 'statement-type-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/statement-type/statement-type-dialog.html',
                    controller: 'StatementTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['StatementType', function(StatementType) {
                            return StatementType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('statement-type.new', {
            parent: 'statement-type',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/statement-type/statement-type-dialog.html',
                    controller: 'StatementTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                type: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('statement-type', null, { reload: 'statement-type' });
                }, function() {
                    $state.go('statement-type');
                });
            }]
        })
        .state('statement-type.edit', {
            parent: 'statement-type',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/statement-type/statement-type-dialog.html',
                    controller: 'StatementTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['StatementType', function(StatementType) {
                            return StatementType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('statement-type', null, { reload: 'statement-type' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('statement-type.delete', {
            parent: 'statement-type',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/statement-type/statement-type-delete-dialog.html',
                    controller: 'StatementTypeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['StatementType', function(StatementType) {
                            return StatementType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('statement-type', null, { reload: 'statement-type' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('doctorclubboApp')
        .factory('StatementType', StatementType);

    StatementType.$inject = ['$resource'];

    function StatementType ($resource) {
        var resourceUrl =  'api/statement-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('StatementTypeController', StatementTypeController);

    StatementTypeController.$inject = ['$scope', '$state', 'StatementType', 'ParseLinks', 'AlertService'];

    function StatementTypeController ($scope, $state, StatementType, ParseLinks, AlertService) {
        var vm = this;

        vm.statementTypes = [];
        vm.loadPage = loadPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;

        loadAll();

        function loadAll () {
            StatementType.query({
                page: vm.page,
                size: 20,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.statementTypes.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.statementTypes = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('StatementDialogController', StatementDialogController);

    StatementDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Statement', 'Utente', 'Queue', 'StatementType', 'Campagna', 'Agenzia', 'User'];

    function StatementDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Statement, Utente, Queue, StatementType, Campagna, Agenzia, User) {
        var vm = this;

        vm.statement = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.utentes = Utente.query();
        vm.queues = Queue.query();
        vm.statement_types = StatementType.query();
        vm.campagnas = Campagna.query();
        vm.agenzias = Agenzia.query();
        vm.jhi_users = User.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.statement.id !== null) {
                Statement.update(vm.statement, onSaveSuccess, onSaveError);
            } else {
                Statement.save(vm.statement, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('doctorclubboApp:statementUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.dtIns = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('StatementDetailController', StatementDetailController);

    StatementDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Statement', 'Utente', 'Queue', 'StatementType', 'Campagna', 'Agenzia', 'User'];

    function StatementDetailController($scope, $rootScope, $stateParams, previousState, entity, Statement, Utente, Queue, StatementType, Campagna, Agenzia, User) {
        var vm = this;

        vm.statement = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('doctorclubboApp:statementUpdate', function(event, result) {
            vm.statement = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('StatementDeleteController',StatementDeleteController);

    StatementDeleteController.$inject = ['$uibModalInstance', 'entity', 'Statement'];

    function StatementDeleteController($uibModalInstance, entity, Statement) {
        var vm = this;

        vm.statement = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Statement.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('statement', {
            parent: 'entity',
            url: '/statement?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.statement.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/statement/statements.html',
                    controller: 'StatementController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('statement');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('statement-detail', {
            parent: 'entity',
            url: '/statement/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.statement.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/statement/statement-detail.html',
                    controller: 'StatementDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('statement');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Statement', function($stateParams, Statement) {
                    return Statement.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'statement',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('statement-detail.edit', {
            parent: 'statement-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/statement/statement-dialog.html',
                    controller: 'StatementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Statement', function(Statement) {
                            return Statement.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('statement.new', {
            parent: 'statement',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/statement/statement-dialog.html',
                    controller: 'StatementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                dtIns: null,
                                amount: null,
                                idUser: null,
                                balance: null,
                                queueId: null,
                                description: null,
                                type: null,
                                sign: null,
                                externalRefId: null,
                                campaignId: null,
                                agencyId: null,
                                currency: null,
                                bo_user_id: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('statement', null, { reload: 'statement' });
                }, function() {
                    $state.go('statement');
                });
            }]
        })
        .state('statement.edit', {
            parent: 'statement',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/statement/statement-dialog.html',
                    controller: 'StatementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Statement', function(Statement) {
                            return Statement.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('statement', null, { reload: 'statement' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('statement.delete', {
            parent: 'statement',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/statement/statement-delete-dialog.html',
                    controller: 'StatementDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Statement', function(Statement) {
                            return Statement.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('statement', null, { reload: 'statement' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('doctorclubboApp')
        .factory('Statement', Statement);

    Statement.$inject = ['$resource', 'DateUtils'];

    function Statement ($resource, DateUtils) {
        var resourceUrl =  'api/statements/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dtIns = DateUtils.convertDateTimeFromServer(data.dtIns);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('StatementController', StatementController);

    StatementController.$inject = ['$scope', '$state', 'Statement', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function StatementController ($scope, $state, Statement, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            Statement.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.statements = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('SpecializzazioneDialogController', SpecializzazioneDialogController);

    SpecializzazioneDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Specializzazione'];

    function SpecializzazioneDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Specializzazione) {
        var vm = this;

        vm.specializzazione = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.specializzazione.id !== null) {
                Specializzazione.update(vm.specializzazione, onSaveSuccess, onSaveError);
            } else {
                Specializzazione.save(vm.specializzazione, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('doctorclubboApp:specializzazioneUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('SpecializzazioneDetailController', SpecializzazioneDetailController);

    SpecializzazioneDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Specializzazione'];

    function SpecializzazioneDetailController($scope, $rootScope, $stateParams, previousState, entity, Specializzazione) {
        var vm = this;

        vm.specializzazione = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('doctorclubboApp:specializzazioneUpdate', function(event, result) {
            vm.specializzazione = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('SpecializzazioneDeleteController',SpecializzazioneDeleteController);

    SpecializzazioneDeleteController.$inject = ['$uibModalInstance', 'entity', 'Specializzazione'];

    function SpecializzazioneDeleteController($uibModalInstance, entity, Specializzazione) {
        var vm = this;

        vm.specializzazione = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Specializzazione.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('specializzazione', {
            parent: 'entity',
            url: '/specializzazione',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.specializzazione.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/specializzazione/specializzaziones.html',
                    controller: 'SpecializzazioneController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('specializzazione');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('specializzazione-detail', {
            parent: 'entity',
            url: '/specializzazione/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.specializzazione.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/specializzazione/specializzazione-detail.html',
                    controller: 'SpecializzazioneDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('specializzazione');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Specializzazione', function($stateParams, Specializzazione) {
                    return Specializzazione.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'specializzazione',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('specializzazione-detail.edit', {
            parent: 'specializzazione-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/specializzazione/specializzazione-dialog.html',
                    controller: 'SpecializzazioneDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Specializzazione', function(Specializzazione) {
                            return Specializzazione.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('specializzazione.new', {
            parent: 'specializzazione',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/specializzazione/specializzazione-dialog.html',
                    controller: 'SpecializzazioneDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nome: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('specializzazione', null, { reload: 'specializzazione' });
                }, function() {
                    $state.go('specializzazione');
                });
            }]
        })
        .state('specializzazione.edit', {
            parent: 'specializzazione',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/specializzazione/specializzazione-dialog.html',
                    controller: 'SpecializzazioneDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Specializzazione', function(Specializzazione) {
                            return Specializzazione.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('specializzazione', null, { reload: 'specializzazione' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('specializzazione.delete', {
            parent: 'specializzazione',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/specializzazione/specializzazione-delete-dialog.html',
                    controller: 'SpecializzazioneDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Specializzazione', function(Specializzazione) {
                            return Specializzazione.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('specializzazione', null, { reload: 'specializzazione' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('doctorclubboApp')
        .factory('Specializzazione', Specializzazione);

    Specializzazione.$inject = ['$resource'];

    function Specializzazione ($resource) {
        var resourceUrl =  'api/specializzaziones/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('SpecializzazioneController', SpecializzazioneController);

    SpecializzazioneController.$inject = ['$scope', '$state', 'Specializzazione', 'ParseLinks', 'AlertService'];

    function SpecializzazioneController ($scope, $state, Specializzazione, ParseLinks, AlertService) {
        var vm = this;

        vm.specializzaziones = [];
        vm.loadPage = loadPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;

        loadAll();

        function loadAll () {
            Specializzazione.query({
                page: vm.page,
                size: 20,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.specializzaziones.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.specializzaziones = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('SistemaDialogController', SistemaDialogController);

    SistemaDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Sistema'];

    function SistemaDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Sistema) {
        var vm = this;

        vm.sistema = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.sistema.id !== null) {
                Sistema.update(vm.sistema, onSaveSuccess, onSaveError);
            } else {
                Sistema.save(vm.sistema, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('doctorclubboApp:sistemaUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('SistemaDetailController', SistemaDetailController);

    SistemaDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Sistema'];

    function SistemaDetailController($scope, $rootScope, $stateParams, previousState, entity, Sistema) {
        var vm = this;

        vm.sistema = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('doctorclubboApp:sistemaUpdate', function(event, result) {
            vm.sistema = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('SistemaDeleteController',SistemaDeleteController);

    SistemaDeleteController.$inject = ['$uibModalInstance', 'entity', 'Sistema'];

    function SistemaDeleteController($uibModalInstance, entity, Sistema) {
        var vm = this;

        vm.sistema = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Sistema.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('sistema', {
            parent: 'entity',
            url: '/sistema',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.sistema.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/sistema/sistemas.html',
                    controller: 'SistemaController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('sistema');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('sistema-detail', {
            parent: 'entity',
            url: '/sistema/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.sistema.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/sistema/sistema-detail.html',
                    controller: 'SistemaDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('sistema');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Sistema', function($stateParams, Sistema) {
                    return Sistema.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'sistema',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('sistema-detail.edit', {
            parent: 'sistema-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sistema/sistema-dialog.html',
                    controller: 'SistemaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Sistema', function(Sistema) {
                            return Sistema.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('sistema.new', {
            parent: 'sistema',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sistema/sistema-dialog.html',
                    controller: 'SistemaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nome: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('sistema', null, { reload: 'sistema' });
                }, function() {
                    $state.go('sistema');
                });
            }]
        })
        .state('sistema.edit', {
            parent: 'sistema',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sistema/sistema-dialog.html',
                    controller: 'SistemaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Sistema', function(Sistema) {
                            return Sistema.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('sistema', null, { reload: 'sistema' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('sistema.delete', {
            parent: 'sistema',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sistema/sistema-delete-dialog.html',
                    controller: 'SistemaDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Sistema', function(Sistema) {
                            return Sistema.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('sistema', null, { reload: 'sistema' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('doctorclubboApp')
        .factory('Sistema', Sistema);

    Sistema.$inject = ['$resource'];

    function Sistema ($resource) {
        var resourceUrl =  'api/sistemas/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('SistemaController', SistemaController);

    SistemaController.$inject = ['$scope', '$state', 'Sistema'];

    function SistemaController ($scope, $state, Sistema) {
        var vm = this;

        vm.sistemas = [];

        loadAll();

        function loadAll() {
            Sistema.query(function(result) {
                vm.sistemas = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('Recall_statusDialogController', Recall_statusDialogController);

    Recall_statusDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Recall_status'];

    function Recall_statusDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Recall_status) {
        var vm = this;

        vm.recall_status = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.recall_status.id !== null) {
                Recall_status.update(vm.recall_status, onSaveSuccess, onSaveError);
            } else {
                Recall_status.save(vm.recall_status, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('doctorclubboApp:recall_statusUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('Recall_statusDetailController', Recall_statusDetailController);

    Recall_statusDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Recall_status'];

    function Recall_statusDetailController($scope, $rootScope, $stateParams, previousState, entity, Recall_status) {
        var vm = this;

        vm.recall_status = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('doctorclubboApp:recall_statusUpdate', function(event, result) {
            vm.recall_status = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('Recall_statusDeleteController',Recall_statusDeleteController);

    Recall_statusDeleteController.$inject = ['$uibModalInstance', 'entity', 'Recall_status'];

    function Recall_statusDeleteController($uibModalInstance, entity, Recall_status) {
        var vm = this;

        vm.recall_status = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Recall_status.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('recall-status', {
            parent: 'entity',
            url: '/recall-status',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.recall_status.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/recall-status/recall-statuses.html',
                    controller: 'Recall_statusController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('recall_status');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('recall-status-detail', {
            parent: 'entity',
            url: '/recall-status/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.recall_status.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/recall-status/recall-status-detail.html',
                    controller: 'Recall_statusDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('recall_status');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Recall_status', function($stateParams, Recall_status) {
                    return Recall_status.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'recall-status',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('recall-status-detail.edit', {
            parent: 'recall-status-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/recall-status/recall-status-dialog.html',
                    controller: 'Recall_statusDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Recall_status', function(Recall_status) {
                            return Recall_status.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('recall-status.new', {
            parent: 'recall-status',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/recall-status/recall-status-dialog.html',
                    controller: 'Recall_statusDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                code: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('recall-status', null, { reload: 'recall-status' });
                }, function() {
                    $state.go('recall-status');
                });
            }]
        })
        .state('recall-status.edit', {
            parent: 'recall-status',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/recall-status/recall-status-dialog.html',
                    controller: 'Recall_statusDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Recall_status', function(Recall_status) {
                            return Recall_status.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('recall-status', null, { reload: 'recall-status' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('recall-status.delete', {
            parent: 'recall-status',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/recall-status/recall-status-delete-dialog.html',
                    controller: 'Recall_statusDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Recall_status', function(Recall_status) {
                            return Recall_status.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('recall-status', null, { reload: 'recall-status' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('doctorclubboApp')
        .factory('Recall_status', Recall_status);

    Recall_status.$inject = ['$resource'];

    function Recall_status ($resource) {
        var resourceUrl =  'api/recall-statuses/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('Recall_statusController', Recall_statusController);

    Recall_statusController.$inject = ['$scope', '$state', 'Recall_status'];

    function Recall_statusController ($scope, $state, Recall_status) {
        var vm = this;

        vm.recall_statuses = [];

        loadAll();

        function loadAll() {
            Recall_status.query(function(result) {
                vm.recall_statuses = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('RaciDialogController', RaciDialogController);

    RaciDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Raci', 'Area', 'Azione', 'CampagnaStatus'];

    function RaciDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Raci, Area, Azione, CampagnaStatus) {
        var vm = this;

        vm.raci = entity;
        vm.clear = clear;
        vm.save = save;
        vm.areas = Area.query();
        vm.aziones = Azione.query();
        vm.campagna_statuses = CampagnaStatus.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.raci.id !== null) {
                Raci.update(vm.raci, onSaveSuccess, onSaveError);
            } else {
                Raci.save(vm.raci, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('doctorclubboApp:raciUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('RaciDetailController', RaciDetailController);

    RaciDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Raci', 'Area', 'Azione', 'CampagnaStatus'];

    function RaciDetailController($scope, $rootScope, $stateParams, previousState, entity, Raci, Area, Azione, CampagnaStatus) {
        var vm = this;

        vm.raci = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('doctorclubboApp:raciUpdate', function(event, result) {
            vm.raci = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('RaciDeleteController',RaciDeleteController);

    RaciDeleteController.$inject = ['$uibModalInstance', 'entity', 'Raci'];

    function RaciDeleteController($uibModalInstance, entity, Raci) {
        var vm = this;

        vm.raci = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Raci.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('raci', {
            parent: 'entity',
            url: '/raci?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.raci.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/raci/racis.html',
                    controller: 'RaciController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('raci');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('raci-detail', {
            parent: 'raci',
            url: '/raci/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.raci.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/raci/raci-detail.html',
                    controller: 'RaciDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('raci');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Raci', function($stateParams, Raci) {
                    return Raci.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'raci',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('raci-detail.edit', {
            parent: 'raci-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/raci/raci-dialog.html',
                    controller: 'RaciDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Raci', function(Raci) {
                            return Raci.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('raci.new', {
            parent: 'raci',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/raci/raci-dialog.html',
                    controller: 'RaciDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                ruolo: null,
                                destinatario: null,
                                contenuto: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('raci', null, { reload: 'raci' });
                }, function() {
                    $state.go('raci');
                });
            }]
        })
        .state('raci.edit', {
            parent: 'raci',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/raci/raci-dialog.html',
                    controller: 'RaciDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Raci', function(Raci) {
                            return Raci.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('raci', null, { reload: 'raci' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('raci.delete', {
            parent: 'raci',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/raci/raci-delete-dialog.html',
                    controller: 'RaciDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Raci', function(Raci) {
                            return Raci.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('raci', null, { reload: 'raci' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('doctorclubboApp')
        .factory('Raci', Raci);

    Raci.$inject = ['$resource'];

    function Raci ($resource) {
        var resourceUrl =  'api/racis/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('RaciController', RaciController);

    RaciController.$inject = ['$state', 'Raci', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function RaciController($state, Raci, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            Raci.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.racis = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('QueueTypeDialogController', QueueTypeDialogController);

    QueueTypeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'QueueType'];

    function QueueTypeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, QueueType) {
        var vm = this;

        vm.queueType = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.queueType.id !== null) {
                QueueType.update(vm.queueType, onSaveSuccess, onSaveError);
            } else {
                QueueType.save(vm.queueType, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('doctorclubboApp:queueTypeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('QueueTypeDetailController', QueueTypeDetailController);

    QueueTypeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'QueueType'];

    function QueueTypeDetailController($scope, $rootScope, $stateParams, previousState, entity, QueueType) {
        var vm = this;

        vm.queueType = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('doctorclubboApp:queueTypeUpdate', function(event, result) {
            vm.queueType = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('QueueTypeDeleteController',QueueTypeDeleteController);

    QueueTypeDeleteController.$inject = ['$uibModalInstance', 'entity', 'QueueType'];

    function QueueTypeDeleteController($uibModalInstance, entity, QueueType) {
        var vm = this;

        vm.queueType = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            QueueType.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('queue-type', {
            parent: 'entity',
            url: '/queue-type',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.queueType.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/queue-type/queue-types.html',
                    controller: 'QueueTypeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('queueType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('queue-type-detail', {
            parent: 'entity',
            url: '/queue-type/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.queueType.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/queue-type/queue-type-detail.html',
                    controller: 'QueueTypeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('queueType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'QueueType', function($stateParams, QueueType) {
                    return QueueType.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'queue-type',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('queue-type-detail.edit', {
            parent: 'queue-type-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/queue-type/queue-type-dialog.html',
                    controller: 'QueueTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['QueueType', function(QueueType) {
                            return QueueType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('queue-type.new', {
            parent: 'queue-type',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/queue-type/queue-type-dialog.html',
                    controller: 'QueueTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                type: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('queue-type', null, { reload: 'queue-type' });
                }, function() {
                    $state.go('queue-type');
                });
            }]
        })
        .state('queue-type.edit', {
            parent: 'queue-type',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/queue-type/queue-type-dialog.html',
                    controller: 'QueueTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['QueueType', function(QueueType) {
                            return QueueType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('queue-type', null, { reload: 'queue-type' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('queue-type.delete', {
            parent: 'queue-type',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/queue-type/queue-type-delete-dialog.html',
                    controller: 'QueueTypeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['QueueType', function(QueueType) {
                            return QueueType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('queue-type', null, { reload: 'queue-type' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('doctorclubboApp')
        .factory('QueueType', QueueType);

    QueueType.$inject = ['$resource'];

    function QueueType ($resource) {
        var resourceUrl =  'api/queue-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('QueueTypeController', QueueTypeController);

    QueueTypeController.$inject = ['$scope', '$state', 'QueueType', 'ParseLinks', 'AlertService'];

    function QueueTypeController ($scope, $state, QueueType, ParseLinks, AlertService) {
        var vm = this;

        vm.queueTypes = [];
        vm.loadPage = loadPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;

        loadAll();

        function loadAll () {
            QueueType.query({
                page: vm.page,
                size: 20,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.queueTypes.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.queueTypes = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('QueueStatusDialogController', QueueStatusDialogController);

    QueueStatusDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'QueueStatus'];

    function QueueStatusDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, QueueStatus) {
        var vm = this;

        vm.queueStatus = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.queueStatus.id !== null) {
                QueueStatus.update(vm.queueStatus, onSaveSuccess, onSaveError);
            } else {
                QueueStatus.save(vm.queueStatus, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('doctorclubboApp:queueStatusUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('QueueStatusDetailController', QueueStatusDetailController);

    QueueStatusDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'QueueStatus'];

    function QueueStatusDetailController($scope, $rootScope, $stateParams, previousState, entity, QueueStatus) {
        var vm = this;

        vm.queueStatus = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('doctorclubboApp:queueStatusUpdate', function(event, result) {
            vm.queueStatus = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('QueueStatusDeleteController',QueueStatusDeleteController);

    QueueStatusDeleteController.$inject = ['$uibModalInstance', 'entity', 'QueueStatus'];

    function QueueStatusDeleteController($uibModalInstance, entity, QueueStatus) {
        var vm = this;

        vm.queueStatus = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            QueueStatus.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('queue-status', {
            parent: 'entity',
            url: '/queue-status',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.queueStatus.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/queue-status/queue-statuses.html',
                    controller: 'QueueStatusController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('queueStatus');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('queue-status-detail', {
            parent: 'entity',
            url: '/queue-status/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.queueStatus.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/queue-status/queue-status-detail.html',
                    controller: 'QueueStatusDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('queueStatus');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'QueueStatus', function($stateParams, QueueStatus) {
                    return QueueStatus.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'queue-status',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('queue-status-detail.edit', {
            parent: 'queue-status-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/queue-status/queue-status-dialog.html',
                    controller: 'QueueStatusDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['QueueStatus', function(QueueStatus) {
                            return QueueStatus.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('queue-status.new', {
            parent: 'queue-status',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/queue-status/queue-status-dialog.html',
                    controller: 'QueueStatusDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                status: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('queue-status', null, { reload: 'queue-status' });
                }, function() {
                    $state.go('queue-status');
                });
            }]
        })
        .state('queue-status.edit', {
            parent: 'queue-status',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/queue-status/queue-status-dialog.html',
                    controller: 'QueueStatusDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['QueueStatus', function(QueueStatus) {
                            return QueueStatus.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('queue-status', null, { reload: 'queue-status' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('queue-status.delete', {
            parent: 'queue-status',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/queue-status/queue-status-delete-dialog.html',
                    controller: 'QueueStatusDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['QueueStatus', function(QueueStatus) {
                            return QueueStatus.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('queue-status', null, { reload: 'queue-status' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('doctorclubboApp')
        .factory('QueueStatus', QueueStatus);

    QueueStatus.$inject = ['$resource'];

    function QueueStatus ($resource) {
        var resourceUrl =  'api/queue-statuses/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('QueueStatusController', QueueStatusController);

    QueueStatusController.$inject = ['$scope', '$state', 'QueueStatus', 'ParseLinks', 'AlertService'];

    function QueueStatusController ($scope, $state, QueueStatus, ParseLinks, AlertService) {
        var vm = this;

        vm.queueStatuses = [];
        vm.loadPage = loadPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;

        loadAll();

        function loadAll () {
            QueueStatus.query({
                page: vm.page,
                size: 20,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.queueStatuses.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.queueStatuses = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('Queue_scheduledDialogController', Queue_scheduledDialogController);

    Queue_scheduledDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Queue_scheduled', 'Qsched_direction', 'Qsched_status', 'Qsched_type'];

    function Queue_scheduledDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Queue_scheduled, Qsched_direction, Qsched_status, Qsched_type) {
        var vm = this;

        vm.queue_scheduled = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.qsched_directions = Qsched_direction.query();
        vm.qsched_statuses = Qsched_status.query();
        vm.qsched_types = Qsched_type.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.queue_scheduled.id !== null) {
                Queue_scheduled.update(vm.queue_scheduled, onSaveSuccess, onSaveError);
            } else {
                Queue_scheduled.save(vm.queue_scheduled, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('doctorclubboApp:queue_scheduledUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.dt_ins = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('Queue_scheduledDetailController', Queue_scheduledDetailController);

    Queue_scheduledDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Queue_scheduled', 'Qsched_direction', 'Qsched_status', 'Qsched_type'];

    function Queue_scheduledDetailController($scope, $rootScope, $stateParams, previousState, entity, Queue_scheduled, Qsched_direction, Qsched_status, Qsched_type) {
        var vm = this;

        vm.queue_scheduled = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('doctorclubboApp:queue_scheduledUpdate', function(event, result) {
            vm.queue_scheduled = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('Queue_scheduledDeleteController',Queue_scheduledDeleteController);

    Queue_scheduledDeleteController.$inject = ['$uibModalInstance', 'entity', 'Queue_scheduled'];

    function Queue_scheduledDeleteController($uibModalInstance, entity, Queue_scheduled) {
        var vm = this;

        vm.queue_scheduled = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Queue_scheduled.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('queue-scheduled', {
            parent: 'entity',
            url: '/queue-scheduled?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.queue_scheduled.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/queue-scheduled/queue-scheduleds.html',
                    controller: 'Queue_scheduledController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('queue_scheduled');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('queue-scheduled-detail', {
            parent: 'entity',
            url: '/queue-scheduled/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.queue_scheduled.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/queue-scheduled/queue-scheduled-detail.html',
                    controller: 'Queue_scheduledDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('queue_scheduled');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Queue_scheduled', function($stateParams, Queue_scheduled) {
                    return Queue_scheduled.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'queue-scheduled',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('queue-scheduled-detail.edit', {
            parent: 'queue-scheduled-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/queue-scheduled/queue-scheduled-dialog.html',
                    controller: 'Queue_scheduledDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Queue_scheduled', function(Queue_scheduled) {
                            return Queue_scheduled.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('queue-scheduled.new', {
            parent: 'queue-scheduled',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/queue-scheduled/queue-scheduled-dialog.html',
                    controller: 'Queue_scheduledDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                dt_ins: null,
                                queue_content: null,
                                ext_id: null, 
                                int_id: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('queue-scheduled', null, { reload: 'queue-scheduled' });
                }, function() {
                    $state.go('queue-scheduled');
                });
            }]
        })
        .state('queue-scheduled.edit', {
            parent: 'queue-scheduled',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/queue-scheduled/queue-scheduled-dialog.html',
                    controller: 'Queue_scheduledDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Queue_scheduled', function(Queue_scheduled) {
                            return Queue_scheduled.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('queue-scheduled', null, { reload: 'queue-scheduled' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('queue-scheduled.delete', {
            parent: 'queue-scheduled',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/queue-scheduled/queue-scheduled-delete-dialog.html',
                    controller: 'Queue_scheduledDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Queue_scheduled', function(Queue_scheduled) {
                            return Queue_scheduled.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('queue-scheduled', null, { reload: 'queue-scheduled' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('doctorclubboApp')
        .factory('Queue_scheduled', Queue_scheduled);

    Queue_scheduled.$inject = ['$resource', 'DateUtils'];

    function Queue_scheduled ($resource, DateUtils) {
        var resourceUrl =  'api/queue-scheduleds/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dt_ins = DateUtils.convertDateTimeFromServer(data.dt_ins);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('Queue_scheduledController', Queue_scheduledController);

    Queue_scheduledController.$inject = ['$scope', '$state', 'Queue_scheduled', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function Queue_scheduledController ($scope, $state, Queue_scheduled, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            Queue_scheduled.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.queue_scheduleds = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('Queue_creditDialogController', Queue_creditDialogController);

    Queue_creditDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Queue_credit'];

    function Queue_creditDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Queue_credit) {
        var vm = this;

        vm.queue_credit = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.queue_credit.id !== null) {
                Queue_credit.update(vm.queue_credit, onSaveSuccess, onSaveError);
            } else {
                Queue_credit.save(vm.queue_credit, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('doctorclubboApp:queue_creditUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('Queue_creditDetailController', Queue_creditDetailController);

    Queue_creditDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Queue_credit'];

    function Queue_creditDetailController($scope, $rootScope, $stateParams, previousState, entity, Queue_credit) {
        var vm = this;

        vm.queue_credit = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('doctorclubboApp:queue_creditUpdate', function(event, result) {
            vm.queue_credit = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('Queue_creditDeleteController',Queue_creditDeleteController);

    Queue_creditDeleteController.$inject = ['$uibModalInstance', 'entity', 'Queue_credit'];

    function Queue_creditDeleteController($uibModalInstance, entity, Queue_credit) {
        var vm = this;

        vm.queue_credit = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Queue_credit.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('queue-credit', {
            parent: 'entity',
            url: '/queue-credit?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.queue_credit.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/queue-credit/queue-credits.html',
                    controller: 'Queue_creditController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('queue_credit');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('queue-credit-detail', {
            parent: 'entity',
            url: '/queue-credit/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.queue_credit.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/queue-credit/queue-credit-detail.html',
                    controller: 'Queue_creditDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('queue_credit');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Queue_credit', function($stateParams, Queue_credit) {
                    return Queue_credit.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'queue-credit',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('queue-credit-detail.edit', {
            parent: 'queue-credit-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/queue-credit/queue-credit-dialog.html',
                    controller: 'Queue_creditDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Queue_credit', function(Queue_credit) {
                            return Queue_credit.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('queue-credit.new', {
            parent: 'queue-credit',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/queue-credit/queue-credit-dialog.html',
                    controller: 'Queue_creditDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                customer_email: null,
                                credit_value: null,
                                comment: null,
                                id_queue: null,
                                campagna: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('queue-credit', null, { reload: 'queue-credit' });
                }, function() {
                    $state.go('queue-credit');
                });
            }]
        })
        .state('queue-credit.edit', {
            parent: 'queue-credit',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/queue-credit/queue-credit-dialog.html',
                    controller: 'Queue_creditDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Queue_credit', function(Queue_credit) {
                            return Queue_credit.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('queue-credit', null, { reload: 'queue-credit' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('queue-credit.delete', {
            parent: 'queue-credit',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/queue-credit/queue-credit-delete-dialog.html',
                    controller: 'Queue_creditDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Queue_credit', function(Queue_credit) {
                            return Queue_credit.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('queue-credit', null, { reload: 'queue-credit' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('doctorclubboApp')
        .factory('Queue_credit', Queue_credit);

    Queue_credit.$inject = ['$resource'];

    function Queue_credit ($resource) {
        var resourceUrl =  'api/queue-credits/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('Queue_creditController', Queue_creditController);

    Queue_creditController.$inject = ['$scope', '$state', 'Queue_credit', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function Queue_creditController ($scope, $state, Queue_credit, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            Queue_credit.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.queue_credits = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('QueueAccountDialogController', QueueAccountDialogController);

    QueueAccountDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'QueueAccount'];

    function QueueAccountDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, QueueAccount) {
        var vm = this;

        vm.queueAccount = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.queueAccount.id !== null) {
                QueueAccount.update(vm.queueAccount, onSaveSuccess, onSaveError);
            } else {
                QueueAccount.save(vm.queueAccount, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('doctorclubboApp:queueAccountUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.dtNascita = false;
        vm.datePickerOpenStatus.dtIns = false;
        vm.datePickerOpenStatus.dtUpdate = false;
        vm.datePickerOpenStatus.recallDt = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('QueueAccountDetailController', QueueAccountDetailController);

    QueueAccountDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'QueueAccount'];

    function QueueAccountDetailController($scope, $rootScope, $stateParams, previousState, entity, QueueAccount) {
        var vm = this;

        vm.queueAccount = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('doctorclubboApp:queueAccountUpdate', function(event, result) {
            vm.queueAccount = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('QueueAccountDeleteController',QueueAccountDeleteController);

    QueueAccountDeleteController.$inject = ['$uibModalInstance', 'entity', 'QueueAccount'];

    function QueueAccountDeleteController($uibModalInstance, entity, QueueAccount) {
        var vm = this;

        vm.queueAccount = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            QueueAccount.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('queue-account', {
            parent: 'entity',
            url: '/queue-account?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.queueAccount.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/queue-account/queue-accounts.html',
                    controller: 'QueueAccountController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('queueAccount');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('queue-account-detail', {
            parent: 'entity',
            url: '/queue-account/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.queueAccount.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/queue-account/queue-account-detail.html',
                    controller: 'QueueAccountDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('queueAccount');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'QueueAccount', function($stateParams, QueueAccount) {
                    return QueueAccount.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'queue-account',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('queue-account-detail.edit', {
            parent: 'queue-account-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/queue-account/queue-account-dialog.html',
                    controller: 'QueueAccountDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['QueueAccount', function(QueueAccount) {
                            return QueueAccount.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('queue-account.new', {
            parent: 'queue-account',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/queue-account/queue-account-dialog.html',
                    controller: 'QueueAccountDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nome: null,
                                cognome: null,
                                cf: null,
                                dtNascita: null,
                                numIscrizione: null,
                                telefono: null,
                                cellulare: null,
                                fax: null,
                                email: null,
                                email2: null,
                                attivita: null,
                                precontattogg: null,
                                precontattoOrario1: null,
                                precontattoOrario2: null,
                                ricerchegg: null,
                                ricercheOrario: null,
                                isfgg: null,
                                isfOrario: null,
                                note: null,
                                dispositivo: null,
                                dispositivoOs: null,
                                tablet: null,
                                tabletOs: null,
                                tv: null,
                                canaliTv: null,
                                comune: null,
                                cap: null,
                                indirizzo: null,
                                dtIns: null,
                                dtUpdate: null,
                                recallStatus: null,
                                statusNote: null,
                                recallDt: null,
                                spedizioneComune: null,
                                spedizioneCap: null,
                                spedizioneIndirizzo: null,
                                spedizioneTel: null,
                                source: null,
                                specializzazione1: null,
                                specializzazione2: null,
                                specializzazione3: null,
                                provincia: null,
                                spedizioneProv: null,
                                idQueue: null,
                                error_list: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('queue-account', null, { reload: 'queue-account' });
                }, function() {
                    $state.go('queue-account');
                });
            }]
        })
        .state('queue-account.edit', {
            parent: 'queue-account',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/queue-account/queue-account-dialog.html',
                    controller: 'QueueAccountDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['QueueAccount', function(QueueAccount) {
                            return QueueAccount.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('queue-account', null, { reload: 'queue-account' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('queue-account.delete', {
            parent: 'queue-account',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/queue-account/queue-account-delete-dialog.html',
                    controller: 'QueueAccountDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['QueueAccount', function(QueueAccount) {
                            return QueueAccount.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('queue-account', null, { reload: 'queue-account' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('doctorclubboApp')
        .factory('QueueAccount', QueueAccount);

    QueueAccount.$inject = ['$resource', 'DateUtils'];

    function QueueAccount ($resource, DateUtils) {
        var resourceUrl =  'api/queue-accounts/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dtNascita = DateUtils.convertDateTimeFromServer(data.dtNascita);
                        data.dtIns = DateUtils.convertDateTimeFromServer(data.dtIns);
                        data.dtUpdate = DateUtils.convertDateTimeFromServer(data.dtUpdate);
                        data.recallDt = DateUtils.convertDateTimeFromServer(data.recallDt);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('QueueAccountController', QueueAccountController);

    QueueAccountController.$inject = ['$scope', '$state', 'QueueAccount', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function QueueAccountController ($scope, $state, QueueAccount, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            QueueAccount.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.queueAccounts = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('QueueProcessController',QueueProcessController);

    QueueProcessController.$inject = ['$uibModalInstance', 'entity', 'Queue'];

    function QueueProcessController($uibModalInstance, entity, Queue) {
        var vm = this;

        vm.queue = entity;
        vm.clear = clear;
        vm.confirmProcess = confirmProcess;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmProcess (id) {       	
        	
        	 Queue.process({id: id},
                     function () {
                         $uibModalInstance.close(true);
                     });
        }
        function onSaveSuccess (result) {
            $scope.$emit('doctorclubboApp:queueProcess', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
        
        
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('QueueImportController',QueueImportController);

    QueueImportController.$inject = ['$uibModalInstance', 'entity', 'Queue'];

    function QueueImportController($uibModalInstance, entity, Queue) {
        var vm = this;

        vm.queue = entity;
        vm.clear = clear;
        vm.confirmImport = confirmImport;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmImport (id) {       	
        	
        	 Queue.import({id: id},
                     function () {
                         $uibModalInstance.close(true);
                     });
        }
        function onSaveSuccess (result) {
            $scope.$emit('doctorclubboApp:queueImport', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
        
        
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('QueueDialogController', QueueDialogController);


    QueueDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Queue', 'QueueStatus', 'QueueType', 'User'];

    function QueueDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Queue, QueueStatus, QueueType, User) {

        var vm = this;

        vm.queue = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        vm.queue_statuses = QueueStatus.query();
        vm.queue_types = QueueType.query();
        vm.jhi_users = User.query();


        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.queue.id !== null) {
                Queue.update(vm.queue, onSaveSuccess, onSaveError);
            } else {
                Queue.save(vm.queue, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('doctorclubboApp:queueUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.dtIns = false;
        vm.datePickerOpenStatus.dtUpdate = false;
        vm.datePickerOpenStatus.dtFirstExecution = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('QueueDetailController', QueueDetailController);


    QueueDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Queue', 'QueueStatus', 'QueueType', 'User'];

    function QueueDetailController($scope, $rootScope, $stateParams, previousState, entity, Queue, QueueStatus, QueueType, User) {

        var vm = this;

        vm.queue = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('doctorclubboApp:queueUpdate', function(event, result) {
            vm.queue = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('QueueDeleteController',QueueDeleteController);

    QueueDeleteController.$inject = ['$uibModalInstance', 'entity', 'Queue'];

    function QueueDeleteController($uibModalInstance, entity, Queue) {
        var vm = this;

        vm.queue = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Queue.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('queue', {
            parent: 'entity',
            url: '/queue?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.queue.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/queue/queues.html',
                    controller: 'QueueController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('queue');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('queue-detail', {
            parent: 'entity',
            url: '/queue/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.queue.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/queue/queue-detail.html',
                    controller: 'QueueDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('queue');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Queue', function($stateParams, Queue) {
                    return Queue.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'queue',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('queue-detail.edit', {
            parent: 'queue-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/queue/queue-dialog.html',
                    controller: 'QueueDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Queue', function(Queue) {
                            return Queue.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('queue.new', {
            parent: 'queue',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/queue/queue-dialog.html',
                    controller: 'QueueDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                dtIns: null,
                                type: null,
                                status: null,
                                dtUpdate: null,
                                name: null,
                                dtFirstExecution: null,
                                userInsert: null,
                                userFirstExec: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('queue', null, { reload: 'queue' });
                }, function() {
                    $state.go('queue');
                });
            }]
        })
        .state('queue.edit', {
            parent: 'queue',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/queue/queue-dialog.html',
                    controller: 'QueueDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Queue', function(Queue) {
                            return Queue.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('queue', null, { reload: 'queue' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('queue.delete', {
            parent: 'queue',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/queue/queue-delete-dialog.html',
                    controller: 'QueueDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Queue', function(Queue) {
                            return Queue.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('queue', null, { reload: 'queue' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('queue.import', {
            parent: 'queue',
            url:  '/{id}/import',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/queue/queue-import.html',
                    controller: 'QueueImportController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Queue', function(Queue) {
                            return Queue.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('queue', null, { reload: 'queue' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('queue.process', {
            parent: 'queue',
            url:  '/{id}/process',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/queue/queue-process.html',
                    controller: 'QueueProcessController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Queue', function(Queue) {
                            return Queue.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('queue', null, { reload: 'queue' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('doctorclubboApp')
        .factory('Queue', Queue);

    Queue.$inject = ['$resource', 'DateUtils'];

    function Queue ($resource, DateUtils) {
        var resourceUrl =  'api/queues/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dtIns = DateUtils.convertDateTimeFromServer(data.dtIns);
                        data.dtUpdate = DateUtils.convertDateTimeFromServer(data.dtUpdate);
                        data.dtFirstExecution = DateUtils.convertDateTimeFromServer(data.dtFirstExecution);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'import': { method:'POST', isArray:false, url:'api/queues/import' , params: {id: '@id'}},
            'process': { method:'POST', isArray:false, url:'api/queues/process', params: {id: '@id'} }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('QueueController', QueueController);

    QueueController.$inject = ['$scope', '$state', 'Queue', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function QueueController ($scope, $state, Queue, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            Queue.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.queues = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('Qsched_typeDialogController', Qsched_typeDialogController);

    Qsched_typeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Qsched_type'];

    function Qsched_typeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Qsched_type) {
        var vm = this;

        vm.qsched_type = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.qsched_type.id !== null) {
                Qsched_type.update(vm.qsched_type, onSaveSuccess, onSaveError);
            } else {
                Qsched_type.save(vm.qsched_type, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('doctorclubboApp:qsched_typeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('Qsched_typeDetailController', Qsched_typeDetailController);

    Qsched_typeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Qsched_type'];

    function Qsched_typeDetailController($scope, $rootScope, $stateParams, previousState, entity, Qsched_type) {
        var vm = this;

        vm.qsched_type = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('doctorclubboApp:qsched_typeUpdate', function(event, result) {
            vm.qsched_type = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('Qsched_typeDeleteController',Qsched_typeDeleteController);

    Qsched_typeDeleteController.$inject = ['$uibModalInstance', 'entity', 'Qsched_type'];

    function Qsched_typeDeleteController($uibModalInstance, entity, Qsched_type) {
        var vm = this;

        vm.qsched_type = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Qsched_type.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('qsched-type', {
            parent: 'entity',
            url: '/qsched-type',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.qsched_type.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/qsched-type/qsched-types.html',
                    controller: 'Qsched_typeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('qsched_type');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('qsched-type-detail', {
            parent: 'entity',
            url: '/qsched-type/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.qsched_type.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/qsched-type/qsched-type-detail.html',
                    controller: 'Qsched_typeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('qsched_type');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Qsched_type', function($stateParams, Qsched_type) {
                    return Qsched_type.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'qsched-type',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('qsched-type-detail.edit', {
            parent: 'qsched-type-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/qsched-type/qsched-type-dialog.html',
                    controller: 'Qsched_typeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Qsched_type', function(Qsched_type) {
                            return Qsched_type.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('qsched-type.new', {
            parent: 'qsched-type',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/qsched-type/qsched-type-dialog.html',
                    controller: 'Qsched_typeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('qsched-type', null, { reload: 'qsched-type' });
                }, function() {
                    $state.go('qsched-type');
                });
            }]
        })
        .state('qsched-type.edit', {
            parent: 'qsched-type',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/qsched-type/qsched-type-dialog.html',
                    controller: 'Qsched_typeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Qsched_type', function(Qsched_type) {
                            return Qsched_type.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('qsched-type', null, { reload: 'qsched-type' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('qsched-type.delete', {
            parent: 'qsched-type',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/qsched-type/qsched-type-delete-dialog.html',
                    controller: 'Qsched_typeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Qsched_type', function(Qsched_type) {
                            return Qsched_type.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('qsched-type', null, { reload: 'qsched-type' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('doctorclubboApp')
        .factory('Qsched_type', Qsched_type);

    Qsched_type.$inject = ['$resource'];

    function Qsched_type ($resource) {
        var resourceUrl =  'api/qsched-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('Qsched_typeController', Qsched_typeController);

    Qsched_typeController.$inject = ['$scope', '$state', 'Qsched_type', 'ParseLinks', 'AlertService'];

    function Qsched_typeController ($scope, $state, Qsched_type, ParseLinks, AlertService) {
        var vm = this;

        vm.qsched_types = [];
        vm.loadPage = loadPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;

        loadAll();

        function loadAll () {
            Qsched_type.query({
                page: vm.page,
                size: 20,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.qsched_types.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.qsched_types = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('Qsched_statusDialogController', Qsched_statusDialogController);

    Qsched_statusDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Qsched_status'];

    function Qsched_statusDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Qsched_status) {
        var vm = this;

        vm.qsched_status = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.qsched_status.id !== null) {
                Qsched_status.update(vm.qsched_status, onSaveSuccess, onSaveError);
            } else {
                Qsched_status.save(vm.qsched_status, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('doctorclubboApp:qsched_statusUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('Qsched_statusDetailController', Qsched_statusDetailController);

    Qsched_statusDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Qsched_status'];

    function Qsched_statusDetailController($scope, $rootScope, $stateParams, previousState, entity, Qsched_status) {
        var vm = this;

        vm.qsched_status = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('doctorclubboApp:qsched_statusUpdate', function(event, result) {
            vm.qsched_status = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('Qsched_statusDeleteController',Qsched_statusDeleteController);

    Qsched_statusDeleteController.$inject = ['$uibModalInstance', 'entity', 'Qsched_status'];

    function Qsched_statusDeleteController($uibModalInstance, entity, Qsched_status) {
        var vm = this;

        vm.qsched_status = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Qsched_status.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('qsched-status', {
            parent: 'entity',
            url: '/qsched-status',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.qsched_status.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/qsched-status/qsched-statuses.html',
                    controller: 'Qsched_statusController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('qsched_status');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('qsched-status-detail', {
            parent: 'entity',
            url: '/qsched-status/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.qsched_status.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/qsched-status/qsched-status-detail.html',
                    controller: 'Qsched_statusDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('qsched_status');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Qsched_status', function($stateParams, Qsched_status) {
                    return Qsched_status.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'qsched-status',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('qsched-status-detail.edit', {
            parent: 'qsched-status-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/qsched-status/qsched-status-dialog.html',
                    controller: 'Qsched_statusDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Qsched_status', function(Qsched_status) {
                            return Qsched_status.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('qsched-status.new', {
            parent: 'qsched-status',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/qsched-status/qsched-status-dialog.html',
                    controller: 'Qsched_statusDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('qsched-status', null, { reload: 'qsched-status' });
                }, function() {
                    $state.go('qsched-status');
                });
            }]
        })
        .state('qsched-status.edit', {
            parent: 'qsched-status',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/qsched-status/qsched-status-dialog.html',
                    controller: 'Qsched_statusDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Qsched_status', function(Qsched_status) {
                            return Qsched_status.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('qsched-status', null, { reload: 'qsched-status' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('qsched-status.delete', {
            parent: 'qsched-status',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/qsched-status/qsched-status-delete-dialog.html',
                    controller: 'Qsched_statusDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Qsched_status', function(Qsched_status) {
                            return Qsched_status.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('qsched-status', null, { reload: 'qsched-status' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('doctorclubboApp')
        .factory('Qsched_status', Qsched_status);

    Qsched_status.$inject = ['$resource'];

    function Qsched_status ($resource) {
        var resourceUrl =  'api/qsched-statuses/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('Qsched_statusController', Qsched_statusController);

    Qsched_statusController.$inject = ['$scope', '$state', 'Qsched_status', 'ParseLinks', 'AlertService'];

    function Qsched_statusController ($scope, $state, Qsched_status, ParseLinks, AlertService) {
        var vm = this;

        vm.qsched_statuses = [];
        vm.loadPage = loadPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;

        loadAll();

        function loadAll () {
            Qsched_status.query({
                page: vm.page,
                size: 20,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.qsched_statuses.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.qsched_statuses = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('Qsched_directionDialogController', Qsched_directionDialogController);

    Qsched_directionDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Qsched_direction'];

    function Qsched_directionDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Qsched_direction) {
        var vm = this;

        vm.qsched_direction = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.qsched_direction.id !== null) {
                Qsched_direction.update(vm.qsched_direction, onSaveSuccess, onSaveError);
            } else {
                Qsched_direction.save(vm.qsched_direction, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('doctorclubboApp:qsched_directionUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('Qsched_directionDetailController', Qsched_directionDetailController);

    Qsched_directionDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Qsched_direction'];

    function Qsched_directionDetailController($scope, $rootScope, $stateParams, previousState, entity, Qsched_direction) {
        var vm = this;

        vm.qsched_direction = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('doctorclubboApp:qsched_directionUpdate', function(event, result) {
            vm.qsched_direction = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('Qsched_directionDeleteController',Qsched_directionDeleteController);

    Qsched_directionDeleteController.$inject = ['$uibModalInstance', 'entity', 'Qsched_direction'];

    function Qsched_directionDeleteController($uibModalInstance, entity, Qsched_direction) {
        var vm = this;

        vm.qsched_direction = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Qsched_direction.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('qsched-direction', {
            parent: 'entity',
            url: '/qsched-direction',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.qsched_direction.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/qsched-direction/qsched-directions.html',
                    controller: 'Qsched_directionController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('qsched_direction');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('qsched-direction-detail', {
            parent: 'entity',
            url: '/qsched-direction/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.qsched_direction.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/qsched-direction/qsched-direction-detail.html',
                    controller: 'Qsched_directionDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('qsched_direction');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Qsched_direction', function($stateParams, Qsched_direction) {
                    return Qsched_direction.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'qsched-direction',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('qsched-direction-detail.edit', {
            parent: 'qsched-direction-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/qsched-direction/qsched-direction-dialog.html',
                    controller: 'Qsched_directionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Qsched_direction', function(Qsched_direction) {
                            return Qsched_direction.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('qsched-direction.new', {
            parent: 'qsched-direction',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/qsched-direction/qsched-direction-dialog.html',
                    controller: 'Qsched_directionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                direction: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('qsched-direction', null, { reload: 'qsched-direction' });
                }, function() {
                    $state.go('qsched-direction');
                });
            }]
        })
        .state('qsched-direction.edit', {
            parent: 'qsched-direction',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/qsched-direction/qsched-direction-dialog.html',
                    controller: 'Qsched_directionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Qsched_direction', function(Qsched_direction) {
                            return Qsched_direction.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('qsched-direction', null, { reload: 'qsched-direction' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('qsched-direction.delete', {
            parent: 'qsched-direction',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/qsched-direction/qsched-direction-delete-dialog.html',
                    controller: 'Qsched_directionDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Qsched_direction', function(Qsched_direction) {
                            return Qsched_direction.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('qsched-direction', null, { reload: 'qsched-direction' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('doctorclubboApp')
        .factory('Qsched_direction', Qsched_direction);

    Qsched_direction.$inject = ['$resource'];

    function Qsched_direction ($resource) {
        var resourceUrl =  'api/qsched-directions/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('Qsched_directionController', Qsched_directionController);

    Qsched_directionController.$inject = ['$scope', '$state', 'Qsched_direction', 'ParseLinks', 'AlertService'];

    function Qsched_directionController ($scope, $state, Qsched_direction, ParseLinks, AlertService) {
        var vm = this;

        vm.qsched_directions = [];
        vm.loadPage = loadPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;

        loadAll();

        function loadAll () {
            Qsched_direction.query({
                page: vm.page,
                size: 20,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.qsched_directions.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.qsched_directions = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('ProvinciaDialogController', ProvinciaDialogController);

    ProvinciaDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Provincia'];

    function ProvinciaDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Provincia) {
        var vm = this;

        vm.provincia = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.provincia.id !== null) {
                Provincia.update(vm.provincia, onSaveSuccess, onSaveError);
            } else {
                Provincia.save(vm.provincia, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('doctorclubboApp:provinciaUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('ProvinciaDetailController', ProvinciaDetailController);

    ProvinciaDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Provincia'];

    function ProvinciaDetailController($scope, $rootScope, $stateParams, previousState, entity, Provincia) {
        var vm = this;

        vm.provincia = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('doctorclubboApp:provinciaUpdate', function(event, result) {
            vm.provincia = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('ProvinciaDeleteController',ProvinciaDeleteController);

    ProvinciaDeleteController.$inject = ['$uibModalInstance', 'entity', 'Provincia'];

    function ProvinciaDeleteController($uibModalInstance, entity, Provincia) {
        var vm = this;

        vm.provincia = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Provincia.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('provincia', {
            parent: 'entity',
            url: '/provincia',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.provincia.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/provincia/provincias.html',
                    controller: 'ProvinciaController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('provincia');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('provincia-detail', {
            parent: 'entity',
            url: '/provincia/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.provincia.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/provincia/provincia-detail.html',
                    controller: 'ProvinciaDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('provincia');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Provincia', function($stateParams, Provincia) {
                    return Provincia.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'provincia',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('provincia-detail.edit', {
            parent: 'provincia-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/provincia/provincia-dialog.html',
                    controller: 'ProvinciaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Provincia', function(Provincia) {
                            return Provincia.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('provincia.new', {
            parent: 'provincia',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/provincia/provincia-dialog.html',
                    controller: 'ProvinciaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                sigla: null,
                                provincia: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('provincia', null, { reload: 'provincia' });
                }, function() {
                    $state.go('provincia');
                });
            }]
        })
        .state('provincia.edit', {
            parent: 'provincia',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/provincia/provincia-dialog.html',
                    controller: 'ProvinciaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Provincia', function(Provincia) {
                            return Provincia.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('provincia', null, { reload: 'provincia' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('provincia.delete', {
            parent: 'provincia',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/provincia/provincia-delete-dialog.html',
                    controller: 'ProvinciaDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Provincia', function(Provincia) {
                            return Provincia.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('provincia', null, { reload: 'provincia' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('doctorclubboApp')
        .factory('Provincia', Provincia);

    Provincia.$inject = ['$resource'];

    function Provincia ($resource) {
        var resourceUrl =  'api/provincias/:id?size=2000';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('ProvinciaController', ProvinciaController);

    ProvinciaController.$inject = ['$scope', '$state', 'Provincia', 'ParseLinks', 'AlertService'];

    function ProvinciaController ($scope, $state, Provincia, ParseLinks, AlertService) {
        var vm = this;

        vm.provincias = [];
        vm.loadPage = loadPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;

        loadAll();

        function loadAll () {
            Provincia.query({
                page: vm.page,
                size: 50,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.provincias.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.provincias = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('Opzioni_ticketDialogController', Opzioni_ticketDialogController);

    Opzioni_ticketDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Opzioni_ticket', 'Campagna'];

    function Opzioni_ticketDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Opzioni_ticket, Campagna) {
        var vm = this;

        vm.opzioni_ticket = entity;
        vm.clear = clear;
        vm.save = save;
        vm.campagnas = Campagna.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.opzioni_ticket.id !== null) {
                Opzioni_ticket.update(vm.opzioni_ticket, onSaveSuccess, onSaveError);
            } else {
                Opzioni_ticket.save(vm.opzioni_ticket, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('doctorclubboApp:opzioni_ticketUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('Opzioni_ticketDetailController', Opzioni_ticketDetailController);

    Opzioni_ticketDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Opzioni_ticket', 'Campagna'];

    function Opzioni_ticketDetailController($scope, $rootScope, $stateParams, previousState, entity, Opzioni_ticket, Campagna) {
        var vm = this;

        vm.opzioni_ticket = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('doctorclubboApp:opzioni_ticketUpdate', function(event, result) {
            vm.opzioni_ticket = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('Opzioni_ticketDeleteController',Opzioni_ticketDeleteController);

    Opzioni_ticketDeleteController.$inject = ['$uibModalInstance', 'entity', 'Opzioni_ticket'];

    function Opzioni_ticketDeleteController($uibModalInstance, entity, Opzioni_ticket) {
        var vm = this;

        vm.opzioni_ticket = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Opzioni_ticket.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('opzioni-ticket', {
            parent: 'entity',
            url: '/opzioni-ticket?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.opzioni_ticket.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/opzioni-ticket/opzioni-tickets.html',
                    controller: 'Opzioni_ticketController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('opzioni_ticket');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('opzioni-ticket-detail', {
            parent: 'opzioni-ticket',
            url: '/opzioni-ticket/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.opzioni_ticket.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/opzioni-ticket/opzioni-ticket-detail.html',
                    controller: 'Opzioni_ticketDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('opzioni_ticket');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Opzioni_ticket', function($stateParams, Opzioni_ticket) {
                    return Opzioni_ticket.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'opzioni-ticket',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('opzioni-ticket-detail.edit', {
            parent: 'opzioni-ticket-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/opzioni-ticket/opzioni-ticket-dialog.html',
                    controller: 'Opzioni_ticketDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Opzioni_ticket', function(Opzioni_ticket) {
                            return Opzioni_ticket.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('opzioni-ticket.new', {
            parent: 'opzioni-ticket',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/opzioni-ticket/opzioni-ticket-dialog.html',
                    controller: 'Opzioni_ticketDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                importo: null,
                                num: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('opzioni-ticket', null, { reload: 'opzioni-ticket' });
                }, function() {
                    $state.go('opzioni-ticket');
                });
            }]
        })
        .state('opzioni-ticket.edit', {
            parent: 'opzioni-ticket',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/opzioni-ticket/opzioni-ticket-dialog.html',
                    controller: 'Opzioni_ticketDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Opzioni_ticket', function(Opzioni_ticket) {
                            return Opzioni_ticket.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('opzioni-ticket', null, { reload: 'opzioni-ticket' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('opzioni-ticket.delete', {
            parent: 'opzioni-ticket',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/opzioni-ticket/opzioni-ticket-delete-dialog.html',
                    controller: 'Opzioni_ticketDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Opzioni_ticket', function(Opzioni_ticket) {
                            return Opzioni_ticket.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('opzioni-ticket', null, { reload: 'opzioni-ticket' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('doctorclubboApp')
        .factory('Opzioni_ticket', Opzioni_ticket);

    Opzioni_ticket.$inject = ['$resource'];

    function Opzioni_ticket ($resource) {
        var resourceUrl =  'api/opzioni-tickets/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('Opzioni_ticketController', Opzioni_ticketController);

    Opzioni_ticketController.$inject = ['$state', 'Opzioni_ticket', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function Opzioni_ticketController($state, Opzioni_ticket, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            Opzioni_ticket.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.opzioni_tickets = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('GiftcardStatementDialogController', GiftcardStatementDialogController);

    GiftcardStatementDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'GiftcardStatement', 'GcSystem', 'Sistema'];

    function GiftcardStatementDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, GiftcardStatement, GcSystem, Sistema) {
        var vm = this;

        vm.giftcardStatement = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.gcsystems = GcSystem.query();
        vm.sistemas = Sistema.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.giftcardStatement.id !== null) {
                GiftcardStatement.update(vm.giftcardStatement, onSaveSuccess, onSaveError);
            } else {
                GiftcardStatement.save(vm.giftcardStatement, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('doctorclubboApp:giftcardStatementUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.dtIns = false;
        vm.datePickerOpenStatus.gcExpirationDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('GiftcardStatementDetailController', GiftcardStatementDetailController);

    GiftcardStatementDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'GiftcardStatement', 'GcSystem', 'Sistema'];

    function GiftcardStatementDetailController($scope, $rootScope, $stateParams, previousState, entity, GiftcardStatement, GcSystem, Sistema) {
        var vm = this;

        vm.giftcardStatement = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('doctorclubboApp:giftcardStatementUpdate', function(event, result) {
            vm.giftcardStatement = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('GiftcardStatementDeleteController',GiftcardStatementDeleteController);

    GiftcardStatementDeleteController.$inject = ['$uibModalInstance', 'entity', 'GiftcardStatement'];

    function GiftcardStatementDeleteController($uibModalInstance, entity, GiftcardStatement) {
        var vm = this;

        vm.giftcardStatement = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            GiftcardStatement.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('giftcard-statement', {
            parent: 'entity',
            url: '/giftcard-statement?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.giftcardStatement.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/giftcard-statement/giftcard-statements.html',
                    controller: 'GiftcardStatementController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('giftcardStatement');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('giftcard-statement-detail', {
            parent: 'giftcard-statement',
            url: '/giftcard-statement/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.giftcardStatement.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/giftcard-statement/giftcard-statement-detail.html',
                    controller: 'GiftcardStatementDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('giftcardStatement');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'GiftcardStatement', function($stateParams, GiftcardStatement) {
                    return GiftcardStatement.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'giftcard-statement',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('giftcard-statement-detail.edit', {
            parent: 'giftcard-statement-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/giftcard-statement/giftcard-statement-dialog.html',
                    controller: 'GiftcardStatementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['GiftcardStatement', function(GiftcardStatement) {
                            return GiftcardStatement.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('giftcard-statement.new', {
            parent: 'giftcard-statement',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/giftcard-statement/giftcard-statement-dialog.html',
                    controller: 'GiftcardStatementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                dtIns: null,
                                gcClaimCode: null,
                                gcId: null,
                                creationRequestId: null,
                                emailSource: null,
                                emailDestination: null,
                                currencyCode: null,
                                amount: null,
                                balance: null,
                                cardStatus: null,
                                status: null,
                                processed: null,
                                gcExpirationDate: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('giftcard-statement', null, { reload: 'giftcard-statement' });
                }, function() {
                    $state.go('giftcard-statement');
                });
            }]
        })
        .state('giftcard-statement.edit', {
            parent: 'giftcard-statement',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/giftcard-statement/giftcard-statement-dialog.html',
                    controller: 'GiftcardStatementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['GiftcardStatement', function(GiftcardStatement) {
                            return GiftcardStatement.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('giftcard-statement', null, { reload: 'giftcard-statement' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('giftcard-statement.delete', {
            parent: 'giftcard-statement',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/giftcard-statement/giftcard-statement-delete-dialog.html',
                    controller: 'GiftcardStatementDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['GiftcardStatement', function(GiftcardStatement) {
                            return GiftcardStatement.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('giftcard-statement', null, { reload: 'giftcard-statement' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('doctorclubboApp')
        .factory('GiftcardStatement', GiftcardStatement);

    GiftcardStatement.$inject = ['$resource', 'DateUtils'];

    function GiftcardStatement ($resource, DateUtils) {
        var resourceUrl =  'api/giftcard-statements/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dtIns = DateUtils.convertDateTimeFromServer(data.dtIns);
                        data.gcExpirationDate = DateUtils.convertDateTimeFromServer(data.gcExpirationDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('GiftcardStatementController', GiftcardStatementController);

    GiftcardStatementController.$inject = ['$state', 'GiftcardStatement', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function GiftcardStatementController($state, GiftcardStatement, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            GiftcardStatement.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.giftcardStatements = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('GcSystemDialogController', GcSystemDialogController);

    GcSystemDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'GcSystem'];

    function GcSystemDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, GcSystem) {
        var vm = this;

        vm.gcSystem = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.gcSystem.id !== null) {
                GcSystem.update(vm.gcSystem, onSaveSuccess, onSaveError);
            } else {
                GcSystem.save(vm.gcSystem, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('doctorclubboApp:gcSystemUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('GcSystemDetailController', GcSystemDetailController);

    GcSystemDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'GcSystem'];

    function GcSystemDetailController($scope, $rootScope, $stateParams, previousState, entity, GcSystem) {
        var vm = this;

        vm.gcSystem = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('doctorclubboApp:gcSystemUpdate', function(event, result) {
            vm.gcSystem = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('GcSystemDeleteController',GcSystemDeleteController);

    GcSystemDeleteController.$inject = ['$uibModalInstance', 'entity', 'GcSystem'];

    function GcSystemDeleteController($uibModalInstance, entity, GcSystem) {
        var vm = this;

        vm.gcSystem = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            GcSystem.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('gc-system', {
            parent: 'entity',
            url: '/gc-system',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.gcSystem.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/gc-system/gc-systems.html',
                    controller: 'GcSystemController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('gcSystem');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('gc-system-detail', {
            parent: 'gc-system',
            url: '/gc-system/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.gcSystem.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/gc-system/gc-system-detail.html',
                    controller: 'GcSystemDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('gcSystem');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'GcSystem', function($stateParams, GcSystem) {
                    return GcSystem.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'gc-system',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('gc-system-detail.edit', {
            parent: 'gc-system-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/gc-system/gc-system-dialog.html',
                    controller: 'GcSystemDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['GcSystem', function(GcSystem) {
                            return GcSystem.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('gc-system.new', {
            parent: 'gc-system',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/gc-system/gc-system-dialog.html',
                    controller: 'GcSystemDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nome: null,
                                endpoint: null,
                                partnerId: null,
                                programId: null,
                                currencyCode: null,
                                awsAccessKey: null,
                                awsSecretKey: null,
                                region: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('gc-system', null, { reload: 'gc-system' });
                }, function() {
                    $state.go('gc-system');
                });
            }]
        })
        .state('gc-system.edit', {
            parent: 'gc-system',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/gc-system/gc-system-dialog.html',
                    controller: 'GcSystemDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['GcSystem', function(GcSystem) {
                            return GcSystem.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('gc-system', null, { reload: 'gc-system' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('gc-system.delete', {
            parent: 'gc-system',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/gc-system/gc-system-delete-dialog.html',
                    controller: 'GcSystemDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['GcSystem', function(GcSystem) {
                            return GcSystem.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('gc-system', null, { reload: 'gc-system' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('doctorclubboApp')
        .factory('GcSystem', GcSystem);

    GcSystem.$inject = ['$resource'];

    function GcSystem ($resource) {
        var resourceUrl =  'api/gc-systems/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('GcSystemController', GcSystemController);

    GcSystemController.$inject = ['GcSystem', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function GcSystemController(GcSystem, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.gcSystems = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;

        loadAll();

        function loadAll () {
            GcSystem.query({
                page: vm.page,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.gcSystems.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.gcSystems = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('Fee_agenziaDialogController', Fee_agenziaDialogController);

    Fee_agenziaDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Fee_agenzia', 'Fee', 'Agenzia'];

    function Fee_agenziaDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Fee_agenzia, Fee, Agenzia) {
        var vm = this;

        vm.fee_agenzia = entity;
        vm.clear = clear;
        vm.save = save;
        vm.fees = Fee.query();
        vm.agenzias = Agenzia.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.fee_agenzia.id !== null) {
                Fee_agenzia.update(vm.fee_agenzia, onSaveSuccess, onSaveError);
            } else {
                Fee_agenzia.save(vm.fee_agenzia, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('doctorclubboApp:fee_agenziaUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('Fee_agenziaDetailController', Fee_agenziaDetailController);

    Fee_agenziaDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Fee_agenzia', 'Fee', 'Agenzia'];

    function Fee_agenziaDetailController($scope, $rootScope, $stateParams, previousState, entity, Fee_agenzia, Fee, Agenzia) {
        var vm = this;

        vm.fee_agenzia = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('doctorclubboApp:fee_agenziaUpdate', function(event, result) {
            vm.fee_agenzia = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('Fee_agenziaDeleteController',Fee_agenziaDeleteController);

    Fee_agenziaDeleteController.$inject = ['$uibModalInstance', 'entity', 'Fee_agenzia'];

    function Fee_agenziaDeleteController($uibModalInstance, entity, Fee_agenzia) {
        var vm = this;

        vm.fee_agenzia = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Fee_agenzia.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('fee-agenzia', {
            parent: 'entity',
            url: '/fee-agenzia?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.fee_agenzia.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/fee-agenzia/fee-agenzias.html',
                    controller: 'Fee_agenziaController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('fee_agenzia');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('fee-agenzia-detail', {
            parent: 'fee-agenzia',
            url: '/fee-agenzia/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.fee_agenzia.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/fee-agenzia/fee-agenzia-detail.html',
                    controller: 'Fee_agenziaDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('fee_agenzia');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Fee_agenzia', function($stateParams, Fee_agenzia) {
                    return Fee_agenzia.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'fee-agenzia',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('fee-agenzia-detail.edit', {
            parent: 'fee-agenzia-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/fee-agenzia/fee-agenzia-dialog.html',
                    controller: 'Fee_agenziaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Fee_agenzia', function(Fee_agenzia) {
                            return Fee_agenzia.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('fee-agenzia.new', {
            parent: 'fee-agenzia',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/fee-agenzia/fee-agenzia-dialog.html',
                    controller: 'Fee_agenziaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                valore: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('fee-agenzia', null, { reload: 'fee-agenzia' });
                }, function() {
                    $state.go('fee-agenzia');
                });
            }]
        })
        .state('fee-agenzia.edit', {
            parent: 'fee-agenzia',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/fee-agenzia/fee-agenzia-dialog.html',
                    controller: 'Fee_agenziaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Fee_agenzia', function(Fee_agenzia) {
                            return Fee_agenzia.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('fee-agenzia', null, { reload: 'fee-agenzia' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('fee-agenzia.delete', {
            parent: 'fee-agenzia',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/fee-agenzia/fee-agenzia-delete-dialog.html',
                    controller: 'Fee_agenziaDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Fee_agenzia', function(Fee_agenzia) {
                            return Fee_agenzia.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('fee-agenzia', null, { reload: 'fee-agenzia' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('doctorclubboApp')
        .factory('Fee_agenzia', Fee_agenzia);

    Fee_agenzia.$inject = ['$resource'];

    function Fee_agenzia ($resource) {
        var resourceUrl =  'api/fee-agenzias/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('Fee_agenziaController', Fee_agenziaController);

    Fee_agenziaController.$inject = ['$state', 'Fee_agenzia', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function Fee_agenziaController($state, Fee_agenzia, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            Fee_agenzia.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.fee_agenzias = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('FeeDialogController', FeeDialogController);

    FeeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Fee'];

    function FeeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Fee) {
        var vm = this;

        vm.fee = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.fee.id !== null) {
                Fee.update(vm.fee, onSaveSuccess, onSaveError);
            } else {
                Fee.save(vm.fee, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('doctorclubboApp:feeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('FeeDetailController', FeeDetailController);

    FeeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Fee'];

    function FeeDetailController($scope, $rootScope, $stateParams, previousState, entity, Fee) {
        var vm = this;

        vm.fee = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('doctorclubboApp:feeUpdate', function(event, result) {
            vm.fee = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('FeeDeleteController',FeeDeleteController);

    FeeDeleteController.$inject = ['$uibModalInstance', 'entity', 'Fee'];

    function FeeDeleteController($uibModalInstance, entity, Fee) {
        var vm = this;

        vm.fee = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Fee.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('fee', {
            parent: 'entity',
            url: '/fee',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.fee.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/fee/fees.html',
                    controller: 'FeeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('fee');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('fee-detail', {
            parent: 'fee',
            url: '/fee/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.fee.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/fee/fee-detail.html',
                    controller: 'FeeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('fee');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Fee', function($stateParams, Fee) {
                    return Fee.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'fee',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('fee-detail.edit', {
            parent: 'fee-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/fee/fee-dialog.html',
                    controller: 'FeeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Fee', function(Fee) {
                            return Fee.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('fee.new', {
            parent: 'fee',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/fee/fee-dialog.html',
                    controller: 'FeeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                fee: null,
                                valore: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('fee', null, { reload: 'fee' });
                }, function() {
                    $state.go('fee');
                });
            }]
        })
        .state('fee.edit', {
            parent: 'fee',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/fee/fee-dialog.html',
                    controller: 'FeeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Fee', function(Fee) {
                            return Fee.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('fee', null, { reload: 'fee' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('fee.delete', {
            parent: 'fee',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/fee/fee-delete-dialog.html',
                    controller: 'FeeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Fee', function(Fee) {
                            return Fee.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('fee', null, { reload: 'fee' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('doctorclubboApp')
        .factory('Fee', Fee);

    Fee.$inject = ['$resource'];

    function Fee ($resource) {
        var resourceUrl =  'api/fees/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('FeeController', FeeController);

    FeeController.$inject = ['Fee', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function FeeController(Fee, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.fees = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;

        loadAll();

        function loadAll () {
            Fee.query({
                page: vm.page,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.fees.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.fees = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('entity', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('Dispositivo_osDialogController', Dispositivo_osDialogController);

    Dispositivo_osDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Dispositivo_os'];

    function Dispositivo_osDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Dispositivo_os) {
        var vm = this;

        vm.dispositivo_os = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.dispositivo_os.id !== null) {
                Dispositivo_os.update(vm.dispositivo_os, onSaveSuccess, onSaveError);
            } else {
                Dispositivo_os.save(vm.dispositivo_os, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('doctorclubboApp:dispositivo_osUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('Dispositivo_osDetailController', Dispositivo_osDetailController);

    Dispositivo_osDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Dispositivo_os'];

    function Dispositivo_osDetailController($scope, $rootScope, $stateParams, previousState, entity, Dispositivo_os) {
        var vm = this;

        vm.dispositivo_os = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('doctorclubboApp:dispositivo_osUpdate', function(event, result) {
            vm.dispositivo_os = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('Dispositivo_osDeleteController',Dispositivo_osDeleteController);

    Dispositivo_osDeleteController.$inject = ['$uibModalInstance', 'entity', 'Dispositivo_os'];

    function Dispositivo_osDeleteController($uibModalInstance, entity, Dispositivo_os) {
        var vm = this;

        vm.dispositivo_os = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Dispositivo_os.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('dispositivo-os', {
            parent: 'entity',
            url: '/dispositivo-os',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.dispositivo_os.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/dispositivo-os/dispositivo-os.html',
                    controller: 'Dispositivo_osController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('dispositivo_os');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('dispositivo-os-detail', {
            parent: 'entity',
            url: '/dispositivo-os/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.dispositivo_os.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/dispositivo-os/dispositivo-os-detail.html',
                    controller: 'Dispositivo_osDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('dispositivo_os');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Dispositivo_os', function($stateParams, Dispositivo_os) {
                    return Dispositivo_os.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'dispositivo-os',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('dispositivo-os-detail.edit', {
            parent: 'dispositivo-os-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/dispositivo-os/dispositivo-os-dialog.html',
                    controller: 'Dispositivo_osDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Dispositivo_os', function(Dispositivo_os) {
                            return Dispositivo_os.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('dispositivo-os.new', {
            parent: 'dispositivo-os',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/dispositivo-os/dispositivo-os-dialog.html',
                    controller: 'Dispositivo_osDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                os: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('dispositivo-os', null, { reload: 'dispositivo-os' });
                }, function() {
                    $state.go('dispositivo-os');
                });
            }]
        })
        .state('dispositivo-os.edit', {
            parent: 'dispositivo-os',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/dispositivo-os/dispositivo-os-dialog.html',
                    controller: 'Dispositivo_osDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Dispositivo_os', function(Dispositivo_os) {
                            return Dispositivo_os.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('dispositivo-os', null, { reload: 'dispositivo-os' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('dispositivo-os.delete', {
            parent: 'dispositivo-os',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/dispositivo-os/dispositivo-os-delete-dialog.html',
                    controller: 'Dispositivo_osDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Dispositivo_os', function(Dispositivo_os) {
                            return Dispositivo_os.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('dispositivo-os', null, { reload: 'dispositivo-os' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('doctorclubboApp')
        .factory('Dispositivo_os', Dispositivo_os);

    Dispositivo_os.$inject = ['$resource'];

    function Dispositivo_os ($resource) {
        var resourceUrl =  'api/dispositivo-os/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('Dispositivo_osController', Dispositivo_osController);

    Dispositivo_osController.$inject = ['$scope', '$state', 'Dispositivo_os'];

    function Dispositivo_osController ($scope, $state, Dispositivo_os) {
        var vm = this;

        vm.dispositivo_os = [];

        loadAll();

        function loadAll() {
            Dispositivo_os.query(function(result) {
                vm.dispositivo_os = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('DispositivoDialogController', DispositivoDialogController);

    DispositivoDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Dispositivo'];

    function DispositivoDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Dispositivo) {
        var vm = this;

        vm.dispositivo = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.dispositivo.id !== null) {
                Dispositivo.update(vm.dispositivo, onSaveSuccess, onSaveError);
            } else {
                Dispositivo.save(vm.dispositivo, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('doctorclubboApp:dispositivoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('DispositivoDetailController', DispositivoDetailController);

    DispositivoDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Dispositivo'];

    function DispositivoDetailController($scope, $rootScope, $stateParams, previousState, entity, Dispositivo) {
        var vm = this;

        vm.dispositivo = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('doctorclubboApp:dispositivoUpdate', function(event, result) {
            vm.dispositivo = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('DispositivoDeleteController',DispositivoDeleteController);

    DispositivoDeleteController.$inject = ['$uibModalInstance', 'entity', 'Dispositivo'];

    function DispositivoDeleteController($uibModalInstance, entity, Dispositivo) {
        var vm = this;

        vm.dispositivo = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Dispositivo.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('dispositivo', {
            parent: 'entity',
            url: '/dispositivo',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.dispositivo.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/dispositivo/dispositivos.html',
                    controller: 'DispositivoController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('dispositivo');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('dispositivo-detail', {
            parent: 'entity',
            url: '/dispositivo/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.dispositivo.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/dispositivo/dispositivo-detail.html',
                    controller: 'DispositivoDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('dispositivo');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Dispositivo', function($stateParams, Dispositivo) {
                    return Dispositivo.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'dispositivo',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('dispositivo-detail.edit', {
            parent: 'dispositivo-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/dispositivo/dispositivo-dialog.html',
                    controller: 'DispositivoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Dispositivo', function(Dispositivo) {
                            return Dispositivo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('dispositivo.new', {
            parent: 'dispositivo',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/dispositivo/dispositivo-dialog.html',
                    controller: 'DispositivoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                dispositivo: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('dispositivo', null, { reload: 'dispositivo' });
                }, function() {
                    $state.go('dispositivo');
                });
            }]
        })
        .state('dispositivo.edit', {
            parent: 'dispositivo',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/dispositivo/dispositivo-dialog.html',
                    controller: 'DispositivoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Dispositivo', function(Dispositivo) {
                            return Dispositivo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('dispositivo', null, { reload: 'dispositivo' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('dispositivo.delete', {
            parent: 'dispositivo',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/dispositivo/dispositivo-delete-dialog.html',
                    controller: 'DispositivoDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Dispositivo', function(Dispositivo) {
                            return Dispositivo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('dispositivo', null, { reload: 'dispositivo' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('doctorclubboApp')
        .factory('Dispositivo', Dispositivo);

    Dispositivo.$inject = ['$resource'];

    function Dispositivo ($resource) {
        var resourceUrl =  'api/dispositivos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('DispositivoController', DispositivoController);

    DispositivoController.$inject = ['$scope', '$state', 'Dispositivo', 'ParseLinks', 'AlertService'];

    function DispositivoController ($scope, $state, Dispositivo, ParseLinks, AlertService) {
        var vm = this;

        vm.dispositivos = [];
        vm.loadPage = loadPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;

        loadAll();

        function loadAll () {
            Dispositivo.query({
                page: vm.page,
                size: 20,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.dispositivos.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.dispositivos = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('Delivery_statusDialogController', Delivery_statusDialogController);

    Delivery_statusDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Delivery_status'];

    function Delivery_statusDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Delivery_status) {
        var vm = this;

        vm.delivery_status = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.delivery_status.id !== null) {
                Delivery_status.update(vm.delivery_status, onSaveSuccess, onSaveError);
            } else {
                Delivery_status.save(vm.delivery_status, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('doctorclubboApp:delivery_statusUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('Delivery_statusDetailController', Delivery_statusDetailController);

    Delivery_statusDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Delivery_status'];

    function Delivery_statusDetailController($scope, $rootScope, $stateParams, previousState, entity, Delivery_status) {
        var vm = this;

        vm.delivery_status = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('doctorclubboApp:delivery_statusUpdate', function(event, result) {
            vm.delivery_status = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('Delivery_statusDeleteController',Delivery_statusDeleteController);

    Delivery_statusDeleteController.$inject = ['$uibModalInstance', 'entity', 'Delivery_status'];

    function Delivery_statusDeleteController($uibModalInstance, entity, Delivery_status) {
        var vm = this;

        vm.delivery_status = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Delivery_status.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('delivery-status', {
            parent: 'entity',
            url: '/delivery-status',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.delivery_status.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/delivery-status/delivery-statuses.html',
                    controller: 'Delivery_statusController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('delivery_status');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('delivery-status-detail', {
            parent: 'delivery-status',
            url: '/delivery-status/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.delivery_status.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/delivery-status/delivery-status-detail.html',
                    controller: 'Delivery_statusDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('delivery_status');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Delivery_status', function($stateParams, Delivery_status) {
                    return Delivery_status.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'delivery-status',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('delivery-status-detail.edit', {
            parent: 'delivery-status-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/delivery-status/delivery-status-dialog.html',
                    controller: 'Delivery_statusDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Delivery_status', function(Delivery_status) {
                            return Delivery_status.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('delivery-status.new', {
            parent: 'delivery-status',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/delivery-status/delivery-status-dialog.html',
                    controller: 'Delivery_statusDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                status: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('delivery-status', null, { reload: 'delivery-status' });
                }, function() {
                    $state.go('delivery-status');
                });
            }]
        })
        .state('delivery-status.edit', {
            parent: 'delivery-status',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/delivery-status/delivery-status-dialog.html',
                    controller: 'Delivery_statusDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Delivery_status', function(Delivery_status) {
                            return Delivery_status.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('delivery-status', null, { reload: 'delivery-status' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('delivery-status.delete', {
            parent: 'delivery-status',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/delivery-status/delivery-status-delete-dialog.html',
                    controller: 'Delivery_statusDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Delivery_status', function(Delivery_status) {
                            return Delivery_status.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('delivery-status', null, { reload: 'delivery-status' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('doctorclubboApp')
        .factory('Delivery_status', Delivery_status);

    Delivery_status.$inject = ['$resource'];

    function Delivery_status ($resource) {
        var resourceUrl =  'api/delivery-statuses/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('Delivery_statusController', Delivery_statusController);

    Delivery_statusController.$inject = ['Delivery_status', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function Delivery_statusController(Delivery_status, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.delivery_statuses = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;

        loadAll();

        function loadAll () {
            Delivery_status.query({
                page: vm.page,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.delivery_statuses.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.delivery_statuses = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('Delivery_option_agenziaDialogController', Delivery_option_agenziaDialogController);

    Delivery_option_agenziaDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Delivery_option_agenzia', 'Delivery_option', 'Agenzia'];

    function Delivery_option_agenziaDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Delivery_option_agenzia, Delivery_option, Agenzia) {
        var vm = this;

        vm.delivery_option_agenzia = entity;
        vm.clear = clear;
        vm.save = save;
        vm.delivery_options = Delivery_option.query();
        vm.agenzias = Agenzia.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.delivery_option_agenzia.id !== null) {
                Delivery_option_agenzia.update(vm.delivery_option_agenzia, onSaveSuccess, onSaveError);
            } else {
                Delivery_option_agenzia.save(vm.delivery_option_agenzia, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('doctorclubboApp:delivery_option_agenziaUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('Delivery_option_agenziaDetailController', Delivery_option_agenziaDetailController);

    Delivery_option_agenziaDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Delivery_option_agenzia', 'Delivery_option', 'Agenzia'];

    function Delivery_option_agenziaDetailController($scope, $rootScope, $stateParams, previousState, entity, Delivery_option_agenzia, Delivery_option, Agenzia) {
        var vm = this;

        vm.delivery_option_agenzia = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('doctorclubboApp:delivery_option_agenziaUpdate', function(event, result) {
            vm.delivery_option_agenzia = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('Delivery_option_agenziaDeleteController',Delivery_option_agenziaDeleteController);

    Delivery_option_agenziaDeleteController.$inject = ['$uibModalInstance', 'entity', 'Delivery_option_agenzia'];

    function Delivery_option_agenziaDeleteController($uibModalInstance, entity, Delivery_option_agenzia) {
        var vm = this;

        vm.delivery_option_agenzia = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Delivery_option_agenzia.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('delivery-option-agenzia', {
            parent: 'entity',
            url: '/delivery-option-agenzia?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.delivery_option_agenzia.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/delivery-option-agenzia/delivery-option-agenzias.html',
                    controller: 'Delivery_option_agenziaController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('delivery_option_agenzia');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('delivery-option-agenzia-detail', {
            parent: 'delivery-option-agenzia',
            url: '/delivery-option-agenzia/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.delivery_option_agenzia.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/delivery-option-agenzia/delivery-option-agenzia-detail.html',
                    controller: 'Delivery_option_agenziaDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('delivery_option_agenzia');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Delivery_option_agenzia', function($stateParams, Delivery_option_agenzia) {
                    return Delivery_option_agenzia.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'delivery-option-agenzia',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('delivery-option-agenzia-detail.edit', {
            parent: 'delivery-option-agenzia-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/delivery-option-agenzia/delivery-option-agenzia-dialog.html',
                    controller: 'Delivery_option_agenziaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Delivery_option_agenzia', function(Delivery_option_agenzia) {
                            return Delivery_option_agenzia.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('delivery-option-agenzia.new', {
            parent: 'delivery-option-agenzia',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/delivery-option-agenzia/delivery-option-agenzia-dialog.html',
                    controller: 'Delivery_option_agenziaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                costo_unitario: null,
                                importo_fix: null,
                                max_buoni: null,
                                descrizione: null,
                                descrizione_costi: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('delivery-option-agenzia', null, { reload: 'delivery-option-agenzia' });
                }, function() {
                    $state.go('delivery-option-agenzia');
                });
            }]
        })
        .state('delivery-option-agenzia.edit', {
            parent: 'delivery-option-agenzia',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/delivery-option-agenzia/delivery-option-agenzia-dialog.html',
                    controller: 'Delivery_option_agenziaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Delivery_option_agenzia', function(Delivery_option_agenzia) {
                            return Delivery_option_agenzia.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('delivery-option-agenzia', null, { reload: 'delivery-option-agenzia' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('delivery-option-agenzia.delete', {
            parent: 'delivery-option-agenzia',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/delivery-option-agenzia/delivery-option-agenzia-delete-dialog.html',
                    controller: 'Delivery_option_agenziaDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Delivery_option_agenzia', function(Delivery_option_agenzia) {
                            return Delivery_option_agenzia.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('delivery-option-agenzia', null, { reload: 'delivery-option-agenzia' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('doctorclubboApp')
        .factory('Delivery_option_agenzia', Delivery_option_agenzia);

    Delivery_option_agenzia.$inject = ['$resource'];

    function Delivery_option_agenzia ($resource) {
        var resourceUrl =  'api/delivery-option-agenzias/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('Delivery_option_agenziaController', Delivery_option_agenziaController);

    Delivery_option_agenziaController.$inject = ['$state', 'Delivery_option_agenzia', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function Delivery_option_agenziaController($state, Delivery_option_agenzia, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            Delivery_option_agenzia.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.delivery_option_agenzias = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('Delivery_optionDialogController', Delivery_optionDialogController);

    Delivery_optionDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Delivery_option'];

    function Delivery_optionDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Delivery_option) {
        var vm = this;

        vm.delivery_option = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.delivery_option.id !== null) {
                Delivery_option.update(vm.delivery_option, onSaveSuccess, onSaveError);
            } else {
                Delivery_option.save(vm.delivery_option, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('doctorclubboApp:delivery_optionUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('Delivery_optionDetailController', Delivery_optionDetailController);

    Delivery_optionDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Delivery_option'];

    function Delivery_optionDetailController($scope, $rootScope, $stateParams, previousState, entity, Delivery_option) {
        var vm = this;

        vm.delivery_option = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('doctorclubboApp:delivery_optionUpdate', function(event, result) {
            vm.delivery_option = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('Delivery_optionDeleteController',Delivery_optionDeleteController);

    Delivery_optionDeleteController.$inject = ['$uibModalInstance', 'entity', 'Delivery_option'];

    function Delivery_optionDeleteController($uibModalInstance, entity, Delivery_option) {
        var vm = this;

        vm.delivery_option = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Delivery_option.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('delivery-option', {
            parent: 'entity',
            url: '/delivery-option',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.delivery_option.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/delivery-option/delivery-options.html',
                    controller: 'Delivery_optionController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('delivery_option');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('delivery-option-detail', {
            parent: 'delivery-option',
            url: '/delivery-option/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.delivery_option.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/delivery-option/delivery-option-detail.html',
                    controller: 'Delivery_optionDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('delivery_option');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Delivery_option', function($stateParams, Delivery_option) {
                    return Delivery_option.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'delivery-option',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('delivery-option-detail.edit', {
            parent: 'delivery-option-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/delivery-option/delivery-option-dialog.html',
                    controller: 'Delivery_optionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Delivery_option', function(Delivery_option) {
                            return Delivery_option.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('delivery-option.new', {
            parent: 'delivery-option',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/delivery-option/delivery-option-dialog.html',
                    controller: 'Delivery_optionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nome: null,
                                costo_unitario: null,
                                max_buoni: null,
                                descrizione: null,
                                desctizione_costi: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('delivery-option', null, { reload: 'delivery-option' });
                }, function() {
                    $state.go('delivery-option');
                });
            }]
        })
        .state('delivery-option.edit', {
            parent: 'delivery-option',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/delivery-option/delivery-option-dialog.html',
                    controller: 'Delivery_optionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Delivery_option', function(Delivery_option) {
                            return Delivery_option.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('delivery-option', null, { reload: 'delivery-option' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('delivery-option.delete', {
            parent: 'delivery-option',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/delivery-option/delivery-option-delete-dialog.html',
                    controller: 'Delivery_optionDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Delivery_option', function(Delivery_option) {
                            return Delivery_option.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('delivery-option', null, { reload: 'delivery-option' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('doctorclubboApp')
        .factory('Delivery_option', Delivery_option);

    Delivery_option.$inject = ['$resource'];

    function Delivery_option ($resource) {
        var resourceUrl =  'api/delivery-options/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('Delivery_optionController', Delivery_optionController);

    Delivery_optionController.$inject = ['Delivery_option', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function Delivery_optionController(Delivery_option, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.delivery_options = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;

        loadAll();

        function loadAll () {
            Delivery_option.query({
                page: vm.page,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.delivery_options.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.delivery_options = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('ComuneDialogController', ComuneDialogController);

    ComuneDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Comune'];

    function ComuneDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Comune) {
        var vm = this;

        vm.comune = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.comune.id !== null) {
                Comune.update(vm.comune, onSaveSuccess, onSaveError);
            } else {
                Comune.save(vm.comune, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('doctorclubboApp:comuneUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('ComuneDetailController', ComuneDetailController);

    ComuneDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Comune'];

    function ComuneDetailController($scope, $rootScope, $stateParams, previousState, entity, Comune) {
        var vm = this;

        vm.comune = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('doctorclubboApp:comuneUpdate', function(event, result) {
            vm.comune = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('ComuneDeleteController',ComuneDeleteController);

    ComuneDeleteController.$inject = ['$uibModalInstance', 'entity', 'Comune'];

    function ComuneDeleteController($uibModalInstance, entity, Comune) {
        var vm = this;

        vm.comune = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Comune.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('comune', {
            parent: 'entity',
            url: '/comune',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.comune.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/comune/comunes.html',
                    controller: 'ComuneController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('comune');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('comune-detail', {
            parent: 'entity',
            url: '/comune/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.comune.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/comune/comune-detail.html',
                    controller: 'ComuneDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('comune');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Comune', function($stateParams, Comune) {
                    return Comune.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'comune',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('comune-detail.edit', {
            parent: 'comune-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/comune/comune-dialog.html',
                    controller: 'ComuneDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Comune', function(Comune) {
                            return Comune.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('comune.new', {
            parent: 'comune',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/comune/comune-dialog.html',
                    controller: 'ComuneDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                sigla: null,
                                comune: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('comune', null, { reload: 'comune' });
                }, function() {
                    $state.go('comune');
                });
            }]
        })
        .state('comune.edit', {
            parent: 'comune',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/comune/comune-dialog.html',
                    controller: 'ComuneDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Comune', function(Comune) {
                            return Comune.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('comune', null, { reload: 'comune' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('comune.delete', {
            parent: 'comune',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/comune/comune-delete-dialog.html',
                    controller: 'ComuneDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Comune', function(Comune) {
                            return Comune.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('comune', null, { reload: 'comune' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('doctorclubboApp')
        .factory('Comune', Comune);

    Comune.$inject = ['$resource'];

    function Comune ($resource) {
        var resourceUrl =  'api/comunes/:id?size=2000&sort=comune,asc';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('ComuneController', ComuneController);

    ComuneController.$inject = ['$scope', '$state', 'Comune', 'ParseLinks', 'AlertService'];

    function ComuneController ($scope, $state, Comune, ParseLinks, AlertService) {
        var vm = this;

        vm.comunes = [];
        vm.loadPage = loadPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;

        loadAll();

        function loadAll () {
            Comune.query({
                page: vm.page,
                size: 2000,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.comunes.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.comunes = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('Campagnalog_tipoDialogController', Campagnalog_tipoDialogController);

    Campagnalog_tipoDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Campagnalog_tipo'];

    function Campagnalog_tipoDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Campagnalog_tipo) {
        var vm = this;

        vm.campagnalog_tipo = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.campagnalog_tipo.id !== null) {
                Campagnalog_tipo.update(vm.campagnalog_tipo, onSaveSuccess, onSaveError);
            } else {
                Campagnalog_tipo.save(vm.campagnalog_tipo, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('doctorclubboApp:campagnalog_tipoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('Campagnalog_tipoDetailController', Campagnalog_tipoDetailController);

    Campagnalog_tipoDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Campagnalog_tipo'];

    function Campagnalog_tipoDetailController($scope, $rootScope, $stateParams, previousState, entity, Campagnalog_tipo) {
        var vm = this;

        vm.campagnalog_tipo = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('doctorclubboApp:campagnalog_tipoUpdate', function(event, result) {
            vm.campagnalog_tipo = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('Campagnalog_tipoDeleteController',Campagnalog_tipoDeleteController);

    Campagnalog_tipoDeleteController.$inject = ['$uibModalInstance', 'entity', 'Campagnalog_tipo'];

    function Campagnalog_tipoDeleteController($uibModalInstance, entity, Campagnalog_tipo) {
        var vm = this;

        vm.campagnalog_tipo = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Campagnalog_tipo.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('campagnalog-tipo', {
            parent: 'entity',
            url: '/campagnalog-tipo',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.campagnalog_tipo.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/campagnalog-tipo/campagnalog-tipos.html',
                    controller: 'Campagnalog_tipoController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('campagnalog_tipo');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('campagnalog-tipo-detail', {
            parent: 'entity',
            url: '/campagnalog-tipo/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.campagnalog_tipo.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/campagnalog-tipo/campagnalog-tipo-detail.html',
                    controller: 'Campagnalog_tipoDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('campagnalog_tipo');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Campagnalog_tipo', function($stateParams, Campagnalog_tipo) {
                    return Campagnalog_tipo.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'campagnalog-tipo',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('campagnalog-tipo-detail.edit', {
            parent: 'campagnalog-tipo-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/campagnalog-tipo/campagnalog-tipo-dialog.html',
                    controller: 'Campagnalog_tipoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Campagnalog_tipo', function(Campagnalog_tipo) {
                            return Campagnalog_tipo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('campagnalog-tipo.new', {
            parent: 'campagnalog-tipo',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/campagnalog-tipo/campagnalog-tipo-dialog.html',
                    controller: 'Campagnalog_tipoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nome: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('campagnalog-tipo', null, { reload: 'campagnalog-tipo' });
                }, function() {
                    $state.go('campagnalog-tipo');
                });
            }]
        })
        .state('campagnalog-tipo.edit', {
            parent: 'campagnalog-tipo',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/campagnalog-tipo/campagnalog-tipo-dialog.html',
                    controller: 'Campagnalog_tipoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Campagnalog_tipo', function(Campagnalog_tipo) {
                            return Campagnalog_tipo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('campagnalog-tipo', null, { reload: 'campagnalog-tipo' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('campagnalog-tipo.delete', {
            parent: 'campagnalog-tipo',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/campagnalog-tipo/campagnalog-tipo-delete-dialog.html',
                    controller: 'Campagnalog_tipoDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Campagnalog_tipo', function(Campagnalog_tipo) {
                            return Campagnalog_tipo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('campagnalog-tipo', null, { reload: 'campagnalog-tipo' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('doctorclubboApp')
        .factory('Campagnalog_tipo', Campagnalog_tipo);

    Campagnalog_tipo.$inject = ['$resource'];

    function Campagnalog_tipo ($resource) {
        var resourceUrl =  'api/campagnalog-tipos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('Campagnalog_tipoController', Campagnalog_tipoController);

    Campagnalog_tipoController.$inject = ['$scope', '$state', 'Campagnalog_tipo'];

    function Campagnalog_tipoController ($scope, $state, Campagnalog_tipo) {
        var vm = this;

        vm.campagnalog_tipos = [];

        loadAll();

        function loadAll() {
            Campagnalog_tipo.query(function(result) {
                vm.campagnalog_tipos = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('Campagna_typeDialogController', Campagna_typeDialogController);

    Campagna_typeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Campagna_type'];

    function Campagna_typeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Campagna_type) {
        var vm = this;

        vm.campagna_type = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.campagna_type.id !== null) {
                Campagna_type.update(vm.campagna_type, onSaveSuccess, onSaveError);
            } else {
                Campagna_type.save(vm.campagna_type, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('doctorclubboApp:campagna_typeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('Campagna_typeDetailController', Campagna_typeDetailController);

    Campagna_typeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Campagna_type'];

    function Campagna_typeDetailController($scope, $rootScope, $stateParams, previousState, entity, Campagna_type) {
        var vm = this;

        vm.campagna_type = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('doctorclubboApp:campagna_typeUpdate', function(event, result) {
            vm.campagna_type = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('Campagna_typeDeleteController',Campagna_typeDeleteController);

    Campagna_typeDeleteController.$inject = ['$uibModalInstance', 'entity', 'Campagna_type'];

    function Campagna_typeDeleteController($uibModalInstance, entity, Campagna_type) {
        var vm = this;

        vm.campagna_type = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Campagna_type.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('campagna-type', {
            parent: 'entity',
            url: '/campagna-type?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.campagna_type.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/campagna-type/campagna-types.html',
                    controller: 'Campagna_typeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('campagna_type');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('campagna-type-detail', {
            parent: 'entity',
            url: '/campagna-type/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.campagna_type.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/campagna-type/campagna-type-detail.html',
                    controller: 'Campagna_typeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('campagna_type');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Campagna_type', function($stateParams, Campagna_type) {
                    return Campagna_type.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'campagna-type',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('campagna-type-detail.edit', {
            parent: 'campagna-type-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/campagna-type/campagna-type-dialog.html',
                    controller: 'Campagna_typeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Campagna_type', function(Campagna_type) {
                            return Campagna_type.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('campagna-type.new', {
            parent: 'campagna-type',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/campagna-type/campagna-type-dialog.html',
                    controller: 'Campagna_typeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nome: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('campagna-type', null, { reload: 'campagna-type' });
                }, function() {
                    $state.go('campagna-type');
                });
            }]
        })
        .state('campagna-type.edit', {
            parent: 'campagna-type',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/campagna-type/campagna-type-dialog.html',
                    controller: 'Campagna_typeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Campagna_type', function(Campagna_type) {
                            return Campagna_type.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('campagna-type', null, { reload: 'campagna-type' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('campagna-type.delete', {
            parent: 'campagna-type',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/campagna-type/campagna-type-delete-dialog.html',
                    controller: 'Campagna_typeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Campagna_type', function(Campagna_type) {
                            return Campagna_type.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('campagna-type', null, { reload: 'campagna-type' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('doctorclubboApp')
        .factory('Campagna_type', Campagna_type);

    Campagna_type.$inject = ['$resource'];

    function Campagna_type ($resource) {
        var resourceUrl =  'api/campagna-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('Campagna_typeController', Campagna_typeController);

    Campagna_typeController.$inject = ['$scope', '$state', 'Campagna_type', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function Campagna_typeController ($scope, $state, Campagna_type, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            Campagna_type.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.campagna_types = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('CampagnaStatusDialogController', CampagnaStatusDialogController);

    CampagnaStatusDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'CampagnaStatus'];

    function CampagnaStatusDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, CampagnaStatus) {
        var vm = this;

        vm.campagnaStatus = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.campagnaStatus.id !== null) {
                CampagnaStatus.update(vm.campagnaStatus, onSaveSuccess, onSaveError);
            } else {
                CampagnaStatus.save(vm.campagnaStatus, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('doctorclubboApp:campagnaStatusUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('CampagnaStatusDetailController', CampagnaStatusDetailController);

    CampagnaStatusDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'CampagnaStatus'];

    function CampagnaStatusDetailController($scope, $rootScope, $stateParams, previousState, entity, CampagnaStatus) {
        var vm = this;

        vm.campagnaStatus = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('doctorclubboApp:campagnaStatusUpdate', function(event, result) {
            vm.campagnaStatus = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('CampagnaStatusDeleteController',CampagnaStatusDeleteController);

    CampagnaStatusDeleteController.$inject = ['$uibModalInstance', 'entity', 'CampagnaStatus'];

    function CampagnaStatusDeleteController($uibModalInstance, entity, CampagnaStatus) {
        var vm = this;

        vm.campagnaStatus = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CampagnaStatus.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('campagna-status', {
            parent: 'entity',
            url: '/campagna-status',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.campagnaStatus.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/campagna-status/campagna-statuses.html',
                    controller: 'CampagnaStatusController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('campagnaStatus');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('campagna-status-detail', {
            parent: 'entity',
            url: '/campagna-status/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.campagnaStatus.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/campagna-status/campagna-status-detail.html',
                    controller: 'CampagnaStatusDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('campagnaStatus');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CampagnaStatus', function($stateParams, CampagnaStatus) {
                    return CampagnaStatus.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'campagna-status',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('campagna-status-detail.edit', {
            parent: 'campagna-status-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/campagna-status/campagna-status-dialog.html',
                    controller: 'CampagnaStatusDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CampagnaStatus', function(CampagnaStatus) {
                            return CampagnaStatus.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('campagna-status.new', {
            parent: 'campagna-status',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/campagna-status/campagna-status-dialog.html',
                    controller: 'CampagnaStatusDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                status: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('campagna-status', null, { reload: 'campagna-status' });
                }, function() {
                    $state.go('campagna-status');
                });
            }]
        })
        .state('campagna-status.edit', {
            parent: 'campagna-status',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/campagna-status/campagna-status-dialog.html',
                    controller: 'CampagnaStatusDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CampagnaStatus', function(CampagnaStatus) {
                            return CampagnaStatus.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('campagna-status', null, { reload: 'campagna-status' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('campagna-status.delete', {
            parent: 'campagna-status',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/campagna-status/campagna-status-delete-dialog.html',
                    controller: 'CampagnaStatusDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CampagnaStatus', function(CampagnaStatus) {
                            return CampagnaStatus.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('campagna-status', null, { reload: 'campagna-status' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('doctorclubboApp')
        .factory('CampagnaStatus', CampagnaStatus);

    CampagnaStatus.$inject = ['$resource'];

    function CampagnaStatus ($resource) {
        var resourceUrl =  'api/campagna-statuses/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('CampagnaStatusController', CampagnaStatusController);

    CampagnaStatusController.$inject = ['$scope', '$state', 'CampagnaStatus', 'ParseLinks', 'AlertService'];

    function CampagnaStatusController ($scope, $state, CampagnaStatus, ParseLinks, AlertService) {
        var vm = this;

        vm.campagnaStatuses = [];
        vm.loadPage = loadPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;

        loadAll();

        function loadAll () {
            CampagnaStatus.query({
                page: vm.page,
                size: 20,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.campagnaStatuses.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.campagnaStatuses = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('Campagna_logDialogController', Campagna_logDialogController);

    Campagna_logDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Campagna_log', 'Campagna', 'Campagnalog_tipo'];

    function Campagna_logDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Campagna_log, Campagna, Campagnalog_tipo) {
        var vm = this;

        vm.campagna_log = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.campagnas = Campagna.query();
        vm.campagnalog_tipos = Campagnalog_tipo.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.campagna_log.id !== null) {
                Campagna_log.update(vm.campagna_log, onSaveSuccess, onSaveError);
            } else {
                Campagna_log.save(vm.campagna_log, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('doctorclubboApp:campagna_logUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.dtins = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('Campagna_logDetailController', Campagna_logDetailController);

    Campagna_logDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Campagna_log', 'Campagna', 'Campagnalog_tipo'];

    function Campagna_logDetailController($scope, $rootScope, $stateParams, previousState, entity, Campagna_log, Campagna, Campagnalog_tipo) {
        var vm = this;

        vm.campagna_log = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('doctorclubboApp:campagna_logUpdate', function(event, result) {
            vm.campagna_log = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('Campagna_logDeleteController',Campagna_logDeleteController);

    Campagna_logDeleteController.$inject = ['$uibModalInstance', 'entity', 'Campagna_log'];

    function Campagna_logDeleteController($uibModalInstance, entity, Campagna_log) {
        var vm = this;

        vm.campagna_log = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Campagna_log.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('campagna-log', {
            parent: 'entity',
            url: '/campagna-log?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.campagna_log.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/campagna-log/campagna-logs.html',
                    controller: 'Campagna_logController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('campagna_log');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('campagna-log-detail', {
            parent: 'entity',
            url: '/campagna-log/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.campagna_log.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/campagna-log/campagna-log-detail.html',
                    controller: 'Campagna_logDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('campagna_log');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Campagna_log', function($stateParams, Campagna_log) {
                    return Campagna_log.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'campagna-log',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('campagna-log-detail.edit', {
            parent: 'campagna-log-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/campagna-log/campagna-log-dialog.html',
                    controller: 'Campagna_logDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Campagna_log', function(Campagna_log) {
                            return Campagna_log.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('campagna-log.new', {
            parent: 'campagna-log',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/campagna-log/campagna-log-dialog.html',
                    controller: 'Campagna_logDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                causale: null,
                                tipo: null,
                                segno: null,
                                campagnaid: null,
                                importo: null,
                                dtins: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('campagna-log', null, { reload: 'campagna-log' });
                }, function() {
                    $state.go('campagna-log');
                });
            }]
        })
        .state('campagna-log.edit', {
            parent: 'campagna-log',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/campagna-log/campagna-log-dialog.html',
                    controller: 'Campagna_logDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Campagna_log', function(Campagna_log) {
                            return Campagna_log.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('campagna-log', null, { reload: 'campagna-log' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('campagna-log.delete', {
            parent: 'campagna-log',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/campagna-log/campagna-log-delete-dialog.html',
                    controller: 'Campagna_logDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Campagna_log', function(Campagna_log) {
                            return Campagna_log.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('campagna-log', null, { reload: 'campagna-log' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('doctorclubboApp')
        .factory('Campagna_log', Campagna_log);

    Campagna_log.$inject = ['$resource', 'DateUtils'];

    function Campagna_log ($resource, DateUtils) {
        var resourceUrl =  'api/campagna-logs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dtins = DateUtils.convertDateTimeFromServer(data.dtins);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('Campagna_logController', Campagna_logController);

    Campagna_logController.$inject = ['$scope', '$state', 'Campagna_log', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function Campagna_logController ($scope, $state, Campagna_log, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            Campagna_log.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.campagna_logs = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('CampagnaAmazonDialogController', CampagnaAmazonDialogController);

    CampagnaAmazonDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'CampagnaAmazon', 'Queue_status', 'User'];

    function CampagnaAmazonDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, CampagnaAmazon, Queue_status, User) {
        var vm = this;

        vm.campagnaAmazon = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.queue_statuses = Queue_status.query();
        vm.users = User.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.campagnaAmazon.id !== null) {
                CampagnaAmazon.update(vm.campagnaAmazon, onSaveSuccess, onSaveError);
            } else {
                CampagnaAmazon.save(vm.campagnaAmazon, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('doctorclubboApp:campagnaAmazonUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.datains = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('CampagnaAmazonDetailController', CampagnaAmazonDetailController);

    CampagnaAmazonDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'CampagnaAmazon', 'Queue_status', 'User'];

    function CampagnaAmazonDetailController($scope, $rootScope, $stateParams, previousState, entity, CampagnaAmazon, Queue_status, User) {
        var vm = this;

        vm.campagnaAmazon = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('doctorclubboApp:campagnaAmazonUpdate', function(event, result) {
            vm.campagnaAmazon = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('CampagnaAmazonDeleteController',CampagnaAmazonDeleteController);

    CampagnaAmazonDeleteController.$inject = ['$uibModalInstance', 'entity', 'CampagnaAmazon'];

    function CampagnaAmazonDeleteController($uibModalInstance, entity, CampagnaAmazon) {
        var vm = this;

        vm.campagnaAmazon = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CampagnaAmazon.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('campagna-amazon', {
            parent: 'entity',
            url: '/campagna-amazon?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.campagnaAmazon.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/campagna-amazon/campagna-amazons.html',
                    controller: 'CampagnaAmazonController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('campagnaAmazon');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('campagna-amazon-detail', {
            parent: 'campagna-amazon',
            url: '/campagna-amazon/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.campagnaAmazon.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/campagna-amazon/campagna-amazon-detail.html',
                    controller: 'CampagnaAmazonDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('campagnaAmazon');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CampagnaAmazon', function($stateParams, CampagnaAmazon) {
                    return CampagnaAmazon.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'campagna-amazon',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('campagna-amazon-detail.edit', {
            parent: 'campagna-amazon-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/campagna-amazon/campagna-amazon-dialog.html',
                    controller: 'CampagnaAmazonDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CampagnaAmazon', function(CampagnaAmazon) {
                            return CampagnaAmazon.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('campagna-amazon.new', {
            parent: 'campagna-amazon',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/campagna-amazon/campagna-amazon-dialog.html',
                    controller: 'CampagnaAmazonDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nome: null,
                                datains: null,
                                csv: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('campagna-amazon', null, { reload: 'campagna-amazon' });
                }, function() {
                    $state.go('campagna-amazon');
                });
            }]
        })
        .state('campagna-amazon.edit', {
            parent: 'campagna-amazon',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/campagna-amazon/campagna-amazon-dialog.html',
                    controller: 'CampagnaAmazonDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CampagnaAmazon', function(CampagnaAmazon) {
                            return CampagnaAmazon.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('campagna-amazon', null, { reload: 'campagna-amazon' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('campagna-amazon.delete', {
            parent: 'campagna-amazon',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/campagna-amazon/campagna-amazon-delete-dialog.html',
                    controller: 'CampagnaAmazonDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CampagnaAmazon', function(CampagnaAmazon) {
                            return CampagnaAmazon.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('campagna-amazon', null, { reload: 'campagna-amazon' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('doctorclubboApp')
        .factory('CampagnaAmazon', CampagnaAmazon);

    CampagnaAmazon.$inject = ['$resource', 'DateUtils'];

    function CampagnaAmazon ($resource, DateUtils) {
        var resourceUrl =  'api/campagna-amazons/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.datains = DateUtils.convertDateTimeFromServer(data.datains);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('CampagnaAmazonController', CampagnaAmazonController);

    CampagnaAmazonController.$inject = ['$state', 'CampagnaAmazon', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function CampagnaAmazonController($state, CampagnaAmazon, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            CampagnaAmazon.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.campagnaAmazons = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('CampagnaDialogController', CampagnaDialogController);


    CampagnaDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Campagna', 'Agenzia', 'CampagnaStatus', 'Campagna_type', 'User'];

    function CampagnaDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Campagna, Agenzia, CampagnaStatus, Campagna_type, User) {

        var vm = this;

        vm.campagna = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.agenzias = Agenzia.query();
        vm.campagna_statuses = CampagnaStatus.query();
        vm.campagna_types = Campagna_type.query();
        vm.campagna_users = User.query();


        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.campagna.id !== null) {
                Campagna.update(vm.campagna, onSaveSuccess, onSaveError);
            } else {
                Campagna.save(vm.campagna, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('doctorclubboApp:campagnaUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.dtStart = false;
        vm.datePickerOpenStatus.dtEnd = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('CampagnaDetailController', CampagnaDetailController);


    CampagnaDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Campagna', 'Agenzia', 'CampagnaStatus', 'Campagna_type'];

    function CampagnaDetailController($scope, $rootScope, $stateParams, previousState, entity, Campagna, Agenzia, CampagnaStatus, Campagna_type) {

        var vm = this;

        vm.campagna = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('doctorclubboApp:campagnaUpdate', function(event, result) {
            vm.campagna = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('CampagnaDeleteController',CampagnaDeleteController);

    CampagnaDeleteController.$inject = ['$uibModalInstance', 'entity', 'Campagna'];

    function CampagnaDeleteController($uibModalInstance, entity, Campagna) {
        var vm = this;

        vm.campagna = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Campagna.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('campagna', {
            parent: 'entity',
            url: '/campagna?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.campagna.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/campagna/campagnas.html',
                    controller: 'CampagnaController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('campagna');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('campagna-detail', {
            parent: 'entity',
            url: '/campagna/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.campagna.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/campagna/campagna-detail.html',
                    controller: 'CampagnaDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('campagna');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Campagna', function($stateParams, Campagna) {
                    return Campagna.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'campagna',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('campagna-detail.edit', {
            parent: 'campagna-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/campagna/campagna-dialog.html',
                    controller: 'CampagnaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Campagna', function(Campagna) {
                            return Campagna.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('campagna.new', {
            parent: 'campagna',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/campagna/campagna-dialog.html',
                    controller: 'CampagnaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nome: null,
                                agenziaId: null,
                                dtStart: null,
                                dtEnd: null,
                                status: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('campagna', null, { reload: 'campagna' });
                }, function() {
                    $state.go('campagna');
                });
            }]
        })
        .state('campagna.edit', {
            parent: 'campagna',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/campagna/campagna-dialog.html',
                    controller: 'CampagnaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Campagna', function(Campagna) {
                            return Campagna.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('campagna', null, { reload: 'campagna' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('campagna.delete', {
            parent: 'campagna',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/campagna/campagna-delete-dialog.html',
                    controller: 'CampagnaDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Campagna', function(Campagna) {
                            return Campagna.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('campagna', null, { reload: 'campagna' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('doctorclubboApp')
        .factory('Campagna', Campagna);

    Campagna.$inject = ['$resource', 'DateUtils'];

    function Campagna ($resource, DateUtils) {
        var resourceUrl =  'api/campagnas/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dtStart = DateUtils.convertDateTimeFromServer(data.dtStart);
                        data.dtEnd = DateUtils.convertDateTimeFromServer(data.dtEnd);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('CampagnaController', CampagnaController);

    CampagnaController.$inject = ['$scope', '$state', 'Campagna', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function CampagnaController ($scope, $state, Campagna, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            Campagna.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.campagnas = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('AzioneDialogController', AzioneDialogController);

    AzioneDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Azione'];

    function AzioneDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Azione) {
        var vm = this;

        vm.azione = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.azione.id !== null) {
                Azione.update(vm.azione, onSaveSuccess, onSaveError);
            } else {
                Azione.save(vm.azione, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('doctorclubboApp:azioneUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('AzioneDetailController', AzioneDetailController);

    AzioneDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Azione'];

    function AzioneDetailController($scope, $rootScope, $stateParams, previousState, entity, Azione) {
        var vm = this;

        vm.azione = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('doctorclubboApp:azioneUpdate', function(event, result) {
            vm.azione = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('AzioneDeleteController',AzioneDeleteController);

    AzioneDeleteController.$inject = ['$uibModalInstance', 'entity', 'Azione'];

    function AzioneDeleteController($uibModalInstance, entity, Azione) {
        var vm = this;

        vm.azione = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Azione.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('azione', {
            parent: 'entity',
            url: '/azione',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.azione.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/azione/aziones.html',
                    controller: 'AzioneController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('azione');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('azione-detail', {
            parent: 'azione',
            url: '/azione/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.azione.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/azione/azione-detail.html',
                    controller: 'AzioneDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('azione');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Azione', function($stateParams, Azione) {
                    return Azione.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'azione',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('azione-detail.edit', {
            parent: 'azione-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/azione/azione-dialog.html',
                    controller: 'AzioneDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Azione', function(Azione) {
                            return Azione.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('azione.new', {
            parent: 'azione',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/azione/azione-dialog.html',
                    controller: 'AzioneDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nome: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('azione', null, { reload: 'azione' });
                }, function() {
                    $state.go('azione');
                });
            }]
        })
        .state('azione.edit', {
            parent: 'azione',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/azione/azione-dialog.html',
                    controller: 'AzioneDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Azione', function(Azione) {
                            return Azione.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('azione', null, { reload: 'azione' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('azione.delete', {
            parent: 'azione',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/azione/azione-delete-dialog.html',
                    controller: 'AzioneDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Azione', function(Azione) {
                            return Azione.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('azione', null, { reload: 'azione' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('doctorclubboApp')
        .factory('Azione', Azione);

    Azione.$inject = ['$resource'];

    function Azione ($resource) {
        var resourceUrl =  'api/aziones/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('AzioneController', AzioneController);

    AzioneController.$inject = ['Azione', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function AzioneController(Azione, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.aziones = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;

        loadAll();

        function loadAll () {
            Azione.query({
                page: vm.page,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.aziones.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.aziones = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('AttivitaDialogController', AttivitaDialogController);

    AttivitaDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Attivita'];

    function AttivitaDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Attivita) {
        var vm = this;

        vm.attivita = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.attivita.id !== null) {
                Attivita.update(vm.attivita, onSaveSuccess, onSaveError);
            } else {
                Attivita.save(vm.attivita, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('doctorclubboApp:attivitaUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('AttivitaDetailController', AttivitaDetailController);

    AttivitaDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Attivita'];

    function AttivitaDetailController($scope, $rootScope, $stateParams, previousState, entity, Attivita) {
        var vm = this;

        vm.attivita = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('doctorclubboApp:attivitaUpdate', function(event, result) {
            vm.attivita = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('AttivitaDeleteController',AttivitaDeleteController);

    AttivitaDeleteController.$inject = ['$uibModalInstance', 'entity', 'Attivita'];

    function AttivitaDeleteController($uibModalInstance, entity, Attivita) {
        var vm = this;

        vm.attivita = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Attivita.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('attivita', {
            parent: 'entity',
            url: '/attivita',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.attivita.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/attivita/attivitas.html',
                    controller: 'AttivitaController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('attivita');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('attivita-detail', {
            parent: 'entity',
            url: '/attivita/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.attivita.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/attivita/attivita-detail.html',
                    controller: 'AttivitaDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('attivita');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Attivita', function($stateParams, Attivita) {
                    return Attivita.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'attivita',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('attivita-detail.edit', {
            parent: 'attivita-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/attivita/attivita-dialog.html',
                    controller: 'AttivitaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Attivita', function(Attivita) {
                            return Attivita.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('attivita.new', {
            parent: 'attivita',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/attivita/attivita-dialog.html',
                    controller: 'AttivitaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                attivita: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('attivita', null, { reload: 'attivita' });
                }, function() {
                    $state.go('attivita');
                });
            }]
        })
        .state('attivita.edit', {
            parent: 'attivita',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/attivita/attivita-dialog.html',
                    controller: 'AttivitaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Attivita', function(Attivita) {
                            return Attivita.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('attivita', null, { reload: 'attivita' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('attivita.delete', {
            parent: 'attivita',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/attivita/attivita-delete-dialog.html',
                    controller: 'AttivitaDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Attivita', function(Attivita) {
                            return Attivita.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('attivita', null, { reload: 'attivita' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('doctorclubboApp')
        .factory('Attivita', Attivita);

    Attivita.$inject = ['$resource'];

    function Attivita ($resource) {
        var resourceUrl =  'api/attivitas/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('AttivitaController', AttivitaController);

    AttivitaController.$inject = ['$scope', '$state', 'Attivita'];

    function AttivitaController ($scope, $state, Attivita) {
        var vm = this;

        vm.attivitas = [];

        loadAll();

        function loadAll() {
            Attivita.query(function(result) {
                vm.attivitas = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('AreaDialogController', AreaDialogController);

    AreaDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Area'];

    function AreaDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Area) {
        var vm = this;

        vm.area = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.area.id !== null) {
                Area.update(vm.area, onSaveSuccess, onSaveError);
            } else {
                Area.save(vm.area, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('doctorclubboApp:areaUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('AreaDetailController', AreaDetailController);

    AreaDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Area'];

    function AreaDetailController($scope, $rootScope, $stateParams, previousState, entity, Area) {
        var vm = this;

        vm.area = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('doctorclubboApp:areaUpdate', function(event, result) {
            vm.area = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('AreaDeleteController',AreaDeleteController);

    AreaDeleteController.$inject = ['$uibModalInstance', 'entity', 'Area'];

    function AreaDeleteController($uibModalInstance, entity, Area) {
        var vm = this;

        vm.area = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Area.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('area', {
            parent: 'entity',
            url: '/area',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.area.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/area/areas.html',
                    controller: 'AreaController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('area');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('area-detail', {
            parent: 'area',
            url: '/area/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.area.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/area/area-detail.html',
                    controller: 'AreaDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('area');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Area', function($stateParams, Area) {
                    return Area.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'area',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('area-detail.edit', {
            parent: 'area-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/area/area-dialog.html',
                    controller: 'AreaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Area', function(Area) {
                            return Area.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('area.new', {
            parent: 'area',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/area/area-dialog.html',
                    controller: 'AreaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nome: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('area', null, { reload: 'area' });
                }, function() {
                    $state.go('area');
                });
            }]
        })
        .state('area.edit', {
            parent: 'area',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/area/area-dialog.html',
                    controller: 'AreaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Area', function(Area) {
                            return Area.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('area', null, { reload: 'area' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('area.delete', {
            parent: 'area',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/area/area-delete-dialog.html',
                    controller: 'AreaDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Area', function(Area) {
                            return Area.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('area', null, { reload: 'area' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('doctorclubboApp')
        .factory('Area', Area);

    Area.$inject = ['$resource'];

    function Area ($resource) {
        var resourceUrl =  'api/areas/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('AreaController', AreaController);

    AreaController.$inject = ['Area', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function AreaController(Area, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.areas = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;

        loadAll();

        function loadAll () {
            Area.query({
                page: vm.page,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.areas.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.areas = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('AmazonStatementDialogController', AmazonStatementDialogController);

    AmazonStatementDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'AmazonStatement', 'GcSystem', 'CampagnaAmazon'];

    function AmazonStatementDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, AmazonStatement, GcSystem, CampagnaAmazon) {
        var vm = this;

        vm.amazonStatement = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.gcsystems = GcSystem.query();
        vm.campagnaamazons = CampagnaAmazon.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.amazonStatement.id !== null) {
                AmazonStatement.update(vm.amazonStatement, onSaveSuccess, onSaveError);
            } else {
                AmazonStatement.save(vm.amazonStatement, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('doctorclubboApp:amazonStatementUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.dtIns = false;
        vm.datePickerOpenStatus.gcExpirationDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('AmazonStatementDetailController', AmazonStatementDetailController);

    AmazonStatementDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'AmazonStatement', 'GcSystem', 'CampagnaAmazon'];

    function AmazonStatementDetailController($scope, $rootScope, $stateParams, previousState, entity, AmazonStatement, GcSystem, CampagnaAmazon) {
        var vm = this;

        vm.amazonStatement = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('doctorclubboApp:amazonStatementUpdate', function(event, result) {
            vm.amazonStatement = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('AmazonStatementDeleteController',AmazonStatementDeleteController);

    AmazonStatementDeleteController.$inject = ['$uibModalInstance', 'entity', 'AmazonStatement'];

    function AmazonStatementDeleteController($uibModalInstance, entity, AmazonStatement) {
        var vm = this;

        vm.amazonStatement = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            AmazonStatement.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('amazon-statement', {
            parent: 'entity',
            url: '/amazon-statement?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.amazonStatement.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/amazon-statement/amazon-statements.html',
                    controller: 'AmazonStatementController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('amazonStatement');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('amazon-statement-detail', {
            parent: 'amazon-statement',
            url: '/amazon-statement/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.amazonStatement.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/amazon-statement/amazon-statement-detail.html',
                    controller: 'AmazonStatementDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('amazonStatement');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'AmazonStatement', function($stateParams, AmazonStatement) {
                    return AmazonStatement.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'amazon-statement',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('amazon-statement-detail.edit', {
            parent: 'amazon-statement-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/amazon-statement/amazon-statement-dialog.html',
                    controller: 'AmazonStatementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['AmazonStatement', function(AmazonStatement) {
                            return AmazonStatement.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('amazon-statement.new', {
            parent: 'amazon-statement',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/amazon-statement/amazon-statement-dialog.html',
                    controller: 'AmazonStatementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                dtIns: null,
                                gcClaimCode: null,
                                gcId: null,
                                creationRequestId: null,
                                emailSource: null,
                                emailDestination: null,
                                currencyCode: null,
                                amount: null,
                                cardStatus: null,
                                status: null,
                                processed: null,
                                gcExpirationDate: null,
                                operationCode: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('amazon-statement', null, { reload: 'amazon-statement' });
                }, function() {
                    $state.go('amazon-statement');
                });
            }]
        })
        .state('amazon-statement.edit', {
            parent: 'amazon-statement',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/amazon-statement/amazon-statement-dialog.html',
                    controller: 'AmazonStatementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['AmazonStatement', function(AmazonStatement) {
                            return AmazonStatement.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('amazon-statement', null, { reload: 'amazon-statement' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('amazon-statement.delete', {
            parent: 'amazon-statement',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/amazon-statement/amazon-statement-delete-dialog.html',
                    controller: 'AmazonStatementDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['AmazonStatement', function(AmazonStatement) {
                            return AmazonStatement.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('amazon-statement', null, { reload: 'amazon-statement' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('doctorclubboApp')
        .factory('AmazonStatement', AmazonStatement);

    AmazonStatement.$inject = ['$resource', 'DateUtils'];

    function AmazonStatement ($resource, DateUtils) {
        var resourceUrl =  'api/amazon-statements/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dtIns = DateUtils.convertDateTimeFromServer(data.dtIns);
                        data.gcExpirationDate = DateUtils.convertDateTimeFromServer(data.gcExpirationDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('AmazonStatementController', AmazonStatementController);

    AmazonStatementController.$inject = ['$state', 'AmazonStatement', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function AmazonStatementController($state, AmazonStatement, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            AmazonStatement.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.amazonStatements = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('AgenziaDialogController', AgenziaDialogController);

    AgenziaDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Agenzia', 'Comune', 'Provincia'];

    function AgenziaDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Agenzia, Comune, Provincia) {
        var vm = this;

        vm.agenzia = entity;
        vm.clear = clear;
        vm.save = save;
        vm.comunes = Comune.query();
        vm.provincias = Provincia.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.agenzia.id !== null) {
                Agenzia.update(vm.agenzia, onSaveSuccess, onSaveError);
            } else {
                Agenzia.save(vm.agenzia, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('doctorclubboApp:agenziaUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('AgenziaDetailController', AgenziaDetailController);

    AgenziaDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Agenzia', 'Comune', 'Provincia'];

    function AgenziaDetailController($scope, $rootScope, $stateParams, previousState, entity, Agenzia, Comune, Provincia) {
        var vm = this;

        vm.agenzia = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('doctorclubboApp:agenziaUpdate', function(event, result) {
            vm.agenzia = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('AgenziaDeleteController',AgenziaDeleteController);

    AgenziaDeleteController.$inject = ['$uibModalInstance', 'entity', 'Agenzia'];

    function AgenziaDeleteController($uibModalInstance, entity, Agenzia) {
        var vm = this;

        vm.agenzia = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Agenzia.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('agenzia', {
            parent: 'entity',
            url: '/agenzia?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.agenzia.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/agenzia/agenzias.html',
                    controller: 'AgenziaController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('agenzia');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('agenzia-detail', {
            parent: 'entity',
            url: '/agenzia/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.agenzia.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/agenzia/agenzia-detail.html',
                    controller: 'AgenziaDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('agenzia');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Agenzia', function($stateParams, Agenzia) {
                    return Agenzia.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'agenzia',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('agenzia-detail.edit', {
            parent: 'agenzia-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/agenzia/agenzia-dialog.html',
                    controller: 'AgenziaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Agenzia', function(Agenzia) {
                            return Agenzia.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('agenzia.new', {
            parent: 'agenzia',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/agenzia/agenzia-dialog.html',
                    controller: 'AgenziaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nome: null,
                                provincia: null,
                                comune: null,
                                cap: null,
                                indirizzo: null,
                                tel: null,
                                email: null,
                                partitaIva: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('agenzia', null, { reload: 'agenzia' });
                }, function() {
                    $state.go('agenzia');
                });
            }]
        })
        .state('agenzia.edit', {
            parent: 'agenzia',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/agenzia/agenzia-dialog.html',
                    controller: 'AgenziaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Agenzia', function(Agenzia) {
                            return Agenzia.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('agenzia', null, { reload: 'agenzia' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('agenzia.delete', {
            parent: 'agenzia',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/agenzia/agenzia-delete-dialog.html',
                    controller: 'AgenziaDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Agenzia', function(Agenzia) {
                            return Agenzia.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('agenzia', null, { reload: 'agenzia' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('doctorclubboApp')
        .factory('Agenzia', Agenzia);

    Agenzia.$inject = ['$resource'];

    function Agenzia ($resource) {
        var resourceUrl =  'api/agenzias/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('AgenziaController', AgenziaController);

    AgenziaController.$inject = ['$scope', '$state', 'Agenzia', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function AgenziaController ($scope, $state, Agenzia, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            Agenzia.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.agenzias = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .filter('words', words);

    function words() {
        return wordsFilter;

        function wordsFilter(input, words) {
            if (isNaN(words)) {
                return input;
            }
            if (words <= 0) {
                return '';
            }
            if (input) {
                var inputWords = input.split(/\s+/);
                if (inputWords.length > words) {
                    input = inputWords.slice(0, words).join(' ') + '...';
                }
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .filter('characters', characters);

    function characters () {
        return charactersFilter;

        function charactersFilter(input, chars, breakOnWord) {
            if (isNaN(chars)) {
                return input;
            }
            if (chars <= 0) {
                return '';
            }
            if (input && input.length > chars) {
                input = input.substring(0, chars);

                if (!breakOnWord) {
                    var lastspace = input.lastIndexOf(' ');
                    // Get last space
                    if (lastspace !== -1) {
                        input = input.substr(0, lastspace);
                    }
                } else {
                    while (input.charAt(input.length-1) === ' ') {
                        input = input.substr(0, input.length - 1);
                    }
                }
                return input + '...';
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .directive('jhSortBy', jhSortBy);

    function jhSortBy() {
        var directive = {
            restrict: 'A',
            scope: false,
            require: '^jhSort',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs, parentCtrl) {
            element.bind('click', function () {
                parentCtrl.sort(attrs.jhSortBy);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .directive('jhSort', jhSort);

    function jhSort () {
        var directive = {
            restrict: 'A',
            scope: {
                predicate: '=jhSort',
                ascending: '=',
                callback: '&'
            },
            controller: SortController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;
    }

    SortController.$inject = ['$scope', '$element'];

    function SortController ($scope, $element) {
        var vm = this;

        vm.applyClass = applyClass;
        vm.resetClasses = resetClasses;
        vm.sort = sort;
        vm.triggerApply = triggerApply;

        $scope.$watchGroup(['vm.predicate', 'vm.ascending'], vm.triggerApply);
        vm.triggerApply();

        function applyClass (element) {
            var thisIcon = element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt',
                remove = sortIcon + ' ' + sortDesc,
                add = sortAsc;
            if (!vm.ascending) {
                remove = sortIcon + ' ' + sortAsc;
                add = sortDesc;
            }
            vm.resetClasses();
            thisIcon.removeClass(remove);
            thisIcon.addClass(add);
        }

        function resetClasses () {
            var allThIcons = $element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt';
            allThIcons.removeClass(sortAsc + ' ' + sortDesc);
            allThIcons.addClass(sortIcon);
        }

        function sort (field) {
            if (field !== vm.predicate) {
                vm.ascending = true;
            } else {
                vm.ascending = !vm.ascending;
            }
            vm.predicate = field;
            $scope.$apply();
            vm.callback();
        }

        function triggerApply (values)  {
            vm.resetClasses();
            if (values && values[0] !== '_score') {
                vm.applyClass($element.find('th[jh-sort-by=\'' + values[0] + '\']'));
            }
        }
    }
})();

(function(){
    'use strict';

    angular
        .module('doctorclubboApp')
        .factory('ParseLinks', ParseLinks);

    function ParseLinks () {

        var service = {
            parse : parse
        };

        return service;

        function parse(header) {
            if (header.length === 0) {
                throw new Error('input must not be of zero length');
            }

            // Split parts by comma
            var parts = header.split(',');
            var links = {};
            // Parse each part into a named link
            angular.forEach(parts, function(p) {
                var section = p.split('>;');
                if (section.length !== 2) {
                    throw new Error('section could not be split on ">;"');
                }
                var url = section[0].replace(/<(.*)/, '$1').trim();
                var queryString = {};
                url.replace(
                    new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
                    function($0, $1, $2, $3) { queryString[$1] = $3; }
                );
                var page = queryString.page;
                if (angular.isString(page)) {
                    page = parseInt(page);
                }
                var name = section[1].replace(/rel="(.*)"/, '$1').trim();
                links[name] = page;
            });
            return links;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('doctorclubboApp')
        .factory('PaginationUtil', PaginationUtil);

    function PaginationUtil () {

        var service = {
            parseAscending : parseAscending,
            parsePage : parsePage,
            parsePredicate : parsePredicate
        };

        return service;

        function parseAscending (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                return sort.split(',').slice(-1)[0] === 'asc';
            } else {
                // default to true if no sort defined
                return true;
            }
        }

        // query params are strings, and need to be parsed
        function parsePage (page) {
            return parseInt(page);
        }

        // sort can be in the format `id,asc` or `id`
        function parsePredicate (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                sortArray.pop();
            }
            return sortArray.join(',');
        }
    }
})();

(function() {
    'use strict';

    var jhiItemCount = {
        template: '<div class="info">' +
                    'Showing {{(($ctrl.page - 1) * $ctrl.itemsPerPage) == 0 ? 1 : (($ctrl.page - 1) * $ctrl.itemsPerPage + 1)}} - ' +
                    '{{($ctrl.page * $ctrl.itemsPerPage) < $ctrl.queryCount ? ($ctrl.page * $ctrl.itemsPerPage) : $ctrl.queryCount}} ' +
                    'of {{$ctrl.queryCount}} items.' +
                '</div>',
        bindings: {
            page: '<',
            queryCount: '<total',
            itemsPerPage: '<'
        }
    };

    angular
        .module('doctorclubboApp')
        .component('jhiItemCount', jhiItemCount);
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .factory('DateUtils', DateUtils);

    DateUtils.$inject = ['$filter'];

    function DateUtils ($filter) {

        var service = {
            convertDateTimeFromServer : convertDateTimeFromServer,
            convertLocalDateFromServer : convertLocalDateFromServer,
            convertLocalDateToServer : convertLocalDateToServer,
            dateformat : dateformat
        };

        return service;

        function convertDateTimeFromServer (date) {
            if (date) {
                return new Date(date);
            } else {
                return null;
            }
        }

        function convertLocalDateFromServer (date) {
            if (date) {
                var dateString = date.split('-');
                return new Date(dateString[0], dateString[1] - 1, dateString[2]);
            }
            return null;
        }

        function convertLocalDateToServer (date) {
            if (date) {
                return $filter('date')(date, 'yyyy-MM-dd');
            } else {
                return null;
            }
        }

        function dateformat () {
            return 'yyyy-MM-dd';
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .factory('DataUtils', DataUtils);

    DataUtils.$inject = ['$window'];

    function DataUtils ($window) {

        var service = {
            abbreviate: abbreviate,
            byteSize: byteSize,
            openFile: openFile,
            toBase64: toBase64
        };

        return service;

        function abbreviate (text) {
            if (!angular.isString(text)) {
                return '';
            }
            if (text.length < 30) {
                return text;
            }
            return text ? (text.substring(0, 15) + '...' + text.slice(-10)) : '';
        }

        function byteSize (base64String) {
            if (!angular.isString(base64String)) {
                return '';
            }

            function endsWith(suffix, str) {
                return str.indexOf(suffix, str.length - suffix.length) !== -1;
            }

            function paddingSize(base64String) {
                if (endsWith('==', base64String)) {
                    return 2;
                }
                if (endsWith('=', base64String)) {
                    return 1;
                }
                return 0;
            }

            function size(base64String) {
                return base64String.length / 4 * 3 - paddingSize(base64String);
            }

            function formatAsBytes(size) {
                return size.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' bytes';
            }

            return formatAsBytes(size(base64String));
        }

        function openFile (type, data) {
            $window.open('data:' + type + ';base64,' + data, '_blank', 'height=300,width=400');
        }

        function toBase64 (file, cb) {
            var fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = function (e) {
                var base64Data = e.target.result.substr(e.target.result.indexOf('base64,') + 'base64,'.length);
                cb(base64Data);
            };
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .filter('capitalize', capitalize);

    function capitalize() {
        return capitalizeFilter;

        function capitalizeFilter (input) {
            if (input !== null) {
                input = input.toLowerCase();
                input = input.substring(0, 1).toUpperCase() + input.substring(1);
            }
            return input;
        }
    }
})();

(function() {
    /*jshint bitwise: false*/
    'use strict';

    angular
        .module('doctorclubboApp')
        .factory('Base64', Base64);

    function Base64 () {
        var keyStr = 'ABCDEFGHIJKLMNOP' +
            'QRSTUVWXYZabcdef' +
            'ghijklmnopqrstuv' +
            'wxyz0123456789+/' +
            '=';

        var service = {
            decode : decode,
            encode : encode
        };

        return service;

        function encode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            while (i < input.length) {
                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);

                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;

                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }

                output = output +
                    keyStr.charAt(enc1) +
                    keyStr.charAt(enc2) +
                    keyStr.charAt(enc3) +
                    keyStr.charAt(enc4);
            }

            return output;
        }

        function decode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

            while (i < input.length) {
                enc1 = keyStr.indexOf(input.charAt(i++));
                enc2 = keyStr.indexOf(input.charAt(i++));
                enc3 = keyStr.indexOf(input.charAt(i++));
                enc4 = keyStr.indexOf(input.charAt(i++));

                chr1 = (enc1 << 2) | (enc2 >> 4);
                chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                chr3 = ((enc3 & 3) << 6) | enc4;

                output = output + String.fromCharCode(chr1);

                if (enc3 !== 64) {
                    output = output + String.fromCharCode(chr2);
                }
                if (enc4 !== 64) {
                    output = output + String.fromCharCode(chr3);
                }
            }

            return output;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .factory('LoginService', LoginService);

    LoginService.$inject = ['$uibModal'];

    function LoginService ($uibModal) {
        var service = {
            open: open
        };

        var modalInstance = null;
        var resetModal = function () {
            modalInstance = null;
        };

        return service;

        function open () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/components/login/login.html',
                controller: 'LoginController',
                controllerAs: 'vm',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('login');
                        return $translate.refresh();
                    }]
                }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('LoginController', LoginController);

    LoginController.$inject = ['$rootScope', '$state', '$timeout', 'Auth', '$uibModalInstance'];

    function LoginController ($rootScope, $state, $timeout, Auth, $uibModalInstance) {
        var vm = this;

        vm.authenticationError = false;
        vm.cancel = cancel;
        vm.credentials = {};
        vm.login = login;
        vm.password = null;
        vm.rememberMe = true;
        vm.requestResetPassword = requestResetPassword;
        vm.username = null;

        $timeout(function (){angular.element('#username').focus();});

        function cancel () {
            vm.credentials = {
                username: null,
                password: null,
                rememberMe: true
            };
            vm.authenticationError = false;
            $uibModalInstance.dismiss('cancel');
        }

        function login (event) {
            event.preventDefault();
            Auth.login({
                username: vm.username,
                password: vm.password,
                rememberMe: vm.rememberMe
            }).then(function () {
                vm.authenticationError = false;
                $uibModalInstance.close();
                if ($state.current.name === 'activate' ||
                    $state.current.name === 'finishReset' || $state.current.name === 'requestReset') {
                    $state.go('home');
                }

                $rootScope.$broadcast('authenticationSuccess');

                // previousState was set in the authExpiredInterceptor before being redirected to login modal.
                // since login is successful, go to stored previousState and clear previousState
                if (Auth.getPreviousState()) {
                    var previousState = Auth.getPreviousState();
                    Auth.resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }
            }).catch(function () {
                vm.authenticationError = true;
            });
        }

        function requestResetPassword () {
            $uibModalInstance.dismiss('cancel');
            $state.go('requestReset');
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('doctorclubboApp')
        .factory('JhiLanguageService', JhiLanguageService);

    JhiLanguageService.$inject = ['$q', '$http', '$translate', 'LANGUAGES'];

    function JhiLanguageService ($q, $http, $translate, LANGUAGES) {
        var service = {
            getAll: getAll,
            getCurrent: getCurrent
        };

        return service;

        function getAll () {
            var deferred = $q.defer();
            deferred.resolve(LANGUAGES);
            return deferred.promise;
        }

        function getCurrent () {
            var deferred = $q.defer();
            var language = $translate.storage().get('NG_TRANSLATE_LANG_KEY');

            deferred.resolve(language);

            return deferred.promise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .filter('findLanguageFromKey', findLanguageFromKey);

    function findLanguageFromKey() {
        return findLanguageFromKeyFilter;

        function findLanguageFromKeyFilter(lang) {
            return {
                'ca': 'Català',
                'cs': 'Český',
                'da': 'Dansk',
                'de': 'Deutsch',
                'el': 'Ελληνικά',
                'en': 'English',
                'es': 'Español',
                'fr': 'Français',
                'gl': 'Galego',
                'hu': 'Magyar',
                'hi': 'हिंदी',
                'it': 'Italiano',
                'ja': '日本語',
                'ko': '한국어',
                'mr': 'मराठी',
                'nl': 'Nederlands',
                'pl': 'Polski',
                'pt-br': 'Português (Brasil)',
                'pt-pt': 'Português',
                'ro': 'Română',
                'ru': 'Русский',
                'sk': 'Slovenský',
                'sv': 'Svenska',
                'ta': 'தமிழ்',
                'tr': 'Türkçe',
                'zh-cn': '中文（简体）',
                'zh-tw': '繁體中文'
            }[lang];
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('JhiLanguageController', JhiLanguageController);

    JhiLanguageController.$inject = ['$translate', 'JhiLanguageService', 'tmhDynamicLocale'];

    function JhiLanguageController ($translate, JhiLanguageService, tmhDynamicLocale) {
        var vm = this;

        vm.changeLanguage = changeLanguage;
        vm.languages = null;

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function changeLanguage (languageKey) {
            $translate.use(languageKey);
            tmhDynamicLocale.set(languageKey);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('doctorclubboApp')

        /*
         Languages codes are ISO_639-1 codes, see http://en.wikipedia.org/wiki/List_of_ISO_639-1_codes
         They are written in English to avoid character encoding issues (not a perfect solution)
         */
        .constant('LANGUAGES', [
            'it',
            'en'
            // jhipster-needle-i18n-language-constant - JHipster will add/remove languages in this array
        ]
    );
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .directive('showValidation', showValidation);

    function showValidation () {
        var directive = {
            restrict: 'A',
            require: 'form',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, formCtrl) {
            element.find('.form-group').each(function() {
                var $formGroup = angular.element(this);
                var $inputs = $formGroup.find('input[ng-model],textarea[ng-model],select[ng-model]');

                if ($inputs.length > 0) {
                    $inputs.each(function() {
                        var $input = angular.element(this);
                        var inputName = $input.attr('name');
                        scope.$watch(function() {
                            return formCtrl[inputName].$invalid && formCtrl[inputName].$dirty;
                        }, function(isInvalid) {
                            $formGroup.toggleClass('has-error', isInvalid);
                        });
                    });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .directive('minbytes', minbytes);

    function minbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.minbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) >= attrs.minbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .directive('maxbytes', maxbytes);

    function maxbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.maxbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) <= attrs.maxbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }

})();

(function() {
    'use strict';

    var jhiAlertError = {
        template: '<div class="alerts" ng-cloak="">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre>{{ alert.msg }}</pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertErrorController
    };

    angular
        .module('doctorclubboApp')
        .component('jhiAlertError', jhiAlertError);

    jhiAlertErrorController.$inject = ['$scope', 'AlertService', '$rootScope', '$translate'];

    function jhiAlertErrorController ($scope, AlertService, $rootScope, $translate) {
        var vm = this;

        vm.alerts = [];

        function addErrorAlert (message, key, data) {
            key = key ? key : message;
            vm.alerts.push(
                AlertService.add(
                    {
                        type: 'danger',
                        msg: key,
                        params: data,
                        timeout: 5000,
                        toast: AlertService.isToast(),
                        scoped: true
                    },
                    vm.alerts
                )
            );
        }

        var cleanHttpErrorListener = $rootScope.$on('doctorclubboApp.httpError', function (event, httpResponse) {
            var i;
            event.stopPropagation();
            switch (httpResponse.status) {
            // connection refused, server not reachable
            case 0:
                addErrorAlert('Server not reachable','error.server.not.reachable');
                break;

            case 400:
                var errorHeader = httpResponse.headers('X-doctorclubboApp-error');
                var entityKey = httpResponse.headers('X-doctorclubboApp-params');
                if (errorHeader) {
                    var entityName = $translate.instant('global.menu.entities.' + entityKey);
                    addErrorAlert(errorHeader, errorHeader, {entityName: entityName});
                } else if (httpResponse.data && httpResponse.data.fieldErrors) {
                    for (i = 0; i < httpResponse.data.fieldErrors.length; i++) {
                        var fieldError = httpResponse.data.fieldErrors[i];
                        // convert 'something[14].other[4].id' to 'something[].other[].id' so translations can be written to it
                        var convertedField = fieldError.field.replace(/\[\d*\]/g, '[]');
                        var fieldName = $translate.instant('doctorclubboApp.' + fieldError.objectName + '.' + convertedField);
                        addErrorAlert('Field ' + fieldName + ' cannot be empty', 'error.' + fieldError.message, {fieldName: fieldName});
                    }
                } else if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message, httpResponse.data.message, httpResponse.data);
                } else {
                    addErrorAlert(httpResponse.data);
                }
                break;

            case 404:
                addErrorAlert('Not found','error.url.not.found');
                break;

            default:
                if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message);
                } else {
                    addErrorAlert(angular.toJson(httpResponse));
                }
            }
        });

        $scope.$on('$destroy', function () {
            if(angular.isDefined(cleanHttpErrorListener) && cleanHttpErrorListener !== null){
                cleanHttpErrorListener();
                vm.alerts = [];
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .provider('AlertService', AlertService);

    function AlertService () {
        this.toast = false;
        /*jshint validthis: true */
        this.$get = getService;

        this.showAsToast = function(isToast) {
            this.toast = isToast;
        };

        getService.$inject = ['$timeout', '$sce', '$translate'];

        function getService ($timeout, $sce,$translate) {
            var toast = this.toast,
                alertId = 0, // unique id for each alert. Starts from 0.
                alerts = [],
                timeout = 5000; // default timeout

            return {
                factory: factory,
                isToast: isToast,
                add: addAlert,
                closeAlert: closeAlert,
                closeAlertByIndex: closeAlertByIndex,
                clear: clear,
                get: get,
                success: success,
                error: error,
                info: info,
                warning : warning
            };

            function isToast() {
                return toast;
            }

            function clear() {
                alerts = [];
            }

            function get() {
                return alerts;
            }

            function success(msg, params, position) {
                return this.add({
                    type: 'success',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function error(msg, params, position) {
                return this.add({
                    type: 'danger',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function warning(msg, params, position) {
                return this.add({
                    type: 'warning',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function info(msg, params, position) {
                return this.add({
                    type: 'info',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function factory(alertOptions) {
                var alert = {
                    type: alertOptions.type,
                    msg: $sce.trustAsHtml(alertOptions.msg),
                    id: alertOptions.alertId,
                    timeout: alertOptions.timeout,
                    toast: alertOptions.toast,
                    position: alertOptions.position ? alertOptions.position : 'top right',
                    scoped: alertOptions.scoped,
                    close: function (alerts) {
                        return closeAlert(this.id, alerts);
                    }
                };
                if(!alert.scoped) {
                    alerts.push(alert);
                }
                return alert;
            }

            function addAlert(alertOptions, extAlerts) {
                alertOptions.alertId = alertId++;
                alertOptions.msg = $translate.instant(alertOptions.msg, alertOptions.params);
                var that = this;
                var alert = this.factory(alertOptions);
                if (alertOptions.timeout && alertOptions.timeout > 0) {
                    $timeout(function () {
                        that.closeAlert(alertOptions.alertId, extAlerts);
                    }, alertOptions.timeout);
                }
                return alert;
            }

            function closeAlert(id, extAlerts) {
                var thisAlerts = extAlerts ? extAlerts : alerts;
                return closeAlertByIndex(thisAlerts.map(function(e) { return e.id; }).indexOf(id), thisAlerts);
            }

            function closeAlertByIndex(index, thisAlerts) {
                return thisAlerts.splice(index, 1);
            }
        }
    }
})();

(function() {
    'use strict';

    var jhiAlert = {
        template: '<div class="alerts" ng-cloak="">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre ng-bind-html="alert.msg"></pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertController
    };

    angular
        .module('doctorclubboApp')
        .component('jhiAlert', jhiAlert);

    jhiAlertController.$inject = ['$scope', 'AlertService'];

    function jhiAlertController($scope, AlertService) {
        var vm = this;

        vm.alerts = AlertService.get();
        $scope.$on('$destroy', function () {
            vm.alerts = [];
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .factory('notificationInterceptor', notificationInterceptor);

    notificationInterceptor.$inject = ['$q', 'AlertService'];

    function notificationInterceptor ($q, AlertService) {
        var service = {
            response: response
        };

        return service;

        function response (response) {
            var alertKey = response.headers('X-doctorclubboApp-alert');
            if (angular.isString(alertKey)) {
                AlertService.success(alertKey, { param : response.headers('X-doctorclubboApp-params')});
            }
            return response;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .factory('errorHandlerInterceptor', errorHandlerInterceptor);

    errorHandlerInterceptor.$inject = ['$q', '$rootScope'];

    function errorHandlerInterceptor ($q, $rootScope) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError (response) {
            if (!(response.status === 401 && (response.data === '' || (response.data.path && response.data.path.indexOf('/api/account') === 0 )))) {
                $rootScope.$emit('doctorclubboApp.httpError', response);
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .factory('authExpiredInterceptor', authExpiredInterceptor);

    authExpiredInterceptor.$inject = ['$rootScope', '$q', '$injector', '$localStorage', '$sessionStorage'];

    function authExpiredInterceptor($rootScope, $q, $injector, $localStorage, $sessionStorage) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError(response) {
            if (response.status === 401) {
                delete $localStorage.authenticationToken;
                delete $sessionStorage.authenticationToken;
                var Principal = $injector.get('Principal');
                if (Principal.isAuthenticated()) {
                    var Auth = $injector.get('Auth');
                    Auth.authorize(true);
                }
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .factory('authInterceptor', authInterceptor);

    authInterceptor.$inject = ['$rootScope', '$q', '$location', '$localStorage', '$sessionStorage'];

    function authInterceptor ($rootScope, $q, $location, $localStorage, $sessionStorage) {
        var service = {
            request: request
        };

        return service;

        function request (config) {
            /*jshint camelcase: false */
            config.headers = config.headers || {};
            var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
            if (token) {
                config.headers.Authorization = 'Bearer ' + token;
            }
            return config;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .factory('translationHandler', translationHandler);

    translationHandler.$inject = ['$rootScope', '$window', '$state', '$translate'];

    function translationHandler($rootScope, $window, $state, $translate) {
        return {
            initialize: initialize,
            updateTitle: updateTitle
        };

        function initialize() {
            // if the current translation changes, update the window title
            var translateChangeSuccess = $rootScope.$on('$translateChangeSuccess', function() {
                updateTitle();
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(translateChangeSuccess) && translateChangeSuccess !== null){
                    translateChangeSuccess();
                }
            });
        }

        // update the window title using params in the following
        // precedence
        // 1. titleKey parameter
        // 2. $state.$current.data.pageTitle (current state page title)
        // 3. 'global.title'
        function updateTitle(titleKey) {
            if (!titleKey && $state.$current.data && $state.$current.data.pageTitle) {
                titleKey = $state.$current.data.pageTitle;
            }
            $translate(titleKey || 'global.title').then(function (title) {
                $window.document.title = title;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .factory('stateHandler', stateHandler);

    stateHandler.$inject = ['$rootScope', '$state', '$sessionStorage', '$translate', 'JhiLanguageService', 'translationHandler', '$window',
        'Auth', 'Principal', 'VERSION'];

    function stateHandler($rootScope, $state, $sessionStorage, $translate, JhiLanguageService, translationHandler, $window,
        Auth, Principal, VERSION) {
        return {
            initialize: initialize
        };

        function initialize() {
            $rootScope.VERSION = VERSION;

            var stateChangeStart = $rootScope.$on('$stateChangeStart', function (event, toState, toStateParams, fromState) {
                $rootScope.toState = toState;
                $rootScope.toStateParams = toStateParams;
                $rootScope.fromState = fromState;

                // Redirect to a state with an external URL (http://stackoverflow.com/a/30221248/1098564)
                if (toState.external) {
                    event.preventDefault();
                    $window.open(toState.url, '_self');
                }

                if (Principal.isIdentityResolved()) {
                    Auth.authorize();
                }

                // Update the language
                JhiLanguageService.getCurrent().then(function (language) {
                    $translate.use(language);
                });
            });

            var stateChangeSuccess = $rootScope.$on('$stateChangeSuccess',  function(event, toState, toParams, fromState, fromParams) {
                var titleKey = 'global.title' ;

                // Set the page title key to the one configured in state or use default one
                if (toState.data.pageTitle) {
                    titleKey = toState.data.pageTitle;
                }
                translationHandler.updateTitle(titleKey);
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(stateChangeStart) && stateChangeStart !== null){
                    stateChangeStart();
                }
                if(angular.isDefined(stateChangeSuccess) && stateChangeSuccess !== null){
                    stateChangeSuccess();
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(paginationConfig);

    paginationConfig.$inject = ['uibPaginationConfig', 'paginationConstants'];

    function paginationConfig(uibPaginationConfig, paginationConstants) {
        uibPaginationConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPaginationConfig.maxSize = 5;
        uibPaginationConfig.boundaryLinks = true;
        uibPaginationConfig.firstText = '«';
        uibPaginationConfig.previousText = '‹';
        uibPaginationConfig.nextText = '›';
        uibPaginationConfig.lastText = '»';
    }
})();

(function () {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(pagerConfig);

    pagerConfig.$inject = ['uibPagerConfig', 'paginationConstants'];

    function pagerConfig(uibPagerConfig, paginationConstants) {
        uibPagerConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPagerConfig.previousText = '«';
        uibPagerConfig.nextText = '»';
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .factory('translationStorageProvider', translationStorageProvider);

    translationStorageProvider.$inject = ['$cookies', '$log', 'LANGUAGES'];

    function translationStorageProvider($cookies, $log, LANGUAGES) {
        return {
            get: get,
            put: put
        };

        function get(name) {
            if (LANGUAGES.indexOf($cookies.getObject(name)) === -1) {
                $log.info('Resetting invalid cookie language "' + $cookies.getObject(name) + '" to preferred language "it"');
                $cookies.putObject(name, 'it');
            }
            return $cookies.getObject(name);
        }

        function put(name, value) {
            $cookies.putObject(name, value);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(translationConfig);

    translationConfig.$inject = ['$translateProvider', 'tmhDynamicLocaleProvider'];

    function translationConfig($translateProvider, tmhDynamicLocaleProvider) {
        // Initialize angular-translate
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: 'i18n/{lang}/{part}.json'
        });

        $translateProvider.preferredLanguage('it');
        $translateProvider.useStorage('translationStorageProvider');
        $translateProvider.useSanitizeValueStrategy('escaped');
        $translateProvider.addInterpolation('$translateMessageFormatInterpolation');

        tmhDynamicLocaleProvider.localeLocationPattern('i18n/angular-locale_{{locale}}.js');
        tmhDynamicLocaleProvider.useCookieStorage();
        tmhDynamicLocaleProvider.storageKey('NG_TRANSLATE_LANG_KEY');
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(localStorageConfig);

    localStorageConfig.$inject = ['$localStorageProvider', '$sessionStorageProvider'];

    function localStorageConfig($localStorageProvider, $sessionStorageProvider) {
        $localStorageProvider.setKeyPrefix('jhi-');
        $sessionStorageProvider.setKeyPrefix('jhi-');
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(httpConfig);

    httpConfig.$inject = ['$urlRouterProvider', '$httpProvider', 'httpRequestInterceptorCacheBusterProvider', '$urlMatcherFactoryProvider'];

    function httpConfig($urlRouterProvider, $httpProvider, httpRequestInterceptorCacheBusterProvider, $urlMatcherFactoryProvider) {
        //Cache everything except rest api requests
        httpRequestInterceptorCacheBusterProvider.setMatchlist([/.*api.*/, /.*protected.*/], true);

        $urlRouterProvider.otherwise('/');

        $httpProvider.interceptors.push('errorHandlerInterceptor');
        $httpProvider.interceptors.push('authExpiredInterceptor');
        $httpProvider.interceptors.push('authInterceptor');
        $httpProvider.interceptors.push('notificationInterceptor');
        // jhipster-needle-angularjs-add-interceptor JHipster will add new application http interceptor here

        $urlMatcherFactoryProvider.type('boolean', {
            name : 'boolean',
            decode: function(val) { return val === true || val === 'true'; },
            encode: function(val) { return val ? 1 : 0; },
            equals: function(a, b) { return this.is(a) && a === b; },
            is: function(val) { return [true,false,0,1].indexOf(val) >= 0; },
            pattern: /bool|true|0|1/
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(compileServiceConfig);

    compileServiceConfig.$inject = ['$compileProvider','DEBUG_INFO_ENABLED'];

    function compileServiceConfig($compileProvider,DEBUG_INFO_ENABLED) {
        // disable debug data on prod profile to improve performance
        $compileProvider.debugInfoEnabled(DEBUG_INFO_ENABLED);

        /*
        If you wish to debug an application with this information
        then you should open up a debug console in the browser
        then call this method directly in this console:

		angular.reloadWithDebugInfo();
		*/
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(alertServiceConfig);

    alertServiceConfig.$inject = ['AlertServiceProvider'];

    function alertServiceConfig(AlertServiceProvider) {
        // set below to true to make alerts look like toast
        AlertServiceProvider.showAsToast(false);
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('app', {
            abstract: true,
            views: {
                'navbar@': {
                    templateUrl: 'app/layouts/navbar/navbar.html',
                    controller: 'NavbarController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                authorize: ['Auth',
                    function (Auth) {
                        return Auth.authorize();
                    }
                ],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                }]
            }
        });
    }
})();

(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('doctorclubboApp')
        .constant('VERSION', "0.0.1-SNAPSHOT")
        .constant('DEBUG_INFO_ENABLED', false)
;
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('UserManagementDialogController',UserManagementDialogController);

    UserManagementDialogController.$inject = ['$stateParams', '$uibModalInstance', 'entity', 'User', 'JhiLanguageService', 'Agenzia'];

    function UserManagementDialogController ($stateParams, $uibModalInstance, entity, User, JhiLanguageService, Agenzia) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_OWNER', 'ROLE_APPROVER', 'ROLE_SUPERVISOR', 'ROLE_ADMIN'];
        vm.clear = clear;
        vm.languages = null;
        vm.save = save;
        vm.user = entity;
        vm.agenzia = Agenzia.query();

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function onSaveSuccess (result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function save () {
            vm.isSaving = true;
            if (vm.user.id !== null) {
                User.update(vm.user, onSaveSuccess, onSaveError);
            } else {
                User.save(vm.user, onSaveSuccess, onSaveError);
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('UserManagementDetailController', UserManagementDetailController);

    UserManagementDetailController.$inject = ['$stateParams', 'User'];

    function UserManagementDetailController ($stateParams, User) {
        var vm = this;

        vm.load = load;
        vm.user = {};

        vm.load($stateParams.login);

        function load (login) {
            User.get({login: login}, function(result) {
                vm.user = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('UserManagementDeleteController', UserManagementDeleteController);

    UserManagementDeleteController.$inject = ['$uibModalInstance', 'entity', 'User'];

    function UserManagementDeleteController ($uibModalInstance, entity, User) {
        var vm = this;

        vm.user = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (login) {
            User .delete({login: login},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('user-management', {
            parent: 'admin',
            url: '/user-management?page&sort',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'userManagement.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-management.html',
                    controller: 'UserManagementController',
                    controllerAs: 'vm'
                }
            },            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort)
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    return $translate.refresh();
                }]

            }        })
        .state('user-management-detail', {
            parent: 'admin',
            url: '/user/:login',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'user-management.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-management-detail.html',
                    controller: 'UserManagementDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    return $translate.refresh();
                }]
            }
        })
        .state('user-management.new', {
            parent: 'user-management',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null, login: null, firstName: null, lastName: null, email: null,
                                activated: true, langKey: null, createdBy: null, createdDate: null,
                                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                                resetKey: null, authorities: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('user-management');
                });
            }]
        })
        .state('user-management.edit', {
            parent: 'user-management',
            url: '/{login}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login});
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('user-management.delete', {
            parent: 'user-management',
            url: '/{login}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-delete-dialog.html',
                    controller: 'UserManagementDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login});
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('UserManagementController', UserManagementController);

    UserManagementController.$inject = ['Principal', 'User', 'ParseLinks', 'AlertService', '$state', 'pagingParams', 'paginationConstants', 'JhiLanguageService'];

    function UserManagementController(Principal, User, ParseLinks, AlertService, $state, pagingParams, paginationConstants, JhiLanguageService) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        vm.currentAccount = null;
        vm.languages = null;
        vm.loadAll = loadAll;
        vm.setActive = setActive;
        vm.users = [];
        vm.page = 1;
        vm.totalItems = null;
        vm.clear = clear;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.transition = transition;

        vm.loadAll();
        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });
        Principal.identity().then(function(account) {
            vm.currentAccount = account;
        });

        function setActive (user, isActivated) {
            user.activated = isActivated;
            User.update(user, function () {
                vm.loadAll();
                vm.clear();
            });
        }

        function loadAll () {
            User.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
        }

        function onSuccess(data, headers) {
            //hide anonymous user from user management: it's a required user for Spring Security
            var hiddenUsersSize = 0;
            for (var i in data) {
                if (data[i]['login'] === 'anonymoususer') {
                    data.splice(i, 1);
                    hiddenUsersSize++;
                }
            }
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count') - hiddenUsersSize;
            vm.queryCount = vm.totalItems;
            vm.page = pagingParams.page;
            vm.users = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function clear () {
            vm.user = {
                id: null, login: null, firstName: null, lastName: null, email: null,
                activated: null, langKey: null, createdBy: null, createdDate: null,
                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                resetKey: null, authorities: null
            };
        }

        function sort () {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-metrics', {
            parent: 'admin',
            url: '/metrics',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'metrics.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/metrics/metrics.html',
                    controller: 'JhiMetricsMonitoringController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('metrics');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .factory('JhiMetricsService', JhiMetricsService);

    JhiMetricsService.$inject = ['$rootScope', '$http'];

    function JhiMetricsService ($rootScope, $http) {
        var service = {
            getMetrics: getMetrics,
            threadDump: threadDump
        };

        return service;

        function getMetrics () {
            return $http.get('management/jhipster/metrics').then(function (response) {
                return response.data;
            });
        }

        function threadDump () {
            return $http.get('management/dump').then(function (response) {
                return response.data;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('JhiMetricsMonitoringModalController', JhiMetricsMonitoringModalController);

    JhiMetricsMonitoringModalController.$inject = ['$uibModalInstance', 'threadDump'];

    function JhiMetricsMonitoringModalController ($uibModalInstance, threadDump) {
        var vm = this;

        vm.cancel = cancel;
        vm.getLabelClass = getLabelClass;
        vm.threadDump = threadDump;
        vm.threadDumpAll = 0;
        vm.threadDumpBlocked = 0;
        vm.threadDumpRunnable = 0;
        vm.threadDumpTimedWaiting = 0;
        vm.threadDumpWaiting = 0;

        angular.forEach(threadDump, function(value) {
            if (value.threadState === 'RUNNABLE') {
                vm.threadDumpRunnable += 1;
            } else if (value.threadState === 'WAITING') {
                vm.threadDumpWaiting += 1;
            } else if (value.threadState === 'TIMED_WAITING') {
                vm.threadDumpTimedWaiting += 1;
            } else if (value.threadState === 'BLOCKED') {
                vm.threadDumpBlocked += 1;
            }
        });

        vm.threadDumpAll = vm.threadDumpRunnable + vm.threadDumpWaiting +
            vm.threadDumpTimedWaiting + vm.threadDumpBlocked;

        function cancel () {
            $uibModalInstance.dismiss('cancel');
        }

        function getLabelClass (threadState) {
            if (threadState === 'RUNNABLE') {
                return 'label-success';
            } else if (threadState === 'WAITING') {
                return 'label-info';
            } else if (threadState === 'TIMED_WAITING') {
                return 'label-warning';
            } else if (threadState === 'BLOCKED') {
                return 'label-danger';
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('JhiMetricsMonitoringController', JhiMetricsMonitoringController);

    JhiMetricsMonitoringController.$inject = ['$scope','JhiMetricsService', '$uibModal'];

    function JhiMetricsMonitoringController ($scope, JhiMetricsService, $uibModal) {
        var vm = this;

        vm.cachesStats = {};
        vm.metrics = {};
        vm.refresh = refresh;
        vm.refreshThreadDumpData = refreshThreadDumpData;
        vm.servicesStats = {};
        vm.updatingMetrics = true;

        vm.refresh();

        $scope.$watch('vm.metrics', function (newValue) {
            vm.servicesStats = {};
            vm.cachesStats = {};
            angular.forEach(newValue.timers, function (value, key) {
                if (key.indexOf('web.rest') !== -1 || key.indexOf('service') !== -1) {
                    vm.servicesStats[key] = value;
                }
                if (key.indexOf('net.sf.ehcache.Cache') !== -1) {
                    // remove gets or puts
                    var index = key.lastIndexOf('.');
                    var newKey = key.substr(0, index);

                    // Keep the name of the domain
                    vm.cachesStats[newKey] = {
                        'name': newKey,
                        'value': value
                    };
                }
            });
        });

        function refresh () {
            vm.updatingMetrics = true;
            JhiMetricsService.getMetrics().then(function (promise) {
                vm.metrics = promise;
                vm.updatingMetrics = false;
            }, function (promise) {
                vm.metrics = promise.data;
                vm.updatingMetrics = false;
            });
        }

        function refreshThreadDumpData () {
            JhiMetricsService.threadDump().then(function(data) {
                $uibModal.open({
                    templateUrl: 'app/admin/metrics/metrics.modal.html',
                    controller: 'JhiMetricsMonitoringModalController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        threadDump: function() {
                            return data;
                        }

                    }
                });
            });
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('logs', {
            parent: 'admin',
            url: '/logs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'logs.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/logs/logs.html',
                    controller: 'LogsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('logs');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .factory('LogsService', LogsService);

    LogsService.$inject = ['$resource'];

    function LogsService ($resource) {
        var service = $resource('management/jhipster/logs', {}, {
            'findAll': { method: 'GET', isArray: true},
            'changeLevel': { method: 'PUT'}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('LogsController', LogsController);

    LogsController.$inject = ['LogsService'];

    function LogsController (LogsService) {
        var vm = this;

        vm.changeLevel = changeLevel;
        vm.loggers = LogsService.findAll();

        function changeLevel (name, level) {
            LogsService.changeLevel({name: name, level: level}, function () {
                vm.loggers = LogsService.findAll();
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-health', {
            parent: 'admin',
            url: '/health',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'health.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/health/health.html',
                    controller: 'JhiHealthCheckController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('health');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .factory('JhiHealthService', JhiHealthService);

    JhiHealthService.$inject = ['$rootScope', '$http'];

    function JhiHealthService ($rootScope, $http) {
        var separator = '.';
        var service = {
            checkHealth: checkHealth,
            transformHealthData: transformHealthData,
            getBaseName: getBaseName,
            getSubSystemName: getSubSystemName
        };

        return service;

        function checkHealth () {
            return $http.get('management/health').then(function (response) {
                return response.data;
            });
        }

        function transformHealthData (data) {
            var response = [];
            flattenHealthData(response, null, data);
            return response;
        }

        function getBaseName (name) {
            if (name) {
                var split = name.split('.');
                return split[0];
            }
        }

        function getSubSystemName (name) {
            if (name) {
                var split = name.split('.');
                split.splice(0, 1);
                var remainder = split.join('.');
                return remainder ? ' - ' + remainder : '';
            }
        }

        /* private methods */
        function flattenHealthData (result, path, data) {
            angular.forEach(data, function (value, key) {
                if (isHealthObject(value)) {
                    if (hasSubSystem(value)) {
                        addHealthObject(result, false, value, getModuleName(path, key));
                        flattenHealthData(result, getModuleName(path, key), value);
                    } else {
                        addHealthObject(result, true, value, getModuleName(path, key));
                    }
                }
            });
            return result;
        }

        function addHealthObject (result, isLeaf, healthObject, name) {

            var healthData = {
                'name': name
            };
            var details = {};
            var hasDetails = false;

            angular.forEach(healthObject, function (value, key) {
                if (key === 'status' || key === 'error') {
                    healthData[key] = value;
                } else {
                    if (!isHealthObject(value)) {
                        details[key] = value;
                        hasDetails = true;
                    }
                }
            });

            // Add the of the details
            if (hasDetails) {
                angular.extend(healthData, { 'details': details});
            }

            // Only add nodes if they provide additional information
            if (isLeaf || hasDetails || healthData.error) {
                result.push(healthData);
            }
            return healthData;
        }

        function getModuleName (path, name) {
            var result;
            if (path && name) {
                result = path + separator + name;
            }  else if (path) {
                result = path;
            } else if (name) {
                result = name;
            } else {
                result = '';
            }
            return result;
        }

        function hasSubSystem (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value) {
                if (value && value.status) {
                    result = true;
                }
            });
            return result;
        }

        function isHealthObject (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value, key) {
                if (key === 'status') {
                    result = true;
                }
            });
            return result;
        }

    }
})();

(function() {
    'use strict';

    angular.module('doctorclubboApp')
        .controller('HealthModalController', HealthModalController);

    HealthModalController.$inject = ['$uibModalInstance', 'currentHealth', 'baseName', 'subSystemName'];

    function HealthModalController ($uibModalInstance, currentHealth, baseName, subSystemName) {
        var vm = this;

        vm.cancel = cancel;
        vm.currentHealth = currentHealth;
        vm.baseName = baseName;
        vm.subSystemName = subSystemName;

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('JhiHealthCheckController', JhiHealthCheckController);

    JhiHealthCheckController.$inject = ['JhiHealthService', '$uibModal'];

    function JhiHealthCheckController (JhiHealthService, $uibModal) {
        var vm = this;

        vm.updatingHealth = true;
        vm.getLabelClass = getLabelClass;
        vm.refresh = refresh;
        vm.showHealth = showHealth;
        vm.baseName = JhiHealthService.getBaseName;
        vm.subSystemName = JhiHealthService.getSubSystemName;

        vm.refresh();

        function getLabelClass (statusState) {
            if (statusState === 'UP') {
                return 'label-success';
            } else {
                return 'label-danger';
            }
        }

        function refresh () {
            vm.updatingHealth = true;
            JhiHealthService.checkHealth().then(function (response) {
                vm.healthData = JhiHealthService.transformHealthData(response);
                vm.updatingHealth = false;
            }, function (response) {
                vm.healthData =  JhiHealthService.transformHealthData(response.data);
                vm.updatingHealth = false;
            });
        }

        function showHealth (health) {
            $uibModal.open({
                templateUrl: 'app/admin/health/health.modal.html',
                controller: 'HealthModalController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    currentHealth: function() {
                        return health;
                    },
                    baseName: function() {
                        return vm.baseName;
                    },
                    subSystemName: function() {
                        return vm.subSystemName;
                    }

                }
            });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('docs', {
            parent: 'admin',
            url: '/docs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'global.menu.admin.apidocs'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/docs/docs.html'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', function ($translate) {
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-configuration', {
            parent: 'admin',
            url: '/configuration',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'configuration.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/configuration/configuration.html',
                    controller: 'JhiConfigurationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('configuration');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .factory('JhiConfigurationService', JhiConfigurationService);

    JhiConfigurationService.$inject = ['$filter', '$http'];

    function JhiConfigurationService ($filter, $http) {
        var service = {
            get: get,
            getEnv: getEnv
        };

        return service;

        function get () {
            return $http.get('management/configprops').then(getConfigPropsComplete);

            function getConfigPropsComplete (response) {
                var properties = [];
                angular.forEach(response.data, function (data) {
                    properties.push(data);
                });
                var orderBy = $filter('orderBy');
                return orderBy(properties, 'prefix');
            }
        }

        function getEnv () {
            return $http.get('management/env').then(getEnvComplete);

            function getEnvComplete (response) {
                var properties = {};
                angular.forEach(response.data, function (val,key) {
                    var vals = [];
                    angular.forEach(val, function (v,k) {
                        vals.push({ key:k, val:v });
                    });
                    properties[key] = vals;
                });
                return properties;
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('JhiConfigurationController', JhiConfigurationController);

    JhiConfigurationController.$inject = ['$filter','JhiConfigurationService'];

    function JhiConfigurationController (filter,JhiConfigurationService) {
        var vm = this;

        vm.allConfiguration = null;
        vm.configuration = null;

        JhiConfigurationService.get().then(function(configuration) {
            vm.configuration = configuration;
        });
        JhiConfigurationService.getEnv().then(function (configuration) {
            vm.allConfiguration = configuration;
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('audits', {
            parent: 'admin',
            url: '/audits',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'audits.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/audits/audits.html',
                    controller: 'AuditsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('audits');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .factory('AuditsService', AuditsService);

    AuditsService.$inject = ['$resource'];

    function AuditsService ($resource) {
        var service = $resource('management/jhipster/audits/:id', {}, {
            'get': {
                method: 'GET',
                isArray: true
            },
            'query': {
                method: 'GET',
                isArray: true,
                params: {fromDate: null, toDate: null}
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('AuditsController', AuditsController);

    AuditsController.$inject = ['$filter', 'AuditsService', 'ParseLinks'];

    function AuditsController ($filter, AuditsService, ParseLinks) {
        var vm = this;

        vm.audits = null;
        vm.fromDate = null;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.onChangeDate = onChangeDate;
        vm.page = 1;
        vm.previousMonth = previousMonth;
        vm.toDate = null;
        vm.today = today;
        vm.totalItems = null;

        vm.today();
        vm.previousMonth();
        vm.onChangeDate();

        function onChangeDate () {
            var dateFormat = 'yyyy-MM-dd';
            var fromDate = $filter('date')(vm.fromDate, dateFormat);
            var toDate = $filter('date')(vm.toDate, dateFormat);

            AuditsService.query({page: vm.page -1, size: 20, fromDate: fromDate, toDate: toDate}, function(result, headers){
                vm.audits = result;
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
            });
        }

        // Date picker configuration
        function today () {
            // Today + 1 day - needed if the current day must be included
            var today = new Date();
            vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
        }

        function previousMonth () {
            var fromDate = new Date();
            if (fromDate.getMonth() === 0) {
                fromDate = new Date(fromDate.getFullYear() - 1, 11, fromDate.getDate());
            } else {
                fromDate = new Date(fromDate.getFullYear(), fromDate.getMonth() - 1, fromDate.getDate());
            }

            vm.fromDate = fromDate;
        }

        function loadPage (page) {
            vm.page = page;
            vm.onChangeDate();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('admin', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('settings', {
            parent: 'account',
            url: '/settings',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.account.settings'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/settings/settings.html',
                    controller: 'SettingsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('settings');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('SettingsController', SettingsController);

    SettingsController.$inject = ['Principal', 'Auth', 'JhiLanguageService', '$translate'];

    function SettingsController (Principal, Auth, JhiLanguageService, $translate) {
        var vm = this;

        vm.error = null;
        vm.save = save;
        vm.settingsAccount = null;
        vm.success = null;

        /**
         * Store the "settings account" in a separate variable, and not in the shared "account" variable.
         */
        var copyAccount = function (account) {
            return {
                activated: account.activated,
                email: account.email,
                firstName: account.firstName,
                langKey: account.langKey,
                lastName: account.lastName,
                login: account.login
            };
        };

        Principal.identity().then(function(account) {
            vm.settingsAccount = copyAccount(account);
        });

        function save () {
            Auth.updateAccount(vm.settingsAccount).then(function() {
                vm.error = null;
                vm.success = 'OK';
                Principal.identity(true).then(function(account) {
                    vm.settingsAccount = copyAccount(account);
                });
                JhiLanguageService.getCurrent().then(function(current) {
                    if (vm.settingsAccount.langKey !== current) {
                        $translate.use(vm.settingsAccount.langKey);
                    }
                });
            }).catch(function() {
                vm.success = null;
                vm.error = 'ERROR';
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('requestReset', {
            parent: 'account',
            url: '/reset/request',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/request/reset.request.html',
                    controller: 'RequestResetController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('RequestResetController', RequestResetController);

    RequestResetController.$inject = ['$timeout', 'Auth'];

    function RequestResetController ($timeout, Auth) {
        var vm = this;

        vm.error = null;
        vm.errorEmailNotExists = null;
        vm.requestReset = requestReset;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#email').focus();});

        function requestReset () {

            vm.error = null;
            vm.errorEmailNotExists = null;

            Auth.resetPasswordInit(vm.resetAccount.email).then(function () {
                vm.success = 'OK';
            }).catch(function (response) {
                vm.success = null;
                if (response.status === 400 && response.data === 'e-mail address not registered') {
                    vm.errorEmailNotExists = 'ERROR';
                } else {
                    vm.error = 'ERROR';
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('finishReset', {
            parent: 'account',
            url: '/reset/finish?key',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/finish/reset.finish.html',
                    controller: 'ResetFinishController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('ResetFinishController', ResetFinishController);

    ResetFinishController.$inject = ['$stateParams', '$timeout', 'Auth', 'LoginService'];

    function ResetFinishController ($stateParams, $timeout, Auth, LoginService) {
        var vm = this;

        vm.keyMissing = angular.isUndefined($stateParams.key);
        vm.confirmPassword = null;
        vm.doNotMatch = null;
        vm.error = null;
        vm.finishReset = finishReset;
        vm.login = LoginService.open;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#password').focus();});

        function finishReset() {
            vm.doNotMatch = null;
            vm.error = null;
            if (vm.resetAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                Auth.resetPasswordFinish({key: $stateParams.key, newPassword: vm.resetAccount.password}).then(function () {
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('register', {
            parent: 'account',
            url: '/register',
            data: {
                authorities: [],
                pageTitle: 'register.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/register/register.html',
                    controller: 'RegisterController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('register');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('RegisterController', RegisterController);


    RegisterController.$inject = ['$translate', '$timeout', 'Auth', 'LoginService'];

    function RegisterController ($translate, $timeout, Auth, LoginService) {
        var vm = this;

        vm.doNotMatch = null;
        vm.error = null;
        vm.errorUserExists = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.registerAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#login').focus();});

        function register () {
            if (vm.registerAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                vm.registerAccount.langKey = $translate.use();
                vm.doNotMatch = null;
                vm.error = null;
                vm.errorUserExists = null;
                vm.errorEmailExists = null;
            }
        }
    }
})();

/* globals $ */
(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .directive('passwordStrengthBar', passwordStrengthBar);

    function passwordStrengthBar () {
        var directive = {
            replace: true,
            restrict: 'E',
            template: '<div id="strength">' +
                '<small data-translate="global.messages.validate.newpassword.strength">Password strength:</small>' +
                '<ul id="strengthBar">' +
                '<li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li>' +
                '</ul>' +
                '</div>',
            scope: {
                passwordToCheck: '='
            },
            link: linkFunc
        };

        return directive;

        /* private helper methods*/

        function linkFunc(scope, iElement) {
            var strength = {
                colors: ['#F00', '#F90', '#FF0', '#9F0', '#0F0'],
                mesureStrength: function (p) {

                    var _force = 0;
                    var _regex = /[$-/:-?{-~!"^_`\[\]]/g; // "

                    var _lowerLetters = /[a-z]+/.test(p);
                    var _upperLetters = /[A-Z]+/.test(p);
                    var _numbers = /[0-9]+/.test(p);
                    var _symbols = _regex.test(p);

                    var _flags = [_lowerLetters, _upperLetters, _numbers, _symbols];
                    var _passedMatches = $.grep(_flags, function (el) {
                        return el === true;
                    }).length;

                    _force += 2 * p.length + ((p.length >= 10) ? 1 : 0);
                    _force += _passedMatches * 10;

                    // penalty (short password)
                    _force = (p.length <= 6) ? Math.min(_force, 10) : _force;

                    // penalty (poor variety of characters)
                    _force = (_passedMatches === 1) ? Math.min(_force, 10) : _force;
                    _force = (_passedMatches === 2) ? Math.min(_force, 20) : _force;
                    _force = (_passedMatches === 3) ? Math.min(_force, 40) : _force;

                    return _force;

                },
                getColor: function (s) {

                    var idx;
                    if (s <= 10) {
                        idx = 0;
                    }
                    else if (s <= 20) {
                        idx = 1;
                    }
                    else if (s <= 30) {
                        idx = 2;
                    }
                    else if (s <= 40) {
                        idx = 3;
                    }
                    else {
                        idx = 4;
                    }

                    return { idx: idx + 1, col: this.colors[idx] };
                }
            };
            scope.$watch('passwordToCheck', function (password) {
                if (password) {
                    var c = strength.getColor(strength.mesureStrength(password));
                    iElement.removeClass('ng-hide');
                    iElement.find('ul').children('li')
                        .css({ 'background-color': '#DDD' })
                        .slice(0, c.idx)
                        .css({ 'background-color': c.col });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('password', {
            parent: 'account',
            url: '/password',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.account.password'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/password/password.html',
                    controller: 'PasswordController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('password');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('PasswordController', PasswordController);

    PasswordController.$inject = ['Auth', 'Principal'];

    function PasswordController (Auth, Principal) {
        var vm = this;

        vm.changePassword = changePassword;
        vm.doNotMatch = null;
        vm.error = null;
        vm.success = null;

        Principal.identity().then(function(account) {
            vm.account = account;
        });

        function changePassword () {
            if (vm.password !== vm.confirmPassword) {
                vm.error = null;
                vm.success = null;
                vm.doNotMatch = 'ERROR';
            } else {
                vm.doNotMatch = null;
                Auth.changePassword(vm.password).then(function () {
                    vm.error = null;
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('activate', {
            parent: 'account',
            url: '/activate?key',
            data: {
                authorities: [],
                pageTitle: 'activate.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/activate/activate.html',
                    controller: 'ActivationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('activate');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('ActivationController', ActivationController);

    ActivationController.$inject = ['$stateParams', 'Auth', 'LoginService'];

    function ActivationController ($stateParams, Auth, LoginService) {
        var vm = this;

        Auth.activateAccount({key: $stateParams.key}).then(function () {
            vm.error = null;
            vm.success = 'OK';
        }).catch(function () {
            vm.success = null;
            vm.error = 'ERROR';
        });

        vm.login = LoginService.open;
    }
})();

(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('account', {
            abstract: true,
            parent: 'app'
        });
    }
})();
(function(){angular.module('doctorclubboApp').run(['$templateCache', function($templateCache) {$templateCache.put('app/home/home.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1 data-translate="home.title">Welcome, DoctorClub!</h1><p class="lead" data-translate="home.subtitle">Backoffice</p><div ng-switch="vm.isAuthenticated()"><div class="alert alert-success" ng-switch-when="true" data-translate="home.logged.message" translate-values="{username: \'{{vm.account.login}}\'}">You are logged in as user "{{vm.account.login}}".</div></div><!-- p data-translate="home.question">\n                If you have any question on JHipster:\n            </p>\n\n            <ul>\n                <li><a href="http://jhipster.github.io/" target="_blank" data-translate="home.link.homepage">JHipster homepage</a></li>\n                <li><a href="http://stackoverflow.com/tags/jhipster/info" target="_blank" data-translate="home.link.stackoverflow">JHipster on Stack Overflow</a></li>\n                <li><a href="https://github.com/jhipster/generator-jhipster/issues?state=open" target="_blank" data-translate="home.link.bugtracker">JHipster bug tracker</a></li>\n                <li><a href="https://gitter.im/jhipster/generator-jhipster" target="_blank" data-translate="home.link.chat">JHipster public chat room</a></li>\n                <li><a href="https://twitter.com/java_hipster" target="_blank"  data-translate="home.link.follow">follow @java_hipster on Twitter</a></li>\n            </ul>\n\n            <p>\n             <span data-translate="home.like">If you like JHipster, don\'t forget to give us a star on </span>&nbsp;<a href="https://github.com/jhipster/generator-jhipster" target="_blank" data-translate="home.github">Github</a>!\n            </p> --></div></div></div>');
$templateCache.put('app/account/activate/activate.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 data-translate="activate.title">Activation</h1><div class="alert alert-success" ng-show="vm.success" data-translate="activate.messages.success" translate-compile><strong>Your user has been activated.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</div><div class="alert alert-danger" ng-show="vm.error" data-translate="activate.messages.error"><strong>Your user could not be activated.</strong> Please use the registration form to sign up.</div></div></div></div>');
$templateCache.put('app/account/password/password.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h2 data-translate="password.title" translate-values="{username: \'{{vm.account.login}}\'}">Password for [<b>{{vm.account.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success" data-translate="password.messages.success"><strong>Password changed!</strong></div><div class="alert alert-danger" ng-show="vm.error" data-translate="password.messages.error"><strong>An error has occurred!</strong> The password could not be changed.</div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><form name="form" role="form" novalidate ng-submit="vm.changePassword()" show-validation><div class="form-group"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="password.form.button">Save</button></form></div></div></div>');
$templateCache.put('app/account/register/register.html','<div><div class="row"></div></div>');
$templateCache.put('app/account/settings/settings.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h2 data-translate="settings.title" translate-values="{username: \'{{vm.settingsAccount.login}}\'}">User settings for [<b>{{vm.settingsAccount.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success" data-translate="settings.messages.success"><strong>Settings saved!</strong></div><jhi-alert-error></jhi-alert-error><form name="form" role="form" novalidate ng-submit="vm.save()" show-validation><div class="form-group"><label class="control-label" for="firstName" data-translate="settings.form.firstname">First Name</label><input type="text" class="form-control" id="firstName" name="firstName" placeholder="{{\'settings.form.firstname.placeholder\' | translate}}" ng-model="vm.settingsAccount.firstName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.firstName.$dirty && form.firstName.$invalid"><p class="help-block" ng-show="form.firstName.$error.required" data-translate="settings.messages.validate.firstname.required">Your first name is required.</p><p class="help-block" ng-show="form.firstName.$error.minlength" data-translate="settings.messages.validate.firstname.minlength">Your first name is required to be at least 1 character.</p><p class="help-block" ng-show="form.firstName.$error.maxlength" data-translate="settings.messages.validate.firstname.maxlength">Your first name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="lastName" data-translate="settings.form.lastname">Last Name</label><input type="text" class="form-control" id="lastName" name="lastName" placeholder="{{\'settings.form.lastname.placeholder\' | translate}}" ng-model="vm.settingsAccount.lastName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.lastName.$dirty && form.lastName.$invalid"><p class="help-block" ng-show="form.lastName.$error.required" data-translate="settings.messages.validate.lastname.required">Your last name is required.</p><p class="help-block" ng-show="form.lastName.$error.minlength" data-translate="settings.messages.validate.lastname.minlength">Your last name is required to be at least 1 character.</p><p class="help-block" ng-show="form.lastName.$error.maxlength" data-translate="settings.messages.validate.lastname.maxlength">Your last name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="email" data-translate="global.form.email">E-mail</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.settingsAccount.email" ng-minlength="5" ng-maxlength="100" required maxlength="100"><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">Your e-mail is required.</p><p class="help-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your e-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div><div class="form-group"><label for="langKey" data-translate="settings.form.language">Language</label><select id="langKey" name="langKey" class="form-control" ng-model="vm.settingsAccount.langKey" ng-controller="JhiLanguageController as languageVm" ng-options="code as (code | findLanguageFromKey) for code in languageVm.languages"></select></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="settings.form.button">Save</button></form></div></div></div>');
$templateCache.put('app/admin/audits/audits.html','<div><h2 data-translate="audits.title">Audits</h2><div class="row"><div class="col-md-5"><h4 data-translate="audits.filter.title">Filter by date</h4><p class="input-group"><span class="input-group-addon" data-translate="audits.filter.from">from</span> <input type="date" class="input-sm form-control" name="start" ng-model="vm.fromDate" ng-change="vm.onChangeDate()" required> <span class="input-group-addon" data-translate="audits.filter.to">to</span> <input type="date" class="input-sm form-control" name="end" ng-model="vm.toDate" ng-change="vm.onChangeDate()" required></p></div></div><table class="table table-condensed table-striped table-bordered table-responsive"><thead><tr><th ng-click="predicate = \'timestamp\'; reverse=!reverse"><span data-translate="audits.table.header.date">Date</span></th><th ng-click="predicate = \'principal\'; reverse=!reverse"><span data-translate="audits.table.header.principal">User</span></th><th ng-click="predicate = \'type\'; reverse=!reverse"><span data-translate="audits.table.header.status">State</span></th><th ng-click="predicate = \'data.message\'; reverse=!reverse"><span data-translate="audits.table.header.data">Extra data</span></th></tr></thead><tr ng-repeat="audit in vm.audits | filter:filter | orderBy:predicate:reverse" ng-hide="audit.filtered"><td><span>{{audit.timestamp| date:\'medium\'}}</span></td><td><small>{{audit.principal}}</small></td><td>{{audit.type}}</td><td><span ng-show="audit.data.message">{{audit.data.message}}</span> <span ng-show="audit.data.remoteAddress"><span data-translate="audits.table.data.remoteAddress">Remote Address</span> {{audit.data.remoteAddress}}</span></td></tr></table><div class="text-center"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadPage(vm.page)"></uib-pagination></div></div>');
$templateCache.put('app/admin/configuration/configuration.html','<div><h2 data-translate="configuration.title">Configuration</h2><span data-translate="configuration.filter">Filter (by prefix)</span> <input type="text" ng-model="filter" class="form-control"><label ng-hide="filteredConfig.length == 0">Spring configuration</label><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filteredConfig.length == 0"><thead><tr><th ng-click="predicate = \'prefix\'; reverse=!reverse" class="col-sm-4"><span data-translate="configuration.table.prefix">Prefix</span></th><th data-translate="configuration.table.properties" class="col-sm-8">Properties</th></tr></thead><tr ng-repeat="entry in filtered = (vm.configuration | filter:filter | orderBy:predicate:reverse)"><td><span>{{entry.prefix}}</span></td><td><div class="row" ng-repeat="(key, value) in entry.properties"><div class="col-md-4">{{key}}</div><div class="col-md-8"><span class="pull-right label label-default break">{{value}}</span></div></div></td></tr></table><div ng-repeat="(key, value) in vm.allConfiguration"><label ng-hide="filtered.length == 0"><span>{{key}}</span></label><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filtered.length == 0"><thead><tr><th class="col-sm-4">Property</th><th class="col-sm-8">Value</th></tr></thead><tbody><tr ng-repeat="item in filtered = (value | filter:filter)"><td class="break">{{item.key}}</td><td class="break"><span class="pull-right label label-default break">{{item.val}}</span></td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/docs/docs.html','<iframe src="swagger-ui/index.html" frameborder="0" marginheight="0" marginwidth="0" width="100%" height="900" scrolling="auto" target="_top"></iframe>');
$templateCache.put('app/admin/health/health.html','<div><h2 data-translate="health.title">Health Checks</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span data-translate="health.refresh.button">Refresh</span></button></p><table id="healthCheck" class="table table-striped"><thead><tr><th class="col-md-7" data-translate="health.table.service">Service Name</th><th class="col-md-2 text-center" data-translate="health.table.status">Status</th><th class="col-md-2 text-center" data-translate="health.details.details">Details</th></tr></thead><tbody><tr ng-repeat="health in vm.healthData"><td>{{\'health.indicator.\' + vm.baseName(health.name) | translate}} {{vm.subSystemName(health.name)}}</td><td class="text-center"><span class="label" ng-class="vm.getLabelClass(health.status)">{{\'health.status.\' + health.status | translate}}</span></td><td class="text-center"><a class="hand" ng-click="vm.showHealth(health)" ng-show="health.details || health.error"><i class="glyphicon glyphicon-eye-open"></i></a></td></tr></tbody></table></div>');
$templateCache.put('app/admin/health/health.modal.html','<div class="modal-header"><button aria-label="Close" data-dismiss="modal" class="close" type="button" ng-click="vm.cancel()"><span aria-hidden="true">&times;</span></button><h4 class="modal-title" id="showHealthLabel">{{\'health.indicator.\' + vm.baseName(vm.currentHealth.name) | translate}} {{vm.subSystemName(vm.currentHealth.name)}}</h4></div><div class="modal-body pad"><div ng-show="vm.currentHealth.details"><h4 data-translate="health.details.properties">Properties</h4><table class="table table-striped"><thead><tr><th class="col-md-6 text-left" data-translate="health.details.name">Name</th><th class="col-md-6 text-left" data-translate="health.details.value">Value</th></tr></thead><tbody><tr ng-repeat="(k,v) in vm.currentHealth.details"><td class="col-md-6 text-left">{{k}}</td><td class="col-md-6 text-left">{{v}}</td></tr></tbody></table></div><div ng-show="vm.currentHealth.error"><h4 data-translate="health.details.error">Error</h4><pre>{{vm.currentHealth.error}}</pre></div></div><div class="modal-footer"><button data-dismiss="modal" class="btn btn-default pull-left" type="button" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/logs/logs.html','<div class="table-responsive"><h2 data-translate="logs.title">Logs</h2><p data-translate="logs.nbloggers" translate-values="{total: \'{{ vm.loggers.length }}\'}">There are {{ vm.loggers.length }} loggers.</p><span data-translate="logs.filter">Filter</span> <input type="text" ng-model="filter" class="form-control"><table class="table table-condensed table-striped table-bordered"><thead><tr title="click to order"><th ng-click="predicate = \'name\'; reverse=!reverse"><span data-translate="logs.table.name">Name</span></th><th ng-click="predicate = \'level\'; reverse=!reverse"><span data-translate="logs.table.level">Level</span></th></tr></thead><tr ng-repeat="logger in vm.loggers | filter:filter | orderBy:predicate:reverse"><td><small>{{logger.name | characters:140}}</small></td><td><button ng-click="vm.changeLevel(logger.name, \'TRACE\')" ng-class="(logger.level==\'TRACE\') ? \'btn-danger\' : \'btn-default\'" class="btn btn-default btn-xs">TRACE</button> <button ng-click="vm.changeLevel(logger.name, \'DEBUG\')" ng-class="(logger.level==\'DEBUG\') ? \'btn-warning\' : \'btn-default\'" class="btn btn-default btn-xs">DEBUG</button> <button ng-click="vm.changeLevel(logger.name, \'INFO\')" ng-class="(logger.level==\'INFO\') ? \'btn-info\' : \'btn-default\'" class="btn btn-default btn-xs">INFO</button> <button ng-click="vm.changeLevel(logger.name, \'WARN\')" ng-class="(logger.level==\'WARN\') ? \'btn-success\' : \'btn-default\'" class="btn btn-default btn-xs">WARN</button> <button ng-click="vm.changeLevel(logger.name, \'ERROR\')" ng-class="(logger.level==\'ERROR\') ? \'btn-primary\' : \'btn-default\'" class="btn btn-default btn-xs">ERROR</button></td></tr></table></div>');
$templateCache.put('app/admin/metrics/metrics.html','<div><h2 data-translate="metrics.title">Application Metrics</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span data-translate="metrics.refresh.button">Refresh</span></button></p><h3 data-translate="metrics.jvm.title">JVM Metrics</h3><div class="row" ng-hide="vm.updatingMetrics"><div class="col-md-4"><b data-translate="metrics.jvm.memory.title">Memory</b><p><span data-translate="metrics.jvm.memory.total">Total Memory</span> ({{vm.metrics.gauges[\'jvm.memory.total.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.total.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.total.max\'].value" value="vm.metrics.gauges[\'jvm.memory.total.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.total.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.total.max\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.memory.heap">Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.heap.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.heap.max\'].value" value="vm.metrics.gauges[\'jvm.memory.heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.heap.max\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.memory.nonheap">Non-Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value" value="vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b data-translate="metrics.jvm.threads.title">Threads</b> (Total: {{vm.metrics.gauges[\'jvm.threads.count\'].value}}) <a class="hand" ng-click="vm.refreshThreadDumpData()" data-toggle="modal" data-target="#threadDump"><i class="glyphicon glyphicon-eye-open"></i></a><p><span data-translate="metrics.jvm.threads.runnable">Runnable</span> {{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value}}</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.runnable.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.timedwaiting">Timed Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.waiting">Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.blocked">Blocked</span> ({{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.blocked.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b data-translate="metrics.jvm.gc.title">Garbage collections</b><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.marksweepcount">Mark Sweep count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.count\'].value}}</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.marksweeptime">Mark Sweep time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.time\'].value}}ms</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.scavengecount">Scavenge count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.count\'].value}}</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.scavengetime">Scavenge time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.time\'].value}}ms</div></div></div></div><div class="well well-lg" ng-show="vm.updatingMetrics" data-translate="metrics.updating">Updating...</div><h3 data-translate="metrics.jvm.http.title">HTTP requests (events per second)</h3><p><span data-translate="metrics.jvm.http.active">Active requests</span> <b>{{vm.metrics.counters[\'com.codahale.metrics.servlet.InstrumentedFilter.activeRequests\'].count | number:0}}</b> - <span data-translate="metrics.jvm.http.total">Total requests</span> <b>{{vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count | number:0}}</b></p><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="metrics.jvm.http.table.code">Code</th><th data-translate="metrics.jvm.http.table.count">Count</th><th class="text-right" data-translate="metrics.jvm.http.table.mean">Mean</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (1 min)</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (5 min)</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (15 min)</th></tr></thead><tbody><tr><td data-translate="metrics.jvm.http.code.ok">OK</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m15_rate | number:2}}</td></tr><tr><td data-translate="metrics.jvm.http.code.notfound">Not Found</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m15_rate | number:2}}</td></tr><tr><td data-translate="metrics.jvm.http.code.servererror">Server error</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m15_rate | number:2}}</td></tr></tbody></table></div><h3 data-translate="metrics.servicesstats.title">Services statistics (time in millisecond)</h3><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="metrics.servicesstats.table.name">Service name</th><th class="text-right" data-translate="metrics.servicesstats.table.count">Count</th><th class="text-right" data-translate="metrics.servicesstats.table.mean">Mean</th><th class="text-right" data-translate="metrics.servicesstats.table.min">Min</th><th class="text-right" data-translate="metrics.servicesstats.table.p50">p50</th><th class="text-right" data-translate="metrics.servicesstats.table.p75">p75</th><th class="text-right" data-translate="metrics.servicesstats.table.p95">p95</th><th class="text-right" data-translate="metrics.servicesstats.table.p99">p99</th><th class="text-right" data-translate="metrics.servicesstats.table.max">Max</th></tr></thead><tbody><tr ng-repeat="(k, v) in vm.servicesStats"><td>{{k}}</td><td class="text-right">{{v.count}}</td><td class="text-right">{{v.mean * 1000 | number:0}}</td><td class="text-right">{{v.min * 1000 | number:0}}</td><td class="text-right">{{v.p50 * 1000 | number:0}}</td><td class="text-right">{{v.p75 * 1000 | number:0}}</td><td class="text-right">{{v.p95 * 1000 | number:0}}</td><td class="text-right">{{v.p99 * 1000 | number:0}}</td><td class="text-right">{{v.max * 1000 | number:0}}</td></tr></tbody></table></div><h3 data-translate="metrics.datasource.title" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0">DataSource statistics (time in millisecond)</h3><div class="table-responsive" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0"><table class="table table-striped"><thead><tr><th><span data-translate="metrics.datasource.usage">Usage</span> ({{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value}} / {{vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value}})</th><th class="text-right" data-translate="metrics.datasource.count">Count</th><th class="text-right" data-translate="metrics.datasource.mean">Mean</th><th class="text-right" data-translate="metrics.datasource.min">Min</th><th class="text-right" data-translate="metrics.datasource.p50">p50</th><th class="text-right" data-translate="metrics.datasource.p75">p75</th><th class="text-right" data-translate="metrics.datasource.p95">p95</th><th class="text-right" data-translate="metrics.datasource.p99">p99</th><th class="text-right" data-translate="metrics.datasource.max">Max</th></tr></thead><tbody><tr><td><div class="progress progress-striped"><uib-progressbar min="0" max="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value" value="vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value * 100 / vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value | number:0}}%</span></uib-progressbar></div></td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].count}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].mean | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].min | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p50 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p75 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p95 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p99 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].max | number:2}}</td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/metrics/metrics.modal.html','<!-- Modal used to display the threads dump --><div class="modal-header"><button type="button" class="close" ng-click="vm.cancel()">&times;</button><h4 class="modal-title" data-translate="metrics.jvm.threads.dump.title">Threads dump</h4></div><div class="modal-body pad"><span class="label label-primary" ng-click="threadDumpFilter = {}">All&nbsp;<span class="badge">{{vm.threadDumpAll}}</span></span>&nbsp; <span class="label label-success" ng-click="threadDumpFilter = {threadState: \'RUNNABLE\'}">Runnable&nbsp;<span class="badge">{{vm.threadDumpRunnable}}</span></span>&nbsp; <span class="label label-info" ng-click="threadDumpFilter = {threadState: \'WAITING\'}">Waiting&nbsp;<span class="badge">{{vm.threadDumpWaiting}}</span></span>&nbsp; <span class="label label-warning" ng-click="threadDumpFilter = {threadState: \'TIMED_WAITING\'}">Timed Waiting&nbsp;<span class="badge">{{vm.threadDumpTimedWaiting}}</span></span>&nbsp; <span class="label label-danger" ng-click="threadDumpFilter = {threadState: \'BLOCKED\'}">Blocked&nbsp;<span class="badge">{{vm.threadDumpBlocked}}</span></span>&nbsp;<div class="voffset2">&nbsp;</div>Filter <input type="text" ng-model="threadDumpFilter" class="form-control"><div class="row pad" ng-repeat="(k, v) in vm.threadDump | filter:threadDumpFilter"><h5><span class="label" ng-class="vm.getLabelClass(v.threadState)">{{v.threadState}}</span>&nbsp;{{v.threadName}} (ID {{v.threadId}}) <a ng-click="show = !show"><span ng-show="!show" data-translate="metrics.jvm.threads.dump.show">Show StackTrace</span> <span ng-show="show" data-translate="metrics.jvm.threads.dump.hide">Hide StackTrace</span></a></h5><div class="well" ng-show="show"><div ng-repeat="(stK, stV) in v.stackTrace">{{stV.className}}.{{stV.methodName}}({{stV.fileName}}:{{stV.lineNumber}}) <span class="voffset1"></span></div></div><table class="table table-condensed"><thead><tr><th class="text-right" data-translate="metrics.jvm.threads.dump.blockedtime">Blocked Time</th><th class="text-right" data-translate="metrics.jvm.threads.dump.blockedcount">Blocked Count</th><th class="text-right" data-translate="metrics.jvm.threads.dump.waitedtime">Waited Time</th><th class="text-right" data-translate="metrics.jvm.threads.dump.waitedcount">Waited Count</th><th data-translate="metrics.jvm.threads.dump.lockname">Lock Name</th></tr></thead><tbody><tr><td>{{v.blockedTime}}</td><td>{{v.blockedCount}}</td><td>{{v.waitedTime}}</td><td>{{v.waitedCount}}</td><td>{{v.lockName}}</td></tr></tbody></table></div></div><div class="modal-footer"><button type="button" class="btn btn-default pull-left" data-dismiss="modal" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/user-management/user-management-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.user.login)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="userManagement.delete.question" translate-values="{login: \'{{vm.user.login}}\'}">Are you sure you want to delete this User?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management-detail.html','<div><h2><span data-translate="userManagement.detail.title">User</span> "{{vm.user.login}}"</h2><dl class="dl-horizontal"><dt><span data-translate="userManagement.login">Login</span></dt><dd><span>{{vm.user.login}}</span></dd><dt><span data-translate="userManagement.firstName">First Name</span></dt><dd>{{vm.user.firstName}}</dd><dt><span data-translate="userManagement.lastName">Last Name</span></dt><dd>{{vm.user.lastName}}</dd><dt><span data-translate="userManagement.email">Email</span></dt><dd>{{vm.user.email}}</dd><dt><span data-translate="userManagement.activated">Activated</span></dt><dd>{{vm.user.activated}}</dd><dt><span data-translate="userManagement.langKey">Lang Key</span></dt><dd>{{vm.user.langKey}}</dd><dt><span data-translate="userManagement.createdBy">Created By</span></dt><dd>{{vm.user.createdBy}}</dd><dt><span data-translate="userManagement.createdDate">Created Date</span></dt><dd>{{vm.user.createdDate | date:\'dd/MM/yy HH:mm\' }}</dd><dt><span data-translate="userManagement.lastModifiedBy">Last Modified By</span></dt><dd>{{vm.user.lastModifiedBy}}</dd><dt><span data-translate="userManagement.lastModifiedDate">Last Modified Date</span></dt><dd>{{vm.user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</dd><dt><span data-translate="userManagement.profiles">Profiles</span></dt><dd><ul class="list-unstyled"><li ng-repeat="authority in vm.user.authorities"><span>{{authority}}</span></li></ul></dd></dl><button type="submit" ui-sref="user-management" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button></div>');
$templateCache.put('app/admin/user-management/user-management-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myUserLabel" data-translate="userManagement.home.createOrEditLabel">Create or edit a User</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label data-translate="global.field.id">ID</label><input type="text" class="form-control" name="id" ng-model="vm.user.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="userManagement.login">Login</label><input type="text" class="form-control" name="login" ng-model="vm.user.login" ng-required="vm.user.id == null" ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/"><div ng-show="editForm.login.$invalid"><p class="help-block" ng-show="editForm.login.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.login.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="userManagement.firstName">First Name</label><input type="text" class="form-control" name="firstName" ng-model="vm.user.firstName" ng-maxlength="50"><div ng-show="editForm.firstName.$invalid"><p class="help-block" ng-show="editForm.firstName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label data-translate="userManagement.lastName">Last Name</label><input type="text" class="form-control" name="lastName" ng-model="vm.user.lastName" ng-maxlength="50"><div ng-show="editForm.lastName.$invalid"><p class="help-block" ng-show="editForm.lastName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="userManagement.email">Email</label><input type="email" class="form-control" name="email" ng-model="vm.user.email" required ng-maxlength="100"><div ng-show="editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.email.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p><p class="help-block" ng-show="editForm.email.$error.email" data-translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p></div></div><div class="form-group"><label for="activated"><input ng-disabled="vm.user.id === null" type="checkbox" id="activated" name="activated" ng-model="vm.user.activated"> <span data-translate="userManagement.activated">Activated</span></label></div><div class="form-group"><label data-translate="userManagement.langKey">Lang Key</label><select class="form-control" name="langKey" ng-model="vm.user.langKey" ng-options="language as language for language in vm.languages track by language"></select></div><div class="form-group"><label data-translate="userManagement.agency" for="field_agenzia_user">Agenzia</label><select class="form-control" id="field_agenzia_user" name="agenzia_user" ng-model="vm.user.agenziaid" ng-options="agenzia_user as agenzia_user.nome for agenzia_user in vm.agenzia track by agenzia_user.id"><option value=""></option></select></div><div class="form-group"><label data-translate="userManagement.profiles">Profiles</label><select class="form-control" multiple="multiple" name="authority" ng-model="vm.user.authorities" ng-options="authority for authority in vm.authorities"></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management.html','<div><h2 data-translate="userManagement.home.title">Users</h2><jhi-alert></jhi-alert><div class="row"><div class="col-md-4"><button class="btn btn-primary" ui-sref="user-management.new"><span class="glyphicon glyphicon-flash"></span> <span data-translate="userManagement.home.createLabel">Create a new User</span></button></div></div><div class="table-responsive"><table class="table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="login"><span data-translate="userManagement.login">Login</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="email"><span data-translate="userManagement.email">Email</span> <span class="glyphicon glyphicon-sort"></span></th><th></th><th jh-sort-by="langKey"><span data-translate="userManagement.langKey">Lang Key</span> <span class="glyphicon glyphicon-sort"></span></th><th><span data-translate="userManagement.profiles">Profiles</span></th><th jh-sort-by="createdDate"><span data-translate="userManagement.createdDate">Created Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedBy"><span data-translate="userManagement.lastModifiedBy">Last Modified By</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedDate"><span data-translate="userManagement.lastModifiedDate">Last Modified Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="agency"><span data-translate="userManagement.agency">Agency</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="user in vm.users track by user.id"><td><a ui-sref="user-management-detail({login:user.login})">{{user.id}}</a></td><td>{{user.login}}</td><td>{{user.email}}</td><td><span class="label label-danger" ng-click="vm.setActive(user, true)" ng-show="!user.activated" data-translate="userManagement.deactivated" style="cursor: pointer">Deactivated</span> <span class="label label-success" ng-click="vm.setActive(user, false)" ng-show="user.activated" data-translate="userManagement.activated" style="cursor: pointer">Activated</span></td><td>{{user.langKey}}</td><td><div ng-repeat="authority in user.authorities"><span class="label label-info">{{ authority }}</span></div></td><td>{{user.createdDate | date:\'dd/MM/yy HH:mm\'}}</td><td>{{user.lastModifiedBy}}</td><td>{{user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</td><td>{{user.agenziaid.nome}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="user-management-detail({login:user.login})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="user-management.edit({login:user.login})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="user-management.delete({login:user.login})" class="btn btn-danger btn-sm" ng-disabled="vm.currentAccount.login==user.login"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/components/login/login.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.cancel()">&times;</button><h4 class="modal-title" data-translate="login.title">Sign in</h4></div><div class="modal-body"><div class="row"><div class="col-md-4 col-md-offset-4"><h1 data-translate="login.title">Sign in</h1></div><div class="col-md-8 col-md-offset-2"><div class="alert alert-danger" ng-show="vm.authenticationError" data-translate="login.messages.error.authentication"><strong>Failed to sign in!</strong> Please check your credentials and try again.</div></div><div class="col-md-8 col-md-offset-2"><form class="form" role="form" ng-submit="vm.login($event)"><div class="form-group"><label for="username" data-translate="global.form.username">Login</label><input type="text" class="form-control" id="username" placeholder="{{\'global.form.username.placeholder\' | translate}}" ng-model="vm.username"></div><div class="form-group"><label for="password" data-translate="login.form.password">Password</label><input type="password" class="form-control" id="password" placeholder="{{\'login.form.password.placeholder\' | translate}}" ng-model="vm.password"></div><div class="form-group"><label for="rememberMe"><input type="checkbox" id="rememberMe" ng-model="vm.rememberMe" checked="checked"> <span data-translate="login.form.rememberme">Remember me</span></label></div><button type="submit" class="btn btn-primary" data-translate="login.form.button">Sign in</button></form><p></p><div class="alert alert-warning"><a class="alert-link" href="" ng-click="vm.requestResetPassword()" data-translate="login.password.forgot">Did you forget your password?</a></div></div></div></div>');
$templateCache.put('app/entities/agenzia/agenzia-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.agenzia.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="doctorclubboApp.agenzia.delete.question" translate-values="{id: \'{{vm.agenzia.id}}\'}">Are you sure you want to delete this Agenzia?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/agenzia/agenzia-detail.html','<div><h2><span data-translate="doctorclubboApp.agenzia.detail.title">Agenzia</span> {{vm.agenzia.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="doctorclubboApp.agenzia.nome">Nome</span></dt><dd><span>{{vm.agenzia.nome}}</span></dd><dt><span data-translate="doctorclubboApp.agenzia.provincia">Provincia</span></dt><dd><span>{{vm.agenzia.provincia}}</span></dd><dt><span data-translate="doctorclubboApp.agenzia.comune">Comune</span></dt><dd><span>{{vm.agenzia.comune}}</span></dd><dt><span data-translate="doctorclubboApp.agenzia.cap">Cap</span></dt><dd><span>{{vm.agenzia.cap}}</span></dd><dt><span data-translate="doctorclubboApp.agenzia.indirizzo">Indirizzo</span></dt><dd><span>{{vm.agenzia.indirizzo}}</span></dd><dt><span data-translate="doctorclubboApp.agenzia.tel">Tel</span></dt><dd><span>{{vm.agenzia.tel}}</span></dd><dt><span data-translate="doctorclubboApp.agenzia.email">Email</span></dt><dd><span>{{vm.agenzia.email}}</span></dd><dt><span data-translate="doctorclubboApp.agenzia.partitaIva">Partita Iva</span></dt><dd><span>{{vm.agenzia.partitaIva}}</span></dd><dt><span data-translate="doctorclubboApp.agenzia.Intestatario">Intestatario Fattura</span></dt><dd><span>{{agenzia.intestatarioFattura}}</span></dd><dt><span data-translate="doctorclubboApp.agenzia.agenziaComune">Agenzia Comune</span></dt><dd><a ui-sref="comune-detail({id:vm.agenzia.agenziaComune.id})">{{vm.agenzia.agenziaComune.id}}</a></dd><dt><span data-translate="doctorclubboApp.agenzia.agenziaProvincia">Agenzia Provincia</span></dt><dd><a ui-sref="provincia-detail({id:vm.agenzia.agenziaProvincia.id})">{{vm.agenzia.agenziaProvincia.id}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="agenzia-detail.edit({id:vm.agenzia.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/agenzia/agenzia-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myAgenziaLabel" data-translate="doctorclubboApp.agenzia.home.createOrEditLabel">Create or edit a Agenzia</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.agenzia.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.agenzia.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.agenzia.nome" for="field_nome">Nome</label><input type="text" class="form-control" name="nome" id="field_nome" ng-model="vm.agenzia.nome"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.agenzia.provincia" for="field_provincia">Provincia</label><input type="text" class="form-control" name="provincia" id="field_provincia" ng-model="vm.agenzia.provincia"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.agenzia.comune" for="field_comune">Comune</label><input type="text" class="form-control" name="comune" id="field_comune" ng-model="vm.agenzia.comune"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.agenzia.cap" for="field_cap">Cap</label><input type="text" class="form-control" name="cap" id="field_cap" ng-model="vm.agenzia.cap"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.agenzia.indirizzo" for="field_indirizzo">Indirizzo</label><input type="text" class="form-control" name="indirizzo" id="field_indirizzo" ng-model="vm.agenzia.indirizzo"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.agenzia.tel" for="field_tel">Tel</label><input type="text" class="form-control" name="tel" id="field_tel" ng-model="vm.agenzia.tel"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.agenzia.email" for="field_email">Email</label><input type="text" class="form-control" name="email" id="field_email" ng-model="vm.agenzia.email"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.agenzia.partitaIva" for="field_partitaIva">Partita Iva</label><input type="text" class="form-control" name="partitaIva" id="field_partitaIva" ng-model="vm.agenzia.partitaIva"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.agenzia.Intestatario" for="field_intestatarioFattura">Intestatario Fattura</label><input type="text" class="form-control" name="intestatarioFattura" id="field_intestatarioFattura" ng-model="vm.agenzia.intestatarioFattura"></div><div class="form-group"><label data-translate="doctorclubboApp.agenzia.agenziaComune" for="field_agenziaComune">Agenzia Comune</label><select class="form-control" id="field_agenziaComune" name="agenziaComune" ng-model="vm.agenzia.agenziaComune" ng-options="comune as comune.id for comune in vm.comunes track by comune.id"><option value=""></option></select></div><div class="form-group"><label data-translate="doctorclubboApp.agenzia.agenziaProvincia" for="field_agenziaProvincia">Agenzia Provincia</label><select class="form-control" id="field_agenziaProvincia" name="agenziaProvincia" ng-model="vm.agenzia.agenziaProvincia" ng-options="provincia as provincia.id for provincia in vm.provincias track by provincia.id"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/agenzia/agenzias.html','<div><h2 data-translate="doctorclubboApp.agenzia.home.title">Agenzias</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="agenzia.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="doctorclubboApp.agenzia.home.createLabel">Create new Agenzia</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nome"><span data-translate="doctorclubboApp.agenzia.nome">Nome</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="provincia"><span data-translate="doctorclubboApp.agenzia.provincia">Provincia</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="comune"><span data-translate="doctorclubboApp.agenzia.comune">Comune</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="cap"><span data-translate="doctorclubboApp.agenzia.cap">Cap</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="indirizzo"><span data-translate="doctorclubboApp.agenzia.indirizzo">Indirizzo</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="tel"><span data-translate="doctorclubboApp.agenzia.tel">Tel</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="email"><span data-translate="doctorclubboApp.agenzia.email">Email</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="partitaIva"><span data-translate="doctorclubboApp.agenzia.partitaIva">Partita Iva</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="agenziaComune.id"><span data-translate="doctorclubboApp.agenzia.agenziaComune">Agenzia Comune</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="agenziaProvincia.id"><span data-translate="doctorclubboApp.agenzia.agenziaProvincia">Agenzia Provincia</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="intestatarioFattura"><span data-translate="doctorclubboApp.agenzia.Intestatario">Intestatario Fattura</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="agenzia in vm.agenzias track by agenzia.id"><td><a ui-sref="agenzia-detail({id:agenzia.id})">{{agenzia.id}}</a></td><td>{{agenzia.nome}}</td><td>{{agenzia.provincia}}</td><td>{{agenzia.comune}}</td><td>{{agenzia.cap}}</td><td>{{agenzia.indirizzo}}</td><td>{{agenzia.tel}}</td><td>{{agenzia.email}}</td><td>{{agenzia.partitaIva}}</td><td><a ui-sref="comune-detail({id:agenzia.agenziaComune.id})">{{agenzia.agenziaComune.id}}</a></td><td><a ui-sref="provincia-detail({id:agenzia.agenziaProvincia.id})">{{agenzia.agenziaProvincia.id}}</a></td><td>{{agenzia.intestatarioFattura}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="agenzia-detail({id:agenzia.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="agenzia.edit({id:agenzia.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="agenzia.delete({id:agenzia.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/amazon-statement/amazon-statement-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.amazonStatement.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="doctorclubboApp.amazonStatement.delete.question" translate-values="{id: \'{{vm.amazonStatement.id}}\'}">Are you sure you want to delete this Amazon Statement?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/amazon-statement/amazon-statement-detail.html','<div><h2><span data-translate="doctorclubboApp.amazonStatement.detail.title">Amazon Statement</span> {{vm.amazonStatement.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="doctorclubboApp.amazonStatement.dtIns">Dt Ins</span></dt><dd><span>{{vm.amazonStatement.dtIns | date:\'medium\'}}</span></dd><dt><span data-translate="doctorclubboApp.amazonStatement.gcClaimCode">Gc Claim Code</span></dt><dd><span>{{vm.amazonStatement.gcClaimCode}}</span></dd><dt><span data-translate="doctorclubboApp.amazonStatement.gcId">Gc Id</span></dt><dd><span>{{vm.amazonStatement.gcId}}</span></dd><dt><span data-translate="doctorclubboApp.amazonStatement.creationRequestId">Creation Request Id</span></dt><dd><span>{{vm.amazonStatement.creationRequestId}}</span></dd><dt><span data-translate="doctorclubboApp.amazonStatement.emailSource">Email Source</span></dt><dd><span>{{vm.amazonStatement.emailSource}}</span></dd><dt><span data-translate="doctorclubboApp.amazonStatement.emailDestination">Email Destination</span></dt><dd><span>{{vm.amazonStatement.emailDestination}}</span></dd><dt><span data-translate="doctorclubboApp.amazonStatement.currencyCode">Currency Code</span></dt><dd><span>{{vm.amazonStatement.currencyCode}}</span></dd><dt><span data-translate="doctorclubboApp.amazonStatement.amount">Amount</span></dt><dd><span>{{vm.amazonStatement.amount}}</span></dd><dt><span data-translate="doctorclubboApp.amazonStatement.cardStatus">Card Status</span></dt><dd><span>{{vm.amazonStatement.cardStatus}}</span></dd><dt><span data-translate="doctorclubboApp.amazonStatement.status">Status</span></dt><dd><span>{{vm.amazonStatement.status}}</span></dd><dt><span data-translate="doctorclubboApp.amazonStatement.processed">Processed</span></dt><dd><span>{{vm.amazonStatement.processed}}</span></dd><dt><span data-translate="doctorclubboApp.amazonStatement.gcExpirationDate">Gc Expiration Date</span></dt><dd><span>{{vm.amazonStatement.gcExpirationDate | date:\'medium\'}}</span></dd><dt><span data-translate="doctorclubboApp.amazonStatement.operationCode">Operation Code</span></dt><dd><span>{{vm.amazonStatement.operationCode}}</span></dd><dt><span data-translate="doctorclubboApp.amazonStatement.gcSystem">Gc System</span></dt><dd><a ui-sref="gc-system-detail({id:vm.amazonStatement.gcSystemId})">{{vm.amazonStatement.gcSystemId}}</a></dd><dt><span data-translate="doctorclubboApp.amazonStatement.campagnaAmazon">Campagna Amazon</span></dt><dd><a ui-sref="campagna-amazon-detail({id:vm.amazonStatement.campagnaAmazonId})">{{vm.amazonStatement.campagnaAmazonId}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="amazon-statement-detail.edit({id:vm.amazonStatement.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/amazon-statement/amazon-statement-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myAmazonStatementLabel" data-translate="doctorclubboApp.amazonStatement.home.createOrEditLabel">Create or edit a Amazon Statement</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.amazonStatement.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.amazonStatement.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.amazonStatement.dtIns" for="field_dtIns">Dt Ins</label><div class="input-group"><input id="field_dtIns" type="text" class="form-control" name="dtIns" datetime-picker="{{dateformat}}" ng-model="vm.amazonStatement.dtIns" is-open="vm.datePickerOpenStatus.dtIns"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dtIns\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.amazonStatement.gcClaimCode" for="field_gcClaimCode">Gc Claim Code</label><input type="text" class="form-control" name="gcClaimCode" id="field_gcClaimCode" ng-model="vm.amazonStatement.gcClaimCode"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.amazonStatement.gcId" for="field_gcId">Gc Id</label><input type="text" class="form-control" name="gcId" id="field_gcId" ng-model="vm.amazonStatement.gcId"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.amazonStatement.creationRequestId" for="field_creationRequestId">Creation Request Id</label><input type="text" class="form-control" name="creationRequestId" id="field_creationRequestId" ng-model="vm.amazonStatement.creationRequestId"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.amazonStatement.emailSource" for="field_emailSource">Email Source</label><input type="text" class="form-control" name="emailSource" id="field_emailSource" ng-model="vm.amazonStatement.emailSource"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.amazonStatement.emailDestination" for="field_emailDestination">Email Destination</label><input type="text" class="form-control" name="emailDestination" id="field_emailDestination" ng-model="vm.amazonStatement.emailDestination"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.amazonStatement.currencyCode" for="field_currencyCode">Currency Code</label><input type="text" class="form-control" name="currencyCode" id="field_currencyCode" ng-model="vm.amazonStatement.currencyCode"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.amazonStatement.amount" for="field_amount">Amount</label><input type="number" class="form-control" name="amount" id="field_amount" ng-model="vm.amazonStatement.amount"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.amazonStatement.cardStatus" for="field_cardStatus">Card Status</label><input type="text" class="form-control" name="cardStatus" id="field_cardStatus" ng-model="vm.amazonStatement.cardStatus"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.amazonStatement.status" for="field_status">Status</label><input type="text" class="form-control" name="status" id="field_status" ng-model="vm.amazonStatement.status"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.amazonStatement.processed" for="field_processed">Processed</label><input type="checkbox" name="processed" id="field_processed" ng-model="vm.amazonStatement.processed"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.amazonStatement.gcExpirationDate" for="field_gcExpirationDate">Gc Expiration Date</label><div class="input-group"><input id="field_gcExpirationDate" type="text" class="form-control" name="gcExpirationDate" datetime-picker="{{dateformat}}" ng-model="vm.amazonStatement.gcExpirationDate" is-open="vm.datePickerOpenStatus.gcExpirationDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'gcExpirationDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.amazonStatement.operationCode" for="field_operationCode">Operation Code</label><input type="number" class="form-control" name="operationCode" id="field_operationCode" ng-model="vm.amazonStatement.operationCode"></div><div class="form-group"><label data-translate="doctorclubboApp.amazonStatement.gcSystem" for="field_gcSystem">Gc System</label><select class="form-control" id="field_gcSystem" name="gcSystem" ng-model="vm.amazonStatement.gcSystemId" ng-options="gcSystem.id as gcSystem.id for gcSystem in vm.gcsystems"><option value=""></option></select></div><div class="form-group"><label data-translate="doctorclubboApp.amazonStatement.campagnaAmazon" for="field_campagnaAmazon">Campagna Amazon</label><select class="form-control" id="field_campagnaAmazon" name="campagnaAmazon" ng-model="vm.amazonStatement.campagnaAmazonId" ng-options="campagnaAmazon.id as campagnaAmazon.id for campagnaAmazon in vm.campagnaamazons"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/amazon-statement/amazon-statements.html','<div><h2 data-translate="doctorclubboApp.amazonStatement.home.title">Amazon Statements</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="amazon-statement.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="doctorclubboApp.amazonStatement.home.createLabel">Create new Amazon Statement</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="dtIns"><span data-translate="doctorclubboApp.amazonStatement.dtIns">Dt Ins</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="gcClaimCode"><span data-translate="doctorclubboApp.amazonStatement.gcClaimCode">Gc Claim Code</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="gcId"><span data-translate="doctorclubboApp.amazonStatement.gcId">Gc Id</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="creationRequestId"><span data-translate="doctorclubboApp.amazonStatement.creationRequestId">Creation Request Id</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="emailSource"><span data-translate="doctorclubboApp.amazonStatement.emailSource">Email Source</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="emailDestination"><span data-translate="doctorclubboApp.amazonStatement.emailDestination">Email Destination</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="currencyCode"><span data-translate="doctorclubboApp.amazonStatement.currencyCode">Currency Code</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="amount"><span data-translate="doctorclubboApp.amazonStatement.amount">Amount</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="cardStatus"><span data-translate="doctorclubboApp.amazonStatement.cardStatus">Card Status</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="status"><span data-translate="doctorclubboApp.amazonStatement.status">Status</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="processed"><span data-translate="doctorclubboApp.amazonStatement.processed">Processed</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="gcExpirationDate"><span data-translate="doctorclubboApp.amazonStatement.gcExpirationDate">Gc Expiration Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="operationCode"><span data-translate="doctorclubboApp.amazonStatement.operationCode">Operation Code</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="gcSystemId"><span data-translate="doctorclubboApp.amazonStatement.gcSystem">Gc System</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="campagnaAmazonId"><span data-translate="doctorclubboApp.amazonStatement.campagnaAmazon">Campagna Amazon</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="amazonStatement in vm.amazonStatements track by amazonStatement.id"><td><a ui-sref="amazon-statement-detail({id:amazonStatement.id})">{{amazonStatement.id}}</a></td><td>{{amazonStatement.dtIns | date:\'medium\'}}</td><td>{{amazonStatement.gcClaimCode}}</td><td>{{amazonStatement.gcId}}</td><td>{{amazonStatement.creationRequestId}}</td><td>{{amazonStatement.emailSource}}</td><td>{{amazonStatement.emailDestination}}</td><td>{{amazonStatement.currencyCode}}</td><td>{{amazonStatement.amount}}</td><td>{{amazonStatement.cardStatus}}</td><td>{{amazonStatement.status}}</td><td>{{amazonStatement.processed}}</td><td>{{amazonStatement.gcExpirationDate | date:\'medium\'}}</td><td>{{amazonStatement.operationCode}}</td><td><a ui-sref="gc-system-detail({id:amazonStatement.gcSystemId})">{{amazonStatement.gcSystemId}}</a></td><td><a ui-sref="campagna-amazon-detail({id:amazonStatement.campagnaAmazonId})">{{amazonStatement.campagnaAmazonId}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="amazon-statement-detail({id:amazonStatement.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="amazon-statement.edit({id:amazonStatement.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="amazon-statement.delete({id:amazonStatement.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div><uib-pager total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pager></div>');
$templateCache.put('app/entities/area/area-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.area.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="doctorclubboApp.area.delete.question" translate-values="{id: \'{{vm.area.id}}\'}">Are you sure you want to delete this Area?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/area/area-detail.html','<div><h2><span data-translate="doctorclubboApp.area.detail.title">Area</span> {{vm.area.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="doctorclubboApp.area.nome">Nome</span></dt><dd><span>{{vm.area.nome}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="area-detail.edit({id:vm.area.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/area/area-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myAreaLabel" data-translate="doctorclubboApp.area.home.createOrEditLabel">Create or edit a Area</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.area.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.area.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.area.nome" for="field_nome">Nome</label><input type="text" class="form-control" name="nome" id="field_nome" ng-model="vm.area.nome"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/area/areas.html','<div><h2 data-translate="doctorclubboApp.area.home.title">Areas</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="area.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="doctorclubboApp.area.home.createLabel">Create new Area</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nome"><span data-translate="doctorclubboApp.area.nome">Nome</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="area in vm.areas track by area.id"><td><a ui-sref="area-detail({id:area.id})">{{area.id}}</a></td><td>{{area.nome}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="area-detail({id:area.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="area.edit({id:area.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="area.delete({id:area.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/attivita/attivita-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.attivita.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="doctorclubboApp.attivita.delete.question" translate-values="{id: \'{{vm.attivita.id}}\'}">Are you sure you want to delete this Attivita?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/attivita/attivita-detail.html','<div><h2><span data-translate="doctorclubboApp.attivita.detail.title">Attivita</span> {{vm.attivita.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="doctorclubboApp.attivita.attivita">Attivita</span></dt><dd><span>{{vm.attivita.attivita}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="attivita-detail.edit({id:vm.attivita.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/attivita/attivita-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myAttivitaLabel" data-translate="doctorclubboApp.attivita.home.createOrEditLabel">Create or edit a Attivita</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.attivita.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.attivita.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.attivita.attivita" for="field_attivita">Attivita</label><input type="text" class="form-control" name="attivita" id="field_attivita" ng-model="vm.attivita.attivita"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/attivita/attivitas.html','<div><h2 data-translate="doctorclubboApp.attivita.home.title">Attivitas</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="attivita.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="doctorclubboApp.attivita.home.createLabel">Create new Attivita</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="doctorclubboApp.attivita.attivita">Attivita</span></th><th></th></tr></thead><tbody><tr ng-repeat="attivita in vm.attivitas track by attivita.id"><td><a ui-sref="attivita-detail({id:attivita.id})">{{attivita.id}}</a></td><td>{{attivita.attivita}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="attivita-detail({id:attivita.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="attivita.edit({id:attivita.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="attivita.delete({id:attivita.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/azione/azione-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.azione.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="doctorclubboApp.azione.delete.question" translate-values="{id: \'{{vm.azione.id}}\'}">Are you sure you want to delete this Azione?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/azione/azione-detail.html','<div><h2><span data-translate="doctorclubboApp.azione.detail.title">Azione</span> {{vm.azione.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="doctorclubboApp.azione.nome">Nome</span></dt><dd><span>{{vm.azione.nome}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="azione-detail.edit({id:vm.azione.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/azione/azione-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myAzioneLabel" data-translate="doctorclubboApp.azione.home.createOrEditLabel">Create or edit a Azione</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.azione.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.azione.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.azione.nome" for="field_nome">Nome</label><input type="text" class="form-control" name="nome" id="field_nome" ng-model="vm.azione.nome"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/azione/aziones.html','<div><h2 data-translate="doctorclubboApp.azione.home.title">Aziones</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="azione.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="doctorclubboApp.azione.home.createLabel">Create new Azione</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nome"><span data-translate="doctorclubboApp.azione.nome">Nome</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="azione in vm.aziones track by azione.id"><td><a ui-sref="azione-detail({id:azione.id})">{{azione.id}}</a></td><td>{{azione.nome}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="azione-detail({id:azione.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="azione.edit({id:azione.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="azione.delete({id:azione.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/campagna/campagna-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.campagna.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="doctorclubboApp.campagna.delete.question" translate-values="{id: \'{{vm.campagna.id}}\'}">Are you sure you want to delete this Campagna?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/campagna/campagna-detail.html','<div><h2><span data-translate="doctorclubboApp.campagna.detail.title">Campagna</span> {{vm.campagna.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="doctorclubboApp.campagna.nome">Nome</span></dt><dd><span>{{vm.campagna.nome}}</span></dd><dt><span data-translate="doctorclubboApp.campagna.dtStart">Dt Start</span></dt><dd><span>{{vm.campagna.dtStart | date:\'medium\'}}</span></dd><dt><span data-translate="doctorclubboApp.campagna.dtEnd">Dt End</span></dt><dd><span>{{vm.campagna.dtEnd | date:\'medium\'}}</span></dd><dt><span data-translate="doctorclubboApp.campagna.campagnaAgenzia">Campagna Agenzia</span></dt><dd><a ui-sref="agenzia-detail({id:vm.campagna.campagnaAgenzia.id})">{{vm.campagna.campagnaAgenzia.nome}}</a></dd><dt><span data-translate="doctorclubboApp.campagna.campagnaStatus">Campagna Status</span></dt><dd><a ui-sref="campagna-status-detail({id:vm.campagna.campagnaStatus.id})">{{vm.campagna.campagnaStatus.status}}</a></dd><dt><span data-translate="Codice">Codice</span></dt><dd><span>{{vm.campagna.codice}}</span></dd><dt><span data-translate="doctorclubboApp.campagna.Type">Campagna Tipo</span></dt><dd><a ui-sref="campagna-status-detail({id:vm.campagna.campagnaType.id})">{{vm.campagna.campagnaType.nome}}</a></dd><dt><span data-translate="doctorclubboApp.campagna.Balance">Balance</span></dt><dd><span>{{vm.campagna.balance}}</span></dd><dt><span data-translate="doctorclubboApp.campagna.Tot">Tot</span></dt><dd><span>{{vm.campagna.amount_tot}}</span></dd><dt><span data-translate="doctorclubboApp.campagna.ticket">Ticket</span></dt><dd><span>{{vm.campagna.ticket}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="campagna-detail.edit({id:vm.campagna.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/campagna/campagna-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myCampagnaLabel" data-translate="doctorclubboApp.campagna.home.createOrEditLabel">Create or edit a Campagna</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.campagna.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.campagna.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.campagna.nome" for="field_nome">Nome</label><input type="text" class="form-control" name="nome" id="field_nome" ng-model="vm.campagna.nome"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.campagna.dtStart" for="field_dtStart">Dt Start</label><div class="input-group"><input id="field_dtStart" type="text" class="form-control" name="dtStart" datetime-picker="{{dateformat}}" ng-model="vm.campagna.dtStart" is-open="vm.datePickerOpenStatus.dtStart"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dtStart\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.campagna.dtEnd" for="field_dtEnd">Dt End</label><div class="input-group"><input id="field_dtEnd" type="text" class="form-control" name="dtEnd" datetime-picker="{{dateformat}}" ng-model="vm.campagna.dtEnd" is-open="vm.datePickerOpenStatus.dtEnd"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dtEnd\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label data-translate="doctorclubboApp.campagna.campagnaAgenzia" for="field_campagnaAgenzia">Campagna Agenzia</label><select class="form-control" id="field_campagnaAgenzia" name="campagnaAgenzia" ng-model="vm.campagna.campagnaAgenzia" ng-options="agenzia as agenzia.nome for agenzia in vm.agenzias track by agenzia.id"><option value=""></option></select></div><div class="form-group"><label data-translate="doctorclubboApp.campagna.campagnaStatus" for="field_campagnaStatus">Campagna Status</label><select class="form-control" id="field_campagnaStatus" name="campagnaStatus" ng-model="vm.campagna.campagnaStatus" ng-options="campagna_status as campagna_status.status for campagna_status in vm.campagna_statuses track by campagna_status.id"><option value=""></option></select></div><div class="form-group"><label class="control-label" data-translate="Codice" for="field_codice">Codice</label><input type="text" class="form-control" name="nome" id="field_codice" ng-model="vm.campagna.codice"></div><div class="form-group"><label data-translate="doctorclubboApp.campagna.Type" for="field_campagnaType">Campagna Tipo</label><select class="form-control" id="field_campagnaType" name="campagnaType" ng-model="vm.campagna.campagnaType" ng-options="campagna_type as campagna_type.nome for campagna_type in vm.campagna_types track by campagna_type.id"><option value=""></option></select></div><div class="form-group"><label class="control-label" data-translate="ticket" for="field_ticket">Ticket</label><input type="text" class="form-control" name="ticket" id="field_ticket" ng-model="vm.campagna.ticket"></div><div class="form-group"><label class="control-label" data-translate="Tot" for="field_amount_tot">Tot</label><input type="text" class="form-control" name="amount_tot" id="field_amount_tot" ng-model="vm.campagna.amount_tot"></div><div class="form-group"><label class="control-label" data-translate="Balance" for="field_balance">Balance</label><input type="text" class="form-control" name="balance" id="field_balance" ng-model="vm.campagna.balance"></div><div class="form-group"><label data-translate="doctorclubboApp.campagna.campagnaUser" for="field_campagnaUser">User</label><select class="form-control" id="field_campagnaUser" name="campagnaUser" ng-model="vm.campagna.campagnaUser" ng-options="campagna_user as campagna_user.login for campagna_user in vm.campagna_users track by campagna_user.id"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/campagna/campagnas.html','<div><h2 data-translate="doctorclubboApp.campagna.home.title">Campagnas</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="campagna.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="doctorclubboApp.campagna.home.createLabel">Create new Campagna</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nome"><span data-translate="doctorclubboApp.campagna.nome">Nome</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="dt_start"><span data-translate="doctorclubboApp.campagna.dtStart">Dt Start</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="dt_end"><span data-translate="doctorclubboApp.campagna.dtEnd">Dt End</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="campagnaAgenzia.id"><span data-translate="doctorclubboApp.campagna.campagnaAgenzia">Campagna Agenzia</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="campagnaStatus.id"><span data-translate="doctorclubboApp.campagna.campagnaStatus">Campagna Status</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="codice"><span data-translate="Codice">Codice Campagna</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="campagnaType.id"><span data-translate="doctorclubboApp.campagna.Type">Tipo Campagna</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="ticket"><span data-translate="doctorclubboApp.campagna.ticket">Ticket</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="amount_tot"><span data-translate="doctorclubboApp.campagna.Tot">Tot Campagna</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="balance"><span data-translate="doctorclubboApp.campagna.Balance">Balance Campagna</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="campagnaUser.id"><span data-translate="doctorclubboApp.campagna.campagnaUser">User Campagna</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="campagna in vm.campagnas track by campagna.id"><td><a ui-sref="campagna-detail({id:campagna.id})">{{campagna.id}}</a></td><td>{{campagna.nome}}</td><td>{{campagna.dtStart | date:\'medium\'}}</td><td>{{campagna.dtEnd | date:\'medium\'}}</td><td><a ui-sref="agenzia-detail({id:campagna.campagnaAgenzia.id})">{{campagna.campagnaAgenzia.nome}}</a></td><td><a ui-sref="campagna-status-detail({id:campagna.campagnaStatus.id})">{{campagna.campagnaStatus.status}}</a></td><td>{{campagna.codice}}</td><td><a ui-sref="campagna-type-detail({id:campagna.campagnaType.id})">{{campagna.campagnaType.nome}}</a></td><td>{{campagna.ticket}}</td><td>{{campagna.amount_tot}}</td><td>{{campagna.balance}}</td><td>{{campagna.campagnaUser.login}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="campagna-detail({id:campagna.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="campagna.edit({id:campagna.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="campagna.delete({id:campagna.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/campagna-amazon/campagna-amazon-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.campagnaAmazon.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="doctorclubboApp.campagnaAmazon.delete.question" translate-values="{id: \'{{vm.campagnaAmazon.id}}\'}">Are you sure you want to delete this Campagna Amazon?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/campagna-amazon/campagna-amazon-detail.html','<div><h2><span data-translate="doctorclubboApp.campagnaAmazon.detail.title">Campagna Amazon</span> {{vm.campagnaAmazon.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="doctorclubboApp.campagnaAmazon.nome">Nome</span></dt><dd><span>{{vm.campagnaAmazon.nome}}</span></dd><dt><span data-translate="doctorclubboApp.campagnaAmazon.datains">Datains</span></dt><dd><span>{{vm.campagnaAmazon.datains | date:\'medium\'}}</span></dd><dt><span data-translate="doctorclubboApp.campagnaAmazon.csv">Csv</span></dt><dd><span>{{vm.campagnaAmazon.csv}}</span></dd><dt><span data-translate="doctorclubboApp.campagnaAmazon.queue_status">Queue Status</span></dt><dd><a ui-sref="queue-status-detail({id:vm.campagnaAmazon.queue_statusId})">{{vm.campagnaAmazon.queue_statusId}}</a></dd><dt><span data-translate="doctorclubboApp.campagnaAmazon.user">User</span></dt><dd><span ng-repeat="user in vm.campagnaAmazon.users">{{user.login}}{{$last ? \'\' : \', \'}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="campagna-amazon-detail.edit({id:vm.campagnaAmazon.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/campagna-amazon/campagna-amazon-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myCampagnaAmazonLabel" data-translate="doctorclubboApp.campagnaAmazon.home.createOrEditLabel">Create or edit a Campagna Amazon</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.campagnaAmazon.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.campagnaAmazon.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.campagnaAmazon.nome" for="field_nome">Nome</label><input type="text" class="form-control" name="nome" id="field_nome" ng-model="vm.campagnaAmazon.nome"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.campagnaAmazon.datains" for="field_datains">Datains</label><div class="input-group"><input id="field_datains" type="text" class="form-control" name="datains" datetime-picker="{{dateformat}}" ng-model="vm.campagnaAmazon.datains" is-open="vm.datePickerOpenStatus.datains"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'datains\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.campagnaAmazon.csv" for="field_csv">Csv</label><input type="text" class="form-control" name="csv" id="field_csv" ng-model="vm.campagnaAmazon.csv"></div><div class="form-group"><label data-translate="doctorclubboApp.campagnaAmazon.queue_status" for="field_queue_status">Queue Status</label><select class="form-control" id="field_queue_status" name="queue_status" ng-model="vm.campagnaAmazon.queue_statusId" ng-options="queue_status.id as queue_status.id for queue_status in vm.queue_statuses"><option value=""></option></select></div><div class="form-group"><label data-translate="doctorclubboApp.campagnaAmazon.user" for="field_user">User</label><select class="form-control" id="field_user" multiple="multiple" name="user" ng-model="vm.campagnaAmazon.users" ng-options="user as user.login for user in vm.users track by user.id"></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/campagna-amazon/campagna-amazons.html','<div><h2 data-translate="doctorclubboApp.campagnaAmazon.home.title">Campagna Amazons</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="campagna-amazon.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="doctorclubboApp.campagnaAmazon.home.createLabel">Create new Campagna Amazon</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nome"><span data-translate="doctorclubboApp.campagnaAmazon.nome">Nome</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datains"><span data-translate="doctorclubboApp.campagnaAmazon.datains">Datains</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="csv"><span data-translate="doctorclubboApp.campagnaAmazon.csv">Csv</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="queue_statusId"><span data-translate="doctorclubboApp.campagnaAmazon.queue_status">Queue Status</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="campagnaAmazon in vm.campagnaAmazons track by campagnaAmazon.id"><td><a ui-sref="campagna-amazon-detail({id:campagnaAmazon.id})">{{campagnaAmazon.id}}</a></td><td>{{campagnaAmazon.nome}}</td><td>{{campagnaAmazon.datains | date:\'medium\'}}</td><td>{{campagnaAmazon.csv}}</td><td><a ui-sref="queue-status-detail({id:campagnaAmazon.queue_statusId})">{{campagnaAmazon.queue_statusId}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="campagna-amazon-detail({id:campagnaAmazon.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="campagna-amazon.edit({id:campagnaAmazon.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="campagna-amazon.delete({id:campagnaAmazon.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div><uib-pager total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pager></div>');
$templateCache.put('app/entities/campagna-log/campagna-log-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.campagna_log.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="doctorclubboApp.campagna_log.delete.question" translate-values="{id: \'{{vm.campagna_log.id}}\'}">Are you sure you want to delete this Campagna Log?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/campagna-log/campagna-log-detail.html','<div><h2><span data-translate="doctorclubboApp.campagna_log.detail.title">Campagna Log</span> {{vm.campagna_log.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="doctorclubboApp.campagna_log.causale">Causale</span></dt><dd><span>{{vm.campagna_log.causale}}</span></dd><dt><span data-translate="doctorclubboApp.campagna_log.segno">Segno</span></dt><dd><span>{{vm.campagna_log.segno}}</span></dd><dt><span data-translate="doctorclubboApp.campagna_log.importo">Importo</span></dt><dd><span>{{vm.campagna_log.importo}}</span></dd><dt><span data-translate="doctorclubboApp.campagna_log.dtins">Dtins</span></dt><dd><span>{{vm.campagna_log.dtins | date:\'medium\'}}</span></dd><dt><span data-translate="doctorclubboApp.campagna_log.campagnalog_campagna">Campagnalog Campagna</span></dt><dd><a ui-sref="campagna-detail({id:vm.campagna_log.campagnalog_campagna.id})">{{vm.campagna_log.campagnalog_campagna.id}}</a></dd><dt><span data-translate="doctorclubboApp.campagna_log.campagnalogtype">Campagnalogtype</span></dt><dd><a ui-sref="campagnalog-tipo-detail({id:vm.campagna_log.campagnalogtype.id})">{{vm.campagna_log.campagnalogtype.id}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="campagna-log-detail.edit({id:vm.campagna_log.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/campagna-log/campagna-log-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myCampagna_logLabel" data-translate="doctorclubboApp.campagna_log.home.createOrEditLabel">Create or edit a Campagna Log</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.campagna_log.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.campagna_log.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.campagna_log.causale" for="field_causale">Causale</label><input type="text" class="form-control" name="causale" id="field_causale" ng-model="vm.campagna_log.causale"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.campagna_log.segno" for="field_segno">Segno</label><input type="text" class="form-control" name="segno" id="field_segno" ng-model="vm.campagna_log.segno"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.campagna_log.importo" for="field_importo">Importo</label><input type="number" class="form-control" name="importo" id="field_importo" ng-model="vm.campagna_log.importo"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.campagna_log.dtins" for="field_dtins">Dtins</label><div class="input-group"><input id="field_dtins" type="text" class="form-control" name="dtins" datetime-picker="{{dateformat}}" ng-model="vm.campagna_log.dtins" is-open="vm.datePickerOpenStatus.dtins"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dtins\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label data-translate="doctorclubboApp.campagna_log.campagnalog_campagna" for="field_campagnalog_campagna">Campagnalog Campagna</label><select class="form-control" id="field_campagnalog_campagna" name="campagnalog_campagna" ng-model="vm.campagna_log.campagnalog_campagna" ng-options="campagna as campagna.id for campagna in vm.campagnas track by campagna.id"><option value=""></option></select></div><div class="form-group"><label data-translate="doctorclubboApp.campagna_log.campagnalogtype" for="field_campagnalogtype">Campagnalogtype</label><select class="form-control" id="field_campagnalogtype" name="campagnalogtype" ng-model="vm.campagna_log.campagnalogtype" ng-options="campagnalog_tipo as campagnalog_tipo.id for campagnalog_tipo in vm.campagnalog_tipos track by campagnalog_tipo.id"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/campagna-log/campagna-logs.html','<div><h2 data-translate="doctorclubboApp.campagna_log.home.title">Campagna Logs</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="campagna-log.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="doctorclubboApp.campagna_log.home.createLabel">Create new Campagna Log</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="causale"><span data-translate="doctorclubboApp.campagna_log.causale">Causale</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="segno"><span data-translate="doctorclubboApp.campagna_log.segno">Segno</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="importo"><span data-translate="doctorclubboApp.campagna_log.importo">Importo</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="dtins"><span data-translate="doctorclubboApp.campagna_log.dtins">Dtins</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="campagnalog_campagna.id"><span data-translate="doctorclubboApp.campagna_log.campagnalog_campagna">Campagnalog Campagna</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="campagnalogtype.id"><span data-translate="doctorclubboApp.campagna_log.campagnalogtype">Campagnalogtype</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="campagna_log in vm.campagna_logs track by campagna_log.id"><td><a ui-sref="campagna-log-detail({id:campagna_log.id})">{{campagna_log.id}}</a></td><td>{{campagna_log.causale}}</td><td>{{campagna_log.segno}}</td><td>{{campagna_log.importo}}</td><td>{{campagna_log.dtins | date:\'medium\'}}</td><td><a ui-sref="campagna-detail({id:campagna_log.campagnalog_campagna.id})">{{campagna_log.campagnalog_campagna.id}}</a></td><td><a ui-sref="campagnalog-tipo-detail({id:campagna_log.campagnalogtype.id})">{{campagna_log.campagnalogtype.id}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="campagna-log-detail({id:campagna_log.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="campagna-log.edit({id:campagna_log.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="campagna-log.delete({id:campagna_log.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div><uib-pager total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pager></div>');
$templateCache.put('app/entities/campagna-status/campagna-status-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.campagnaStatus.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="doctorclubboApp.campagnaStatus.delete.question" translate-values="{id: \'{{vm.campagnaStatus.id}}\'}">Are you sure you want to delete this Campagna Status?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/campagna-status/campagna-status-detail.html','<div><h2><span data-translate="doctorclubboApp.campagnaStatus.detail.title">Campagna Status</span> {{vm.campagnaStatus.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="doctorclubboApp.campagnaStatus.status">Status</span></dt><dd><span>{{vm.campagnaStatus.status}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="campagna-status-detail.edit({id:vm.campagnaStatus.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/campagna-status/campagna-status-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myCampagnaStatusLabel" data-translate="doctorclubboApp.campagnaStatus.home.createOrEditLabel">Create or edit a Campagna Status</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.campagnaStatus.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.campagnaStatus.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.campagnaStatus.status" for="field_status">Status</label><input type="text" class="form-control" name="status" id="field_status" ng-model="vm.campagnaStatus.status"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/campagna-status/campagna-statuses.html','<div><h2 data-translate="doctorclubboApp.campagnaStatus.home.title">Campagna Statuses</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="campagna-status.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="doctorclubboApp.campagnaStatus.home.createLabel">Create new Campagna Status</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="status"><span data-translate="doctorclubboApp.campagnaStatus.status">Status</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="campagnaStatus in vm.campagnaStatuses track by campagnaStatus.id"><td><a ui-sref="campagna-status-detail({id:campagnaStatus.id})">{{campagnaStatus.id}}</a></td><td>{{campagnaStatus.status}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="campagna-status-detail({id:campagnaStatus.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="campagna-status.edit({id:campagnaStatus.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="campagna-status.delete({id:campagnaStatus.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/campagna-type/campagna-type-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.campagna_type.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="doctorclubboApp.campagna_type.delete.question" translate-values="{id: \'{{vm.campagna_type.id}}\'}">Are you sure you want to delete this Campagna Type?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/campagna-type/campagna-type-detail.html','<div><h2><span data-translate="doctorclubboApp.campagna_type.detail.title">Campagna Type</span> {{vm.campagna_type.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="doctorclubboApp.campagna_type.nome">Nome</span></dt><dd><span>{{vm.campagna_type.nome}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="campagna-type-detail.edit({id:vm.campagna_type.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/campagna-type/campagna-type-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myCampagna_typeLabel" data-translate="doctorclubboApp.campagna_type.home.createOrEditLabel">Create or edit a Campagna Type</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.campagna_type.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.campagna_type.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.campagna_type.nome" for="field_nome">Nome</label><input type="text" class="form-control" name="nome" id="field_nome" ng-model="vm.campagna_type.nome"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/campagna-type/campagna-types.html','<div><h2 data-translate="doctorclubboApp.campagna_type.home.title">Campagna Types</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="campagna-type.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="doctorclubboApp.campagna_type.home.createLabel">Create new Campagna Type</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nome"><span data-translate="doctorclubboApp.campagna_type.nome">Nome</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="campagna_type in vm.campagna_types track by campagna_type.id"><td><a ui-sref="campagna-type-detail({id:campagna_type.id})">{{campagna_type.id}}</a></td><td>{{campagna_type.nome}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="campagna-type-detail({id:campagna_type.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="campagna-type.edit({id:campagna_type.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="campagna-type.delete({id:campagna_type.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div><uib-pager total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pager></div>');
$templateCache.put('app/entities/campagnalog-tipo/campagnalog-tipo-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.campagnalog_tipo.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="doctorclubboApp.campagnalog_tipo.delete.question" translate-values="{id: \'{{vm.campagnalog_tipo.id}}\'}">Are you sure you want to delete this Campagnalog Tipo?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/campagnalog-tipo/campagnalog-tipo-detail.html','<div><h2><span data-translate="doctorclubboApp.campagnalog_tipo.detail.title">Campagnalog Tipo</span> {{vm.campagnalog_tipo.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="doctorclubboApp.campagnalog_tipo.nome">Nome</span></dt><dd><span>{{vm.campagnalog_tipo.nome}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="campagnalog-tipo-detail.edit({id:vm.campagnalog_tipo.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/campagnalog-tipo/campagnalog-tipo-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myCampagnalog_tipoLabel" data-translate="doctorclubboApp.campagnalog_tipo.home.createOrEditLabel">Create or edit a Campagnalog Tipo</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.campagnalog_tipo.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.campagnalog_tipo.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.campagnalog_tipo.nome" for="field_nome">Nome</label><input type="text" class="form-control" name="nome" id="field_nome" ng-model="vm.campagnalog_tipo.nome"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/campagnalog-tipo/campagnalog-tipos.html','<div><h2 data-translate="doctorclubboApp.campagnalog_tipo.home.title">Campagnalog Tipos</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="campagnalog-tipo.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="doctorclubboApp.campagnalog_tipo.home.createLabel">Create new Campagnalog Tipo</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="doctorclubboApp.campagnalog_tipo.nome">Nome</span></th><th></th></tr></thead><tbody><tr ng-repeat="campagnalog_tipo in vm.campagnalog_tipos track by campagnalog_tipo.id"><td><a ui-sref="campagnalog-tipo-detail({id:campagnalog_tipo.id})">{{campagnalog_tipo.id}}</a></td><td>{{campagnalog_tipo.nome}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="campagnalog-tipo-detail({id:campagnalog_tipo.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="campagnalog-tipo.edit({id:campagnalog_tipo.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="campagnalog-tipo.delete({id:campagnalog_tipo.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/comune/comune-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.comune.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="doctorclubboApp.comune.delete.question" translate-values="{id: \'{{vm.comune.id}}\'}">Are you sure you want to delete this Comune?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/comune/comune-detail.html','<div><h2><span data-translate="doctorclubboApp.comune.detail.title">Comune</span> {{vm.comune.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="doctorclubboApp.comune.sigla">Sigla</span></dt><dd><span>{{vm.comune.sigla}}</span></dd><dt><span data-translate="doctorclubboApp.comune.comune">Comune</span></dt><dd><span>{{vm.comune.comune}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="comune-detail.edit({id:vm.comune.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/comune/comune-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myComuneLabel" data-translate="doctorclubboApp.comune.home.createOrEditLabel">Create or edit a Comune</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.comune.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.comune.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.comune.sigla" for="field_sigla">Sigla</label><input type="text" class="form-control" name="sigla" id="field_sigla" ng-model="vm.comune.sigla"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.comune.comune" for="field_comune">Comune</label><input type="text" class="form-control" name="comune" id="field_comune" ng-model="vm.comune.comune"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/comune/comunes.html','<div><h2 data-translate="doctorclubboApp.comune.home.title">Comunes</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="comune.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="doctorclubboApp.comune.home.createLabel">Create new Comune</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="sigla"><span data-translate="doctorclubboApp.comune.sigla">Sigla</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="comune"><span data-translate="doctorclubboApp.comune.comune">Comune</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="comune in vm.comunes track by comune.id"><td><a ui-sref="comune-detail({id:comune.id})">{{comune.id}}</a></td><td>{{comune.sigla}}</td><td>{{comune.comune}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="comune-detail({id:comune.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="comune.edit({id:comune.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="comune.delete({id:comune.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/delivery-option/delivery-option-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.delivery_option.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="doctorclubboApp.delivery_option.delete.question" translate-values="{id: \'{{vm.delivery_option.id}}\'}">Are you sure you want to delete this Delivery Option?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/delivery-option/delivery-option-detail.html','<div><h2><span data-translate="doctorclubboApp.delivery_option.detail.title">Delivery Option</span> {{vm.delivery_option.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="doctorclubboApp.delivery_option.nome">Nome</span></dt><dd><span>{{vm.delivery_option.nome}}</span></dd><dt><span data-translate="doctorclubboApp.delivery_option.costo_unitario">Costo Unitario</span></dt><dd><span>{{vm.delivery_option.costo_unitario}}</span></dd><dt><span data-translate="doctorclubboApp.delivery_option.max_buoni">Max Buoni</span></dt><dd><span>{{vm.delivery_option.max_buoni}}</span></dd><dt><span data-translate="doctorclubboApp.delivery_option.costo_fisso">Costo</span></dt><dd><span>{{vm.delivery_option.importo_fix}}</span></dd><dt><span data-translate="doctorclubboApp.delivery_option.descrizione">Descrizione</span></dt><dd><span>{{vm.delivery_option.descrizione}}</span></dd><dt><span data-translate="doctorclubboApp.delivery_option.descrizione_costi">Descrizione costi</span></dt><dd><span>{{vm.delivery_option.descrizione_costi}}</span></dd><dt><span data-translate="doctorclubboApp.delivery_option.delivery_status_iniziale">Delivery Status iniziale</span></dt><dd><span>{{vm.delivery_option.delivery_status_iniziale}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="delivery-option-detail.edit({id:vm.delivery_option.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/delivery-option/delivery-option-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myDelivery_optionLabel" data-translate="doctorclubboApp.delivery_option.home.createOrEditLabel">Create or edit a Delivery Option</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.delivery_option.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.delivery_option.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.delivery_option.nome" for="field_nome">Nome</label><input type="text" class="form-control" name="nome" id="field_nome" ng-model="vm.delivery_option.nome"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.delivery_option.costo_unitario" for="field_costo_unitario">Costo Unitario</label><input type="number" class="form-control" name="costo_unitario" id="field_costo_unitario" ng-model="vm.delivery_option.costo_unitario"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.delivery_option.max_buoni" for="field_max_buoni">Max Buoni</label><input type="number" class="form-control" name="max_buoni" id="field_max_buoni" ng-model="vm.delivery_option.max_buoni"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.delivery_option.costo_fisso" for="field_importo_fix">Costo</label><input type="number" class="form-control" name="importo_fix" id="field_importo_fix" ng-model="importo_fix"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.delivery_option.descrizione" for="field_descrizione">Descrizione</label><input type="text" class="form-control" name="descrizione" id="field_descrizione" ng-model="vm.delivery_option.descrizione"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.delivery_option.descrizione_costi" for="field_descrizione_costi">Descrizione</label><input type="text" class="form-control" name="descrizione_costi" id="field_descrizione_costi" ng-model="vm.delivery_option.descrizione_costi"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.delivery_option.delivery_status_iniziale" for="field_delivery_status_iniziale">Delivery Status Iniziale</label><input type="text" class="form-control" name="delivery_status_iniziale" id="field_delivery_status_iniziale" ng-model="vm.delivery_option.delivery_status_iniziale"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/delivery-option/delivery-options.html','<div><h2 data-translate="doctorclubboApp.delivery_option.home.title">Delivery Options</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="delivery-option.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="doctorclubboApp.delivery_option.home.createLabel">Create new Delivery Option</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nome"><span data-translate="doctorclubboApp.delivery_option.nome">Nome</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="costo_unitario"><span data-translate="doctorclubboApp.delivery_option.costo_unitario">Costo Unitario</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="max_buoni"><span data-translate="doctorclubboApp.delivery_option.max_buoni">Max Buoni</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="importo_fix"><span data-translate="doctorclubboApp.delivery_option.costo_fisso">Costo</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="descrizione"><span data-translate="doctorclubboApp.delivery_option.descrizione">Descrizione</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="descrizione_costi"><span data-translate="doctorclubboApp.delivery_option.descrizione_costi">Descrizione costi</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="delivery_status_iniziale"><span data-translate="doctorclubboApp.delivery_option.delivery_status_iniziale">Delivery status iniziale</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="delivery_option in vm.delivery_options track by delivery_option.id"><td><a ui-sref="delivery-option-detail({id:delivery_option.id})">{{delivery_option.id}}</a></td><td>{{delivery_option.nome}}</td><td>{{delivery_option.costo_unitario}}</td><td>{{delivery_option.max_buoni}}</td><td>{{delivery_option.importo_fix}}</td><td>{{delivery_option.descrizione}}</td><td>{{delivery_option.descrizione_costi}}</td><td>{{delivery_option.delivery_status_iniziale}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="delivery-option-detail({id:delivery_option.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="delivery-option.edit({id:delivery_option.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="delivery-option.delete({id:delivery_option.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/delivery-option-agenzia/delivery-option-agenzia-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.delivery_option_agenzia.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="doctorclubboApp.delivery_option_agenzia.delete.question" translate-values="{id: \'{{vm.delivery_option_agenzia.id}}\'}">Are you sure you want to delete this Delivery Option Agenzia?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/delivery-option-agenzia/delivery-option-agenzia-detail.html','<div><h2><span data-translate="doctorclubboApp.delivery_option_agenzia.detail.title">Delivery Option Agenzia</span> {{vm.delivery_option_agenzia.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="doctorclubboApp.delivery_option_agenzia.costo_unitario">Costo Unitario</span></dt><dd><span>{{vm.delivery_option_agenzia.costo_unitario}}</span></dd><dt><span data-translate="doctorclubboApp.delivery_option_agenzia.importo_fix">Importo Fix</span></dt><dd><span>{{vm.delivery_option_agenzia.importo_fix}}</span></dd><dt><span data-translate="doctorclubboApp.delivery_option_agenzia.max_buoni">Max Buoni</span></dt><dd><span>{{vm.delivery_option_agenzia.max_buoni}}</span></dd><dt><span data-translate="doctorclubboApp.delivery_option_agenzia.descrizione">Descrizione</span></dt><dd><span>{{vm.delivery_option_agenzia.descrizione}}</span></dd><dt><span data-translate="doctorclubboApp.delivery_option_agenzia.descrizione_costi">Descrizione costi</span></dt><dd><span>{{vm.delivery_option_agenzia.descrizione_costi}}</span></dd><dt><span data-translate="doctorclubboApp.delivery_option_agenzia.delivery_option">Delivery Option</span></dt><dd><a ui-sref="delivery-option-detail({id:vm.delivery_option_agenzia.delivery_optionId})">{{vm.delivery_option_agenzia.delivery_optionId}}</a></dd><dt><span data-translate="doctorclubboApp.delivery_option_agenzia.agenzia">Agenzia</span></dt><dd><a ui-sref="agenzia-detail({id:vm.delivery_option_agenzia.agenziaId})">{{vm.delivery_option_agenzia.agenziaId}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="delivery-option-agenzia-detail.edit({id:vm.delivery_option_agenzia.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/delivery-option-agenzia/delivery-option-agenzia-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myDelivery_option_agenziaLabel" data-translate="doctorclubboApp.delivery_option_agenzia.home.createOrEditLabel">Create or edit a Delivery Option Agenzia</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.delivery_option_agenzia.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.delivery_option_agenzia.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.delivery_option_agenzia.costo_unitario" for="field_costo_unitario">Costo Unitario</label><input type="number" class="form-control" name="costo_unitario" id="field_costo_unitario" ng-model="vm.delivery_option_agenzia.costo_unitario"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.delivery_option_agenzia.importo_fix" for="field_importo_fix">Importo Fix</label><input type="number" class="form-control" name="importo_fix" id="field_importo_fix" ng-model="vm.delivery_option_agenzia.importo_fix"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.delivery_option_agenzia.max_buoni" for="field_max_buoni">Max Buoni</label><input type="number" class="form-control" name="max_buoni" id="field_max_buoni" ng-model="vm.delivery_option_agenzia.max_buoni"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.delivery_option_agenzia.descrizione" for="field_descrizione">Descrizione</label><input type="text" class="form-control" name="descrizione" id="field_descrizione" ng-model="vm.delivery_option_agenzia.descrizione"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.delivery_option_agenzia.descrizione_costi" for="field_descrizione_costi">Descrizione costi</label><input type="text" class="form-control" name="descrizione_costi" id="field_descrizione_costi" ng-model="vm.delivery_option_agenzia.descrizione_costi"></div><div class="form-group"><label data-translate="doctorclubboApp.delivery_option_agenzia.delivery_option" for="field_delivery_option">Delivery Option</label><select class="form-control" id="field_delivery_option" name="delivery_option" ng-model="vm.delivery_option_agenzia.delivery_optionId" ng-options="delivery_option.id as delivery_option.id for delivery_option in vm.delivery_options"><option value=""></option></select></div><div class="form-group"><label data-translate="doctorclubboApp.delivery_option_agenzia.agenzia" for="field_agenzia">Agenzia</label><select class="form-control" id="field_agenzia" name="agenzia" ng-model="vm.delivery_option_agenzia.agenziaId" ng-options="agenzia.id as agenzia.id for agenzia in vm.agenzias"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/delivery-option-agenzia/delivery-option-agenzias.html','<div><h2 data-translate="doctorclubboApp.delivery_option_agenzia.home.title">Delivery Option Agenzias</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="delivery-option-agenzia.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="doctorclubboApp.delivery_option_agenzia.home.createLabel">Create new Delivery Option Agenzia</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="costo_unitario"><span data-translate="doctorclubboApp.delivery_option_agenzia.costo_unitario">Costo Unitario</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="importo_fix"><span data-translate="doctorclubboApp.delivery_option_agenzia.importo_fix">Importo Fix</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="max_buoni"><span data-translate="doctorclubboApp.delivery_option_agenzia.max_buoni">Max Buoni</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="descrizione"><span data-translate="doctorclubboApp.delivery_option_agenzia.descrizione">Descrizione</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="descrizione_costi"><span data-translate="doctorclubboApp.delivery_option_agenzia.descrizione_costi">Descrizione costi</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="delivery_optionId"><span data-translate="doctorclubboApp.delivery_option_agenzia.delivery_option">Delivery Option</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="agenziaId"><span data-translate="doctorclubboApp.delivery_option_agenzia.agenzia">Agenzia</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="delivery_option_agenzia in vm.delivery_option_agenzias track by delivery_option_agenzia.id"><td><a ui-sref="delivery-option-agenzia-detail({id:delivery_option_agenzia.id})">{{delivery_option_agenzia.id}}</a></td><td>{{delivery_option_agenzia.costo_unitario}}</td><td>{{delivery_option_agenzia.importo_fix}}</td><td>{{delivery_option_agenzia.max_buoni}}</td><td>{{delivery_option_agenzia.descrizione}}</td><td>{{delivery_option_agenzia.descrizione_costi}}</td><td><a ui-sref="delivery-option-detail({id:delivery_option_agenzia.delivery_optionId})">{{delivery_option_agenzia.delivery_optionId}}</a></td><td><a ui-sref="agenzia-detail({id:delivery_option_agenzia.agenziaId})">{{delivery_option_agenzia.agenziaId}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="delivery-option-agenzia-detail({id:delivery_option_agenzia.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="delivery-option-agenzia.edit({id:delivery_option_agenzia.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="delivery-option-agenzia.delete({id:delivery_option_agenzia.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div><uib-pager total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pager></div>');
$templateCache.put('app/entities/delivery-status/delivery-status-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.delivery_status.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="doctorclubboApp.delivery_status.delete.question" translate-values="{id: \'{{vm.delivery_status.id}}\'}">Are you sure you want to delete this Delivery Status?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/delivery-status/delivery-status-detail.html','<div><h2><span data-translate="doctorclubboApp.delivery_status.detail.title">Delivery Status</span> {{vm.delivery_status.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="doctorclubboApp.delivery_status.status">Status</span></dt><dd><span>{{vm.delivery_status.status}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="delivery-status-detail.edit({id:vm.delivery_status.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/delivery-status/delivery-status-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myDelivery_statusLabel" data-translate="doctorclubboApp.delivery_status.home.createOrEditLabel">Create or edit a Delivery Status</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.delivery_status.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.delivery_status.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.delivery_status.status" for="field_status">Status</label><input type="text" class="form-control" name="status" id="field_status" ng-model="vm.delivery_status.status"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/delivery-status/delivery-statuses.html','<div><h2 data-translate="doctorclubboApp.delivery_status.home.title">Delivery Statuses</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="delivery-status.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="doctorclubboApp.delivery_status.home.createLabel">Create new Delivery Status</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="status"><span data-translate="doctorclubboApp.delivery_status.status">Status</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="delivery_status in vm.delivery_statuses track by delivery_status.id"><td><a ui-sref="delivery-status-detail({id:delivery_status.id})">{{delivery_status.id}}</a></td><td>{{delivery_status.status}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="delivery-status-detail({id:delivery_status.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="delivery-status.edit({id:delivery_status.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="delivery-status.delete({id:delivery_status.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/dispositivo/dispositivo-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.dispositivo.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="doctorclubboApp.dispositivo.delete.question" translate-values="{id: \'{{vm.dispositivo.id}}\'}">Are you sure you want to delete this Dispositivo?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/dispositivo/dispositivo-detail.html','<div><h2><span data-translate="doctorclubboApp.dispositivo.detail.title">Dispositivo</span> {{vm.dispositivo.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="doctorclubboApp.dispositivo.dispositivo">Dispositivo</span></dt><dd><span>{{vm.dispositivo.dispositivo}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="dispositivo-detail.edit({id:vm.dispositivo.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/dispositivo/dispositivo-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myDispositivoLabel" data-translate="doctorclubboApp.dispositivo.home.createOrEditLabel">Create or edit a Dispositivo</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.dispositivo.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.dispositivo.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.dispositivo.dispositivo" for="field_dispositivo">Dispositivo</label><input type="text" class="form-control" name="dispositivo" id="field_dispositivo" ng-model="vm.dispositivo.dispositivo"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/dispositivo/dispositivos.html','<div><h2 data-translate="doctorclubboApp.dispositivo.home.title">Dispositivos</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="dispositivo.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="doctorclubboApp.dispositivo.home.createLabel">Create new Dispositivo</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="dispositivo"><span data-translate="doctorclubboApp.dispositivo.dispositivo">Dispositivo</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="dispositivo in vm.dispositivos track by dispositivo.id"><td><a ui-sref="dispositivo-detail({id:dispositivo.id})">{{dispositivo.id}}</a></td><td>{{dispositivo.dispositivo}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="dispositivo-detail({id:dispositivo.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="dispositivo.edit({id:dispositivo.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="dispositivo.delete({id:dispositivo.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/dispositivo-os/dispositivo-os-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.dispositivo_os.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="doctorclubboApp.dispositivo_os.delete.question" translate-values="{id: \'{{vm.dispositivo_os.id}}\'}">Are you sure you want to delete this Dispositivo Os?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/dispositivo-os/dispositivo-os-detail.html','<div><h2><span data-translate="doctorclubboApp.dispositivo_os.detail.title">Dispositivo Os</span> {{vm.dispositivo_os.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="doctorclubboApp.dispositivo_os.os">Os</span></dt><dd><span>{{vm.dispositivo_os.os}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="dispositivo-os-detail.edit({id:vm.dispositivo_os.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/dispositivo-os/dispositivo-os-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myDispositivo_osLabel" data-translate="doctorclubboApp.dispositivo_os.home.createOrEditLabel">Create or edit a Dispositivo Os</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.dispositivo_os.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.dispositivo_os.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.dispositivo_os.os" for="field_os">Os</label><input type="text" class="form-control" name="os" id="field_os" ng-model="vm.dispositivo_os.os"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/dispositivo-os/dispositivo-os.html','<div><h2 data-translate="doctorclubboApp.dispositivo_os.home.title">Dispositivo Os</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="dispositivo-os.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="doctorclubboApp.dispositivo_os.home.createLabel">Create new Dispositivo Os</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="doctorclubboApp.dispositivo_os.os">Os</span></th><th></th></tr></thead><tbody><tr ng-repeat="dispositivo_os in vm.dispositivo_os track by dispositivo_os.id"><td><a ui-sref="dispositivo-os-detail({id:dispositivo_os.id})">{{dispositivo_os.id}}</a></td><td>{{dispositivo_os.os}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="dispositivo-os-detail({id:dispositivo_os.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="dispositivo-os.edit({id:dispositivo_os.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="dispositivo-os.delete({id:dispositivo_os.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/fee/fee-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.fee.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="doctorclubboApp.fee.delete.question" translate-values="{id: \'{{vm.fee.id}}\'}">Are you sure you want to delete this Fee?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/fee/fee-detail.html','<div><h2><span data-translate="doctorclubboApp.fee.detail.title">Fee</span> {{vm.fee.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="doctorclubboApp.fee.fee">Fee</span></dt><dd><span>{{vm.fee.fee}}</span></dd><dt><span data-translate="doctorclubboApp.fee.valore">Valore</span></dt><dd><span>{{vm.fee.valore}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="fee-detail.edit({id:vm.fee.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/fee/fee-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myFeeLabel" data-translate="doctorclubboApp.fee.home.createOrEditLabel">Create or edit a Fee</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.fee.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.fee.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.fee.fee" for="field_fee">Fee</label><input type="text" class="form-control" name="fee" id="field_fee" ng-model="vm.fee.fee"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.fee.valore" for="field_valore">Valore</label><input type="number" class="form-control" name="valore" id="field_valore" ng-model="vm.fee.valore"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/fee/fees.html','<div><h2 data-translate="doctorclubboApp.fee.home.title">Fees</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="fee.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="doctorclubboApp.fee.home.createLabel">Create new Fee</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="fee"><span data-translate="doctorclubboApp.fee.fee">Fee</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="valore"><span data-translate="doctorclubboApp.fee.valore">Valore</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="fee in vm.fees track by fee.id"><td><a ui-sref="fee-detail({id:fee.id})">{{fee.id}}</a></td><td>{{fee.fee}}</td><td>{{fee.valore}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="fee-detail({id:fee.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="fee.edit({id:fee.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="fee.delete({id:fee.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/fee-agenzia/fee-agenzia-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.fee_agenzia.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="doctorclubboApp.fee_agenzia.delete.question" translate-values="{id: \'{{vm.fee_agenzia.id}}\'}">Are you sure you want to delete this Fee Agenzia?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/fee-agenzia/fee-agenzia-detail.html','<div><h2><span data-translate="doctorclubboApp.fee_agenzia.detail.title">Fee Agenzia</span> {{vm.fee_agenzia.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="doctorclubboApp.fee_agenzia.valore">Valore</span></dt><dd><span>{{vm.fee_agenzia.valore}}</span></dd><dt><span data-translate="doctorclubboApp.fee_agenzia.fee">Fee</span></dt><dd><a ui-sref="fee-detail({id:vm.fee_agenzia.feeId})">{{vm.fee_agenzia.feeId}}</a></dd><dt><span data-translate="doctorclubboApp.fee_agenzia.agenzia">Agenzia</span></dt><dd><a ui-sref="agenzia-detail({id:vm.fee_agenzia.agenziaId})">{{vm.fee_agenzia.agenziaId}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="fee-agenzia-detail.edit({id:vm.fee_agenzia.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/fee-agenzia/fee-agenzia-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myFee_agenziaLabel" data-translate="doctorclubboApp.fee_agenzia.home.createOrEditLabel">Create or edit a Fee Agenzia</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.fee_agenzia.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.fee_agenzia.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.fee_agenzia.valore" for="field_valore">Valore</label><input type="number" class="form-control" name="valore" id="field_valore" ng-model="vm.fee_agenzia.valore"></div><div class="form-group"><label data-translate="doctorclubboApp.fee_agenzia.fee" for="field_fee">Fee</label><select class="form-control" id="field_fee" name="fee" ng-model="vm.fee_agenzia.feeId" ng-options="fee.id as fee.id for fee in vm.fees"><option value=""></option></select></div><div class="form-group"><label data-translate="doctorclubboApp.fee_agenzia.agenzia" for="field_agenzia">Agenzia</label><select class="form-control" id="field_agenzia" name="agenzia" ng-model="vm.fee_agenzia.agenziaId" ng-options="agenzia.id as agenzia.id for agenzia in vm.agenzias"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/fee-agenzia/fee-agenzias.html','<div><h2 data-translate="doctorclubboApp.fee_agenzia.home.title">Fee Agenzias</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="fee-agenzia.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="doctorclubboApp.fee_agenzia.home.createLabel">Create new Fee Agenzia</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="valore"><span data-translate="doctorclubboApp.fee_agenzia.valore">Valore</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="feeId"><span data-translate="doctorclubboApp.fee_agenzia.fee">Fee</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="agenziaId"><span data-translate="doctorclubboApp.fee_agenzia.agenzia">Agenzia</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="fee_agenzia in vm.fee_agenzias track by fee_agenzia.id"><td><a ui-sref="fee-agenzia-detail({id:fee_agenzia.id})">{{fee_agenzia.id}}</a></td><td>{{fee_agenzia.valore}}</td><td><a ui-sref="fee-detail({id:fee_agenzia.feeId})">{{fee_agenzia.feeId}}</a></td><td><a ui-sref="agenzia-detail({id:fee_agenzia.agenziaId})">{{fee_agenzia.agenziaId}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="fee-agenzia-detail({id:fee_agenzia.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="fee-agenzia.edit({id:fee_agenzia.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="fee-agenzia.delete({id:fee_agenzia.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div><uib-pager total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pager></div>');
$templateCache.put('app/entities/gc-system/gc-system-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.gcSystem.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="doctorclubboApp.gcSystem.delete.question" translate-values="{id: \'{{vm.gcSystem.id}}\'}">Are you sure you want to delete this Gc System?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/gc-system/gc-system-detail.html','<div><h2><span data-translate="doctorclubboApp.gcSystem.detail.title">Gc System</span> {{vm.gcSystem.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="doctorclubboApp.gcSystem.nome">Nome</span></dt><dd><span>{{vm.gcSystem.nome}}</span></dd><dt><span data-translate="doctorclubboApp.gcSystem.endpoint">Endpoint</span></dt><dd><span>{{vm.gcSystem.endpoint}}</span></dd><dt><span data-translate="doctorclubboApp.gcSystem.partnerId">Partner Id</span></dt><dd><span>{{vm.gcSystem.partnerId}}</span></dd><dt><span data-translate="doctorclubboApp.gcSystem.programId">Program Id</span></dt><dd><span>{{vm.gcSystem.programId}}</span></dd><dt><span data-translate="doctorclubboApp.gcSystem.currencyCode">Currency Code</span></dt><dd><span>{{vm.gcSystem.currencyCode}}</span></dd><dt><span data-translate="doctorclubboApp.gcSystem.awsAccessKey">Aws Access Key</span></dt><dd><span>{{vm.gcSystem.awsAccessKey}}</span></dd><dt><span data-translate="doctorclubboApp.gcSystem.awsSecretKey">Aws Secret Key</span></dt><dd><span>{{vm.gcSystem.awsSecretKey}}</span></dd><dt><span data-translate="doctorclubboApp.gcSystem.region">Region</span></dt><dd><span>{{vm.gcSystem.region}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="gc-system-detail.edit({id:vm.gcSystem.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/gc-system/gc-system-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myGcSystemLabel" data-translate="doctorclubboApp.gcSystem.home.createOrEditLabel">Create or edit a Gc System</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.gcSystem.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.gcSystem.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.gcSystem.nome" for="field_nome">Nome</label><input type="text" class="form-control" name="nome" id="field_nome" ng-model="vm.gcSystem.nome"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.gcSystem.endpoint" for="field_endpoint">Endpoint</label><input type="text" class="form-control" name="endpoint" id="field_endpoint" ng-model="vm.gcSystem.endpoint"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.gcSystem.partnerId" for="field_partnerId">Partner Id</label><input type="text" class="form-control" name="partnerId" id="field_partnerId" ng-model="vm.gcSystem.partnerId"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.gcSystem.programId" for="field_programId">Program Id</label><input type="text" class="form-control" name="programId" id="field_programId" ng-model="vm.gcSystem.programId"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.gcSystem.currencyCode" for="field_currencyCode">Currency Code</label><input type="text" class="form-control" name="currencyCode" id="field_currencyCode" ng-model="vm.gcSystem.currencyCode"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.gcSystem.awsAccessKey" for="field_awsAccessKey">Aws Access Key</label><input type="text" class="form-control" name="awsAccessKey" id="field_awsAccessKey" ng-model="vm.gcSystem.awsAccessKey"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.gcSystem.awsSecretKey" for="field_awsSecretKey">Aws Secret Key</label><input type="text" class="form-control" name="awsSecretKey" id="field_awsSecretKey" ng-model="vm.gcSystem.awsSecretKey"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.gcSystem.region" for="field_region">Region</label><input type="text" class="form-control" name="region" id="field_region" ng-model="vm.gcSystem.region"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/gc-system/gc-systems.html','<div><h2 data-translate="doctorclubboApp.gcSystem.home.title">Gc Systems</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="gc-system.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="doctorclubboApp.gcSystem.home.createLabel">Create new Gc System</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nome"><span data-translate="doctorclubboApp.gcSystem.nome">Nome</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="endpoint"><span data-translate="doctorclubboApp.gcSystem.endpoint">Endpoint</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="partnerId"><span data-translate="doctorclubboApp.gcSystem.partnerId">Partner Id</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="programId"><span data-translate="doctorclubboApp.gcSystem.programId">Program Id</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="currencyCode"><span data-translate="doctorclubboApp.gcSystem.currencyCode">Currency Code</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="awsAccessKey"><span data-translate="doctorclubboApp.gcSystem.awsAccessKey">Aws Access Key</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="awsSecretKey"><span data-translate="doctorclubboApp.gcSystem.awsSecretKey">Aws Secret Key</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="region"><span data-translate="doctorclubboApp.gcSystem.region">Region</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="gcSystem in vm.gcSystems track by gcSystem.id"><td><a ui-sref="gc-system-detail({id:gcSystem.id})">{{gcSystem.id}}</a></td><td>{{gcSystem.nome}}</td><td>{{gcSystem.endpoint}}</td><td>{{gcSystem.partnerId}}</td><td>{{gcSystem.programId}}</td><td>{{gcSystem.currencyCode}}</td><td>{{gcSystem.awsAccessKey}}</td><td>{{gcSystem.awsSecretKey}}</td><td>{{gcSystem.region}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="gc-system-detail({id:gcSystem.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="gc-system.edit({id:gcSystem.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="gc-system.delete({id:gcSystem.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/giftcard-statement/giftcard-statement-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.giftcardStatement.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="doctorclubboApp.giftcardStatement.delete.question" translate-values="{id: \'{{vm.giftcardStatement.id}}\'}">Are you sure you want to delete this Giftcard Statement?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/giftcard-statement/giftcard-statement-detail.html','<div><h2><span data-translate="doctorclubboApp.giftcardStatement.detail.title">Giftcard Statement</span> {{vm.giftcardStatement.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="doctorclubboApp.giftcardStatement.dtIns">Dt Ins</span></dt><dd><span>{{vm.giftcardStatement.dtIns | date:\'medium\'}}</span></dd><dt><span data-translate="doctorclubboApp.giftcardStatement.gcClaimCode">Gc Claim Code</span></dt><dd><span>{{vm.giftcardStatement.gcClaimCode}}</span></dd><dt><span data-translate="doctorclubboApp.giftcardStatement.gcId">Gc Id</span></dt><dd><span>{{vm.giftcardStatement.gcId}}</span></dd><dt><span data-translate="doctorclubboApp.giftcardStatement.creationRequestId">Creation Request Id</span></dt><dd><span>{{vm.giftcardStatement.creationRequestId}}</span></dd><dt><span data-translate="doctorclubboApp.giftcardStatement.emailSource">Email Source</span></dt><dd><span>{{vm.giftcardStatement.emailSource}}</span></dd><dt><span data-translate="doctorclubboApp.giftcardStatement.emailDestination">Email Destination</span></dt><dd><span>{{vm.giftcardStatement.emailDestination}}</span></dd><dt><span data-translate="doctorclubboApp.giftcardStatement.currencyCode">Currency Code</span></dt><dd><span>{{vm.giftcardStatement.currencyCode}}</span></dd><dt><span data-translate="doctorclubboApp.giftcardStatement.amount">Amount</span></dt><dd><span>{{vm.giftcardStatement.amount}}</span></dd><dt><span data-translate="doctorclubboApp.giftcardStatement.balance">Balance</span></dt><dd><span>{{vm.giftcardStatement.balance}}</span></dd><dt><span data-translate="doctorclubboApp.giftcardStatement.cardStatus">Card Status</span></dt><dd><span>{{vm.giftcardStatement.cardStatus}}</span></dd><dt><span data-translate="doctorclubboApp.giftcardStatement.status">Status</span></dt><dd><span>{{vm.giftcardStatement.status}}</span></dd><dt><span data-translate="doctorclubboApp.giftcardStatement.processed">Processed</span></dt><dd><span>{{vm.giftcardStatement.processed}}</span></dd><dt><span data-translate="doctorclubboApp.giftcardStatement.gcExpirationDate">Gc Expiration Date</span></dt><dd><span>{{vm.giftcardStatement.gcExpirationDate | date:\'medium\'}}</span></dd><dt><span data-translate="doctorclubboApp.giftcardStatement.cardsystem">Cardsystem</span></dt><dd><a ui-sref="gc-system-detail({id:vm.giftcardStatement.cardsystemId})">{{vm.giftcardStatement.cardsystemId}}</a></dd><dt><span data-translate="doctorclubboApp.giftcardStatement.sistema">Sistema</span></dt><dd><a ui-sref="sistema-detail({id:vm.giftcardStatement.sistemaId})">{{vm.giftcardStatement.sistemaId}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="giftcard-statement-detail.edit({id:vm.giftcardStatement.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/giftcard-statement/giftcard-statement-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myGiftcardStatementLabel" data-translate="doctorclubboApp.giftcardStatement.home.createOrEditLabel">Create or edit a Giftcard Statement</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.giftcardStatement.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.giftcardStatement.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.giftcardStatement.dtIns" for="field_dtIns">Dt Ins</label><div class="input-group"><input id="field_dtIns" type="text" class="form-control" name="dtIns" datetime-picker="{{dateformat}}" ng-model="vm.giftcardStatement.dtIns" is-open="vm.datePickerOpenStatus.dtIns"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dtIns\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.giftcardStatement.gcClaimCode" for="field_gcClaimCode">Gc Claim Code</label><input type="text" class="form-control" name="gcClaimCode" id="field_gcClaimCode" ng-model="vm.giftcardStatement.gcClaimCode"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.giftcardStatement.gcId" for="field_gcId">Gc Id</label><input type="text" class="form-control" name="gcId" id="field_gcId" ng-model="vm.giftcardStatement.gcId"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.giftcardStatement.creationRequestId" for="field_creationRequestId">Creation Request Id</label><input type="text" class="form-control" name="creationRequestId" id="field_creationRequestId" ng-model="vm.giftcardStatement.creationRequestId"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.giftcardStatement.emailSource" for="field_emailSource">Email Source</label><input type="text" class="form-control" name="emailSource" id="field_emailSource" ng-model="vm.giftcardStatement.emailSource"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.giftcardStatement.emailDestination" for="field_emailDestination">Email Destination</label><input type="text" class="form-control" name="emailDestination" id="field_emailDestination" ng-model="vm.giftcardStatement.emailDestination"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.giftcardStatement.currencyCode" for="field_currencyCode">Currency Code</label><input type="text" class="form-control" name="currencyCode" id="field_currencyCode" ng-model="vm.giftcardStatement.currencyCode"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.giftcardStatement.amount" for="field_amount">Amount</label><input type="number" class="form-control" name="amount" id="field_amount" ng-model="vm.giftcardStatement.amount"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.giftcardStatement.balance" for="field_balance">Balance</label><input type="number" class="form-control" name="balance" id="field_balance" ng-model="vm.giftcardStatement.balance"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.giftcardStatement.cardStatus" for="field_cardStatus">Card Status</label><input type="text" class="form-control" name="cardStatus" id="field_cardStatus" ng-model="vm.giftcardStatement.cardStatus"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.giftcardStatement.status" for="field_status">Status</label><input type="text" class="form-control" name="status" id="field_status" ng-model="vm.giftcardStatement.status"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.giftcardStatement.processed" for="field_processed">Processed</label><input type="checkbox" name="processed" id="field_processed" ng-model="vm.giftcardStatement.processed"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.giftcardStatement.gcExpirationDate" for="field_gcExpirationDate">Gc Expiration Date</label><div class="input-group"><input id="field_gcExpirationDate" type="text" class="form-control" name="gcExpirationDate" datetime-picker="{{dateformat}}" ng-model="vm.giftcardStatement.gcExpirationDate" is-open="vm.datePickerOpenStatus.gcExpirationDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'gcExpirationDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label data-translate="doctorclubboApp.giftcardStatement.cardsystem" for="field_cardsystem">Cardsystem</label><select class="form-control" id="field_cardsystem" name="cardsystem" ng-model="vm.giftcardStatement.cardsystemId" ng-options="gcSystem.id as gcSystem.id for gcSystem in vm.gcsystems"><option value=""></option></select></div><div class="form-group"><label data-translate="doctorclubboApp.giftcardStatement.sistema" for="field_sistema">Sistema</label><select class="form-control" id="field_sistema" name="sistema" ng-model="vm.giftcardStatement.sistemaId" ng-options="sistema.id as sistema.id for sistema in vm.sistemas"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/giftcard-statement/giftcard-statements.html','<div><h2 data-translate="doctorclubboApp.giftcardStatement.home.title">Giftcard Statements</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="giftcard-statement.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="doctorclubboApp.giftcardStatement.home.createLabel">Create new Giftcard Statement</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="dtIns"><span data-translate="doctorclubboApp.giftcardStatement.dtIns">Dt Ins</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="gcClaimCode"><span data-translate="doctorclubboApp.giftcardStatement.gcClaimCode">Gc Claim Code</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="gcId"><span data-translate="doctorclubboApp.giftcardStatement.gcId">Gc Id</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="creationRequestId"><span data-translate="doctorclubboApp.giftcardStatement.creationRequestId">Creation Request Id</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="emailSource"><span data-translate="doctorclubboApp.giftcardStatement.emailSource">Email Source</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="emailDestination"><span data-translate="doctorclubboApp.giftcardStatement.emailDestination">Email Destination</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="currencyCode"><span data-translate="doctorclubboApp.giftcardStatement.currencyCode">Currency Code</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="amount"><span data-translate="doctorclubboApp.giftcardStatement.amount">Amount</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="balance"><span data-translate="doctorclubboApp.giftcardStatement.balance">Balance</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="cardStatus"><span data-translate="doctorclubboApp.giftcardStatement.cardStatus">Card Status</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="status"><span data-translate="doctorclubboApp.giftcardStatement.status">Status</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="processed"><span data-translate="doctorclubboApp.giftcardStatement.processed">Processed</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="gcExpirationDate"><span data-translate="doctorclubboApp.giftcardStatement.gcExpirationDate">Gc Expiration Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="cardsystemId"><span data-translate="doctorclubboApp.giftcardStatement.cardsystem">Cardsystem</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="sistemaId"><span data-translate="doctorclubboApp.giftcardStatement.sistema">Sistema</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="giftcardStatement in vm.giftcardStatements track by giftcardStatement.id"><td><a ui-sref="giftcard-statement-detail({id:giftcardStatement.id})">{{giftcardStatement.id}}</a></td><td>{{giftcardStatement.dtIns | date:\'medium\'}}</td><td>{{giftcardStatement.gcClaimCode}}</td><td>{{giftcardStatement.gcId}}</td><td>{{giftcardStatement.creationRequestId}}</td><td>{{giftcardStatement.emailSource}}</td><td>{{giftcardStatement.emailDestination}}</td><td>{{giftcardStatement.currencyCode}}</td><td>{{giftcardStatement.amount}}</td><td>{{giftcardStatement.balance}}</td><td>{{giftcardStatement.cardStatus}}</td><td>{{giftcardStatement.status}}</td><td>{{giftcardStatement.processed}}</td><td>{{giftcardStatement.gcExpirationDate | date:\'medium\'}}</td><td><a ui-sref="gc-system-detail({id:giftcardStatement.cardsystemId})">{{giftcardStatement.cardsystemId}}</a></td><td><a ui-sref="sistema-detail({id:giftcardStatement.sistemaId})">{{giftcardStatement.sistemaId}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="giftcard-statement-detail({id:giftcardStatement.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="giftcard-statement.edit({id:giftcardStatement.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="giftcard-statement.delete({id:giftcardStatement.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div><uib-pager total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pager></div>');
$templateCache.put('app/entities/opzioni-ticket/opzioni-ticket-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.opzioni_ticket.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="doctorclubboApp.opzioni_ticket.delete.question" translate-values="{id: \'{{vm.opzioni_ticket.id}}\'}">Are you sure you want to delete this Opzioni Ticket?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/opzioni-ticket/opzioni-ticket-detail.html','<div><h2><span data-translate="doctorclubboApp.opzioni_ticket.detail.title">Opzioni Ticket</span> {{vm.opzioni_ticket.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="doctorclubboApp.opzioni_ticket.importo">Importo</span></dt><dd><span>{{vm.opzioni_ticket.importo}}</span></dd><dt><span data-translate="doctorclubboApp.opzioni_ticket.num">Num</span></dt><dd><span>{{vm.opzioni_ticket.num}}</span></dd><dt><span data-translate="doctorclubboApp.opzioni_ticket.campagna">Campagna</span></dt><dd><a ui-sref="campagna-detail({id:vm.opzioni_ticket.campagnaId})">{{vm.opzioni_ticket.campagnaId}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="opzioni-ticket-detail.edit({id:vm.opzioni_ticket.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/opzioni-ticket/opzioni-ticket-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myOpzioni_ticketLabel" data-translate="doctorclubboApp.opzioni_ticket.home.createOrEditLabel">Create or edit a Opzioni Ticket</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.opzioni_ticket.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.opzioni_ticket.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.opzioni_ticket.importo" for="field_importo">Importo</label><input type="number" class="form-control" name="importo" id="field_importo" ng-model="vm.opzioni_ticket.importo"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.opzioni_ticket.num" for="field_num">Num</label><input type="number" class="form-control" name="num" id="field_num" ng-model="vm.opzioni_ticket.num"></div><div class="form-group"><label data-translate="doctorclubboApp.opzioni_ticket.campagna" for="field_campagna">Campagna</label><select class="form-control" id="field_campagna" name="campagna" ng-model="vm.opzioni_ticket.campagnaId" ng-options="campagna.id as campagna.id for campagna in vm.campagnas"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/opzioni-ticket/opzioni-tickets.html','<div><h2 data-translate="doctorclubboApp.opzioni_ticket.home.title">Opzioni Tickets</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="opzioni-ticket.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="doctorclubboApp.opzioni_ticket.home.createLabel">Create new Opzioni Ticket</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="importo"><span data-translate="doctorclubboApp.opzioni_ticket.importo">Importo</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="num"><span data-translate="doctorclubboApp.opzioni_ticket.num">Num</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="campagnaId"><span data-translate="doctorclubboApp.opzioni_ticket.campagna">Campagna</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="opzioni_ticket in vm.opzioni_tickets track by opzioni_ticket.id"><td><a ui-sref="opzioni-ticket-detail({id:opzioni_ticket.id})">{{opzioni_ticket.id}}</a></td><td>{{opzioni_ticket.importo}}</td><td>{{opzioni_ticket.num}}</td><td><a ui-sref="campagna-detail({id:opzioni_ticket.campagnaId})">{{opzioni_ticket.campagnaId}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="opzioni-ticket-detail({id:opzioni_ticket.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="opzioni-ticket.edit({id:opzioni_ticket.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="opzioni-ticket.delete({id:opzioni_ticket.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div><uib-pager total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pager></div>');
$templateCache.put('app/entities/provincia/provincia-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.provincia.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="doctorclubboApp.provincia.delete.question" translate-values="{id: \'{{vm.provincia.id}}\'}">Are you sure you want to delete this Provincia?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/provincia/provincia-detail.html','<div><h2><span data-translate="doctorclubboApp.provincia.detail.title">Provincia</span> {{vm.provincia.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="doctorclubboApp.provincia.sigla">ID</span></dt><dd><span>{{vm.provincia.id}}</span></dd><dt><span data-translate="doctorclubboApp.provincia.provincia">Provincia</span></dt><dd><span>{{vm.provincia.provincia}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="provincia-detail.edit({id:vm.provincia.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/provincia/provincia-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myProvinciaLabel" data-translate="doctorclubboApp.provincia.home.createOrEditLabel">Create or edit a Provincia</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.provincia.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.provincia.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.provincia.provincia" for="field_provincia">Provincia</label><input type="text" class="form-control" name="provincia" id="field_provincia" ng-model="vm.provincia.provincia"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/provincia/provincias.html','<div><h2 data-translate="doctorclubboApp.provincia.home.title">Provincias</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="provincia.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="doctorclubboApp.provincia.home.createLabel">Create new Provincia</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="provincia"><span data-translate="doctorclubboApp.provincia.provincia">Provincia</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="provincia in vm.provincias track by provincia.id"><td><a ui-sref="provincia-detail({id:provincia.id})">{{provincia.id}}</a></td><td>{{provincia.provincia}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="provincia-detail({id:provincia.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="provincia.edit({id:provincia.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="provincia.delete({id:provincia.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/qsched-direction/qsched-direction-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.qsched_direction.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="doctorclubboApp.qsched_direction.delete.question" translate-values="{id: \'{{vm.qsched_direction.id}}\'}">Are you sure you want to delete this Qsched Direction?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/qsched-direction/qsched-direction-detail.html','<div><h2><span data-translate="doctorclubboApp.qsched_direction.detail.title">Qsched Direction</span> {{vm.qsched_direction.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="doctorclubboApp.qsched_direction.direction">Direction</span></dt><dd><span>{{vm.qsched_direction.direction}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="qsched-direction-detail.edit({id:vm.qsched_direction.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/qsched-direction/qsched-direction-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myQsched_directionLabel" data-translate="doctorclubboApp.qsched_direction.home.createOrEditLabel">Create or edit a Qsched Direction</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.qsched_direction.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.qsched_direction.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.qsched_direction.direction" for="field_direction">Direction</label><input type="text" class="form-control" name="direction" id="field_direction" ng-model="vm.qsched_direction.direction"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/qsched-direction/qsched-directions.html','<div><h2 data-translate="doctorclubboApp.qsched_direction.home.title">Qsched Directions</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="qsched-direction.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="doctorclubboApp.qsched_direction.home.createLabel">Create new Qsched Direction</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="direction"><span data-translate="doctorclubboApp.qsched_direction.direction">Direction</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="qsched_direction in vm.qsched_directions track by qsched_direction.id"><td><a ui-sref="qsched-direction-detail({id:qsched_direction.id})">{{qsched_direction.id}}</a></td><td>{{qsched_direction.direction}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="qsched-direction-detail({id:qsched_direction.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="qsched-direction.edit({id:qsched_direction.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="qsched-direction.delete({id:qsched_direction.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/qsched-status/qsched-status-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.qsched_status.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="doctorclubboApp.qsched_status.delete.question" translate-values="{id: \'{{vm.qsched_status.id}}\'}">Are you sure you want to delete this Qsched Status?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/qsched-status/qsched-status-detail.html','<div><h2><span data-translate="doctorclubboApp.qsched_status.detail.title">Qsched Status</span> {{vm.qsched_status.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="doctorclubboApp.qsched_status.name">Name</span></dt><dd><span>{{vm.qsched_status.name}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="qsched-status-detail.edit({id:vm.qsched_status.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/qsched-status/qsched-status-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myQsched_statusLabel" data-translate="doctorclubboApp.qsched_status.home.createOrEditLabel">Create or edit a Qsched Status</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.qsched_status.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.qsched_status.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.qsched_status.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.qsched_status.name"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/qsched-status/qsched-statuses.html','<div><h2 data-translate="doctorclubboApp.qsched_status.home.title">Qsched Statuses</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="qsched-status.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="doctorclubboApp.qsched_status.home.createLabel">Create new Qsched Status</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="name"><span data-translate="doctorclubboApp.qsched_status.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="qsched_status in vm.qsched_statuses track by qsched_status.id"><td><a ui-sref="qsched-status-detail({id:qsched_status.id})">{{qsched_status.id}}</a></td><td>{{qsched_status.name}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="qsched-status-detail({id:qsched_status.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="qsched-status.edit({id:qsched_status.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="qsched-status.delete({id:qsched_status.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/qsched-type/qsched-type-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.qsched_type.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="doctorclubboApp.qsched_type.delete.question" translate-values="{id: \'{{vm.qsched_type.id}}\'}">Are you sure you want to delete this Qsched Type?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/qsched-type/qsched-type-detail.html','<div><h2><span data-translate="doctorclubboApp.qsched_type.detail.title">Qsched Type</span> {{vm.qsched_type.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="doctorclubboApp.qsched_type.name">Name</span></dt><dd><span>{{vm.qsched_type.name}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="qsched-type-detail.edit({id:vm.qsched_type.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/qsched-type/qsched-type-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myQsched_typeLabel" data-translate="doctorclubboApp.qsched_type.home.createOrEditLabel">Create or edit a Qsched Type</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.qsched_type.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.qsched_type.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.qsched_type.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.qsched_type.name"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/qsched-type/qsched-types.html','<div><h2 data-translate="doctorclubboApp.qsched_type.home.title">Qsched Types</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="qsched-type.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="doctorclubboApp.qsched_type.home.createLabel">Create new Qsched Type</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="name"><span data-translate="doctorclubboApp.qsched_type.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="qsched_type in vm.qsched_types track by qsched_type.id"><td><a ui-sref="qsched-type-detail({id:qsched_type.id})">{{qsched_type.id}}</a></td><td>{{qsched_type.name}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="qsched-type-detail({id:qsched_type.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="qsched-type.edit({id:qsched_type.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="qsched-type.delete({id:qsched_type.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/queue/queue-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.queue.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="doctorclubboApp.queue.delete.question" translate-values="{id: \'{{vm.queue.id}}\'}">Are you sure you want to delete this Queue?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/queue/queue-detail.html','<div><h2><span data-translate="doctorclubboApp.queue.detail.title">Queue</span> {{vm.queue.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="doctorclubboApp.queue.dtIns">Dt Ins</span></dt><dd><span>{{vm.queue.dtIns | date:\'medium\'}}</span></dd><dt><span data-translate="doctorclubboApp.queue.dtUpdate">Dt Update</span></dt><dd><span>{{vm.queue.dtUpdate | date:\'medium\'}}</span></dd><dt><span data-translate="doctorclubboApp.queue.name">Name</span></dt><dd><span>{{vm.queue.name}}</span></dd><dt><span data-translate="doctorclubboApp.queue.dtFirstExecution">Dt First Execution</span></dt><dd><span>{{vm.queue.dtFirstExecution | date:\'medium\'}}</span></dd><dt><span data-translate="doctorclubboApp.queue.queue_statusqueue">Queue Statusqueue</span></dt><dd><a ui-sref="queue-status-detail({id:vm.queue.queue_statusqueue.id})">{{vm.queue.queue_statusqueue.status}}</a></dd><dt><span data-translate="doctorclubboApp.queue.queue_queuetype">Queuetype</span></dt><dd><a ui-sref="queue-type-detail({id:vm.queue.queue_queuetype.id})">{{vm.queue.queue_queuetype.type}}</a></dd><dt><span data-translate="doctorclubboApp.queue.userinsert_user">Userinsert User</span></dt><dd><a ui-sref="jhi-user-detail({id:vm.queue.userinsert_user.id})">{{vm.queue.userinsert_user.login}}</a></dd><dt><span data-translate="doctorclubboApp.queue.userfirst_user">Userfirst User</span></dt><dd><a ui-sref="jhi-user-detail({id:vm.queue.userfirst_user.id})">{{vm.queue.userfirst_user.login}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="queue-detail.edit({id:vm.queue.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/queue/queue-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myQueueLabel" data-translate="doctorclubboApp.queue.home.createOrEditLabel">Create or edit a Queue</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.queue.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.queue.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.queue.dtIns" for="field_dtIns">Dt Ins</label><div class="input-group"><input id="field_dtIns" type="text" class="form-control" name="dtIns" datetime-picker="{{dateformat}}" ng-model="vm.queue.dtIns" is-open="vm.datePickerOpenStatus.dtIns"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dtIns\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.queue.dtUpdate" for="field_dtUpdate">Dt Update</label><div class="input-group"><input id="field_dtUpdate" type="text" class="form-control" name="dtUpdate" datetime-picker="{{dateformat}}" ng-model="vm.queue.dtUpdate" is-open="vm.datePickerOpenStatus.dtUpdate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dtUpdate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.queue.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.queue.name"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.queue.dtFirstExecution" for="field_dtFirstExecution">Dt First Execution</label><div class="input-group"><input id="field_dtFirstExecution" type="text" class="form-control" name="dtFirstExecution" datetime-picker="{{dateformat}}" ng-model="vm.queue.dtFirstExecution" is-open="vm.datePickerOpenStatus.dtFirstExecution"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dtFirstExecution\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label data-translate="doctorclubboApp.queue.queue_statusqueue" for="field_queue_statusqueue">Statusqueue</label><select class="form-control" id="field_queue_statusqueue" name="queue_statusqueue" ng-model="vm.queue.queue_statusqueue" ng-options="queue_status as queue_status.status for queue_status in vm.queue_statuses track by queue_status.id"><option value=""></option></select></div><div class="form-group"><label data-translate="doctorclubboApp.queue.queue_queuetype" for="field_queue_queuetype">Queuetype</label><select class="form-control" id="field_queue_queuetype" name="queue_queuetype" ng-model="vm.queue.queue_queuetype" ng-options="queue_type as queue_type.type for queue_type in vm.queue_types track by queue_type.id"><option value=""></option></select></div><div class="form-group"><label data-translate="doctorclubboApp.queue.userinsert_user" for="field_userinsert_user">Userinsert User</label><select class="form-control" id="field_userinsert_user" name="userinsert_user" ng-model="vm.queue.userinsert_user" ng-options="jhi_user as jhi_user.login for jhi_user in vm.jhi_users track by jhi_user.id"><option value=""></option></select></div><div class="form-group"><label data-translate="doctorclubboApp.queue.userfirst_user" for="field_userfirst_user">Userfirst User</label><select class="form-control" id="field_userfirst_user" name="userfirst_user" ng-model="vm.queue.userfirst_user" ng-options="jhi_user as jhi_user.login for jhi_user in vm.jhi_users track by jhi_user.id"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/queue/queue-import.html','<form name="importForm" ng-submit="vm.confirmImport(vm.queue.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm import operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate-values="{id: \'{{vm.queue.id}}\'}">Are you sure you want to import this Queue?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="importForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Import</span></button></div></form>');
$templateCache.put('app/entities/queue/queue-process.html','<form name="processForm" ng-submit="vm.confirmProcess(vm.queue.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm process operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate-values="{id: \'{{vm.queue.id}}\'}">Are you sure you want to process this Queue?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="importForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Process</span></button></div></form>');
$templateCache.put('app/entities/queue/queues.html','<div><h2 data-translate="doctorclubboApp.queue.home.title">Queues</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="queue.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="doctorclubboApp.queue.home.createLabel">Create new Queue</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="dtIns"><span data-translate="doctorclubboApp.queue.dtIns">Dt Ins</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="dtUpdate"><span data-translate="doctorclubboApp.queue.dtUpdate">Dt Update</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="name"><span data-translate="doctorclubboApp.queue.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="dtFirstExecution"><span data-translate="doctorclubboApp.queue.dtFirstExecution">Dt First Execution</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="queue_statusqueue.status"><span data-translate="doctorclubboApp.queue.queue_statusqueue">Status</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="queue_queuetype.type"><span data-translate="doctorclubboApp.queue.queue_queuetype">Type</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="userinsert_user.id"><span data-translate="doctorclubboApp.queue.userinsert_user">Userinsert User</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="userfirst_user.id"><span data-translate="doctorclubboApp.queue.userfirst_user">Userfirst User</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="queue in vm.queues track by queue.id"><td><a ui-sref="queue-detail({id:queue.id})">{{queue.id}}</a></td><td>{{queue.dtIns | date:\'medium\'}}</td><td>{{queue.dtUpdate | date:\'medium\'}}</td><td>{{queue.name}}</td><td>{{queue.dtFirstExecution | date:\'medium\'}}</td><td><a ui-sref="queue-status-detail({id:queue.queue_statusqueue.id})">{{queue.queue_statusqueue.status}}</a></td><td><a ui-sref="queue-type-detail({id:queue.queue_queuetype.id})">{{queue.queue_queuetype.type}}</a></td><td><a ui-sref="jhi-user-detail({id:queue.userinsert_user.id})">{{queue.userinsert_user.login}}</a></td><td><a ui-sref="jhi-user-detail({id:queue.userfirst_user.id})">{{queue.userfirst_user.login}}</a></td><td class="text-right"><div class="btn-group-vertical"><button type="submit" ui-sref="queue.import({id:queue.id})" class="btn btn-primary btn-xs"><span class="glyphicon glyphicon-import"></span> <span class="hidden-xs hidden-xs">Importa</span></button> <button type="submit" ui-sref="queue.process({id:queue.id})" class="btn btn-primary btn-xs"><span class="glyphicon glyphicon-flash"></span> <span class="hidden-xs hidden-xs">Processa</span></button> <button type="submit" ui-sref="queue-detail({id:queue.id})" class="btn btn-info btn-xs"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-xs" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="queue.edit({id:queue.id})" class="btn btn-primary btn-xs"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-xs" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="queue.delete({id:queue.id})" class="btn btn-danger btn-xs"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-xs" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/queue-account/queue-account-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.queueAccount.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="doctorclubboApp.queueAccount.delete.question" translate-values="{id: \'{{vm.queueAccount.id}}\'}">Are you sure you want to delete this Queue Account?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/queue-account/queue-account-detail.html','<div><h2><span data-translate="doctorclubboApp.queueAccount.detail.title">Queue Account</span> {{vm.queueAccount.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="doctorclubboApp.queueAccount.nome">Nome</span></dt><dd><span>{{vm.queueAccount.nome}}</span></dd><dt><span data-translate="doctorclubboApp.queueAccount.cognome">Cognome</span></dt><dd><span>{{vm.queueAccount.cognome}}</span></dd><dt><span data-translate="doctorclubboApp.queueAccount.cf">Cf</span></dt><dd><span>{{vm.queueAccount.cf}}</span></dd><dt><span data-translate="doctorclubboApp.queueAccount.dtNascita">Dt Nascita</span></dt><dd><span>{{vm.queueAccount.dtNascita | date:\'medium\'}}</span></dd><dt><span data-translate="doctorclubboApp.queueAccount.numIscrizione">Num Iscrizione</span></dt><dd><span>{{vm.queueAccount.numIscrizione}}</span></dd><dt><span data-translate="doctorclubboApp.queueAccount.telefono">Telefono</span></dt><dd><span>{{vm.queueAccount.telefono}}</span></dd><dt><span data-translate="doctorclubboApp.queueAccount.cellulare">Cellulare</span></dt><dd><span>{{vm.queueAccount.cellulare}}</span></dd><dt><span data-translate="doctorclubboApp.queueAccount.fax">Fax</span></dt><dd><span>{{vm.queueAccount.fax}}</span></dd><dt><span data-translate="doctorclubboApp.queueAccount.email">Email</span></dt><dd><span>{{vm.queueAccount.email}}</span></dd><dt><span data-translate="doctorclubboApp.queueAccount.email2">Email 2</span></dt><dd><span>{{vm.queueAccount.email2}}</span></dd><dt><span data-translate="doctorclubboApp.queueAccount.attivita">Attivita</span></dt><dd><span>{{vm.queueAccount.attivita}}</span></dd><dt><span data-translate="doctorclubboApp.queueAccount.precontattogg">Precontattogg</span></dt><dd><span>{{vm.queueAccount.precontattogg}}</span></dd><dt><span data-translate="doctorclubboApp.queueAccount.precontattoOrario1">Precontatto Orario 1</span></dt><dd><span>{{vm.queueAccount.precontattoOrario1}}</span></dd><dt><span data-translate="doctorclubboApp.queueAccount.precontattoOrario2">Precontatto Orario 2</span></dt><dd><span>{{vm.queueAccount.precontattoOrario2}}</span></dd><dt><span data-translate="doctorclubboApp.queueAccount.ricerchegg">Ricerchegg</span></dt><dd><span>{{vm.queueAccount.ricerchegg}}</span></dd><dt><span data-translate="doctorclubboApp.queueAccount.ricercheOrario">Ricerche Orario</span></dt><dd><span>{{vm.queueAccount.ricercheOrario}}</span></dd><dt><span data-translate="doctorclubboApp.queueAccount.isfgg">Isfgg</span></dt><dd><span>{{vm.queueAccount.isfgg}}</span></dd><dt><span data-translate="doctorclubboApp.queueAccount.isfOrario">Isf Orario</span></dt><dd><span>{{vm.queueAccount.isfOrario}}</span></dd><dt><span data-translate="doctorclubboApp.queueAccount.note">Note</span></dt><dd><span>{{vm.queueAccount.note}}</span></dd><dt><span data-translate="doctorclubboApp.queueAccount.dispositivo">Dispositivo</span></dt><dd><span>{{vm.queueAccount.dispositivo}}</span></dd><dt><span data-translate="doctorclubboApp.queueAccount.dispositivoOs">Dispositivo Os</span></dt><dd><span>{{vm.queueAccount.dispositivoOs}}</span></dd><dt><span data-translate="doctorclubboApp.queueAccount.tablet">Tablet</span></dt><dd><span>{{vm.queueAccount.tablet}}</span></dd><dt><span data-translate="doctorclubboApp.queueAccount.tabletOs">Tablet Os</span></dt><dd><span>{{vm.queueAccount.tabletOs}}</span></dd><dt><span data-translate="doctorclubboApp.queueAccount.tv">Tv</span></dt><dd><span>{{vm.queueAccount.tv}}</span></dd><dt><span data-translate="doctorclubboApp.queueAccount.canaliTv">Canali Tv</span></dt><dd><span>{{vm.queueAccount.canaliTv}}</span></dd><dt><span data-translate="doctorclubboApp.queueAccount.comune">Comune</span></dt><dd><span>{{vm.queueAccount.comune}}</span></dd><dt><span data-translate="doctorclubboApp.queueAccount.cap">Cap</span></dt><dd><span>{{vm.queueAccount.cap}}</span></dd><dt><span data-translate="doctorclubboApp.queueAccount.indirizzo">Indirizzo</span></dt><dd><span>{{vm.queueAccount.indirizzo}}</span></dd><dt><span data-translate="doctorclubboApp.queueAccount.dtIns">Dt Ins</span></dt><dd><span>{{vm.queueAccount.dtIns | date:\'medium\'}}</span></dd><dt><span data-translate="doctorclubboApp.queueAccount.dtUpdate">Dt Update</span></dt><dd><span>{{vm.queueAccount.dtUpdate | date:\'medium\'}}</span></dd><dt><span data-translate="doctorclubboApp.queueAccount.recallStatus">Recall Status</span></dt><dd><span>{{vm.queueAccount.recallStatus}}</span></dd><dt><span data-translate="doctorclubboApp.queueAccount.statusNote">Status Note</span></dt><dd><span>{{vm.queueAccount.statusNote}}</span></dd><dt><span data-translate="doctorclubboApp.queueAccount.recallDt">Recall Dt</span></dt><dd><span>{{vm.queueAccount.recallDt | date:\'medium\'}}</span></dd><dt><span data-translate="doctorclubboApp.queueAccount.spedizioneComune">Spedizione Comune</span></dt><dd><span>{{vm.queueAccount.spedizioneComune}}</span></dd><dt><span data-translate="doctorclubboApp.queueAccount.spedizioneCap">Spedizione Cap</span></dt><dd><span>{{vm.queueAccount.spedizioneCap}}</span></dd><dt><span data-translate="doctorclubboApp.queueAccount.spedizioneIndirizzo">Spedizione Indirizzo</span></dt><dd><span>{{vm.queueAccount.spedizioneIndirizzo}}</span></dd><dt><span data-translate="doctorclubboApp.queueAccount.spedizioneTel">Spedizione Tel</span></dt><dd><span>{{vm.queueAccount.spedizioneTel}}</span></dd><dt><span data-translate="doctorclubboApp.queueAccount.source">Source</span></dt><dd><span>{{vm.queueAccount.source}}</span></dd><dt><span data-translate="doctorclubboApp.queueAccount.specializzazione1">Specializzazione 1</span></dt><dd><span>{{vm.queueAccount.specializzazione1}}</span></dd><dt><span data-translate="doctorclubboApp.queueAccount.specializzazione2">Specializzazione 2</span></dt><dd><span>{{vm.queueAccount.specializzazione2}}</span></dd><dt><span data-translate="doctorclubboApp.queueAccount.specializzazione3">Specializzazione 3</span></dt><dd><span>{{vm.queueAccount.specializzazione3}}</span></dd><dt><span data-translate="doctorclubboApp.queueAccount.provincia">Provincia</span></dt><dd><span>{{vm.queueAccount.provincia}}</span></dd><dt><span data-translate="doctorclubboApp.queueAccount.spedizioneProv">Spedizione Prov</span></dt><dd><span>{{vm.queueAccount.spedizioneProv}}</span></dd><dt><span data-translate="doctorclubboApp.queueAccount.idQueue">Id Queue</span></dt><dd><span>{{vm.queueAccount.idQueue}}</span></dd><dt><span data-translate="doctorclubboApp.queueAccount.error_list">Error List</span></dt><dd><span>{{vm.queueAccount.error_list}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="queue-account-detail.edit({id:vm.queueAccount.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/queue-account/queue-account-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myQueueAccountLabel" data-translate="doctorclubboApp.queueAccount.home.createOrEditLabel">Create or edit a Queue Account</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.queueAccount.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.queueAccount.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.queueAccount.nome" for="field_nome">Nome</label><input type="text" class="form-control" name="nome" id="field_nome" ng-model="vm.queueAccount.nome"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.queueAccount.cognome" for="field_cognome">Cognome</label><input type="text" class="form-control" name="cognome" id="field_cognome" ng-model="vm.queueAccount.cognome"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.queueAccount.cf" for="field_cf">Cf</label><input type="text" class="form-control" name="cf" id="field_cf" ng-model="vm.queueAccount.cf"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.queueAccount.dtNascita" for="field_dtNascita">Dt Nascita</label><div class="input-group"><input id="field_dtNascita" type="text" class="form-control" name="dtNascita" datetime-picker="{{dateformat}}" ng-model="vm.queueAccount.dtNascita" is-open="vm.datePickerOpenStatus.dtNascita"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dtNascita\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.queueAccount.numIscrizione" for="field_numIscrizione">Num Iscrizione</label><input type="text" class="form-control" name="numIscrizione" id="field_numIscrizione" ng-model="vm.queueAccount.numIscrizione"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.queueAccount.telefono" for="field_telefono">Telefono</label><input type="text" class="form-control" name="telefono" id="field_telefono" ng-model="vm.queueAccount.telefono"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.queueAccount.cellulare" for="field_cellulare">Cellulare</label><input type="text" class="form-control" name="cellulare" id="field_cellulare" ng-model="vm.queueAccount.cellulare"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.queueAccount.fax" for="field_fax">Fax</label><input type="text" class="form-control" name="fax" id="field_fax" ng-model="vm.queueAccount.fax"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.queueAccount.email" for="field_email">Email</label><input type="text" class="form-control" name="email" id="field_email" ng-model="vm.queueAccount.email"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.queueAccount.email2" for="field_email2">Email 2</label><input type="text" class="form-control" name="email2" id="field_email2" ng-model="vm.queueAccount.email2"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.queueAccount.attivita" for="field_attivita">Attivita</label><input type="text" class="form-control" name="attivita" id="field_attivita" ng-model="vm.queueAccount.attivita"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.queueAccount.precontattogg" for="field_precontattogg">Precontattogg</label><input type="text" class="form-control" name="precontattogg" id="field_precontattogg" ng-model="vm.queueAccount.precontattogg"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.queueAccount.precontattoOrario1" for="field_precontattoOrario1">Precontatto Orario 1</label><input type="text" class="form-control" name="precontattoOrario1" id="field_precontattoOrario1" ng-model="vm.queueAccount.precontattoOrario1"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.queueAccount.precontattoOrario2" for="field_precontattoOrario2">Precontatto Orario 2</label><input type="text" class="form-control" name="precontattoOrario2" id="field_precontattoOrario2" ng-model="vm.queueAccount.precontattoOrario2"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.queueAccount.ricerchegg" for="field_ricerchegg">Ricerchegg</label><input type="text" class="form-control" name="ricerchegg" id="field_ricerchegg" ng-model="vm.queueAccount.ricerchegg"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.queueAccount.ricercheOrario" for="field_ricercheOrario">Ricerche Orario</label><input type="text" class="form-control" name="ricercheOrario" id="field_ricercheOrario" ng-model="vm.queueAccount.ricercheOrario"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.queueAccount.isfgg" for="field_isfgg">Isfgg</label><input type="text" class="form-control" name="isfgg" id="field_isfgg" ng-model="vm.queueAccount.isfgg"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.queueAccount.isfOrario" for="field_isfOrario">Isf Orario</label><input type="text" class="form-control" name="isfOrario" id="field_isfOrario" ng-model="vm.queueAccount.isfOrario"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.queueAccount.note" for="field_note">Note</label><input type="text" class="form-control" name="note" id="field_note" ng-model="vm.queueAccount.note"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.queueAccount.dispositivo" for="field_dispositivo">Dispositivo</label><input type="text" class="form-control" name="dispositivo" id="field_dispositivo" ng-model="vm.queueAccount.dispositivo"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.queueAccount.dispositivoOs" for="field_dispositivoOs">Dispositivo Os</label><input type="text" class="form-control" name="dispositivoOs" id="field_dispositivoOs" ng-model="vm.queueAccount.dispositivoOs"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.queueAccount.tablet" for="field_tablet">Tablet</label><input type="number" class="form-control" name="tablet" id="field_tablet" ng-model="vm.queueAccount.tablet"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.queueAccount.tabletOs" for="field_tabletOs">Tablet Os</label><input type="text" class="form-control" name="tabletOs" id="field_tabletOs" ng-model="vm.queueAccount.tabletOs"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.queueAccount.tv" for="field_tv">Tv</label><input type="number" class="form-control" name="tv" id="field_tv" ng-model="vm.queueAccount.tv"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.queueAccount.canaliTv" for="field_canaliTv">Canali Tv</label><input type="text" class="form-control" name="canaliTv" id="field_canaliTv" ng-model="vm.queueAccount.canaliTv"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.queueAccount.comune" for="field_comune">Comune</label><input type="text" class="form-control" name="comune" id="field_comune" ng-model="vm.queueAccount.comune"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.queueAccount.cap" for="field_cap">Cap</label><input type="text" class="form-control" name="cap" id="field_cap" ng-model="vm.queueAccount.cap"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.queueAccount.indirizzo" for="field_indirizzo">Indirizzo</label><input type="text" class="form-control" name="indirizzo" id="field_indirizzo" ng-model="vm.queueAccount.indirizzo"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.queueAccount.dtIns" for="field_dtIns">Dt Ins</label><div class="input-group"><input id="field_dtIns" type="text" class="form-control" name="dtIns" datetime-picker="{{dateformat}}" ng-model="vm.queueAccount.dtIns" is-open="vm.datePickerOpenStatus.dtIns"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dtIns\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.queueAccount.dtUpdate" for="field_dtUpdate">Dt Update</label><div class="input-group"><input id="field_dtUpdate" type="text" class="form-control" name="dtUpdate" datetime-picker="{{dateformat}}" ng-model="vm.queueAccount.dtUpdate" is-open="vm.datePickerOpenStatus.dtUpdate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dtUpdate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.queueAccount.recallStatus" for="field_recallStatus">Recall Status</label><input type="text" class="form-control" name="recallStatus" id="field_recallStatus" ng-model="vm.queueAccount.recallStatus"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.queueAccount.statusNote" for="field_statusNote">Status Note</label><input type="text" class="form-control" name="statusNote" id="field_statusNote" ng-model="vm.queueAccount.statusNote"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.queueAccount.recallDt" for="field_recallDt">Recall Dt</label><div class="input-group"><input id="field_recallDt" type="text" class="form-control" name="recallDt" datetime-picker="{{dateformat}}" ng-model="vm.queueAccount.recallDt" is-open="vm.datePickerOpenStatus.recallDt"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'recallDt\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.queueAccount.spedizioneComune" for="field_spedizioneComune">Spedizione Comune</label><input type="text" class="form-control" name="spedizioneComune" id="field_spedizioneComune" ng-model="vm.queueAccount.spedizioneComune"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.queueAccount.spedizioneCap" for="field_spedizioneCap">Spedizione Cap</label><input type="text" class="form-control" name="spedizioneCap" id="field_spedizioneCap" ng-model="vm.queueAccount.spedizioneCap"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.queueAccount.spedizioneIndirizzo" for="field_spedizioneIndirizzo">Spedizione Indirizzo</label><input type="text" class="form-control" name="spedizioneIndirizzo" id="field_spedizioneIndirizzo" ng-model="vm.queueAccount.spedizioneIndirizzo"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.queueAccount.spedizioneTel" for="field_spedizioneTel">Spedizione Tel</label><input type="text" class="form-control" name="spedizioneTel" id="field_spedizioneTel" ng-model="vm.queueAccount.spedizioneTel"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.queueAccount.source" for="field_source">Source</label><input type="text" class="form-control" name="source" id="field_source" ng-model="vm.queueAccount.source"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.queueAccount.specializzazione1" for="field_specializzazione1">Specializzazione 1</label><input type="number" class="form-control" name="specializzazione1" id="field_specializzazione1" ng-model="vm.queueAccount.specializzazione1"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.queueAccount.specializzazione2" for="field_specializzazione2">Specializzazione 2</label><input type="number" class="form-control" name="specializzazione2" id="field_specializzazione2" ng-model="vm.queueAccount.specializzazione2"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.queueAccount.specializzazione3" for="field_specializzazione3">Specializzazione 3</label><input type="number" class="form-control" name="specializzazione3" id="field_specializzazione3" ng-model="vm.queueAccount.specializzazione3"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.queueAccount.provincia" for="field_provincia">Provincia</label><input type="text" class="form-control" name="provincia" id="field_provincia" ng-model="vm.queueAccount.provincia"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.queueAccount.spedizioneProv" for="field_spedizioneProv">Spedizione Prov</label><input type="text" class="form-control" name="spedizioneProv" id="field_spedizioneProv" ng-model="vm.queueAccount.spedizioneProv"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.queueAccount.idQueue" for="field_idQueue">Id Queue</label><input type="number" class="form-control" name="idQueue" id="field_idQueue" ng-model="vm.queueAccount.idQueue"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.queueAccount.error_list" for="field_error_list">Error List</label><input type="text" class="form-control" name="error_list" id="field_error_list" ng-model="vm.queueAccount.error_list"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/queue-account/queue-accounts.html','<div><h2 data-translate="doctorclubboApp.queueAccount.home.title">Queue Accounts</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="queue-account.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="doctorclubboApp.queueAccount.home.createLabel">Create new Queue Account</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="idQueue"><span data-translate="doctorclubboApp.queueAccount.idQueue">Id Queue</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="error_list"><span data-translate="doctorclubboApp.queueAccount.error_list">Error List</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nome"><span data-translate="doctorclubboApp.queueAccount.nome">Nome</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="cognome"><span data-translate="doctorclubboApp.queueAccount.cognome">Cognome</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="cf"><span data-translate="doctorclubboApp.queueAccount.cf">Cf</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="dtNascita"><span data-translate="doctorclubboApp.queueAccount.dtNascita">Dt Nascita</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="numIscrizione"><span data-translate="doctorclubboApp.queueAccount.numIscrizione">Num Iscrizione</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="telefono"><span data-translate="doctorclubboApp.queueAccount.telefono">Telefono</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="cellulare"><span data-translate="doctorclubboApp.queueAccount.cellulare">Cellulare</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="fax"><span data-translate="doctorclubboApp.queueAccount.fax">Fax</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="email"><span data-translate="doctorclubboApp.queueAccount.email">Email</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="email2"><span data-translate="doctorclubboApp.queueAccount.email2">Email 2</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="attivita"><span data-translate="doctorclubboApp.queueAccount.attivita">Attivita</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="precontattogg"><span data-translate="doctorclubboApp.queueAccount.precontattogg">Precontattogg</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="precontattoOrario1"><span data-translate="doctorclubboApp.queueAccount.precontattoOrario1">Precontatto Orario 1</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="precontattoOrario2"><span data-translate="doctorclubboApp.queueAccount.precontattoOrario2">Precontatto Orario 2</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="ricerchegg"><span data-translate="doctorclubboApp.queueAccount.ricerchegg">Ricerchegg</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="ricercheOrario"><span data-translate="doctorclubboApp.queueAccount.ricercheOrario">Ricerche Orario</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="isfgg"><span data-translate="doctorclubboApp.queueAccount.isfgg">Isfgg</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="isfOrario"><span data-translate="doctorclubboApp.queueAccount.isfOrario">Isf Orario</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="note"><span data-translate="doctorclubboApp.queueAccount.note">Note</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="dispositivo"><span data-translate="doctorclubboApp.queueAccount.dispositivo">Dispositivo</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="dispositivoOs"><span data-translate="doctorclubboApp.queueAccount.dispositivoOs">Dispositivo Os</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="tablet"><span data-translate="doctorclubboApp.queueAccount.tablet">Tablet</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="tabletOs"><span data-translate="doctorclubboApp.queueAccount.tabletOs">Tablet Os</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="tv"><span data-translate="doctorclubboApp.queueAccount.tv">Tv</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="canaliTv"><span data-translate="doctorclubboApp.queueAccount.canaliTv">Canali Tv</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="comune"><span data-translate="doctorclubboApp.queueAccount.comune">Comune</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="cap"><span data-translate="doctorclubboApp.queueAccount.cap">Cap</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="indirizzo"><span data-translate="doctorclubboApp.queueAccount.indirizzo">Indirizzo</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="dtIns"><span data-translate="doctorclubboApp.queueAccount.dtIns">Dt Ins</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="dtUpdate"><span data-translate="doctorclubboApp.queueAccount.dtUpdate">Dt Update</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="recallStatus"><span data-translate="doctorclubboApp.queueAccount.recallStatus">Recall Status</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="statusNote"><span data-translate="doctorclubboApp.queueAccount.statusNote">Status Note</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="recallDt"><span data-translate="doctorclubboApp.queueAccount.recallDt">Recall Dt</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="spedizioneComune"><span data-translate="doctorclubboApp.queueAccount.spedizioneComune">Spedizione Comune</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="spedizioneCap"><span data-translate="doctorclubboApp.queueAccount.spedizioneCap">Spedizione Cap</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="spedizioneIndirizzo"><span data-translate="doctorclubboApp.queueAccount.spedizioneIndirizzo">Spedizione Indirizzo</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="spedizioneTel"><span data-translate="doctorclubboApp.queueAccount.spedizioneTel">Spedizione Tel</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="source"><span data-translate="doctorclubboApp.queueAccount.source">Source</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="specializzazione1"><span data-translate="doctorclubboApp.queueAccount.specializzazione1">Specializzazione 1</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="specializzazione2"><span data-translate="doctorclubboApp.queueAccount.specializzazione2">Specializzazione 2</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="specializzazione3"><span data-translate="doctorclubboApp.queueAccount.specializzazione3">Specializzazione 3</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="provincia"><span data-translate="doctorclubboApp.queueAccount.provincia">Provincia</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="spedizioneProv"><span data-translate="doctorclubboApp.queueAccount.spedizioneProv">Spedizione Prov</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="queueAccount in vm.queueAccounts track by queueAccount.id"><td><a ui-sref="queue-account-detail({id:queueAccount.id})">{{queueAccount.id}}</a></td><td>{{queueAccount.idQueue}}</td><td>{{queueAccount.error_list}}</td><td>{{queueAccount.nome}}</td><td>{{queueAccount.cognome}}</td><td>{{queueAccount.cf}}</td><td>{{queueAccount.dtNascita | date:\'medium\'}}</td><td>{{queueAccount.numIscrizione}}</td><td>{{queueAccount.telefono}}</td><td>{{queueAccount.cellulare}}</td><td>{{queueAccount.fax}}</td><td>{{queueAccount.email}}</td><td>{{queueAccount.email2}}</td><td>{{queueAccount.attivita}}</td><td>{{queueAccount.precontattogg}}</td><td>{{queueAccount.precontattoOrario1}}</td><td>{{queueAccount.precontattoOrario2}}</td><td>{{queueAccount.ricerchegg}}</td><td>{{queueAccount.ricercheOrario}}</td><td>{{queueAccount.isfgg}}</td><td>{{queueAccount.isfOrario}}</td><td>{{queueAccount.note}}</td><td>{{queueAccount.dispositivo}}</td><td>{{queueAccount.dispositivoOs}}</td><td>{{queueAccount.tablet}}</td><td>{{queueAccount.tabletOs}}</td><td>{{queueAccount.tv}}</td><td>{{queueAccount.canaliTv}}</td><td>{{queueAccount.comune}}</td><td>{{queueAccount.cap}}</td><td>{{queueAccount.indirizzo}}</td><td>{{queueAccount.dtIns | date:\'medium\'}}</td><td>{{queueAccount.dtUpdate | date:\'medium\'}}</td><td>{{queueAccount.recallStatus}}</td><td>{{queueAccount.statusNote}}</td><td>{{queueAccount.recallDt | date:\'medium\'}}</td><td>{{queueAccount.spedizioneComune}}</td><td>{{queueAccount.spedizioneCap}}</td><td>{{queueAccount.spedizioneIndirizzo}}</td><td>{{queueAccount.spedizioneTel}}</td><td>{{queueAccount.source}}</td><td>{{queueAccount.specializzazione1}}</td><td>{{queueAccount.specializzazione2}}</td><td>{{queueAccount.specializzazione3}}</td><td>{{queueAccount.provincia}}</td><td>{{queueAccount.spedizioneProv}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="queue-account-detail({id:queueAccount.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="queue-account.edit({id:queueAccount.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="queue-account.delete({id:queueAccount.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/queue-credit/queue-credit-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.queue_credit.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="doctorclubboApp.queue_credit.delete.question" translate-values="{id: \'{{vm.queue_credit.id}}\'}">Are you sure you want to delete this Queue Credit?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/queue-credit/queue-credit-detail.html','<div><h2><span data-translate="doctorclubboApp.queue_credit.detail.title">Queue Credit</span> {{vm.queue_credit.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="doctorclubboApp.queue_credit.customer_email">Customer Email</span></dt><dd><span>{{vm.queue_credit.customer_email}}</span></dd><dt><span data-translate="doctorclubboApp.queue_credit.credit_value">Credit Value</span></dt><dd><span>{{vm.queue_credit.credit_value}}</span></dd><dt><span data-translate="doctorclubboApp.queue_credit.comment">Comment</span></dt><dd><span>{{vm.queue_credit.comment}}</span></dd><dt><span data-translate="doctorclubboApp.queue_credit.id_queue">Id Queue</span></dt><dd><span>{{vm.queue_credit.id_queue}}</span></dd><dt><span data-translate="doctorclubboApp.queue_credit.campagna">Campagna</span></dt><dd><span>{{vm.queue_credit.campagna}}</span></dd><dt><span data-translate="doctorclubboApp.queue_credit.error_list">Error List</span></dt><dd><span>{{vm.queue_credit.error_list}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="queue-credit-detail.edit({id:vm.queue_credit.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/queue-credit/queue-credit-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myQueue_creditLabel" data-translate="doctorclubboApp.queue_credit.home.createOrEditLabel">Create or edit a Queue Credit</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.queue_credit.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.queue_credit.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.queue_credit.customer_email" for="field_customer_email">Customer Email</label><input type="text" class="form-control" name="customer_email" id="field_customer_email" ng-model="vm.queue_credit.customer_email"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.queue_credit.credit_value" for="field_credit_value">Credit Value</label><input type="text" class="form-control" name="credit_value" id="field_credit_value" ng-model="vm.queue_credit.credit_value"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.queue_credit.comment" for="field_comment">Comment</label><input type="text" class="form-control" name="comment" id="field_comment" ng-model="vm.queue_credit.comment"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.queue_credit.id_queue" for="field_id_queue">Id Queue</label><input type="number" class="form-control" name="id_queue" id="field_id_queue" ng-model="vm.queue_credit.id_queue"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.queue_credit.campagna" for="field_campagna">Campagna</label><input type="text" class="form-control" name="campagna" id="field_campagna" ng-model="vm.queue_credit.campagna"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.queue_credit.error_list" for="field_error_list">Error List</label><input type="text" class="form-control" name="error_list" id="field_error_list" ng-model="vm.queue_credit.error_list"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/queue-credit/queue-credits.html','<div><h2 data-translate="doctorclubboApp.queue_credit.home.title">Queue Credits</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="queue-credit.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="doctorclubboApp.queue_credit.home.createLabel">Create new Queue Credit</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="id_queue"><span data-translate="doctorclubboApp.queue_credit.id_queue">Id Queue</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="error_list"><span data-translate="doctorclubboApp.queue_credit.error_list">Error List</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="customer_email"><span data-translate="doctorclubboApp.queue_credit.customer_email">Customer Email</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="credit_value"><span data-translate="doctorclubboApp.queue_credit.credit_value">Credit Value</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="comment"><span data-translate="doctorclubboApp.queue_credit.comment">Comment</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="campagna"><span data-translate="doctorclubboApp.queue_credit.campagna">Campagna</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="queue_credit in vm.queue_credits track by queue_credit.id"><td><a ui-sref="queue-credit-detail({id:queue_credit.id})">{{queue_credit.id}}</a></td><td>{{queue_credit.id_queue}}</td><td>{{queue_credit.error_list}}</td><td>{{queue_credit.customer_email}}</td><td>{{queue_credit.credit_value}}</td><td>{{queue_credit.comment}}</td><td>{{queue_credit.campagna}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="queue-credit-detail({id:queue_credit.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="queue-credit.edit({id:queue_credit.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="queue-credit.delete({id:queue_credit.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div><uib-pager total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pager></div>');
$templateCache.put('app/entities/queue-scheduled/queue-scheduled-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.queue_scheduled.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="doctorclubboApp.queue_scheduled.delete.question" translate-values="{id: \'{{vm.queue_scheduled.id}}\'}">Are you sure you want to delete this Queue Scheduled?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/queue-scheduled/queue-scheduled-detail.html','<div><h2><span data-translate="doctorclubboApp.queue_scheduled.detail.title">Queue Scheduled</span> {{vm.queue_scheduled.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="doctorclubboApp.queue_scheduled.dt_ins">Dt Ins</span></dt><dd><span>{{vm.queue_scheduled.dt_ins | date:\'medium\'}}</span></dd><dt><span data-translate="doctorclubboApp.queue_scheduled.queue_content">Queue Content</span></dt><dd><span>{{vm.queue_scheduled.queue_content}}</span></dd><dt><span data-translate="doctorclubboApp.queue_scheduled.ext_id">Ext Id</span></dt><dd><span>{{vm.queue_scheduled.ext_id}}</span></dd><dt><span data-translate="doctorclubboApp.queue_scheduled.int_id">Int Id</span></dt><dd><span>{{vm.queue_scheduled.int_id}}</span></dd><dt><span data-translate="doctorclubboApp.queue_scheduled.qsched_to_direction">Qsched To Direction</span></dt><dd><a ui-sref="qsched-direction-detail({id:vm.queue_scheduled.qsched_to_direction.id})">{{vm.queue_scheduled.qsched_to_direction.direction}}</a></dd><dt><span data-translate="doctorclubboApp.queue_scheduled.qsched_to_status">Qsched To Status</span></dt><dd><a ui-sref="qsched-status-detail({id:vm.queue_scheduled.qsched_to_status.id})">{{vm.queue_scheduled.qsched_to_status.name}}</a></dd><dt><span data-translate="doctorclubboApp.queue_scheduled.qsched_to_type">Qsched To Type</span></dt><dd><a ui-sref="qsched-type-detail({id:vm.queue_scheduled.qsched_to_type.id})">{{vm.queue_scheduled.qsched_to_type.name}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="queue-scheduled-detail.edit({id:vm.queue_scheduled.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/queue-scheduled/queue-scheduled-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myQueue_scheduledLabel" data-translate="doctorclubboApp.queue_scheduled.home.createOrEditLabel">Create or edit a Queue Scheduled</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.queue_scheduled.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.queue_scheduled.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.queue_scheduled.dt_ins" for="field_dt_ins">Dt Ins</label><div class="input-group"><input id="field_dt_ins" type="text" class="form-control" name="dt_ins" datetime-picker="{{dateformat}}" ng-model="vm.queue_scheduled.dt_ins" is-open="vm.datePickerOpenStatus.dt_ins"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dt_ins\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.queue_scheduled.queue_content" for="field_queue_content">Queue Content</label><input type="text" class="form-control" name="queue_content" id="field_queue_content" ng-model="vm.queue_scheduled.queue_content"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.queue_scheduled.ext_id" for="field_ext_id">Ext Id</label><input type="text" class="form-control" name="ext_id" id="field_ext_id" ng-model="vm.queue_scheduled.ext_id"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.queue_scheduled.int_id" for="field_int_id">Int Id</label><input type="text" class="form-control" name="int_id" id="field_int_id" ng-model="vm.queue_scheduled.int_id"></div><div class="form-group"><label data-translate="doctorclubboApp.queue_scheduled.qsched_to_direction" for="field_qsched_to_direction">Qsched To Direction</label><select class="form-control" id="field_qsched_to_direction" name="qsched_to_direction" ng-model="vm.queue_scheduled.qsched_to_direction" ng-options="qsched_direction as qsched_direction.direction for qsched_direction in vm.qsched_directions track by qsched_direction.id"><option value=""></option></select></div><div class="form-group"><label data-translate="doctorclubboApp.queue_scheduled.qsched_to_status" for="field_qsched_to_status">Qsched To Status</label><select class="form-control" id="field_qsched_to_status" name="qsched_to_status" ng-model="vm.queue_scheduled.qsched_to_status" ng-options="qsched_status as qsched_status.name for qsched_status in vm.qsched_statuses track by qsched_status.id"><option value=""></option></select></div><div class="form-group"><label data-translate="doctorclubboApp.queue_scheduled.qsched_to_type" for="field_qsched_to_type">Qsched To Type</label><select class="form-control" id="field_qsched_to_type" name="qsched_to_type" ng-model="vm.queue_scheduled.qsched_to_type" ng-options="qsched_type as qsched_type.name for qsched_type in vm.qsched_types track by qsched_type.id"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/queue-scheduled/queue-scheduleds.html','<div><h2 data-translate="doctorclubboApp.queue_scheduled.home.title">Queue Scheduleds</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="queue-scheduled.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="doctorclubboApp.queue_scheduled.home.createLabel">Create new Queue Scheduled</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="dt_ins"><span data-translate="doctorclubboApp.queue_scheduled.dt_ins">Dt Ins</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="queue_content"><span data-translate="doctorclubboApp.queue_scheduled.queue_content">Queue Content</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="ext_id"><span data-translate="doctorclubboApp.queue_scheduled.ext_id">Ext Id</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="int_id"><span data-translate="doctorclubboApp.queue_scheduled.int_id">Int Id</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="qsched_to_direction.id"><span data-translate="doctorclubboApp.queue_scheduled.qsched_to_direction">Qsched To Direction</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="qsched_to_status.id"><span data-translate="doctorclubboApp.queue_scheduled.qsched_to_status">Qsched To Status</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="qsched_to_type.id"><span data-translate="doctorclubboApp.queue_scheduled.qsched_to_type">Qsched To Type</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="queue_scheduled in vm.queue_scheduleds track by queue_scheduled.id"><td><a ui-sref="queue-scheduled-detail({id:queue_scheduled.id})">{{queue_scheduled.id}}</a></td><td>{{queue_scheduled.dt_ins | date:\'medium\'}}</td><td>{{queue_scheduled.queue_content}}</td><td>{{queue_scheduled.ext_id}}</td><td>{{queue_scheduled.int_id}}</td><td><a ui-sref="qsched-direction-detail({id:queue_scheduled.qsched_to_direction.id})">{{queue_scheduled.qsched_to_direction.direction}}</a></td><td><a ui-sref="qsched-status-detail({id:queue_scheduled.qsched_to_status.id})">{{queue_scheduled.qsched_to_status.name}}</a></td><td><a ui-sref="qsched-type-detail({id:queue_scheduled.qsched_to_type.id})">{{queue_scheduled.qsched_to_type.name}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="queue-scheduled-detail({id:queue_scheduled.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="queue-scheduled.edit({id:queue_scheduled.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="queue-scheduled.delete({id:queue_scheduled.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div><uib-pager total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pager></div>');
$templateCache.put('app/entities/queue-status/queue-status-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.queueStatus.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="doctorclubboApp.queueStatus.delete.question" translate-values="{id: \'{{vm.queueStatus.id}}\'}">Are you sure you want to delete this Queue Status?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/queue-status/queue-status-detail.html','<div><h2><span data-translate="doctorclubboApp.queueStatus.detail.title">Queue Status</span> {{vm.queueStatus.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="doctorclubboApp.queueStatus.status">Status</span></dt><dd><span>{{vm.queueStatus.status}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="queue-status-detail.edit({id:vm.queueStatus.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/queue-status/queue-status-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myQueueStatusLabel" data-translate="doctorclubboApp.queueStatus.home.createOrEditLabel">Create or edit a Queue Status</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.queueStatus.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.queueStatus.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.queueStatus.status" for="field_status">Status</label><input type="text" class="form-control" name="status" id="field_status" ng-model="vm.queueStatus.status"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/queue-status/queue-statuses.html','<div><h2 data-translate="doctorclubboApp.queueStatus.home.title">Queue Statuses</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="queue-status.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="doctorclubboApp.queueStatus.home.createLabel">Create new Queue Status</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="status"><span data-translate="doctorclubboApp.queueStatus.status">Status</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="queueStatus in vm.queueStatuses track by queueStatus.id"><td><a ui-sref="queue-status-detail({id:queueStatus.id})">{{queueStatus.id}}</a></td><td>{{queueStatus.status}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="queue-status-detail({id:queueStatus.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="queue-status.edit({id:queueStatus.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="queue-status.delete({id:queueStatus.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/queue-type/queue-type-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.queueType.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="doctorclubboApp.queueType.delete.question" translate-values="{id: \'{{vm.queueType.id}}\'}">Are you sure you want to delete this Queue Type?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/queue-type/queue-type-detail.html','<div><h2><span data-translate="doctorclubboApp.queueType.detail.title">Queue Type</span> {{vm.queueType.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="doctorclubboApp.queueType.type">Type</span></dt><dd><span>{{vm.queueType.type}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="queue-type-detail.edit({id:vm.queueType.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/queue-type/queue-type-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myQueueTypeLabel" data-translate="doctorclubboApp.queueType.home.createOrEditLabel">Create or edit a Queue Type</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.queueType.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.queueType.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.queueType.type" for="field_type">Type</label><input type="text" class="form-control" name="type" id="field_type" ng-model="vm.queueType.type"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/queue-type/queue-types.html','<div><h2 data-translate="doctorclubboApp.queueType.home.title">Queue Types</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="queue-type.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="doctorclubboApp.queueType.home.createLabel">Create new Queue Type</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="type"><span data-translate="doctorclubboApp.queueType.type">Type</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="queueType in vm.queueTypes track by queueType.id"><td><a ui-sref="queue-type-detail({id:queueType.id})">{{queueType.id}}</a></td><td>{{queueType.type}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="queue-type-detail({id:queueType.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="queue-type.edit({id:queueType.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="queue-type.delete({id:queueType.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/raci/raci-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.raci.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="doctorclubboApp.raci.delete.question" translate-values="{id: \'{{vm.raci.id}}\'}">Are you sure you want to delete this Raci?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/raci/raci-detail.html','<div><h2><span data-translate="doctorclubboApp.raci.detail.title">Raci</span> {{vm.raci.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="doctorclubboApp.raci.ruolo">Ruolo</span></dt><dd><span>{{vm.raci.ruolo}}</span></dd><dt><span data-translate="doctorclubboApp.raci.destinatario">Destinatario</span></dt><dd><span>{{vm.raci.destinatario}}</span></dd><dt><span data-translate="doctorclubboApp.raci.contenuto">Contenuto</span></dt><dd><span>{{vm.raci.contenuto}}</span></dd><dt><span data-translate="doctorclubboApp.raci.areaId">Area Id</span></dt><dd><a ui-sref="area-detail({id:vm.raci.areaIdId})">{{vm.raci.areaIdId}}</a></dd><dt><span data-translate="doctorclubboApp.raci.azioneId">Azione Id</span></dt><dd><a ui-sref="azione-detail({id:vm.raci.azioneIdId})">{{vm.raci.azioneIdId}}</a></dd><dt><span data-translate="doctorclubboApp.raci.campagnaStatusId">Campagna Status Id</span></dt><dd><a ui-sref="campagna-status-detail({id:vm.raci.campagnaStatusIdId})">{{vm.raci.campagnaStatus.Id}}</a></dd><dt><span data-translate="doctorclubboApp.raci.proxStatus">Prox Status</span></dt><dd><a ui-sref="campagna-status-detail({id:vm.raci.proxStatusId})">{{vm.raci.proxStatusId}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="raci-detail.edit({id:vm.raci.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/raci/raci-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myRaciLabel" data-translate="doctorclubboApp.raci.home.createOrEditLabel">Create or edit a Raci</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.raci.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.raci.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.raci.ruolo" for="field_ruolo">Ruolo</label><input type="text" class="form-control" name="ruolo" id="field_ruolo" ng-model="vm.raci.ruolo"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.raci.destinatario" for="field_destinatario">Destinatario</label><input type="text" class="form-control" name="destinatario" id="field_destinatario" ng-model="vm.raci.destinatario"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.raci.contenuto" for="field_contenuto">Contenuto</label><input type="text" class="form-control" name="contenuto" id="field_contenuto" ng-model="vm.raci.contenuto"></div><div class="form-group"><label data-translate="doctorclubboApp.raci.areaId" for="field_areaId">Area Id</label><select class="form-control" id="field_areaId" name="areaId" ng-model="vm.raci.areaId" ng-options="area.id as area.id for area in vm.areas"><option value=""></option></select></div><div class="form-group"><label data-translate="doctorclubboApp.raci.azioneId" for="field_azioneId">Azione Id</label><select class="form-control" id="field_azioneId" name="azioneId" ng-model="vm.raci.azioneId" ng-options="azione.id as azione.id for azione in vm.aziones"><option value=""></option></select></div><div class="form-group"><label data-translate="doctorclubboApp.raci.campagnaStatusId" for="field_campagnaStatusId">Campagna Status Id</label><select class="form-control" id="field_campagnaStatusId" name="campagnaStatusId" ng-model="vm.raci.campagnaStatusId" ng-options="campagna_status.id as campagna_status.id for campagna_status in vm.campagna_statuses"><option value=""></option></select></div><div class="form-group"><label data-translate="doctorclubboApp.raci.proxStatus" for="field_proxStatus">Prox Status</label><select class="form-control" id="field_proxStatus" name="proxStatus" ng-model="vm.raci.proxStatusId" ng-options="campagna_status.id as campagna_status.id for campagna_status in vm.campagna_statuses"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/raci/racis.html','<div><h2 data-translate="doctorclubboApp.raci.home.title">Racis</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="raci.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="doctorclubboApp.raci.home.createLabel">Create new Raci</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="ruolo"><span data-translate="doctorclubboApp.raci.ruolo">Ruolo</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="destinatario"><span data-translate="doctorclubboApp.raci.destinatario">Destinatario</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="contenuto"><span data-translate="doctorclubboApp.raci.contenuto">Contenuto</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="areaIdId"><span data-translate="doctorclubboApp.raci.areaId">Area Id</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="azioneIdId"><span data-translate="doctorclubboApp.raci.azioneId">Azione Id</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="campagnaStatusIdId"><span data-translate="doctorclubboApp.raci.campagnaStatusId">Campagna Status Id</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="proxStatusId"><span data-translate="doctorclubboApp.raci.proxStatus">Prox Status</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="raci in vm.racis track by raci.id"><td><a ui-sref="raci-detail({id:raci.id})">{{raci.id}}</a></td><td>{{raci.ruolo}}</td><td>{{raci.destinatario}}</td><td>{{raci.contenuto}}</td><td><a ui-sref="area-detail({id:raci.areaIdId})">{{raci.areaId}}</a></td><td><a ui-sref="azione-detail({id:raci.azioneIdId})">{{raci.azioneId}}</a></td><td><a ui-sref="campagna-status-detail({id:raci.campagnaStatusIdId})">{{raci.campagnaStatusId}}</a></td><td><a ui-sref="campagna-status-detail({id:raci.proxStatusId})">{{raci.proxStatusId}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="raci-detail({id:raci.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="raci.edit({id:raci.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="raci.delete({id:raci.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div><uib-pager total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pager></div>');
$templateCache.put('app/entities/recall-status/recall-status-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.recall_status.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="doctorclubboApp.recall_status.delete.question" translate-values="{id: \'{{vm.recall_status.id}}\'}">Are you sure you want to delete this Recall Status?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/recall-status/recall-status-detail.html','<div><h2><span data-translate="doctorclubboApp.recall_status.detail.title">Recall Status</span> {{vm.recall_status.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="doctorclubboApp.recall_status.code">Code</span></dt><dd><span>{{vm.recall_status.code}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="recall-status-detail.edit({id:vm.recall_status.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/recall-status/recall-status-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myRecall_statusLabel" data-translate="doctorclubboApp.recall_status.home.createOrEditLabel">Create or edit a Recall Status</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.recall_status.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.recall_status.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.recall_status.code" for="field_code">Code</label><input type="text" class="form-control" name="code" id="field_code" ng-model="vm.recall_status.code"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/recall-status/recall-statuses.html','<div><h2 data-translate="doctorclubboApp.recall_status.home.title">Recall Statuses</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="recall-status.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="doctorclubboApp.recall_status.home.createLabel">Create new Recall Status</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="doctorclubboApp.recall_status.code">Code</span></th><th></th></tr></thead><tbody><tr ng-repeat="recall_status in vm.recall_statuses track by recall_status.id"><td><a ui-sref="recall-status-detail({id:recall_status.id})">{{recall_status.id}}</a></td><td>{{recall_status.code}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="recall-status-detail({id:recall_status.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="recall-status.edit({id:recall_status.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="recall-status.delete({id:recall_status.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/sistema/sistema-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.sistema.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="doctorclubboApp.sistema.delete.question" translate-values="{id: \'{{vm.sistema.id}}\'}">Are you sure you want to delete this Sistema?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/sistema/sistema-detail.html','<div><h2><span data-translate="doctorclubboApp.sistema.detail.title">Sistema</span> {{vm.sistema.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="doctorclubboApp.sistema.nome">Nome</span></dt><dd><span>{{vm.sistema.nome}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="sistema-detail.edit({id:vm.sistema.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/sistema/sistema-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="mySistemaLabel" data-translate="doctorclubboApp.sistema.home.createOrEditLabel">Create or edit a Sistema</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.sistema.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.sistema.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.sistema.nome" for="field_nome">Nome</label><input type="text" class="form-control" name="nome" id="field_nome" ng-model="vm.sistema.nome"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/sistema/sistemas.html','<div><h2 data-translate="doctorclubboApp.sistema.home.title">Sistemas</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="sistema.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="doctorclubboApp.sistema.home.createLabel">Create new Sistema</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="doctorclubboApp.sistema.nome">Nome</span></th><th></th></tr></thead><tbody><tr ng-repeat="sistema in vm.sistemas track by sistema.id"><td><a ui-sref="sistema-detail({id:sistema.id})">{{sistema.id}}</a></td><td>{{sistema.nome}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="sistema-detail({id:sistema.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="sistema.edit({id:sistema.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="sistema.delete({id:sistema.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/specializzazione/specializzazione-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.specializzazione.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="doctorclubboApp.specializzazione.delete.question" translate-values="{id: \'{{vm.specializzazione.id}}\'}">Are you sure you want to delete this Specializzazione?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/specializzazione/specializzazione-detail.html','<div><h2><span data-translate="doctorclubboApp.specializzazione.detail.title">Specializzazione</span> {{vm.specializzazione.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="doctorclubboApp.specializzazione.nome">Nome</span></dt><dd><span>{{vm.specializzazione.nome}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="specializzazione-detail.edit({id:vm.specializzazione.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/specializzazione/specializzazione-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="mySpecializzazioneLabel" data-translate="doctorclubboApp.specializzazione.home.createOrEditLabel">Create or edit a Specializzazione</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.specializzazione.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.specializzazione.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.specializzazione.nome" for="field_nome">Nome</label><input type="text" class="form-control" name="nome" id="field_nome" ng-model="vm.specializzazione.nome"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/specializzazione/specializzaziones.html','<div><h2 data-translate="doctorclubboApp.specializzazione.home.title">Specializzaziones</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="specializzazione.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="doctorclubboApp.specializzazione.home.createLabel">Create new Specializzazione</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nome"><span data-translate="doctorclubboApp.specializzazione.nome">Nome</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="specializzazione in vm.specializzaziones track by specializzazione.id"><td><a ui-sref="specializzazione-detail({id:specializzazione.id})">{{specializzazione.id}}</a></td><td>{{specializzazione.nome}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="specializzazione-detail({id:specializzazione.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="specializzazione.edit({id:specializzazione.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="specializzazione.delete({id:specializzazione.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/statement/statement-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.statement.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="doctorclubboApp.statement.delete.question" translate-values="{id: \'{{vm.statement.id}}\'}">Are you sure you want to delete this Statement?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/statement/statement-detail.html','<div><h2><span data-translate="doctorclubboApp.statement.detail.title">Statement</span> {{vm.statement.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="doctorclubboApp.statement.dtIns">Dt Ins</span></dt><dd><span>{{vm.statement.dtIns | date:\'medium\'}}</span></dd><dt><span data-translate="doctorclubboApp.statement.amount">Amount</span></dt><dd><span>{{vm.statement.amount}}</span></dd><dt><span data-translate="doctorclubboApp.statement.idUser">Id User</span></dt><dd><span>{{vm.statement.idUser}}</span></dd><dt><span data-translate="doctorclubboApp.statement.balance">Balance</span></dt><dd><span>{{vm.statement.balance}}</span></dd><dt><span data-translate="doctorclubboApp.statement.queueId">Queue Id</span></dt><dd><span>{{vm.statement.queueId}}</span></dd><dt><span data-translate="doctorclubboApp.statement.description">Description</span></dt><dd><span>{{vm.statement.description}}</span></dd><dt><span data-translate="doctorclubboApp.statement.type">Type</span></dt><dd><span>{{vm.statement.type}}</span></dd><dt><span data-translate="doctorclubboApp.statement.sign">Sign</span></dt><dd><span>{{vm.statement.sign}}</span></dd><dt><span data-translate="doctorclubboApp.statement.externalRefId">External Ref Id</span></dt><dd><span>{{vm.statement.externalRefId}}</span></dd><dt><span data-translate="doctorclubboApp.statement.campaignId">Campaign Id</span></dt><dd><span>{{vm.statement.campaignId}}</span></dd><dt><span data-translate="doctorclubboApp.statement.agencyId">Agency Id</span></dt><dd><span>{{vm.statement.agencyId}}</span></dd><dt><span data-translate="doctorclubboApp.statement.currency">Currency</span></dt><dd><span>{{vm.statement.currency}}</span></dd><dt><span data-translate="doctorclubboApp.statement.bo_user_id">Bo User Id</span></dt><dd><span>{{vm.statement.bo_user_id}}</span></dd><dt><span data-translate="doctorclubboApp.statement.statement_utente">Statement Utente</span></dt><dd><a ui-sref="utente-detail({id:vm.statement.statement_utente.id})">{{vm.statement.statement_utente.login}}</a></dd><dt><span data-translate="doctorclubboApp.statement.statement_queue">Statement Queue</span></dt><dd><a ui-sref="queue-detail({id:vm.statement.statement_queue.id})">{{vm.statement.statement_queue.name}}</a></dd><dt><span data-translate="doctorclubboApp.statement.statement_type">Statement Type</span></dt><dd><a ui-sref="statement-type-detail({id:vm.statement.statement_type.id})">{{vm.statement.statement_type.type}}</a></dd><dt><span data-translate="doctorclubboApp.statement.statement_campagna">Statement Campagna</span></dt><dd><a ui-sref="campagna-detail({id:vm.statement.statement_campagna.id})">{{vm.statement.statement_campagna.codice}}</a></dd><dt><span data-translate="doctorclubboApp.statement.statement_agenzia">Statement Agenzia</span></dt><dd><a ui-sref="agenzia-detail({id:vm.statement.statement_agenzia.id})">{{vm.statement.statement_agenzia.nome}}</a></dd><dt><span data-translate="doctorclubboApp.statement.statement_bouser">Statement Bouser</span></dt><dd><a ui-sref="jhi-user-detail({id:vm.statement.statement_bouser.id})">{{vm.statement.statement_bouser.login}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="statement-detail.edit({id:vm.statement.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/statement/statement-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myStatementLabel" data-translate="doctorclubboApp.statement.home.createOrEditLabel">Create or edit a Statement</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.statement.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.statement.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.statement.dtIns" for="field_dtIns">Dt Ins</label><div class="input-group"><input id="field_dtIns" type="text" class="form-control" name="dtIns" datetime-picker="{{dateformat}}" ng-model="vm.statement.dtIns" is-open="vm.datePickerOpenStatus.dtIns"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dtIns\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.statement.amount" for="field_amount">Amount</label><input type="number" class="form-control" name="amount" id="field_amount" ng-model="vm.statement.amount"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.statement.balance" for="field_balance">Balance</label><input type="number" class="form-control" name="balance" id="field_balance" ng-model="vm.statement.balance"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.statement.description" for="field_description">Description</label><input type="text" class="form-control" name="description" id="field_description" ng-model="vm.statement.description"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.statement.sign" for="field_sign">Sign</label><input type="text" class="form-control" name="sign" id="field_sign" ng-model="vm.statement.sign"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.statement.externalRefId" for="field_externalRefId">External Ref Id</label><input type="number" class="form-control" name="externalRefId" id="field_externalRefId" ng-model="vm.statement.externalRefId"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.statement.currency" for="field_currency">Currency</label><input type="text" class="form-control" name="currency" id="field_currency" ng-model="vm.statement.currency"></div><div class="form-group"><label data-translate="doctorclubboApp.statement.statement_utente" for="field_statement_utente">Statement Utente</label><select class="form-control" id="field_statement_utente" name="statement_utente" ng-model="vm.statement.statement_utente" ng-options="utente as utente.email for utente in vm.utentes track by utente.id"><option value=""></option></select></div><div class="form-group"><label data-translate="doctorclubboApp.statement.statement_queue" for="field_statement_queue">Statement Queue</label><select class="form-control" id="field_statement_queue" name="statement_queue" ng-model="vm.statement.statement_queue" ng-options="queue as queue.name for queue in vm.queues track by queue.id"><option value=""></option></select></div><div class="form-group"><label data-translate="doctorclubboApp.statement.statement_type" for="field_statement_type">Statement Type</label><select class="form-control" id="field_statement_type" name="statement_type" ng-model="vm.statement.statement_type" ng-options="statement_type as statement_type.type for statement_type in vm.statement_types track by statement_type.id"><option value=""></option></select></div><div class="form-group"><label data-translate="doctorclubboApp.statement.statement_campagna" for="field_statement_campagna">Statement Campagna</label><select class="form-control" id="field_statement_campagna" name="statement_campagna" ng-model="vm.statement.statement_campagna" ng-options="campagna as campagna.codice for campagna in vm.campagnas track by campagna.id"><option value=""></option></select></div><div class="form-group"><label data-translate="doctorclubboApp.statement.statement_agenzia" for="field_statement_agenzia">Statement Agenzia</label><select class="form-control" id="field_statement_agenzia" name="statement_agenzia" ng-model="vm.statement.statement_agenzia" ng-options="agenzia as agenzia.nome for agenzia in vm.agenzias track by agenzia.id"><option value=""></option></select></div><div class="form-group"><label data-translate="doctorclubboApp.statement.statement_bouser" for="field_statement_bouser">Statement Bouser</label><select class="form-control" id="field_statement_bouser" name="statement_bouser" ng-model="vm.statement.statement_bouser" ng-options="jhi_user as jhi_user.login for jhi_user in vm.jhi_users track by jhi_user.id"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/statement/statements.html','<div><h2 data-translate="doctorclubboApp.statement.home.title">Statements</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="statement.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="doctorclubboApp.statement.home.createLabel">Create new Statement</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="dtIns"><span data-translate="doctorclubboApp.statement.dtIns">Dt Ins</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="amount"><span data-translate="doctorclubboApp.statement.amount">Amount</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="balance"><span data-translate="doctorclubboApp.statement.balance">Balance</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="description"><span data-translate="doctorclubboApp.statement.description">Description</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="sign"><span data-translate="doctorclubboApp.statement.sign">Sign</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="externalRefId"><span data-translate="doctorclubboApp.statement.externalRefId">External Ref Id</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="currency"><span data-translate="doctorclubboApp.statement.currency">Currency</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="ticketid"><span data-translate="Ticketid">TicketId</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="statement_utente.id"><span data-translate="doctorclubboApp.statement.statement_utente">Statement Utente</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="statement_queue.id"><span data-translate="doctorclubboApp.statement.statement_queue">Statement Queue</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="statement_type.id"><span data-translate="doctorclubboApp.statement.statement_type">Statement Type</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="statement_campagna.id"><span data-translate="doctorclubboApp.statement.statement_campagna">Statement Campagna</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="statement_agenzia.id"><span data-translate="doctorclubboApp.statement.statement_agenzia">Statement Agenzia</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="statement_bouser.id"><span data-translate="doctorclubboApp.statement.statement_bouser">Statement Bouser</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="statement in vm.statements track by statement.id"><td><a ui-sref="statement-detail({id:statement.id})">{{statement.id}}</a></td><td>{{statement.dtIns | date:\'medium\'}}</td><td>{{statement.amount}}</td><td>{{statement.balance}}</td><td>{{statement.description}}</td><td>{{statement.sign}}</td><td>{{statement.externalRefId}}</td><td>{{statement.currency}}</td><td>{{statement.ticketid}}</td><td><a ui-sref="utente-detail({id:statement.statement_utente.id})">{{statement.statement_utente.email}}</a></td><td><a ui-sref="queue-detail({id:statement.statement_queue.id})">{{statement.statement_queue.name}}</a></td><td><a ui-sref="statement-type-detail({id:statement.statement_type.id})">{{statement.statement_type.type}}</a></td><td><a ui-sref="campagna-detail({id:statement.statement_campagna.id})">{{statement.statement_campagna.codice}}</a></td><td><a ui-sref="agenzia-detail({id:statement.statement_agenzia.id})">{{statement.statement_agenzia.nome}}</a></td><td><a ui-sref="jhi-user-detail({id:statement.statement_bouser.id})">{{statement.statement_bouser.login}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="statement-detail({id:statement.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="statement.edit({id:statement.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="statement.delete({id:statement.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/statement-type/statement-type-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.statementType.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="doctorclubboApp.statementType.delete.question" translate-values="{id: \'{{vm.statementType.id}}\'}">Are you sure you want to delete this Statement Type?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/statement-type/statement-type-detail.html','<div><h2><span data-translate="doctorclubboApp.statementType.detail.title">Statement Type</span> {{vm.statementType.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="doctorclubboApp.statementType.type">Type</span></dt><dd><span>{{vm.statementType.type}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="statement-type-detail.edit({id:vm.statementType.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/statement-type/statement-type-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myStatementTypeLabel" data-translate="doctorclubboApp.statementType.home.createOrEditLabel">Create or edit a Statement Type</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.statementType.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.statementType.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.statementType.type" for="field_type">Type</label><input type="text" class="form-control" name="type" id="field_type" ng-model="vm.statementType.type"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/statement-type/statement-types.html','<div><h2 data-translate="doctorclubboApp.statementType.home.title">Statement Types</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="statement-type.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="doctorclubboApp.statementType.home.createLabel">Create new Statement Type</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="type"><span data-translate="doctorclubboApp.statementType.type">Type</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="statementType in vm.statementTypes track by statementType.id"><td><a ui-sref="statement-type-detail({id:statementType.id})">{{statementType.id}}</a></td><td>{{statementType.type}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="statement-type-detail({id:statementType.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="statement-type.edit({id:statementType.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="statement-type.delete({id:statementType.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/tablet/tablet-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.tablet.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="doctorclubboApp.tablet.delete.question" translate-values="{id: \'{{vm.tablet.id}}\'}">Are you sure you want to delete this Tablet?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/tablet/tablet-detail.html','<div><h2><span data-translate="doctorclubboApp.tablet.detail.title">Tablet</span> {{vm.tablet.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="doctorclubboApp.tablet.tablet">Tablet</span></dt><dd><span>{{vm.tablet.tablet}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="tablet-detail.edit({id:vm.tablet.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/tablet/tablet-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myTabletLabel" data-translate="doctorclubboApp.tablet.home.createOrEditLabel">Create or edit a Tablet</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.tablet.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.tablet.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.tablet.tablet" for="field_tablet">Tablet</label><input type="text" class="form-control" name="tablet" id="field_tablet" ng-model="vm.tablet.tablet"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/tablet/tablets.html','<div><h2 data-translate="doctorclubboApp.tablet.home.title">Tablets</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="tablet.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="doctorclubboApp.tablet.home.createLabel">Create new Tablet</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="doctorclubboApp.tablet.tablet">Tablet</span></th><th></th></tr></thead><tbody><tr ng-repeat="tablet in vm.tablets track by tablet.id"><td><a ui-sref="tablet-detail({id:tablet.id})">{{tablet.id}}</a></td><td>{{tablet.tablet}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="tablet-detail({id:tablet.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="tablet.edit({id:tablet.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="tablet.delete({id:tablet.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/ticket/ticket-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.ticket.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="doctorclubboApp.ticket.delete.question" translate-values="{id: \'{{vm.ticket.id}}\'}">Are you sure you want to delete this Ticket?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/ticket/ticket-detail.html','<div><h2><span data-translate="doctorclubboApp.ticket.detail.title">Ticket</span> {{vm.ticket.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="doctorclubboApp.ticket.codice">Codice</span></dt><dd><span>{{vm.ticket.codice}}</span></dd><dt><span data-translate="doctorclubboApp.ticket.dtins">Dtins</span></dt><dd><span>{{vm.ticket.dtins | date:\'medium\'}}</span></dd><dt><span data-translate="doctorclubboApp.ticket.dtend">Dtend</span></dt><dd><span>{{vm.ticket.dtend | date:\'medium\'}}</span></dd><dt><span data-translate="doctorclubboApp.ticket.importo">Importo</span></dt><dd><span>{{vm.ticket.importo}}</span></dd><dt><span data-translate="doctorclubboApp.ticket.importousato">Importousato</span></dt><dd><span>{{vm.ticket.importousato}}</span></dd><dt><span data-translate="doctorclubboApp.ticket.statusid">Statusid</span></dt><dd><span>{{vm.ticket.statusid}}</span></dd><dt><span data-translate="doctorclubboApp.ticket.idcampagna">Idcampagna</span></dt><dd><span>{{vm.ticket.idcampagna}}</span></dd><dt><span data-translate="doctorclubboApp.ticket.parentid">Parentid</span></dt><dd><span>{{vm.ticket.parentid}}</span></dd><dt><span data-translate="doctorclubboApp.ticket.idemissione">Idemissione</span></dt><dd><span>{{vm.ticket.idemissione}}</span></dd><dt><span data-translate="doctorclubboApp.ticket.ticket_ticketstatus">Ticket Ticketstatus</span></dt><dd><a ui-sref="ticket-status-detail({id:vm.ticket.ticket_ticketstatus.id})">{{vm.ticket.ticket_ticketstatus.id}}</a></dd><dt><span data-translate="doctorclubboApp.ticket.ticket_campagna">Ticket Campagna</span></dt><dd><a ui-sref="campagna-detail({id:vm.ticket.ticket_campagna.id})">{{vm.ticket.ticket_campagna.id}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="ticket-detail.edit({id:vm.ticket.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/ticket/ticket-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myTicketLabel" data-translate="doctorclubboApp.ticket.home.createOrEditLabel">Create or edit a Ticket</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.ticket.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.ticket.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.ticket.codice" for="field_codice">Codice</label><input type="text" class="form-control" name="codice" id="field_codice" ng-model="vm.ticket.codice"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.ticket.dtins" for="field_dtins">Dtins</label><div class="input-group"><input id="field_dtins" type="text" class="form-control" name="dtins" datetime-picker="{{dateformat}}" ng-model="vm.ticket.dtins" is-open="vm.datePickerOpenStatus.dtins"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dtins\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.ticket.dtend" for="field_dtend">Dtend</label><div class="input-group"><input id="field_dtend" type="text" class="form-control" name="dtend" datetime-picker="{{dateformat}}" ng-model="vm.ticket.dtend" is-open="vm.datePickerOpenStatus.dtend"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dtend\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.ticket.importo" for="field_importo">Importo</label><input type="number" class="form-control" name="importo" id="field_importo" ng-model="vm.ticket.importo"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.ticket.importousato" for="field_importousato">Importousato</label><input type="number" class="form-control" name="importousato" id="field_importousato" ng-model="vm.ticket.importousato"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.ticket.statusid" for="field_statusid">Statusid</label><input type="number" class="form-control" name="statusid" id="field_statusid" ng-model="vm.ticket.statusid"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.ticket.idcampagna" for="field_idcampagna">Idcampagna</label><input type="number" class="form-control" name="idcampagna" id="field_idcampagna" ng-model="vm.ticket.idcampagna"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.ticket.parentid" for="field_parentid">Parentid</label><input type="number" class="form-control" name="parentid" id="field_parentid" ng-model="vm.ticket.parentid"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.ticket.idemissione" for="field_idemissione">Idemissione</label><input type="number" class="form-control" name="idemissione" id="field_idemissione" ng-model="vm.ticket.idemissione"></div><div class="form-group"><label data-translate="doctorclubboApp.ticket.ticket_ticketstatus" for="field_ticket_ticketstatus">Ticket Ticketstatus</label><select class="form-control" id="field_ticket_ticketstatus" name="ticket_ticketstatus" ng-model="vm.ticket.ticket_ticketstatus" ng-options="ticket_status as ticket_status.id for ticket_status in vm.ticket_statuses track by ticket_status.id"><option value=""></option></select></div><div class="form-group"><label data-translate="doctorclubboApp.ticket.ticket_campagna" for="field_ticket_campagna">Ticket Campagna</label><select class="form-control" id="field_ticket_campagna" name="ticket_campagna" ng-model="vm.ticket.ticket_campagna" ng-options="campagna as campagna.id for campagna in vm.campagnas track by campagna.id"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/ticket/tickets.html','<div><h2 data-translate="doctorclubboApp.ticket.home.title">Tickets</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="ticket.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="doctorclubboApp.ticket.home.createLabel">Create new Ticket</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="codice"><span data-translate="doctorclubboApp.ticket.codice">Codice</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="dtins"><span data-translate="doctorclubboApp.ticket.dtins">Dtins</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="dtend"><span data-translate="doctorclubboApp.ticket.dtend">Dtend</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="importo"><span data-translate="doctorclubboApp.ticket.importo">Importo</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="importousato"><span data-translate="doctorclubboApp.ticket.importousato">Importousato</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="statusid"><span data-translate="doctorclubboApp.ticket.statusid">Statusid</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="idcampagna"><span data-translate="doctorclubboApp.ticket.idcampagna">Idcampagna</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="parentid"><span data-translate="doctorclubboApp.ticket.parentid">Parentid</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="idemissione"><span data-translate="doctorclubboApp.ticket.idemissione">Idemissione</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="ticket_ticketstatus.id"><span data-translate="doctorclubboApp.ticket.ticket_ticketstatus">Ticket Ticketstatus</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="ticket_campagna.id"><span data-translate="doctorclubboApp.ticket.ticket_campagna">Ticket Campagna</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="ticket in vm.tickets track by ticket.id"><td><a ui-sref="ticket-detail({id:ticket.id})">{{ticket.id}}</a></td><td>{{ticket.codice}}</td><td>{{ticket.dtins | date:\'medium\'}}</td><td>{{ticket.dtend | date:\'medium\'}}</td><td>{{ticket.importo}}</td><td>{{ticket.importousato}}</td><td>{{ticket.statusid}}</td><td>{{ticket.idcampagna}}</td><td>{{ticket.parentid}}</td><td>{{ticket.idemissione}}</td><td><a ui-sref="ticket-status-detail({id:ticket.ticket_ticketstatus.id})">{{ticket.ticket_ticketstatus.id}}</a></td><td><a ui-sref="campagna-detail({id:ticket.ticket_campagna.id})">{{ticket.ticket_campagna.id}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="ticket-detail({id:ticket.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="ticket.edit({id:ticket.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="ticket.delete({id:ticket.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div><uib-pager total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pager></div>');
$templateCache.put('app/entities/ticket-status/ticket-status-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.ticket_status.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="doctorclubboApp.ticket_status.delete.question" translate-values="{id: \'{{vm.ticket_status.id}}\'}">Are you sure you want to delete this Ticket Status?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/ticket-status/ticket-status-detail.html','<div><h2><span data-translate="doctorclubboApp.ticket_status.detail.title">Ticket Status</span> {{vm.ticket_status.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="doctorclubboApp.ticket_status.status">Status</span></dt><dd><span>{{vm.ticket_status.status}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="ticket-status-detail.edit({id:vm.ticket_status.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/ticket-status/ticket-status-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myTicket_statusLabel" data-translate="doctorclubboApp.ticket_status.home.createOrEditLabel">Create or edit a Ticket Status</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.ticket_status.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.ticket_status.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.ticket_status.status" for="field_status">Status</label><input type="text" class="form-control" name="status" id="field_status" ng-model="vm.ticket_status.status"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/ticket-status/ticket-statuses.html','<div><h2 data-translate="doctorclubboApp.ticket_status.home.title">Ticket Statuses</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="ticket-status.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="doctorclubboApp.ticket_status.home.createLabel">Create new Ticket Status</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="doctorclubboApp.ticket_status.status">Status</span></th><th></th></tr></thead><tbody><tr ng-repeat="ticket_status in vm.ticket_statuses track by ticket_status.id"><td><a ui-sref="ticket-status-detail({id:ticket_status.id})">{{ticket_status.id}}</a></td><td>{{ticket_status.status}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="ticket-status-detail({id:ticket_status.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="ticket-status.edit({id:ticket_status.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="ticket-status.delete({id:ticket_status.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/tv/tv-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.tv.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="doctorclubboApp.tv.delete.question" translate-values="{id: \'{{vm.tv.id}}\'}">Are you sure you want to delete this Tv?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/tv/tv-detail.html','<div><h2><span data-translate="doctorclubboApp.tv.detail.title">Tv</span> {{vm.tv.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="doctorclubboApp.tv.tv">Tv</span></dt><dd><span>{{vm.tv.tv}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="tv-detail.edit({id:vm.tv.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/tv/tv-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myTvLabel" data-translate="doctorclubboApp.tv.home.createOrEditLabel">Create or edit a Tv</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.tv.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.tv.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.tv.tv" for="field_tv">Tv</label><input type="text" class="form-control" name="tv" id="field_tv" ng-model="vm.tv.tv"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/tv/tvs.html','<div><h2 data-translate="doctorclubboApp.tv.home.title">Tvs</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="tv.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="doctorclubboApp.tv.home.createLabel">Create new Tv</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="doctorclubboApp.tv.tv">Tv</span></th><th></th></tr></thead><tbody><tr ng-repeat="tv in vm.tvs track by tv.id"><td><a ui-sref="tv-detail({id:tv.id})">{{tv.id}}</a></td><td>{{tv.tv}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="tv-detail({id:tv.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="tv.edit({id:tv.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="tv.delete({id:tv.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/upload/upload-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.upload.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="doctorclubboApp.upload.delete.question" translate-values="{id: \'{{vm.upload.id}}\'}">Are you sure you want to delete this Upload?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/upload/upload-detail.html','<div><h2><span data-translate="doctorclubboApp.upload.detail.title">Upload</span> {{vm.upload.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="doctorclubboApp.upload.nome">Nome</span></dt><dd><span>{{vm.upload.nome}}</span></dd><dt><span data-translate="doctorclubboApp.upload.file">File</span></dt><dd><span>{{vm.upload.file}}</span></dd><dt><span data-translate="doctorclubboApp.upload.agenzia">Agenzia</span></dt><dd><a ui-sref="agenzia-detail({id:vm.upload.agenziaId})">{{vm.upload.agenziaId}}</a></dd><dt><span data-translate="doctorclubboApp.upload.campagna">Campagna</span></dt><dd><a ui-sref="campagna-detail({id:vm.upload.campagnaId})">{{vm.upload.campagnaId}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="upload-detail.edit({id:vm.upload.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/upload/upload-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myUploadLabel" data-translate="doctorclubboApp.upload.home.createOrEditLabel">Create or edit a Upload</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.upload.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.upload.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.upload.nome" for="field_nome">Nome</label><input type="text" class="form-control" name="nome" id="field_nome" ng-model="vm.upload.nome"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.upload.file" for="field_file">File</label><input type="text" class="form-control" name="file" id="field_file" ng-model="vm.upload.file"></div><div class="form-group"><label data-translate="doctorclubboApp.upload.agenzia" for="field_agenzia">Agenzia</label><select class="form-control" id="field_agenzia" name="agenzia" ng-model="vm.upload.agenziaId" ng-options="agenzia.id as agenzia.id for agenzia in vm.agenzias"><option value=""></option></select></div><div class="form-group"><label data-translate="doctorclubboApp.upload.campagna" for="field_campagna">Campagna</label><select class="form-control" id="field_campagna" name="campagna" ng-model="vm.upload.campagnaId" ng-options="campagna.id as campagna.id for campagna in vm.campagnas"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/upload/uploads.html','<div><h2 data-translate="doctorclubboApp.upload.home.title">Uploads</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="upload.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="doctorclubboApp.upload.home.createLabel">Create new Upload</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nome"><span data-translate="doctorclubboApp.upload.nome">Nome</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="file"><span data-translate="doctorclubboApp.upload.file">File</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="agenziaId"><span data-translate="doctorclubboApp.upload.agenzia">Agenzia</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="campagnaId"><span data-translate="doctorclubboApp.upload.campagna">Campagna</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="upload in vm.uploads track by upload.id"><td><a ui-sref="upload-detail({id:upload.id})">{{upload.id}}</a></td><td>{{upload.nome}}</td><td>{{upload.file}}</td><td><a ui-sref="agenzia-detail({id:upload.agenziaId})">{{upload.agenziaId}}</a></td><td><a ui-sref="campagna-detail({id:upload.campagnaId})">{{upload.campagnaId}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="upload-detail({id:upload.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="upload.edit({id:upload.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="upload.delete({id:upload.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div><uib-pager total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pager></div>');
$templateCache.put('app/entities/utente/utente-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.utente.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="doctorclubboApp.utente.delete.question" translate-values="{id: \'{{vm.utente.id}}\'}">Are you sure you want to delete this Utente?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/utente/utente-detail.html','<div><h2><span data-translate="doctorclubboApp.utente.detail.title">Utente</span> {{vm.utente.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="doctorclubboApp.utente.nome">Nome</span></dt><dd><span>{{vm.utente.nome}}</span></dd><dt><span data-translate="doctorclubboApp.utente.cognome">Cognome</span></dt><dd><span>{{vm.utente.cognome}}</span></dd><dt><span data-translate="doctorclubboApp.utente.cf">Cf</span></dt><dd><span>{{vm.utente.cf}}</span></dd><dt><span data-translate="doctorclubboApp.utente.dtNascita">Dt Nascita</span></dt><dd><span>{{vm.utente.dtNascita | date:\'medium\'}}</span></dd><dt><span data-translate="doctorclubboApp.utente.numIscrizione">Num Iscrizione</span></dt><dd><span>{{vm.utente.numIscrizione}}</span></dd><dt><span data-translate="doctorclubboApp.utente.telefono">Telefono</span></dt><dd><span>{{vm.utente.telefono}}</span></dd><dt><span data-translate="doctorclubboApp.utente.cellulare">Cellulare</span></dt><dd><span>{{vm.utente.cellulare}}</span></dd><dt><span data-translate="doctorclubboApp.utente.fax">Fax</span></dt><dd><span>{{vm.utente.fax}}</span></dd><dt><span data-translate="doctorclubboApp.utente.email">Email</span></dt><dd><span>{{vm.utente.email}}</span></dd><dt><span data-translate="doctorclubboApp.utente.email2">Email 2</span></dt><dd><span>{{vm.utente.email2}}</span></dd><dt><span data-translate="doctorclubboApp.utente.precontattogg">Precontattogg</span></dt><dd><span>{{vm.utente.precontattogg}}</span></dd><dt><span data-translate="doctorclubboApp.utente.precontattoOrario1">Precontatto Orario 1</span></dt><dd><span>{{vm.utente.precontattoOrario1}}</span></dd><dt><span data-translate="doctorclubboApp.utente.precontattoOrario2">Precontatto Orario 2</span></dt><dd><span>{{vm.utente.precontattoOrario2}}</span></dd><dt><span data-translate="doctorclubboApp.utente.ricerchegg">Ricerchegg</span></dt><dd><span>{{vm.utente.ricerchegg}}</span></dd><dt><span data-translate="doctorclubboApp.utente.ricercheOrario">Ricerche Orario</span></dt><dd><span>{{vm.utente.ricercheOrario}}</span></dd><dt><span data-translate="doctorclubboApp.utente.isfgg">Isfgg</span></dt><dd><span>{{vm.utente.isfgg}}</span></dd><dt><span data-translate="doctorclubboApp.utente.isfOrario">Isf Orario</span></dt><dd><span>{{vm.utente.isfOrario}}</span></dd><dt><span data-translate="doctorclubboApp.utente.note">Note</span></dt><dd><span>{{vm.utente.note}}</span></dd><dt><span data-translate="doctorclubboApp.utente.canaliTv">Canali Tv</span></dt><dd><span>{{vm.utente.canaliTv}}</span></dd><dt><span data-translate="doctorclubboApp.utente.cap">Cap</span></dt><dd><span>{{vm.utente.cap}}</span></dd><dt><span data-translate="doctorclubboApp.utente.indirizzo">Indirizzo</span></dt><dd><span>{{vm.utente.indirizzo}}</span></dd><dt><span data-translate="doctorclubboApp.utente.dtIns">Dt Ins</span></dt><dd><span>{{vm.utente.dtIns | date:\'medium\'}}</span></dd><dt><span data-translate="doctorclubboApp.utente.dtUpdate">Dt Update</span></dt><dd><span>{{vm.utente.dtUpdate | date:\'medium\'}}</span></dd><dt><span data-translate="doctorclubboApp.utente.statusNote">Status Note</span></dt><dd><span>{{vm.utente.statusNote}}</span></dd><dt><span data-translate="doctorclubboApp.utente.recallDt">Recall Dt</span></dt><dd><span>{{vm.utente.recallDt | date:\'medium\'}}</span></dd><dt><span data-translate="doctorclubboApp.utente.spedizioneCap">Spedizione Cap</span></dt><dd><span>{{vm.utente.spedizioneCap}}</span></dd><dt><span data-translate="doctorclubboApp.utente.spedizioneIndirizzo">Spedizione Indirizzo</span></dt><dd><span>{{vm.utente.spedizioneIndirizzo}}</span></dd><dt><span data-translate="doctorclubboApp.utente.spedizioneTel">Spedizione Tel</span></dt><dd><span>{{vm.utente.spedizioneTel}}</span></dd><dt><span data-translate="doctorclubboApp.utente.source">Source</span></dt><dd><span>{{vm.utente.source}}</span></dd><dt><span data-translate="doctorclubboApp.utente.balance">Balance</span></dt><dd><span>{{vm.utente.balance}}</span></dd><dt><span data-translate="doctorclubboApp.utente.externalUserid">External Userid</span></dt><dd><span>{{vm.utente.externalUserid}}</span></dd><dt><span data-translate="doctorclubboApp.utente.utente_specializzazione1">Utente Specializzazione 1</span></dt><dd><a ui-sref="specializzazione-detail({id:vm.utente.utente_specializzazione1.id})">{{vm.utente.utente_specializzazione1.nome}}</a></dd><dt><span data-translate="doctorclubboApp.utente.utente_specializzazione2">Utente Specializzazione 2</span></dt><dd><a ui-sref="specializzazione-detail({id:vm.utente.utente_specializzazione2.id})">{{vm.utente.utente_specializzazione2.nome}}</a></dd><dt><span data-translate="doctorclubboApp.utente.utente_specializzazione3">Utente Specializzazione 3</span></dt><dd><a ui-sref="specializzazione-detail({id:vm.utente.utente_specializzazione3.id})">{{vm.utente.utente_specializzazione3.nome}}</a></dd><dt><span data-translate="doctorclubboApp.utente.utente_attivita">Utente Attivita</span></dt><dd><a ui-sref="attivita-detail({id:vm.utente.utente_attivita.id})">{{vm.utente.utente_attivita.attivita}}</a></dd><dt><span data-translate="doctorclubboApp.utente.utente_dispositivo">Utente Dispositivo</span></dt><dd><a ui-sref="dispositivo-detail({id:vm.utente.utente_dispositivo.id})">{{vm.utente.utente_dispositivo.dispositivo}}</a></dd><dt><span data-translate="doctorclubboApp.utente.utente_dispositivoos">Utente Dispositivoos</span></dt><dd><a ui-sref="dispositivo-os-detail({id:vm.utente.utente_dispositivoos.id})">{{vm.utente.utente_dispositivoos.os}}</a></dd><dt><span data-translate="doctorclubboApp.utente.utente_tablet">Utente Tablet</span></dt><dd><a ui-sref="tablet-detail({id:vm.utente.utente_tablet.id})">{{vm.utente.utente_tablet.tablet}}</a></dd><dt><span data-translate="doctorclubboApp.utente.utente_tabletos">Utente Tabletos</span></dt><dd><a ui-sref="tablet-os-detail({id:vm.utente.utente_tabletos.id})">{{vm.utente.utente_tabletos.os}}</a></dd><dt><span data-translate="doctorclubboApp.utente.utente_tv">Utente Tv</span></dt><dd><a ui-sref="tv-detail({id:vm.utente.utente_tv.id})">{{vm.utente.utente_tv.tv}}</a></dd><dt><span data-translate="doctorclubboApp.utente.utente_provincia">Utente Provincia</span></dt><dd><a ui-sref="provincia-detail({id:vm.utente.utente_provincia.id})">{{vm.utente.utente_provincia.id}}</a></dd><dt><span data-translate="doctorclubboApp.utente.utente_comune">Utente Comune</span></dt><dd><a ui-sref="comune-detail({id:vm.utente.utente_comune.id})">{{vm.utente.utente_comune.comune}}</a></dd><dt><span data-translate="doctorclubboApp.utente.utente_status">Utente Status</span></dt><dd><a ui-sref="recall-status-detail({id:vm.utente.utente_status.id})">{{vm.utente.utente_status.code}}</a></dd><dt><span data-translate="doctorclubboApp.utente.utente_spedprovincia">Utente Spedprovincia</span></dt><dd><a ui-sref="provincia-detail({id:vm.utente.utente_spedprovincia.id})">{{vm.utente.utente_spedprovincia.id}}</a></dd><dt><span data-translate="doctorclubboApp.utente.utente_spedcomune">Utente Spedcomune</span></dt><dd><a ui-sref="comune-detail({id:vm.utente.utente_spedcomune.id})">{{vm.utente.utente_spedcomune.comune}}</a></dd><dt><span data-translate="doctorclubboApp.utente.utente_agenzia">Utente Agenzia</span></dt><dd><a ui-sref="agenzia-detail({id:vm.utente.utente_agenzia.id})">{{vm.utente.utente_agenzia.nome}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="utente-detail.edit({id:vm.utente.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/utente/utente-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myUtenteLabel" data-translate="doctorclubboApp.utente.home.createOrEditLabel">Create or edit a Utente</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.utente.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.utente.id" readonly="readonly"></div><div class="form-group" ng-show="vm.utente.externalUserid"><label for="id">External ID</label><input type="text" class="form-control" id="externalUserid" name="externalUserid" ng-model="vm.utente.externalUserid"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.utente.nome" for="field_nome">Nome</label><input type="text" class="form-control" name="nome" id="field_nome" ng-model="vm.utente.nome"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.utente.cognome" for="field_cognome">Cognome</label><input type="text" class="form-control" name="cognome" id="field_cognome" ng-model="vm.utente.cognome"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.utente.cf" for="field_cf">Cf</label><input type="text" class="form-control" name="cf" id="field_cf" ng-model="vm.utente.cf"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.utente.dtNascita" for="field_dtNascita">Dt Nascita</label><div class="input-group"><input id="field_dtNascita" type="text" class="form-control" name="dtNascita" datetime-picker="{{dateformat}}" ng-model="vm.utente.dtNascita" is-open="vm.datePickerOpenStatus.dtNascita"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dtNascita\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.utente.numIscrizione" for="field_numIscrizione">Num Iscrizione</label><input type="text" class="form-control" name="numIscrizione" id="field_numIscrizione" ng-model="vm.utente.numIscrizione"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.utente.telefono" for="field_telefono">Telefono</label><input type="text" class="form-control" name="telefono" id="field_telefono" ng-model="vm.utente.telefono"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.utente.cellulare" for="field_cellulare">Cellulare</label><input type="text" class="form-control" name="cellulare" id="field_cellulare" ng-model="vm.utente.cellulare"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.utente.fax" for="field_fax">Fax</label><input type="text" class="form-control" name="fax" id="field_fax" ng-model="vm.utente.fax"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.utente.email" for="field_email">Email</label><input type="text" class="form-control" name="email" id="field_email" ng-model="vm.utente.email"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.utente.email2" for="field_email2">Email 2</label><input type="text" class="form-control" name="email2" id="field_email2" ng-model="vm.utente.email2"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.utente.precontattogg" for="field_precontattogg">Precontattogg</label><input type="text" class="form-control" name="precontattogg" id="field_precontattogg" ng-model="vm.utente.precontattogg"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.utente.precontattoOrario1" for="field_precontattoOrario1">Precontatto Orario 1</label><input type="text" class="form-control" name="precontattoOrario1" id="field_precontattoOrario1" ng-model="vm.utente.precontattoOrario1"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.utente.precontattoOrario2" for="field_precontattoOrario2">Precontatto Orario 2</label><input type="text" class="form-control" name="precontattoOrario2" id="field_precontattoOrario2" ng-model="vm.utente.precontattoOrario2"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.utente.ricerchegg" for="field_ricerchegg">Ricerchegg</label><input type="text" class="form-control" name="ricerchegg" id="field_ricerchegg" ng-model="vm.utente.ricerchegg"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.utente.ricercheOrario" for="field_ricercheOrario">Ricerche Orario</label><input type="text" class="form-control" name="ricercheOrario" id="field_ricercheOrario" ng-model="vm.utente.ricercheOrario"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.utente.isfgg" for="field_isfgg">Isfgg</label><input type="text" class="form-control" name="isfgg" id="field_isfgg" ng-model="vm.utente.isfgg"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.utente.isfOrario" for="field_isfOrario">Isf Orario</label><input type="text" class="form-control" name="isfOrario" id="field_isfOrario" ng-model="vm.utente.isfOrario"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.utente.note" for="field_note">Note</label><input type="text" class="form-control" name="note" id="field_note" ng-model="vm.utente.note"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.utente.canaliTv" for="field_canaliTv">Canali Tv</label><input type="text" class="form-control" name="canaliTv" id="field_canaliTv" ng-model="vm.utente.canaliTv"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.utente.cap" for="field_cap">Cap</label><input type="text" class="form-control" name="cap" id="field_cap" ng-model="vm.utente.cap"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.utente.indirizzo" for="field_indirizzo">Indirizzo</label><input type="text" class="form-control" name="indirizzo" id="field_indirizzo" ng-model="vm.utente.indirizzo"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.utente.dtIns" for="field_dtIns">Dt Ins</label><div class="input-group"><input id="field_dtIns" type="text" class="form-control" name="dtIns" datetime-picker="{{dateformat}}" ng-model="vm.utente.dtIns" is-open="vm.datePickerOpenStatus.dtIns"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dtIns\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.utente.dtUpdate" for="field_dtUpdate">Dt Update</label><div class="input-group"><input id="field_dtUpdate" type="text" class="form-control" name="dtUpdate" datetime-picker="{{dateformat}}" ng-model="vm.utente.dtUpdate" is-open="vm.datePickerOpenStatus.dtUpdate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dtUpdate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.utente.statusNote" for="field_statusNote">Status Note</label><input type="text" class="form-control" name="statusNote" id="field_statusNote" ng-model="vm.utente.statusNote"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.utente.recallDt" for="field_recallDt">Recall Dt</label><div class="input-group"><input id="field_recallDt" type="text" class="form-control" name="recallDt" datetime-picker="{{dateformat}}" ng-model="vm.utente.recallDt" is-open="vm.datePickerOpenStatus.recallDt"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'recallDt\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.utente.spedizioneCap" for="field_spedizioneCap">Spedizione Cap</label><input type="text" class="form-control" name="spedizioneCap" id="field_spedizioneCap" ng-model="vm.utente.spedizioneCap"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.utente.spedizioneIndirizzo" for="field_spedizioneIndirizzo">Spedizione Indirizzo</label><input type="text" class="form-control" name="spedizioneIndirizzo" id="field_spedizioneIndirizzo" ng-model="vm.utente.spedizioneIndirizzo"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.utente.spedizioneTel" for="field_spedizioneTel">Spedizione Tel</label><input type="text" class="form-control" name="spedizioneTel" id="field_spedizioneTel" ng-model="vm.utente.spedizioneTel"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.utente.source" for="field_source">Source</label><input type="text" class="form-control" name="source" id="field_source" ng-model="vm.utente.source"></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.utente.balance" for="field_balance">Balance</label><input type="number" class="form-control" name="balance" id="field_balance" ng-model="vm.utente.balance"></div><div class="form-group"><label data-translate="doctorclubboApp.utente.utente_specializzazione1" for="field_utente_specializzazione1">Utente Specializzazione 1</label><select class="form-control" id="field_utente_specializzazione1" name="utente_specializzazione1" ng-model="vm.utente.utente_specializzazione1" ng-options="specializzazione as specializzazione.nome for specializzazione in vm.specializzaziones track by specializzazione.id"><option value=""></option></select></div><div class="form-group"><label data-translate="doctorclubboApp.utente.utente_specializzazione2" for="field_utente_specializzazione2">Utente Specializzazione 2</label><select class="form-control" id="field_utente_specializzazione2" name="utente_specializzazione2" ng-model="vm.utente.utente_specializzazione2" ng-options="specializzazione as specializzazione.nome for specializzazione in vm.specializzaziones track by specializzazione.id"><option value=""></option></select></div><div class="form-group"><label data-translate="doctorclubboApp.utente.utente_specializzazione3" for="field_utente_specializzazione3">Utente Specializzazione 3</label><select class="form-control" id="field_utente_specializzazione3" name="utente_specializzazione3" ng-model="vm.utente.utente_specializzazione3" ng-options="specializzazione as specializzazione.nome for specializzazione in vm.specializzaziones track by specializzazione.id"><option value=""></option></select></div><div class="form-group"><label data-translate="doctorclubboApp.utente.utente_attivita" for="field_utente_attivita">Utente Attivita</label><select class="form-control" id="field_utente_attivita" name="utente_attivita" ng-model="vm.utente.utente_attivita" ng-options="attivita as attivita.attivita for attivita in vm.attivitas track by attivita.id"><option value=""></option></select></div><div class="form-group"><label data-translate="doctorclubboApp.utente.utente_dispositivo" for="field_utente_dispositivo">Utente Dispositivo</label><select class="form-control" id="field_utente_dispositivo" name="utente_dispositivo" ng-model="vm.utente.utente_dispositivo" ng-options="dispositivo as dispositivo.dispositivo for dispositivo in vm.dispositivos track by dispositivo.id"><option value=""></option></select></div><div class="form-group"><label data-translate="doctorclubboApp.utente.utente_dispositivoos" for="field_utente_dispositivoos">Utente Dispositivoos</label><select class="form-control" id="field_utente_dispositivoos" name="utente_dispositivoos" ng-model="vm.utente.utente_dispositivoos" ng-options="dispositivo_os as dispositivo_os.os for dispositivo_os in vm.dispositivo_os track by dispositivo_os.id"><option value=""></option></select></div><div class="form-group"><label data-translate="doctorclubboApp.utente.utente_tablet" for="field_utente_tablet">Utente Tablet</label><select class="form-control" id="field_utente_tablet" name="utente_tablet" ng-model="vm.utente.utente_tablet" ng-options="tablet as tablet.tablet for tablet in vm.tablets track by tablet.id"><option value=""></option></select></div><div class="form-group"><label data-translate="doctorclubboApp.utente.utente_tabletos" for="field_utente_tabletos">Utente Tabletos</label><select class="form-control" id="field_utente_tabletos" name="utente_tabletos" ng-model="vm.utente.utente_tabletos" ng-options="tablet_os as tablet_os.os for tablet_os in vm.tablet_os track by tablet_os.id"><option value=""></option></select></div><div class="form-group"><label data-translate="doctorclubboApp.utente.utente_tv" for="field_utente_tv">Utente Tv</label><select class="form-control" id="field_utente_tv" name="utente_tv" ng-model="vm.utente.utente_tv" ng-options="tv as tv.tv for tv in vm.tvs track by tv.id"><option value=""></option></select></div><div class="form-group"><label data-translate="doctorclubboApp.utente.utente_provincia" for="field_utente_provincia">Utente Provincia</label><select class="form-control" id="field_utente_provincia" name="utente_provincia" ng-model="vm.utente.utente_provincia" ng-options="provincia as provincia.id for provincia in vm.provincias track by provincia.id"><option value=""></option></select></div><div class="form-group"><label data-translate="doctorclubboApp.utente.utente_comune" for="field_utente_comune">Utente Comune</label><select class="form-control" id="field_utente_comune" name="utente_comune" ng-model="vm.utente.utente_comune" ng-options="comune as comune.comune for comune in vm.comunes track by comune.id"><option value=""></option></select></div><div class="form-group"><label data-translate="doctorclubboApp.utente.utente_status" for="field_utente_status">Utente Status</label><select class="form-control" id="field_utente_status" name="utente_status" ng-model="vm.utente.utente_status" ng-options="recall_status as recall_status.code for recall_status in vm.recall_statuses track by recall_status.id"><option value=""></option></select></div><div class="form-group"><label data-translate="doctorclubboApp.utente.utente_spedprovincia" for="field_utente_spedprovincia">Utente Spedprovincia</label><select class="form-control" id="field_utente_spedprovincia" name="utente_spedprovincia" ng-model="vm.utente.utente_spedprovincia" ng-options="provincia as provincia.id for provincia in vm.provincias track by provincia.id"><option value=""></option></select></div><div class="form-group"><label data-translate="doctorclubboApp.utente.utente_spedcomune" for="field_utente_spedcomune">Utente Spedcomune</label><select class="form-control" id="field_utente_spedcomune" name="utente_spedcomune" ng-model="vm.utente.utente_spedcomune" ng-options="comune as comune.comune for comune in vm.comunes track by comune.id"><option value=""></option></select></div><div class="form-group"><label data-translate="doctorclubboApp.utente.utente_agenzia" for="field_utente_agenzia">Utente Agenzia</label><select class="form-control" id="field_utente_agenzia" name="utente_agenzia" ng-model="vm.utente.utente_agenzia" ng-options="agenzia as agenzia.nome for agenzia in vm.agenzias track by agenzia.id"><option value=""></option></select></div><div class="form-group"><label class="control-label" data-translate="doctorclubboApp.utente.utente_agenzia" for="field_sistemaid">Sistema</label><input type="number" class="form-control" name="sistemaid" id="field_sistemaid" ng-model="vm.utente.sistemaid"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/utente/utentes.html','<div><h2 data-translate="doctorclubboApp.utente.home.title">Utentes</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="utente.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="doctorclubboApp.utente.home.createLabel">Create new Utente</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="externalUserid"><span>External ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nome"><span data-translate="doctorclubboApp.utente.nome">Nome</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="cognome"><span data-translate="doctorclubboApp.utente.cognome">Cognome</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="cf"><span data-translate="doctorclubboApp.utente.cf">Cf</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="dtNascita"><span data-translate="doctorclubboApp.utente.dtNascita">Dt Nascita</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="numIscrizione"><span data-translate="doctorclubboApp.utente.numIscrizione">Num Iscrizione</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="telefono"><span data-translate="doctorclubboApp.utente.telefono">Telefono</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="cellulare"><span data-translate="doctorclubboApp.utente.cellulare">Cellulare</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="fax"><span data-translate="doctorclubboApp.utente.fax">Fax</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="email"><span data-translate="doctorclubboApp.utente.email">Email</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="email2"><span data-translate="doctorclubboApp.utente.email2">Email 2</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="precontattogg"><span data-translate="doctorclubboApp.utente.precontattogg">Precontattogg</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="precontattoOrario1"><span data-translate="doctorclubboApp.utente.precontattoOrario1">Precontatto Orario 1</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="precontattoOrario2"><span data-translate="doctorclubboApp.utente.precontattoOrario2">Precontatto Orario 2</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="ricerchegg"><span data-translate="doctorclubboApp.utente.ricerchegg">Ricerchegg</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="ricercheOrario"><span data-translate="doctorclubboApp.utente.ricercheOrario">Ricerche Orario</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="isfgg"><span data-translate="doctorclubboApp.utente.isfgg">Isfgg</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="isfOrario"><span data-translate="doctorclubboApp.utente.isfOrario">Isf Orario</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="note"><span data-translate="doctorclubboApp.utente.note">Note</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="canaliTv"><span data-translate="doctorclubboApp.utente.canaliTv">Canali Tv</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="cap"><span data-translate="doctorclubboApp.utente.cap">Cap</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="indirizzo"><span data-translate="doctorclubboApp.utente.indirizzo">Indirizzo</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="dtIns"><span data-translate="doctorclubboApp.utente.dtIns">Dt Ins</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="dtUpdate"><span data-translate="doctorclubboApp.utente.dtUpdate">Dt Update</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="statusNote"><span data-translate="doctorclubboApp.utente.statusNote">Status Note</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="recallDt"><span data-translate="doctorclubboApp.utente.recallDt">Recall Dt</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="spedizioneCap"><span data-translate="doctorclubboApp.utente.spedizioneCap">Spedizione Cap</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="spedizioneIndirizzo"><span data-translate="doctorclubboApp.utente.spedizioneIndirizzo">Spedizione Indirizzo</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="spedizioneTel"><span data-translate="doctorclubboApp.utente.spedizioneTel">Spedizione Tel</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="source"><span data-translate="doctorclubboApp.utente.source">Source</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="balance"><span data-translate="doctorclubboApp.utente.balance">Balance</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="utente_specializzazione1.id"><span data-translate="doctorclubboApp.utente.utente_specializzazione1">Utente Specializzazione 1</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="utente_specializzazione2.id"><span data-translate="doctorclubboApp.utente.utente_specializzazione2">Utente Specializzazione 2</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="utente_specializzazione3.id"><span data-translate="doctorclubboApp.utente.utente_specializzazione3">Utente Specializzazione 3</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="utente_attivita.id"><span data-translate="doctorclubboApp.utente.utente_attivita">Utente Attivita</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="utente_dispositivo.id"><span data-translate="doctorclubboApp.utente.utente_dispositivo">Utente Dispositivo</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="utente_dispositivoos.id"><span data-translate="doctorclubboApp.utente.utente_dispositivoos">Utente Dispositivoos</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="utente_tablet.id"><span data-translate="doctorclubboApp.utente.utente_tablet">Utente Tablet</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="utente_tabletos.id"><span data-translate="doctorclubboApp.utente.utente_tabletos">Utente Tabletos</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="utente_tv.id"><span data-translate="doctorclubboApp.utente.utente_tv">Utente Tv</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="utente_provincia.id"><span data-translate="doctorclubboApp.utente.utente_provincia">Utente Provincia</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="utente_comune.id"><span data-translate="doctorclubboApp.utente.utente_comune">Utente Comune</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="utente_status.id"><span data-translate="doctorclubboApp.utente.utente_status">Utente Status</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="utente_spedprovincia.id"><span data-translate="doctorclubboApp.utente.utente_spedprovincia">Utente Spedprovincia</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="utente_spedcomune.id"><span data-translate="doctorclubboApp.utente.utente_spedcomune">Utente Spedcomune</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="utente_agenzia.id"><span data-translate="doctorclubboApp.utente.utente_agenzia">Utente Agenzia</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="sistemaid"><span data-translate="doctorclubboApp.utente.utente_agenzia">Sistema</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="utente in vm.utentes track by utente.id"><td><a ui-sref="utente-detail({id:utente.id})">{{utente.id}}</a></td><td>{{utente.externalUserid}}</td><td>{{utente.nome}}</td><td>{{utente.cognome}}</td><td>{{utente.cf}}</td><td>{{utente.dtNascita | date:\'medium\'}}</td><td>{{utente.numIscrizione}}</td><td>{{utente.telefono}}</td><td>{{utente.cellulare}}</td><td>{{utente.fax}}</td><td>{{utente.email}}</td><td>{{utente.email2}}</td><td>{{utente.precontattogg}}</td><td>{{utente.precontattoOrario1}}</td><td>{{utente.precontattoOrario2}}</td><td>{{utente.ricerchegg}}</td><td>{{utente.ricercheOrario}}</td><td>{{utente.isfgg}}</td><td>{{utente.isfOrario}}</td><td>{{utente.note}}</td><td>{{utente.canaliTv}}</td><td>{{utente.cap}}</td><td>{{utente.indirizzo}}</td><td>{{utente.dtIns | date:\'medium\'}}</td><td>{{utente.dtUpdate | date:\'medium\'}}</td><td>{{utente.statusNote}}</td><td>{{utente.recallDt | date:\'medium\'}}</td><td>{{utente.spedizioneCap}}</td><td>{{utente.spedizioneIndirizzo}}</td><td>{{utente.spedizioneTel}}</td><td>{{utente.source}}</td><td>{{utente.balance}}</td><td><a ui-sref="specializzazione-detail({id:utente.utente_specializzazione1.id})">{{utente.utente_specializzazione1.nome}}</a></td><td><a ui-sref="specializzazione-detail({id:utente.utente_specializzazione2.id})">{{utente.utente_specializzazione2.nome}}</a></td><td><a ui-sref="specializzazione-detail({id:utente.utente_specializzazione3.id})">{{utente.utente_specializzazione3.nome}}</a></td><td><a ui-sref="attivita-detail({id:utente.utente_attivita.id})">{{utente.utente_attivita.attivita}}</a></td><td><a ui-sref="dispositivo-detail({id:utente.utente_dispositivo.id})">{{utente.utente_dispositivo.dispositivo}}</a></td><td><a ui-sref="dispositivo-os-detail({id:utente.utente_dispositivoos.id})">{{utente.utente_dispositivoos.os}}</a></td><td><a ui-sref="tablet-detail({id:utente.utente_tablet.id})">{{utente.utente_tablet.tablet}}</a></td><td><a ui-sref="tablet-os-detail({id:utente.utente_tabletos.id})">{{utente.utente_tabletos.os}}</a></td><td><a ui-sref="tv-detail({id:utente.utente_tv.id})">{{utente.utente_tv.tv}}</a></td><td><a ui-sref="provincia-detail({id:utente.utente_provincia.id})">{{utente.utente_provincia.id}}</a></td><td><a ui-sref="comune-detail({id:utente.utente_comune.id})">{{utente.utente_comune.comune}}</a></td><td><a ui-sref="recall-status-detail({id:utente.utente_status.id})">{{utente.utente_status.code}}</a></td><td><a ui-sref="provincia-detail({id:utente.utente_spedprovincia.id})">{{utente.utente_spedprovincia.id}}</a></td><td><a ui-sref="comune-detail({id:utente.utente_spedcomune.id})">{{utente.utente_spedcomune.comune}}</a></td><td><a ui-sref="agenzia-detail({id:utente.utente_agenzia.id})">{{utente.utente_agenzia.nome}}</a></td><td>{{utente.sistemaid}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="utente-detail({id:utente.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="utente.edit({id:utente.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="utente.delete({id:utente.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/layouts/error/accessdenied.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1 data-translate="error.title">Error Page!</h1><div class="alert alert-danger" data-translate="error.403">You are not authorized to access the page.</div></div></div></div>');
$templateCache.put('app/layouts/error/error.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1 data-translate="error.title">Error Page!</h1><div ng-show="errorMessage"><div class="alert alert-danger">{{errorMessage}}</div></div></div></div></div>');
$templateCache.put('app/layouts/navbar/navbar.html','<nav class="navbar navbar-default" role="navigation"><div class="container"><div class="navbar-header"><button type="button" class="navbar-toggle" ng-click="vm.toggleNavbar()"><span class="sr-only">Toggle navigation</span> <span class="icon-bar"></span> <span class="icon-bar"></span> <span class="icon-bar"></span></button> <a class="navbar-brand logo" href="#/" ng-click="vm.collapseNavbar()"><img class="logo-img" src="content/images/logo-jhipster.png"> <span data-translate="global.title">Doctorclubbo</span> <span class="navbar-version">v{{VERSION}}</span></a></div><div class="navbar-collapse" uib-collapse="vm.isNavbarCollapsed" ng-switch="vm.isAuthenticated()"><ul class="nav navbar-nav navbar-right"><li ui-sref-active="active"><a ui-sref="home" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-home"></span> <span class="hidden-sm" data-translate="global.menu.home">Home</span></a></li><!-- jhipster-needle-add-element-to-menu - JHipster will add new menu items here --><!--  li ng-class="{active: vm.$state.includes(\'entity\')}" ng-switch-when="true" uib-dropdown class="dropdown pointer">--><li ng-class="{active: vm.$state.includes(\'entity\')}" ng-switch-when="true" has-authority="ROLE_ADMIN" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="entity-menu"><span><span class="glyphicon glyphicon-th-list"></span> <span class="hidden-sm" data-translate="global.menu.entities.main">Entities </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="queue-status" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.queueStatus">Queue Status</span></a></li><li ui-sref-active="active"><a ui-sref="queue-type" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.queueType">Queue Type</span></a></li><li ui-sref-active="active"><a ui-sref="specializzazione" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.specializzazione">Specializzazione</span></a></li><li ui-sref-active="active"><a ui-sref="statement" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.statement">Statement</span></a></li><li ui-sref-active="active"><a ui-sref="statement-type" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.statementType">Statement Type</span></a></li><li ui-sref-active="active"><a ui-sref="campagna" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.campagna">Campagna</span></a></li><li ui-sref-active="active"><a ui-sref="campagna-status" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.campagnaStatus">Campagna Status</span></a></li><li ui-sref-active="active"><a ui-sref="agenzia" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.agenzia">Agenzia</span></a></li><li ui-sref-active="active"><a ui-sref="comune" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.comune">Comune</span></a></li><li ui-sref-active="active"><a ui-sref="provincia" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.provincia">Provincia</span></a></li><li ui-sref-active="active"><a ui-sref="queue" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.queue">Queue</span></a></li><li ui-sref-active="active"><a ui-sref="queue-account" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.queueAccount">Queue Account</span></a></li><li ui-sref-active="active"><a ui-sref="utente" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.utente">Utente</span></a></li><li ui-sref-active="active"><a ui-sref="attivita" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.attivita">Attivita</span></a></li><li ui-sref-active="active"><a ui-sref="recall-status" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.recallStatus">Recall Status</span></a></li><li ui-sref-active="active"><a ui-sref="tablet" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.tablet">Tablet</span></a></li><li ui-sref-active="active"><a ui-sref="tv" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.tv">Tv</span></a></li><li ui-sref-active="active"><a ui-sref="dispositivo" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.dispositivo">Dispositivo</span></a></li><li ui-sref-active="active"><a ui-sref="dispositivo-os" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.dispositivoOs">Dispositivo Os</span></a></li><li ui-sref-active="active"><a ui-sref="queue-credit" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.queueCredit">Queue Credit</span></a></li><li ui-sref-active="active"><a ui-sref="qsched-direction" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.qschedDirection">Qsched Direction</span></a></li><li ui-sref-active="active"><a ui-sref="qsched-status" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.qschedStatus">Qsched Status</span></a></li><li ui-sref-active="active"><a ui-sref="qsched-type" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.qschedType">Qsched Type</span></a></li><li ui-sref-active="active"><a ui-sref="queue-scheduled" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.queueScheduled">Queue Scheduled</span></a></li><li ui-sref-active="active"><a ui-sref="ticket" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.ticket">Ticket</span></a></li><li ui-sref-active="active"><a ui-sref="ticket-status" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.ticketStatus">Ticket Status</span></a></li><li ui-sref-active="active"><a ui-sref="campagna-type" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.campagnaType">Campagna Type</span></a></li><li ui-sref-active="active"><a ui-sref="sistema" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.sistema">Sistema</span></a></li><li ui-sref-active="active"><a ui-sref="campagna-log" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.campagnaLog">Campagna Log</span></a></li><li ui-sref-active="active"><a ui-sref="campagnalog-tipo" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.campagnalogTipo">Campagnalog Tipo</span></a></li><li ui-sref-active="active"><a ui-sref="area" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.area">Area</span></a></li><li ui-sref-active="active"><a ui-sref="azione" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.azione">Azione</span></a></li><li ui-sref-active="active"><a ui-sref="raci" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.raci">Raci</span></a></li><li ui-sref-active="active"><a ui-sref="delivery-option" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.deliveryOption">Delivery Option</span></a></li><li ui-sref-active="active"><a ui-sref="delivery-status" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.deliveryStatus">Delivery Status</span></a></li><li ui-sref-active="active"><a ui-sref="fee" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.fee">Fee</span></a></li><li ui-sref-active="active"><a ui-sref="opzioni-ticket" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.opzioniTicket">Opzioni Ticket</span></a></li><li ui-sref-active="active"><a ui-sref="delivery-option-agenzia" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.deliveryOptionAgenzia">Delivery Option Agenzia</span></a></li><li ui-sref-active="active"><a ui-sref="fee-agenzia" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.feeAgenzia">Fee Agenzia</span></a></li><li ui-sref-active="active"><a ui-sref="upload" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.upload">Upload</span></a></li><li ui-sref-active="active"><a ui-sref="gc-system" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.gcSystem">Gc System</span></a></li><li ui-sref-active="active"><a ui-sref="giftcard-statement" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.giftcardStatement">Giftcard Statement</span></a></li><li ui-sref-active="active"><a ui-sref="campagna-amazon" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.campagnaAmazon">Campagna Amazon</span></a></li><li ui-sref-active="active"><a ui-sref="amazon-statement" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.amazonStatement">Amazon Statement</span></a></li><!-- jhipster-needle-add-entity-to-menu - JHipster will add entities to the menu here --></ul></li><li ng-class="{active: vm.$state.includes(\'account\')}" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="account-menu"><span><span class="glyphicon glyphicon-user"></span> <span class="hidden-sm" data-translate="global.menu.account.main">Account </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active" ng-switch-when="true"><a ui-sref="settings" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-wrench"></span>&nbsp; <span data-translate="global.menu.account.settings">Settings</span></a></li><li ui-sref-active="active" ng-switch-when="true"><a ui-sref="password" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-lock"></span>&nbsp; <span data-translate="global.menu.account.password">Password</span></a></li><li ui-sref-active="active" ng-switch-when="true"><a href="" ng-click="vm.logout()" id="logout"><span class="glyphicon glyphicon-log-out"></span>&nbsp; <span data-translate="global.menu.account.logout">Sign out</span></a></li><li ui-sref-active="active" ng-switch-when="false"><a href="" ng-click="vm.login()" id="login"><span class="glyphicon glyphicon-log-in"></span>&nbsp; <span data-translate="global.menu.account.login">Sign in</span></a></li></ul></li><li ng-class="{active: vm.$state.includes(\'admin\')}" ng-switch-when="true" has-authority="ROLE_ADMIN" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="admin-menu"><span><span class="glyphicon glyphicon-tower"></span> <span class="hidden-sm" data-translate="global.menu.admin.main">Administration</span> <b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="user-management" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-user"></span>&nbsp; <span data-translate="global.menu.admin.userManagement">User management</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-metrics" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-dashboard"></span>&nbsp; <span data-translate="global.menu.admin.metrics">Metrics</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-health" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-heart"></span>&nbsp; <span data-translate="global.menu.admin.health">Health</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-configuration" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-list-alt"></span>&nbsp; <span data-translate="global.menu.admin.configuration">Configuration</span></a></li><li ui-sref-active="active"><a ui-sref="audits" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-bell"></span>&nbsp; <span data-translate="global.menu.admin.audits">Audits</span></a></li><li ui-sref-active="active"><a ui-sref="logs" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-tasks"></span>&nbsp; <span data-translate="global.menu.admin.logs">Logs</span></a></li><li ng-show="vm.swaggerEnabled" ui-sref-active="active"><a ui-sref="docs" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-book"></span>&nbsp; <span data-translate="global.menu.admin.apidocs">API</span></a></li><!-- jhipster-needle-add-element-to-admin-menu - JHipster will add entities to the admin menu here --></ul></li><li ui-sref-active="active" uib-dropdown class="dropdown pointer" ng-controller="JhiLanguageController as languageVm"><a class="dropdown-toggle" uib-dropdown-toggle href="" ng-if="languageVm.languages.length > 1"><span><span class="glyphicon glyphicon-flag"></span> <span class="hidden-sm" data-translate="global.menu.language">Language</span> <b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu ng-if="languageVm.languages.length > 1"><li active-menu="{{language}}" ng-repeat="language in languageVm.languages"><a href="" ng-click="languageVm.changeLanguage(language);vm.collapseNavbar();">{{language | findLanguageFromKey}}</a></li></ul></li></ul></div></div></nav>');
$templateCache.put('app/account/reset/finish/reset.finish.html','<div><div class="row"><div class="col-md-4 col-md-offset-4"><h1 data-translate="reset.finish.title">Reset password</h1><div class="alert alert-danger" data-translate="reset.finish.messages.keymissing" ng-show="vm.keyMissing"><strong>The password reset key is missing.</strong></div><div class="alert alert-warning" ng-hide="vm.success || vm.keyMissing"><p data-translate="reset.finish.messages.info">Choose a new password</p></div><div class="alert alert-danger" ng-show="vm.error"><p data-translate="reset.finish.messages.error">Your password couldn\'t be reset. Remember a password request is only valid for 24 hours.</p></div><div class="alert alert-success" ng-show="vm.success"><p data-translate="reset.finish.messages.success" translate-compile><strong>Your password has been reset.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</p></div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><div ng-hide="vm.keyMissing"><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.finishReset()" show-validation><div class="form-group"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.resetAccount.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.resetAccount.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your password confirmation is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your password confirmation is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your password confirmation cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="reset.finish.form.button">Reset Password</button></form></div></div></div></div>');
$templateCache.put('app/account/reset/request/reset.request.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 data-translate="reset.request.title">Reset your password</h1><div class="alert alert-danger" data-translate="reset.request.messages.notfound" ng-show="vm.errorEmailNotExists"><strong>E-Mail address isn\'t registered!</strong> Please check and try again.</div><div class="alert alert-warning" ng-hide="vm.success"><p data-translate="reset.request.messages.info">Enter the e-mail address you used to register.</p></div><div class="alert alert-success" ng-show="vm.success == \'OK\'"><p data-translate="reset.request.messages.success">Check your e-mails for details on how to reset your password.</p></div><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.requestReset()" show-validation><div class="form-group"><label class="control-label" for="email" data-translate="global.form.email">E-mail</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.resetAccount.email" ng-minlength="5" ng-maxlength="100" required><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">Your e-mail is required.</p><p class="help-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your e-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="reset.request.form.button">Reset</button></form></div></div></div>');}]);})();